var nsModuleExport = function(root,name,prototype)
	{
		if(typeof exports === 'object' && typeof module === 'object')
		{
			module.exports[name] = prototype;
		}
		else if (typeof define === "function" && define.amd)
		{
			define(name,[], function () {return prototype;});
		}
		else if(typeof exports === 'object')
		{
			exports[name] = prototype;
		}
		else
		{
			root[name] = prototype;
		}
	};var nsIsWeb = function(root)
	{
		if(typeof exports === 'object' && typeof module === 'object')
		{
			return false;
		}
		else if (typeof define === "function" && define.amd)
		{
			return false;
		}
		else if(typeof exports === 'object')
		{
			return false;
		}
		else
		{
			return true;
		}
	};if(!nsIsWeb())
		{
var nsutilRef = require('./nsUtil.min.js');
var NSUtil = nsutilRef.NSUtil;
var nscontainerbaseRef = require('./nsContainerBase.min.js');
var nsExtendPrototype = nscontainerbaseRef.nsExtendPrototype;
var NSContainerBase = nscontainerbaseRef.NSContainerBase;
var svgRef = require('./nsSVG.min.js');
var NSSvg = svgRef.NSSvg;
var NSSvgShapes = svgRef.NSSvgShapes;
var plugginsRef = require('./nsPluggins.min.js');
var nsTextEditor = plugginsRef.nsTextEditor;
var nsTextAreaEditor = plugginsRef.nsTextAreaEditor;
var NSCellSelection = plugginsRef.NSCellSelection;
var NSTableCellNavigator = plugginsRef.NSTableCellNavigator;
var dateutilRef = require('./nsDateUtil.min.js');
var NSDateUtil = dateutilRef.NSDateUtil;

		}
 "use strict"; 
var NSMenu = (function()
{
	function NSMenu(setting) 
	{
		this.util = new NSUtil();
		this.DEFAULT_POSITION = this.util.POS_BOTTOMRIGHT;
		
		this.__setting = setting;
		this.__config = null;
		
		this.__id = null;
		this.__popUp = null;
		this.__nsPopUp = null;
		this.__fieldItem = null;
		this.__fieldItemChild = null;
		this.__fieldChild = "children";
		this.__isInternalCall = false;
		this.__suppressDocumentHandler = false;
		
		this.__documentClickRef = null;
		this.__documentKeyUpRef = null;
		this.__lastSelectedTarget = null;
		
		this.__initialize();
	}
	
	NSMenu.prototype.create = function (dataSource) 
	{ 
		if(dataSource && (this.__config.createRunTime || this.__isInternalCall))
		{
			if(this.__popUp)
			{
				this.remove();
			}
			this.__isInternalCall = false;
			this.__config.dataSource = dataSource;
			this.__popUp = this.__createElement(true,this.__config.dataSource);
			this.util.addStyleClass(this.__nsPopUp,"nsMainMenu");
		}
	};
	
	NSMenu.prototype.remove = function () 
	{ 
		if(this.__config.createRunTime || this.__isInternalCall)
		{
			this.__isInternalCall = false;
			this.__nsPopUp.remove();
			this.__popUp = null;
		}
	};
	
	NSMenu.prototype.show = function (event) 
	{ 
		event = this.util.getEvent(event);
		this.__nsPopUp.hideOtherNSPopUp();
		if(this.__config.createRunTime)
		{
			this.__isInternalCall = true;
			var dataSource = null;
			if(this.__config.sourceProvider)
			{
				dataSource = this.__config.sourceProvider(this.__lastSelectedTarget);
			}
			if(dataSource && dataSource.length > 0)
			{
				this.create(dataSource);
			}
			else
			{
				this.util.preventDefault(event);
				return;
			}
		}
		this.__nsPopUp.show();
		this.__nsPopUp.placePopUp(event);
		if(!this.__documentClickRef)
		{
			this.__documentClickRef = this.__documentClickHandler.bind(this);
			this.util.addEvent(document.documentElement,"click", this.__documentClickRef);
		}
		if(!this.__documentKeyUpRef)
		{
			this.__documentKeyUpRef = this.__documentKeyUpHandler.bind(this);
			this.util.addEvent(document.documentElement,"keyup", this.__documentKeyUpRef);
		}
		this.util.preventDefault(event);
	};
	NSMenu.prototype.hide = function() 
	{
		this.__lastSelectedTarget = null;
		this.__hideAllSubMenus();
		if(this.__config.createRunTime)
		{
			this.__isInternalCall = true;
			this.remove();
		}
		else
		{
			this.__nsPopUp.hide();
		}
		if(this.__documentClickRef)
		{
			this.util.removeEvent(document.documentElement,"click", this.__documentClickRef, false);
			this.__documentClickRef = null;
		}
		if(this.__documentKeyUpRef)
		{
			this.util.removeEvent(document.documentElement,"keyup", this.__documentKeyUpRef, false);
			this.__documentKeyUpRef = null;
		}
	};
	
	NSMenu.prototype.__initialize = function ()
	{
		if(this.__setting)
		{
			//eventHandler:extra eventHandler which developer wants to execute on the event i.e. click,customEvent etc
			this.__config = {
					parent: this.__setting["parent"] || null,
					dataSource: this.__setting["dataSource"] || null,
					isContextMenu: (this.util.isUndefined(this.__setting["isContextMenu"]) || this.__setting["isContextMenu"] === null) ? true : Boolean.parse(this.__setting["isContextMenu"]),
					eventType: this.__setting["eventType"] || "click",
					createRunTime: (this.util.isUndefined(this.__setting["createRunTime"]) || this.__setting["createRunTime"] === null) ? false : Boolean.parse(this.__setting["createRunTime"]),
					sourceProvider: this.__setting["sourceProvider"] || null,
					targetType: this.__setting["targetType"] || null,
					defaultHandler: (this.__setting["defaultHandler"] ? this.util.getFunction(this.__setting["defaultHandler"]) : null),
					eventHandler: (this.__setting["eventHandler"] ? this.util.getFunction(this.__setting["eventHandler"]) : null),
					position: this.__setting["position"] || this.DEFAULT_POSITION,
					width: parseInt(this.__setting["width"]) || -1
				};
			if(this.__config.parent)
			{
				var popUpSetting = {id:this.__getID() + "menu",type:"ul",width:this.__config.width,position:this.__config.position};
				this.__nsPopUp = new this.util.nsPopUp(popUpSetting);
				this.__fieldItem = this.__getID() + "_item";
				this.__fieldItemChild = this.__getID() + "_child";
				if(!this.__config.createRunTime)
				{
					this.__isInternalCall = true;
					this.create(this.__config.dataSource);
				}
				if(this.__config.isContextMenu)
				{
					this.util.addEvent(this.__config.parent,"contextmenu", this.__parentContextMenuHandler.bind(this));
				}
				else
				{
					this.util.addEvent(this.__config.parent,this.__config.eventType, this.__parentClickHandler.bind(this),false);
				}
			}
		}
	};
	
	NSMenu.prototype.__createElement = function(isRoot,dataSource) 
	{
		var parentNode = null;
		if(dataSource && dataSource.length > 0)
		{
			if(isRoot)
			{
				parentNode = this.__nsPopUp.create();
			}
			else
			{
				parentNode = document.createElement("ul"); 
				this.util.addStyleClass(parentNode,"nsMenu");
				if(this.__config.width > -1)
				{
					parentNode.style.width = this.__config.width + "px";
				}
			}
			for (var count = 0; count < dataSource.length; count++) 
			{
				var item = dataSource[count];
				this.__createItem(item,parentNode);
			}
		}
		return parentNode;
	};
	
	NSMenu.prototype.__createItem = function(item,parent)
	{
		var menuItem = null;
		if(item)
		{
			menuItem = document.createElement("li");
			this.util.addStyleClass(menuItem,"nsMenuItem");
			if(item["header"])
			{
				this.util.addStyleClass(menuItem,"nsHeader");
			}
			if(item["disabled"])
			{
				this.util.addStyleClass(menuItem,"nsDisabled");
			}
			var button = document.createElement("BUTTON");
			this.util.addStyleClass(button,"nsMenuButton");
			if(item["iconHTML"])
			{
				var spanIcon = document.createElement("span");
				this.util.addStyleClass(spanIcon,"nsMenuAlign");
				spanIcon.innerHTML = item["iconHTML"];
				button.appendChild(spanIcon);
			}
			var spanText = document.createElement("span");
			this.util.addStyleClass(spanText,"nsMenuText");
			spanText.appendChild(document.createTextNode(item["title"]));
			button.appendChild(spanText);
			menuItem.appendChild(button);
			this.util.addEvent(menuItem,"click",this.__itemClickHandler.bind(this));
			this.util.addEvent(menuItem,"mouseenter",this.__itemMouseOverHandler.bind(this));
			this.util.addEvent(menuItem,"mouseleave",this.__itemMouseOutHandler.bind(this));
			if(item[this.__fieldChild]) 
			{
				this.util.addStyleClass(menuItem,"nsSubMenu");
		    	var subMenu = this.__createElement(false,item[this.__fieldChild]);
		    	if(subMenu)
		    	{
		    		this.util.addStyleClass(subMenu,"nsSubMenuContainer");
			    	menuItem.appendChild(subMenu);
			    	item[this.__fieldItemChild] = subMenu;
			    	menuItem.setAttribute("hasChild",true);
		    	}
			}
			else
			{
				menuItem.setAttribute("hasChild",false);
			}
			if(parent)
			{
				parent.appendChild(menuItem);
				if(item["separatorBelow"])
				{
					var lineMenuItem = document.createElement("li");
					this.util.addStyleClass(lineMenuItem,"nsMenuSeparator");
					parent.appendChild(lineMenuItem);
				}
			}
			item[this.__fieldItem] = menuItem;
		}
		return menuItem;
	};
	
	NSMenu.prototype.__itemClickHandler = function(event) 
	{
		event = this.util.getEvent(event);
		var target = this.util.getTarget(event);
		target = this.util.findParent(target,"LI");
		var item = this.__getItem(target,this.__config.dataSource);
		if(item)
		{
			var handler = null;
			if(item["handler"])
			{
				handler = this.util.getFunction(item["handler"]);
			}
			if(!handler)
			{
				handler = this.__config.defaultHandler;
			}
			if(handler)
			{
				handler(this.__lastSelectedTarget,item);
			}
		}
		this.hide();
		event.stopImmediatePropagation();
	};
	
	NSMenu.prototype.__itemMouseOverHandler = function(event) 
	{
		var target = this.util.getTarget(event);
		target = this.util.findParent(target,"LI");
		if(target.getAttribute("hasChild") === "true")
		{
			var item = this.__getItem(target,this.__config.dataSource);
			if(item && item[this.__fieldItemChild])
			{
				var childMenu = item[this.__fieldItemChild];
				this.util.addStyleClass(childMenu,"nsShowMenu");
			}
		}
	};
	
	NSMenu.prototype.__itemMouseOutHandler = function(event) 
	{
		var target = this.util.getTarget(event);
		target = this.util.findParent(target,"LI");
		if(target.getAttribute("hasChild") === "true")
		{
			var item = this.__getItem(target,this.__config.dataSource);
			if(item && item[this.__fieldItemChild])
			{
				var childMenu = item[this.__fieldItemChild];
				this.util.removeStyleClass(childMenu,"nsShowMenu");
			}
		}
	};
	
	NSMenu.prototype.__documentClickHandler = function(event) 
	{
		event = this.util.getEvent(event);
		/*if(!this.__config.isContextMenu && this.__isParentPresent(event.target,this.__config.parent))
		{
			return;
		}*/
		//commenting this so that menu closes on click in Grid
		/*if(this.__suppressDocumentHandler)
		{
			this.__suppressDocumentHandler = false;
			return;
		}*/
		this.hide();
	};
	
	
	NSMenu.prototype.__documentKeyUpHandler = function(event) 
	{
		event = this.util.getEvent(event);
		if(event.keyCode === this.util.KEYCODE.ESC) 
		{
			this.hide();
		}
	};
	
	NSMenu.prototype.__parentContextMenuHandler = function(event)
	{
		if(this.__config.eventHandler)
		{
			this.__config.eventHandler(event);
		}
		this.__setLastSelectedTarget(this.util.getTarget(event));
		this.show(event);
	};
	
	NSMenu.prototype.__parentClickHandler = function(event)
	{
		if(this.__config.eventHandler)
		{
			this.__config.eventHandler(event);
		}
		this.__setLastSelectedTarget(this.util.getTarget(event));
		//below condition to make documentClickhandler aware that do not hide the menu,hence put only for click handler
		if(this.__config.eventType === "click")
		{
			this.__suppressDocumentHandler = true;
			event.stopPropagation();
		}
		this.show(event);
	};
	
	NSMenu.prototype.__getItem = function(objItem,dataSource)
	{
		if(objItem)
		{
			for (var count = 0; count < dataSource.length; count++) 
			{
				var item = dataSource[count];
				if(item[this.__fieldItem] == objItem)
				{
					return item;
				}
				if(item.hasOwnProperty(this.__fieldChild))
				{
					var childItem = this.__getItem(objItem,item[this.__fieldChild]);
					if(childItem)
					{
						return childItem;
					}
				}
			}
		}
		return null;
	};
	
	NSMenu.prototype.__hideAllSubMenus = function()
	{
		var arrSubMenus = this.__popUp.querySelectorAll("ul");
		if(arrSubMenus && arrSubMenus.length > 0)
		{
			var subMenu = null;
			for(var count = 0;count < arrSubMenus.length;count++)
			{
				subMenu = arrSubMenus[count];
				this.util.removeStyleClass(subMenu,"nsShowMenu");
			}
		}
	};
	
	NSMenu.prototype.__setLastSelectedTarget = function(target)
	{
		if(target && this.__config.targetType)
		{
			target = this.util.findParent(target,this.__config.targetType);
		}
		this.__lastSelectedTarget = target;
	};
	
	NSMenu.prototype.__getID = function()
	{
		if(!this.__id)
		{
			if(this.__config.parent.hasAttribute("id"))
			{
				this.__id = this.__config.parent.getAttribute("id");
			}
			else if(this.__config.parent.hasAttribute("name"))
			{
				this.__id = this.__config.parent.getAttribute("name");
			}
			else
			{
				this.__id = "comp" + this.util.getUniqueId();
			}
		}
		return this.__id;
	};
	
	NSMenu.prototype.__isParentPresent =  function(node,parentNode) 
	{
		while (node && node!== document.body)
		{
			if(node.id === parentNode.id) 
			{
				return true;
			}
			node = node.parentNode;
		}
		return false;
	};
	
	return NSMenu;
})();
nsModuleExport(this,"NSMenu",NSMenu); "use strict";
var NSPagination = (function()
{
	function NSPagination(setting) 
	{
		this.PAGE_CLICK = "pageClick";
		this.PAGE_CHANGE = "pageChange";
		this.util = new NSUtil();
		
		this.__setting = setting;
		this.__config = null;
		
		this.__id = null;
		this.__container = null;
		this.__itemFirst = null;
		this.__itemLast = null;
		this.__itemPrev = null;
		this.__itemNext = null;
		this.__arrItemPage = [];
		this.__pageCount = 0;
		this.__selectedPage = -1;
		this.__initialize();
	}
	
	NSPagination.prototype.__initialize = function ()
	{
		if(this.__setting)
		{
			this.__config = {
					parent: this.__setting["parent"] || null,
					totalRecords: parseInt(this.__setting["totalRecords"]) || 0,
					pageSize: parseInt(this.__setting["pageSize"]) || 0,
					totalPageCount: parseInt(this.__setting["totalPageCount"]) || 0,
					visiblePages: parseInt(this.__setting["visiblePages"]) || 5,
					containerStyle: this.__setting["containerStyle"] || "nsPaginationContainer",
					activeStyle: this.__setting["activeStyle"] || "nsPageActive",
					disabledStyle: this.__setting["disabledStyle"] || "nsPageDisabled",
					textFirst : this.__setting["textFirst"] || "&laquo;",
					textLast : this.__setting["textLast"] || "&raquo;",
					textNext : this.__setting["textNext"] || "&rsaquo;",
					textPrev : this.__setting["textPrev"] || "&lsaquo;",
					textTitlePagePrefix: this.__setting["textTitlePagePrefix"] || "Page",
			        textTitleFirst : this.__setting["textTitleFirst"] || 'First Page', 
			        textTitleLast : this.__setting["textTitleLast"] || 'Last Page',
			        textTitleNext : this.__setting["textTitleNext"] || 'Next Page', 
			        textTitlePrev : this.__setting["textTitlePrev"] || 'Previous Page', 
					showPrevNext : (!this.util.isUndefined(this.__setting["showPrevNext"]) && this.__setting["showPrevNext"] != null) ? Boolean.parse(this.__setting["showPrevNext"]) : true,
					showFirstLast : (!this.util.isUndefined(this.__setting["showFirstLast"]) && this.__setting["showFirstLast"] != null) ? Boolean.parse(this.__setting["showFirstLast"]) : false
				};
			this.__create();
		}
	};
	
	NSPagination.prototype.changePageSize = function(pageSize)
	{
		if(pageSize > 0 && this.__config)
		{
			this.__config.pageSize = pageSize;
			this.__create();
		}
	};
	
	NSPagination.prototype.setSelectedPage = function(pageNumber)
	{
		this.__update(pageNumber);
	};
	
	NSPagination.prototype.getSelectedPage = function(pageNumber)
	{
		return this.__selectedPage;
	};
	
	NSPagination.prototype.__create = function()
	{
		if(this.__config.parent)
		{
			if(this.__container)
			{
				this.__container.parentNode.removeChild(this.__container);
				this.__arrItemPage = [];
				this.__selectedPage = -1;
			}
			if(this.__config.totalPageCount > 0)
			{
				this.__pageCount = this.__config.totalPageCount;
			}
			else if(this.__config.pageSize > 0)
			{
				this.__pageCount =  Math.ceil(this.__config.totalRecords / this.__config.pageSize);
			}
			this.__container = this.util.createElement("ul",this.__getID() + "container",this.__config.containerStyle);
			this.__config.parent.appendChild(this.__container);
			if(this.__config.showFirstLast)
			{
				this.__itemFirst = this.__createItem("-4",this.__config["textFirst"],this.__config.textTitleFirst,this.__controlItemClickHandler);
			}
			if(this.__config.showPrevNext)
			{
				this.__itemPrev = this.__createItem("-3",this.__config["textPrev"],this.__config.textTitlePrev,this.__controlItemClickHandler);
			}
			var createdNumber = Math.min(this.__pageCount,this.__config.visiblePages);
			for(var count = 1;count <= createdNumber;count++)
			{
				var pageItem = this.__createItem(count,count,this.__config.textTitlePagePrefix + " " + count,this.__pageItemClickHandler);
				this.__arrItemPage.push(pageItem);
			}
			if(this.__config.showPrevNext)
			{
				this.__itemNext = this.__createItem("-2",this.__config["textNext"],this.__config.textTitleNext,this.__controlItemClickHandler);
			}
			if(this.__config.showFirstLast)
			{
				this.__itemLast = this.__createItem("-1",this.__config["textLast"],this.__config.textTitleLast,this.__controlItemClickHandler);
			}
			//this.__selectPage(1);
			this.__updateControlState(1);
		}
	};
	
	NSPagination.prototype.__controlItemClickHandler = function(event)
	{
		var target = this.util.getTarget(event);
		target = this.util.findParent(target,"li");
		var index = parseInt(target.getAttribute("pageNum"));
		var pageSelected = -1;
		switch(index)
		{
			case -4:
				pageSelected = 1;
				break;
			case -3:
				pageSelected = this.__selectedPage - 1;
				break;
			case -2:
				pageSelected = this.__selectedPage + 1;
				break;
			case -1:
				pageSelected = this.__pageCount;
				break;
		}
		this.__update(pageSelected);
	};
	
	NSPagination.prototype.__pageItemClickHandler = function(event)
	{
		var target = this.util.getTarget(event);
		target = this.util.findParent(target,"li");
		var index = parseInt(target.getAttribute("pageNum"));
		this.__update(index);
	};
	
	NSPagination.prototype.__createItem = function(pageNumber,htmlText,titleText,clickHandler)
	{
		var pageItem = this.util.createElement("li",this.__getID() + "Page" + pageNumber,null);
		pageItem.setAttribute("pageNum",pageNumber);
		pageItem.setAttribute("title",titleText);
		this.util.addEvent(pageItem,"click",clickHandler.bind(this));
		var pageText = this.util.createElement("a",null,null);
		pageText.setAttribute("href","javascript:void(0);");
		pageText.innerHTML = htmlText;
		pageItem.appendChild(pageText);
		this.__container.appendChild(pageItem);
		return pageItem;
	};
	
	NSPagination.prototype.__update = function(pageNumber)
	{
		if(pageNumber <= 0)
		{
			pageNumber = 1;
		}
		else if(pageNumber > this.__pageCount)
		{
			pageNumber = this.__pageCount;
		}
		var range = this.__calculateRange(this.__pageCount,Math.min(this.__pageCount,this.__config.visiblePages),pageNumber);
		this.__updateItem(range[0],range[1]);
		this.__selectPage(pageNumber);
		this.__updateControlState(pageNumber);
	};
	
	NSPagination.prototype.__updateItem = function(fromPage,toPage)
	{
		var firstNumber = parseInt(this.__arrItemPage[0].getAttribute("pageNum"));
		var lastNumber = parseInt(this.__arrItemPage[this.__arrItemPage.length - 1].getAttribute("pageNum"));
		if(!(firstNumber === fromPage && lastNumber === toPage))
		{
			for(var count = 0;count < this.__arrItemPage.length;count++)
			{
				var pageItem = this.__arrItemPage[count];
				var index = count + fromPage;
				pageItem.setAttribute("pageNum",index);
				pageItem.setAttribute("title",this.__config.textTitlePagePrefix + " " + index);
				var pageText = pageItem.firstChild;
				pageText.innerHTML = index;
			}
		}
	};
	
	NSPagination.prototype.__updateControlState = function(pageNumber)
	{
		if(pageNumber === 1)
		{
			this.__itemFirst ? this.util.addStyleClass(this.__itemFirst,this.__config.disabledStyle) : "";
			this.__itemPrev ? this.util.addStyleClass(this.__itemPrev,this.__config.disabledStyle) : "";
		}
		else
		{
			this.__itemFirst ? this.util.removeStyleClass(this.__itemFirst,this.__config.disabledStyle) : "";
			this.__itemPrev ? this.util.removeStyleClass(this.__itemPrev,this.__config.disabledStyle) : "";
		}
		if(pageNumber === this.__pageCount)
		{
			this.__itemNext ? this.util.addStyleClass(this.__itemNext,this.__config.disabledStyle) : "";
			this.__itemLast ? this.util.addStyleClass(this.__itemLast,this.__config.disabledStyle) : "";
		}
		else
		{
			this.__itemNext ? this.util.removeStyleClass(this.__itemNext,this.__config.disabledStyle) : "";
			this.__itemLast ? this.util.removeStyleClass(this.__itemLast,this.__config.disabledStyle) : "";
		};
	};
	
	NSPagination.prototype.__calculateRange = function(totalPages,visiblePages,pageToBeSelected)
	{
		var renderPage = [1,totalPages];
		var limit = Math.floor(visiblePages/2);
		if(visiblePages > 0)
		{
			renderPage[0] = Math.max(pageToBeSelected - limit, 1);
			renderPage[1] = Math.min(pageToBeSelected + limit, totalPages);
			var difference = renderPage[1] - renderPage[0];
			if(renderPage[0] === 1 && difference < visiblePages)
			{
				renderPage[1] = visiblePages;
			}
			else if(renderPage[1] === totalPages && difference < visiblePages)
			{
				renderPage[0] = renderPage[1] - visiblePages + 1;
			}
		}
		return renderPage;
	};
	
	NSPagination.prototype.__selectPage = function(pageIndex)
	{
		var selectedIndex = -1;
		for(var count = 0;count < this.__arrItemPage.length;count++)
		{
			var pageItem = this.__arrItemPage[count];
			this.util.removeStyleClass(pageItem,this.__config.activeStyle);
			var index = parseInt(pageItem.getAttribute("pageNum"));
			if(index === pageIndex)
			{
				selectedIndex = count;
			}
		}
		if(selectedIndex > -1)
		{
			var oldPage = this.__selectedPage;
			this.util.addStyleClass(this.__arrItemPage[selectedIndex],this.__config.activeStyle);
			this.__selectedPage = pageIndex;
			var fromRecord =  (pageIndex - 1) * this.__config.pageSize;
			var toRecord = fromRecord +  this.__config.pageSize - 1;
			toRecord = (toRecord < this.__config.totalRecords) ? toRecord : ((toRecord === this.__config.totalRecords) ? this.__config.totalRecords - 1 : this.__config.totalRecords);
			var item = {oldIndex:oldPage,newIndex:this.__selectedPage,fromRecord:fromRecord,toRecord:toRecord};
			this.util.dispatchEvent(this.__config.parent,this.PAGE_CLICK,item,item);
			if(oldPage !== this.__selectedPage)
			{
				this.util.dispatchEvent(this.__config.parent,this.PAGE_CHANGE,item,item);
			}
		}
	};
	
	NSPagination.prototype.__getID = function()
	{
		if(!this.__id)
		{
			if(this.__config.parent.hasAttribute("id"))
			{
				this.__id = this.__config.parent.getAttribute("id");
			}
			else if(this.__config.parent.hasAttribute("name"))
			{
				this.__id = this.__config.parent.getAttribute("name");
			}
			else
			{
				this.__id = "comp" + this.util.getUniqueId();
			}
		}
		return this.__id;
	};
	
	return NSPagination;
})();
nsModuleExport(this,"NSPagination",NSPagination);
var NSExport = (function()
{
	//DONOT REMOVE: taken from https://gist.github.com/sevir/3946819
	if (window && !window.atob && !window.btoa)
	{
	 ( function( window ) {
	    var _PADCHAR = "=",
	      _ALPHA = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	   
	    function _getbyte64( s, i ) { 
	      var idx = _ALPHA.indexOf( s.charAt( i ) );
	   
	      if ( idx === -1 ) {
	        throw "Cannot decode base64";
	      }
	   
	      return idx;
	    }
	   
	    function _decode( s ) {
	      var pads = 0,
	        i,
	        b10,
	        imax = s.length,
	        x = [];
	   
	      s = String( s );
	   
	      if ( imax === 0 ) {
	        return s;
	      }
	   
	      if ( imax % 4 !== 0 ) {
	        throw "Cannot decode base64";
	      }
	   
	      if ( s.charAt( imax - 1 ) === _PADCHAR ) {
	        pads = 1;
	   
	        if ( s.charAt( imax - 2 ) === _PADCHAR ) {
	          pads = 2;
	        }
	   
	        // either way, we want to ignore this last block
	        imax -= 4;
	      }
	   
	      for ( i = 0; i < imax; i += 4 ) {
	        b10 = ( _getbyte64( s, i ) << 18 ) | ( _getbyte64( s, i + 1 ) << 12 ) | ( _getbyte64( s, i + 2 ) << 6 ) | _getbyte64( s, i + 3 );
	        x.push( String.fromCharCode( b10 >> 16, ( b10 >> 8 ) & 0xff, b10 & 0xff ) );
	      }
	   
	      switch ( pads ) {
	        case 1:
	          b10 = ( _getbyte64( s, i ) << 18 ) | ( _getbyte64( s, i + 1 ) << 12 ) | ( _getbyte64( s, i + 2 ) << 6 );
	          x.push( String.fromCharCode( b10 >> 16, ( b10 >> 8 ) & 0xff ) );
	          break;
	   
	        case 2:
	          b10 = ( _getbyte64( s, i ) << 18) | ( _getbyte64( s, i + 1 ) << 12 );
	          x.push( String.fromCharCode( b10 >> 16 ) );
	          break;
	      }
	   
	      return x.join( "" );
	    }
	   
	    function _getbyte( s, i ) {
	      var x = s.charCodeAt( i );
	   
	      if ( x > 255 ) {
	        throw "INVALID_CHARACTER_ERR: DOM Exception 5";
	      }
	   
	      return x;
	    }
	   
	    function _encode( s ) {
	      if ( arguments.length !== 1 ) {
	        throw "SyntaxError: exactly one argument required";
	      }
	   
	      s = String( s );
	   
	      var i,
	        b10,
	        x = [],
	        imax = s.length - s.length % 3;
	   
	      if ( s.length === 0 ) {
	        return s;
	      }
	   
	      for ( i = 0; i < imax; i += 3 ) {
	        b10 = ( _getbyte( s, i ) << 16 ) | ( _getbyte( s, i + 1 ) << 8 ) | _getbyte( s, i + 2 );
	        x.push( _ALPHA.charAt( b10 >> 18 ) );
	        x.push( _ALPHA.charAt( ( b10 >> 12 ) & 0x3F ) );
	        x.push( _ALPHA.charAt( ( b10 >> 6 ) & 0x3f ) );
	        x.push( _ALPHA.charAt( b10 & 0x3f ) );
	      }
	   
	      switch ( s.length - imax ) {
	        case 1:
	          b10 = _getbyte( s, i ) << 16;
	          x.push( _ALPHA.charAt( b10 >> 18 ) + _ALPHA.charAt( ( b10 >> 12 ) & 0x3F ) + _PADCHAR + _PADCHAR );
	          break;
	   
	        case 2:
	          b10 = ( _getbyte( s, i ) << 16 ) | ( _getbyte( s, i + 1 ) << 8 );
	          x.push( _ALPHA.charAt( b10 >> 18 ) + _ALPHA.charAt( ( b10 >> 12 ) & 0x3F ) + _ALPHA.charAt( ( b10 >> 6 ) & 0x3f ) + _PADCHAR );
	          break;
	      }
	   
	      return x.join("");
	    }
	
	    window.btoa = _encode;
	    window.atoa = _decode;
	   
	  })( window );
	}
	
	"use strict"; 
	function NSExport(grid,fileName,extPath,ignoreColumn) 
	{
		this.__grid = grid;
		this.__fileName = fileName;
		this.__ignoreColumn = ignoreColumn;
		this.__extFilePath = extPath ? extPath : "../lib/com/ext";
		this.util = new NSUtil();
		this.__defaultDelimiter = ",";
		this.__defaultNewLine = "\r\n";
		this.__externalScriptLoad = {jspdf:false,html2canvas:false};
	}
	
	//Orientation: portrait or landscape
	NSExport.prototype.word = function(setting) 
	{
		if(setting)
		{
			if(setting.type === "doc")
			{
				var docSetting = {appType:"doc",extension:"doc",event:setting.event,orientation:setting.orientation,element:setting.element,pageBreakTag:setting.pageBreakTag,headerFooterCss:"",startHtml:"",endHtml:""};
				if(setting.hasHeaderOrFooter)
	            {
	            	docSetting.headerFooterCss = setting.headerFooterCss || "";
	            	docSetting.startHtml = setting.startHtml || "";
	            	docSetting.endHtml = setting.endHtml || "";
	            }
				if(setting.enablePageNumber)
				{
					docSetting.headerFooterCss += "p.MsoHeader, li.MsoHeader, div.MsoHeader{     margin:0in;     margin-top:.0001pt;     mso-pagination:widow-orphan;     tab-stops:center 3.0in right 6.0in; } p.MsoFooter, li.MsoFooter, div.MsoFooter{     margin:0in 0in 1in 0in;     margin-bottom:.0001pt;     mso-pagination:widow-orphan;     tab-stops:center 3.0in right 6.0in; } .footer {     font-size: 9pt; } @page Section1{     size:8.5in 11.0in;     margin:0.5in 0.5in 0.5in 0.5in;     mso-header-margin:0.5in;     mso-header:h1;     mso-footer:f1;     mso-footer-margin:0.5in;     mso-paper-source:0; } div.Section1{     page:Section1; } table#hrdftrtbl{     margin:0in 0in 0in 9in; }";
					docSetting.startHtml = "<div class=\"Section1\">" + docSetting.startHtml; 
					docSetting.endHtml += "<table id=\"hrdftrtbl\" border=\"1\" cellspacing=\"0\" cellpadding=\"0\"> <tr> <td> <div style=\"mso-element:footer\" id=\"f1\"> <p class=\"MsoFooter\"> <table width=\"100%\" border=\"0\" cellspacing=\"0\" cellpadding=\"0\"> <tr> <td align=\"center\" class=\"footer\"> <g:message code=\"offer.letter.page.label\"/> <span style=\"mso-field-code: PAGE \"></span> of <span style=\"mso-field-code: NUMPAGES \"></span> </td> </tr> </table> </p> </div> </td> </tr> </table> </div>";;
				}
				this.__exportOfficeTypes(docSetting);
			}
			else
			{
				if(!setting.orientation || (setting.orientation !== "portrait" && setting.orientation !== "landscape"))
				{
					this.util.warning("NSExport","Docx type value was either not valid or not in the correct format.Hence defaulting to portrait");
					setting.orientation = "portrait";
				}
				var docSetting = {appType:"doc",element:setting.element,pageBreakTag:setting.pageBreakTag,headerFooterCss:"",startHtml:"",endHtml:""};
				if(setting.hasHeaderOrFooter)
	            {
	            	docSetting.headerFooterCss = setting.headerFooterCss;
	            	docSetting.startHtml = setting.startHtml;
	            	docSetting.endHtml = setting.endHtml;
	            }
				var htmlText = this.__getHTMLTextForOffice(docSetting);
				if(htmlText && htmlText.length > 0)
				{
					var fileName = this.__getFileName("docx");
					var exportSetting = {fileName:fileName,htmlSetting:{html:htmlText,htmlStyle: setting.extraStyle,loopNodesCallback: setting.loopNodesCallback},printSetting:{orientation: setting.orientation}};
					var docxExport = new NSDocxExport(exportSetting);
					docxExport.process();
				}
			}
		}
	};
	
	NSExport.prototype.powerpoint = function(setting) 
	{
		if(setting)
		{
			var docSetting = {appType:"powerpoint",extension:"ppt",event:setting.event,element:setting.element};
			this.__exportOfficeTypes(docSetting);
		}
	};
	
	NSExport.prototype.excel = function(setting) 
	{
		if(setting)
		{
			if(setting.type === "xls")
			{
				var docSetting = {appType:"excel",extension:"xls",sheetName:setting.sheetName,event:setting.event,element:setting.element,properties:setting.properties};
				this.__exportOfficeTypes(docSetting);
			}
			else
			{
				var objXslxExport = new this.xslxExport(this,setting.sheetName,setting.event,setting.properties);
				objXslxExport.exportToxlsx();
			}
		}
	};
	
	NSExport.prototype.csv = function(event) 
	{ 
		var csvText = this.__getTableAsString(this.__defaultDelimiter,this.__defaultNewLine);
		if(csvText)
		{
			var uri = "application/csv";
			this.__downloadFile(csvText,uri,"csv",event);
		}
	};
	
	NSExport.prototype.xml = function(event) 
	{ 
		var xmlText = this.__getTableAsXML();
		if(xmlText)
		{
			var uri = "application/xml";
			this.__downloadFile(xmlText,uri,"xml",event);
		}
	};
	
	NSExport.prototype.text = function(event) 
	{ 
		var csvText = this.__getTableAsString(this.__defaultDelimiter,this.__defaultNewLine,"-");
		if(csvText)
		{
			var uri = "application/txt";
			this.__downloadFile(csvText,uri,"txt",event);
		}
	};
	
	NSExport.prototype.json = function(event) 
	{ 
		var jsonText = this.__getTableAsJson();
		if(jsonText)
		{
			var uri = "application/json";
			this.__downloadFile(jsonText,uri,"json",event);
		}
	};
	
	NSExport.prototype.pdf = function(event,setting) 
	{ 
		this.__processPDF = function()
		{
			this.__externalScriptLoad.jspdf = true;
			if(!setting)
			{
				setting = {};
			}
			var config = {
					fontSize: setting["fontSize"] || 14,
					width: setting["width"] || 1200,
					topMargin: setting["topMargin"] || 30,
					bottomMargin: setting["bottomMargin"] || 60,
					leftMargin: setting["leftMargin"] || 60,
					maxWidth: setting["maxWidth"] || 550
			};
			var divSource = this.__getStructureForPDF(config.width,config.fontSize);
			document.body.appendChild(divSource);
			var pdf = new jsPDF("p", "pt", "ledger");
			// we support special element handlers. Register them with jQuery-style 
		    // ID selector for either ID or node name. ("#iAmID", "div", "span" etc.)
		    // There is no support for any other type of selectors 
		    // (class, of compound) at this time.
			specialElementHandlers = 
			{
		        // element with id of "bypass" - jQuery style selector
		        '#bypassme' : function(element, renderer) {
		            // true = "handled elsewhere, bypass text extraction"
		            return true;
		        }
		    };
		    margins = {
		        top : config.topMargin,
		        bottom : config.bottomMargin,
		        left : config.leftMargin,
		        width : config.maxWidth
		    };
		    var self =  this;
		    // all coords and widths are in jsPDF instance's declared units
		    // 'inches' in this case
		    pdf.fromHTML(divSource, // HTML string or DOM elem ref.
		    margins.left, // x coord
		    margins.top, { // y coord
		        'width' : margins.width, // max width of content on PDF
		        'elementHandlers' : specialElementHandlers
		    },
	
		    function(dispose) {
		        // dispose: object with X, Y of the last line add to the PDF 
		        //          this allow the insertion of new lines after html
		        pdf.save(self.__getFileName("pdf"));
				document.body.removeChild(divSource);
		    }, margins);
		};
		if(!this.__externalScriptLoad.jspdf)
		{
			this.__includeJavaScriptFile(this.__extFilePath + "/jspdf/jspdf.min.js",this.__processPDF.bind(this));
		}
		else
		{
			this.__processPDF.bind(this)();
		}
	};
	
	NSExport.prototype.image = function(setting) 
	{
		if(!setting)
		{
			setting = {};
		}
		this.__processImage = function()
		{
			this.__externalScriptLoad.html2canvas = true;
			if(!setting.type || (setting.type !== "png" && setting.type !== "jpeg"))
			{
				this.util.warning("NSExport","Image type value was either not valid or not in the correct format.Hence defaulting to png");
				setting.type = "png";
			}
			var imageType = "image/" + setting.type; 
			var divParent = this.__getStructureForImage();
			if(divParent)
			{
				var nsExport = this;
				html2canvas(divParent,{
					onrendered: function(canvas) {		
						//document.body.appendChild(canvas);
						var data = canvas.toDataURL(imageType);
						if(!data || data === "data:,")
						{
							nsExport.util.throwNSError("NSExport","Please give table some width and height");
						}
						else
						{
							nsExport.__downloadFile(data,imageType,setting.type);
						}
					}
				});	
			}
			else
			{
				this.util.throwNSError("NSExport","Please add the table inside a parent Element");
			}
		};
		if(!this.__externalScriptLoad.html2canvas)
		{
			this.__includeJavaScriptFile(this.__extFilePath + "/html2canvas/html2canvas.min.js",this.__processImage.bind(this));
		}
		else
		{
			this.__processImage.bind(this)();
		}
	};
	
	NSExport.prototype.__exportOfficeTypes = function(setting) 
	{
		var htmlText = this.__getHTMLTextForOffice(setting);
		if(htmlText && htmlText.length > 0)
		{
			var uri = "application/vnd.ms-" + setting.appType;
			if(setting.extension === "doc")
			{
				uri = "application/msword";
			}
			this.__downloadFile(htmlText,uri,setting.extension,setting.event);
		}
	};
	
	NSExport.prototype.__getHTMLTextForOffice = function(setting) 
	{
		var appType = setting.appType;
		var element = setting.element;
		var headerFooterCss = setting.headerFooterCss ? setting.headerFooterCss : "";
	    var startHtml = setting.startHtml ? setting.startHtml : "";
	    var endHtml = setting.endHtml ? setting.endHtml : "";
		var htmlText = "";
		var outerHTML = null;
		var isTable =  false;
		if(element)
		{
			outerHTML = element.outerHTML;
		}
		else
		{
			var table = this.__getTable();
			if(table)
			{
				outerHTML = table.outerHTML;
			}
			isTable = true;
		}
		var objValue = {};
		switch(appType)
		{
			case "doc":
				objValue = this.__getHTMLTextForWord(setting,outerHTML,isTable);
			break;
			case "excel":
				objValue = this.__getHTMLTextForExcel(setting,outerHTML,isTable);
			break;
			case "powerpoint":
				objValue = this.__getHTMLTextForPpt(setting,outerHTML,isTable);
			break;
		}
		if(outerHTML)
		{
			objValue.style = (objValue.style) ? objValue.style : "";
			htmlText = '<html  xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:' + appType +'" xmlns="http://www.w3.org/TR/REC-html40">';
			htmlText += '<head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8">';
			htmlText +='<!--[if gte mso 9]><xml>';
			htmlText += objValue.header;
			htmlText += '</xml><![endif]-->';
		    //htmlText +="<o:shapedefaults v:ext=\"edit\" spidmax=\"1026\"/>";
			htmlText += '<style>' + objValue.style + headerFooterCss + '.header{mso-style-parent:style0;color:white;font-size:10.0pt;font-weight:700;font-family:Tahoma, sans-serif;mso-font-charset:0;text-align:center;background:gray;mso-pattern:black none;}</style>';
			htmlText += '</head>';
			htmlText += '<body link="blue" vlink="purple">';
			htmlText += startHtml + objValue.html + endHtml;
			htmlText += '</body></html>';
		}
		return htmlText;
	};
	
	NSExport.prototype.__getHTMLTextForWord = function(setting,html,isTable)
	{
		var objReturn = {header:null,style:null,html:html};
		objReturn.header = "<w:WordDocument><w:View>Print</w:View><w:Zoom>100</w:Zoom><w:DoNotOptimizeForBrowser/></w:WordDocument>";
		if(isTable)
		{
			objReturn.style = 'table{border-collapse: collapse;} table, th, td {border: 1px solid black;} ';
		}
		if(setting["pageBreakTag"])
		{
			objReturn.html = objReturn.html.replaceAll(setting["pageBreakTag"],"<br clear=all style='mso-special-character:line-break;page-break-before:always'>");
		}
		return objReturn;
	};
	
	NSExport.prototype.__getHTMLTextForExcel = function(setting,html,isTable)
	{
		var objReturn = {header:null,style:null,html:html};
		objReturn.header = "<x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>";
		objReturn.header += (setting["sheetName"] ? setting["sheetName"]: ((this.__fileName ? this.__fileName : "Sheet 1")));
		objReturn.header += '</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook>';
		return objReturn;
	};
	
	NSExport.prototype.__getHTMLTextForPpt = function(setting,html,isTable)
	{
		var objReturn = {header:null,style:null,html:html};
		objReturn.header = "<x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>";
		objReturn.header += (setting["sheetName"] ? setting["sheetName"]: ((this.__fileName ? this.__fileName : "Sheet 1")));
		objReturn.header += '</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook>';
		return objReturn;
	};
	
	NSExport.prototype.__downloadFile = function(text,uri,fileType,event) 
	{
		if(text && fileType)
		{
			if ("Blob" in window) 
			{
				var fileName = this.__getFileName(fileType);
				if ("msSaveOrOpenBlob" in window.navigator) 
				{
					var blobObject = null;
					if(text instanceof Blob)
					{
						blobObject = text;
					}
					else if(!(text instanceof ArrayBuffer) && text.indexOf("base64") > -1)
					{
						blobObject = this.__dataURItoBlob(text);
					}
					else
					{
						blobObject = new Blob([text], { type: uri});
					}
					window.navigator.msSaveOrOpenBlob(blobObject,fileName);
				}
				else
				{
					var hrefvalue = null;
					if(text instanceof ArrayBuffer)
					{
						var blobObject = new Blob([text], {type: uri});
						hrefvalue = URL.createObjectURL(blobObject);
					}
					else if(text instanceof Blob)
					{
						hrefvalue = URL.createObjectURL(text);
					}
					else
					{
						if(text.indexOf("data:") === -1)
						{
							uri = "data:" + uri;
						}
						if(text.indexOf(";base64,") === -1)
						{
							var base64String = ";base64," + window.btoa(window.unescape(encodeURIComponent(text)));
							hrefvalue = uri + base64String;
						}
						else
						{
							hrefvalue = text;
						}
					}
					
				    var anchor = document.createElement("a");
				    if ("webkitURL" in window) 
				    {
				          // Chrome allows the link to be clicked without actually adding it to the DOM.
				    	//hrefvalue = window.webkitURL.createObjectURL([hrefvalue]);
				    }
				    else
				    {
				    	//hrefvalue = window.URL.createObjectURL([hrefvalue]);
				    	anchor.style.display = 'none';
				        document.body.appendChild(anchor);
				        this.util.addEvent(anchor,"click",function(event){
				    		document.body.removeChild(event.target);
				    	});
				    }
				    anchor.setAttribute("href",hrefvalue);
				    anchor.setAttribute("download",this.__getFileName(fileType));
				    anchor.setAttribute("target","_blank");
				    anchor.innerHTML = "Download File";
				    /*if(window.URL && window.URL.revokeObjectURL)
				    {
				    	window.URL.revokeObjectURL(hrefvalue);
				    }*/
				    anchor.click();
				    if(event)
				    {
				    	this.util.preventDefault(event);
				    }
				}
			}
		}
	};
	
	NSExport.prototype.__getTable = function() 
	{ 
		var tblResult = null;
		if(this.__grid)
		{
			var grid = this.__getPrototype(this.__grid);
			if(grid && this.__isTypeNSGrid(grid))
			{
				var tblHeader = grid.__tblCenterHeader;
		    	var tblBody = grid.__tblCenterBody;
		    	tblResult = document.createElement("TABLE");
		    	tblResult.style.width = tblHeader.style.width;
		    	if(tblHeader && tblHeader.tBodies && tblHeader.tBodies.length > 0 && tblHeader.tBodies[0].rows && tblHeader.tBodies[0].rows.length > 0)
				{
		    		var arrColumns = grid.__columns;
		    		if(grid.gridType === grid.GRID_TYPE_GROUP)
					{
						arrColumns = grid.util.cloneObject(arrColumns);
						arrColumns.splice(0, 1);
					}
		    		var header = tblResult.createTHead();
		    		var headerRow = header.insertRow(-1);
		    		var rowIndex = 0;
		    		var colIndex = 0;
			        for(colIndex = 0; colIndex < arrColumns.length; colIndex++)
			        {
			        	var colItem = arrColumns[colIndex];
			        	if(colItem && (!colItem.hasOwnProperty(grid.__fieldColVisible) || colItem[grid.__fieldColVisible]) && (!colItem.hasOwnProperty("isExportable") || Boolean.parse(colItem["isExportable"])))
			        	{
			        		var headerCell = headerRow.insertCell(-1);
			        		this.util.addStyleClass(headerCell,"header");
				    		headerCell.style.width = colItem["width"]; 
				    		var headerText = colItem["headerText"];
				    		headerCell.appendChild(document.createTextNode(headerText));
			        	}
			        }
			        if(tblBody && tblBody.tBodies && tblBody.tBodies.length > 0 && tblBody.tBodies[0].rows && tblBody.tBodies[0].rows.length > 0)
					{
			        	var arrItems = grid.__getAllItems();
			        	var body = document.createElement("tbody");
			        	tblResult.appendChild(body);
			        	var colText = "";
			        	var row = null;
			        	for(rowIndex = 0;rowIndex < arrItems.length;rowIndex++)
			 	        {
			        		var item = arrItems[rowIndex];
			        		if(!item.hasOwnProperty(grid.__fieldRowVisible) || item[grid.__fieldRowVisible])
			        		{
				        		var bodyRow = body.insertRow(-1);
				        		for(colIndex = 0;colIndex < arrColumns.length;colIndex++)
				    	        {
				        			var colItem = arrColumns[colIndex];
				        			if(colItem && (!colItem.hasOwnProperty(grid.__fieldColVisible) || colItem[grid.__fieldColVisible]) && (!colItem.hasOwnProperty("isExportable") || Boolean.parse(colItem["isExportable"])))
				    	        	{
				        				colText = item[colItem["dataField"]];
										if(colItem.hasOwnProperty("exportRenderer"))
										{
											colText = colItem["exportRenderer"](item,colItem["dataField"],item[grid.__fieldIndex],count);
										}
				        				var bodyCell = bodyRow.insertCell(-1);
					        			bodyCell.style.width = colItem["width"]; 
					    	    		bodyCell.innerHTML = colText;
				    	        	}
				    	        }
			        		}
			 	        }
					}
				}
			}
			else
			{
				tblResult = this.__grid.cloneNode(true);
				if(tblResult.tHead && tblResult.tHead.rows && tblResult.tHead.rows.length > 0)
				{
					var headerRow = tblResult.tHead.rows[0];
					if(headerRow)
					{
						var arrCells = [];
						var arrTempCells = [];
						if(headerRow.getElementsByTagName("th").length > 0)
						{
							arrTempCells = headerRow.getElementsByTagName("th");
						}
						else if(headerRow.getElementsByTagName("td").length > 0)
						{
							arrTempCells = headerRow.getElementsByTagName("td");
						}
						arrCells = Array.prototype.slice.call(arrTempCells).slice(0);
			    		var colIndex = 0;
			    		var cell = null;
			    		for(colIndex = arrCells.length - 1; colIndex >= 0; colIndex--)
				        {
			    			headerRow.deleteCell(colIndex);
				        }
				        for(colIndex = 0; colIndex < arrCells.length; colIndex++)
				        {
				        	cell = arrCells[colIndex];
				        	var headerCell = headerRow.insertCell(-1);
				        	headerCell.style.width = cell.offsetWidth + "px";
				        	headerCell.color = "red";
				        	headerCell.appendChild(document.createTextNode(cell.textContent.trim()));
				        	this.util.addStyleClass(headerCell,"header");
				        }
					}
				}
			}
			if(tblResult)
			{
				tblResult.setAttribute("border",0);
		    	tblResult.setAttribute("cellpadding",0);
		    	tblResult.setAttribute("cellspacing",0);
		    	tblResult.setAttribute("style","border-collapse:collapse;table-layout:fixed;");
			}
		}
		return tblResult;
	};
	
	NSExport.prototype.__getTableAsString = function(delimiter,newLine,headerSeparator) 
	{ 
		var strResult = "";
		if(this.__grid)
		{
			var grid = this.__getPrototype(this.__grid);
			if(grid && this.__isTypeNSGrid(grid))
			{
				var tblHeader = grid.__tblCenterHeader;
		    	var tblBody = grid.__tblCenterBody;
		    	if(tblHeader && tblHeader.tBodies && tblHeader.tBodies.length > 0 && tblHeader.tBodies[0].rows && tblHeader.tBodies[0].rows.length > 0)
				{
		    		var arrColumns = grid.__columns;
		    		if(grid.gridType === grid.GRID_TYPE_GROUP)
					{
						arrColumns = grid.util.cloneObject(arrColumns);
						arrColumns.splice(0, 1);
					}
		    		var rowIndex = 0;
		    		var colIndex = 0;
		    		var cell = null;
		    		var arrCollItem = [];
			        for(colIndex = 0; colIndex < arrColumns.length; colIndex++)
			        {
			        	var colItem = arrColumns[colIndex];
			        	if(colItem && (!colItem.hasOwnProperty(grid.__fieldColVisible) || colItem[grid.__fieldColVisible]) && (!colItem.hasOwnProperty("isExportable") || Boolean.parse(colItem["isExportable"])))
			        	{
				    		var headerText = colItem["headerText"];
				    		if(colIndex > 0)
				    		{
				    			strResult += delimiter;
				    		}
				    		strResult += this.__getFieldValue(headerText,delimiter);
			        	}
			        }
			        strResult += newLine;
			        if(headerSeparator)
			        {
			        	var separatorLength = strResult.length + 20;
			        	for(var count = 0;count < separatorLength;count++)
			 	        {
			        		strResult += headerSeparator;
			 	        }
			        	strResult += newLine;
			        }
			        if(tblBody && tblBody.tBodies && tblBody.tBodies.length > 0 && tblBody.tBodies[0].rows && tblBody.tBodies[0].rows.length > 0)
					{
			        	var arrItems = grid.__getAllItems();
			        	var colText = "";
			        	for(rowIndex = 0;rowIndex < arrItems.length;rowIndex++)
			 	        {
			        		var item = arrItems[rowIndex];
			        		if(!item.hasOwnProperty(grid.__fieldRowVisible) || item[grid.__fieldRowVisible])
			        		{
				        		for(colIndex = 0;colIndex < arrColumns.length;colIndex++)
				    	        {
				        			var colItem = arrColumns[colIndex];
				        			if(colItem && (!colItem.hasOwnProperty(grid.__fieldColVisible) || colItem[grid.__fieldColVisible]) && (!colItem.hasOwnProperty("isExportable") || Boolean.parse(colItem["isExportable"])))
				    	        	{
				        				if(colIndex > 0)
							    		{
							    			strResult += delimiter;
							    		}
				        				colText = item[colItem["dataField"]];
										if(colItem.hasOwnProperty("exportRenderer"))
										{
											colText = colItem["exportRenderer"](item,colItem["dataField"],item[grid.__fieldIndex],count);
										}
				        				strResult += this.__getFieldValue(colText,delimiter);
				    	        	}
				    	        }
				        		strResult += newLine;
			        		}
			 	        }
					}
				}
			}
			else
			{
				if(this.__grid.tHead && this.__grid.tHead.rows && this.__grid.tHead.rows.length > 0)
				{
					var headerRow = this.__grid.tHead.rows[0];
					if(headerRow)
					{
						var arrCells = [];
						if(headerRow.getElementsByTagName("th").length > 0)
						{
							arrCells = headerRow.getElementsByTagName("th");
						}
						else if(headerRow.getElementsByTagName("td").length > 0)
						{
							arrCells = headerRow.getElementsByTagName("td");
						}
			    		var colIndex = 0;
			    		var cell = null;
				        for(colIndex = 0; colIndex < arrCells.length; colIndex++)
				        {
				        	if(!this.__isColumnIgnored(colIndex))
				        	{
					        	cell = arrCells[colIndex];
					    		var headerText = cell.textContent.trim();
					    		if(colIndex > 0)
					    		{
					    			strResult += delimiter;
					    		}
					    		strResult += this.__getFieldValue(headerText,delimiter);
				        	}
				        }
				        strResult += newLine;
				        if(headerSeparator)
				        {
				        	var separatorLength = strResult.length + 20;
				        	for(var count = 0;count < separatorLength;count++)
				 	        {
				        		strResult += headerSeparator;
				 	        }
				        	strResult += newLine;
				        }
					}
				}
				if(this.__grid.tBodies && this.__grid.tBodies.length > 0 && this.__grid.tBodies[0].rows && this.__grid.tBodies[0].rows.length > 0)
				{
					var arrRows = this.__grid.tBodies[0].rows;
		    		var rowIndex = 0;
		    		var colIndex = 0;
		    		for(rowIndex = 0;rowIndex < arrRows.length;rowIndex++)
		 	        {
		        		var row = arrRows[rowIndex];
		        		var cells = row.cells;
		        		for(colIndex = 0;colIndex < cells.length;colIndex++)
		    	        {
		        			if(!this.__isColumnIgnored(colIndex))
				        	{
			        			var cell = cells[colIndex];
			        			if(colIndex > 0)
					    		{
					    			strResult += delimiter;
					    		}
			        			strResult += this.__getFieldValue(cell.textContent.trim());
				        	}
		    	        }
		        		strResult += newLine;
		 	        }
				}
			}
		}
		return strResult;
	};
	
	NSExport.prototype.__getTableAsXML = function() 
	{ 
		var strXML = "";
		if(this.__grid)
		{
			strXML = '<?xml version="1.0" encoding="utf-8"?>';
			strXML += '<root>';
			var grid = this.__getPrototype(this.__grid);
			if(grid && this.__isTypeNSGrid(grid))
			{
				var tblHeader = grid.__tblCenterHeader;
		    	var tblBody = grid.__tblCenterBody;
		    	if(tblHeader && tblHeader.tBodies && tblHeader.tBodies.length > 0 && tblHeader.tBodies[0].rows && tblHeader.tBodies[0].rows.length > 0)
				{
		    		strXML += '<columns>';
		    		var arrColumns = grid.__columns;
		    		if(grid.gridType === grid.GRID_TYPE_GROUP)
					{
						arrColumns = grid.util.cloneObject(arrColumns);
						arrColumns.splice(0, 1);
					}
		    		var rowIndex = 0;
		    		var colIndex = 0;
		    		var cell = null;
		    		var arrCollItem = [];
			        for(colIndex = 0; colIndex < arrColumns.length; colIndex++)
			        {
			        	var colItem = arrColumns[colIndex];
			        	if(colItem && (!colItem.hasOwnProperty(grid.__fieldColVisible) || colItem[grid.__fieldColVisible]) && (!colItem.hasOwnProperty("isExportable") || Boolean.parse(colItem["isExportable"])))
			        	{
				    		var headerText = colItem["headerText"];
				    		strXML += "<column>" + headerText + "</column>";
			        	}
			        }
			        strXML += '</columns>';
			        if(tblBody && tblBody.tBodies && tblBody.tBodies.length > 0 && tblBody.tBodies[0].rows && tblBody.tBodies[0].rows.length > 0)
					{
			        	strXML += '<rows>';
			        	var arrItems = grid.__getAllItems();
			        	var colText = "";
			        	var rowCounter = 1;
			        	for(rowIndex = 0;rowIndex < arrItems.length;rowIndex++)
			 	        {
			        		var item = arrItems[rowIndex];
			        		if(!item.hasOwnProperty(grid.__fieldRowVisible) || item[grid.__fieldRowVisible])
			        		{
			        			strXML += '<row id="row-'+ rowCounter++ +'">';
								var colCounter = 1;
				        		for(colIndex = 0;colIndex < arrColumns.length;colIndex++)
				    	        {
				        			var colItem = arrColumns[colIndex];
				        			if(colItem && (!colItem.hasOwnProperty(grid.__fieldColVisible) || colItem[grid.__fieldColVisible]) && (!colItem.hasOwnProperty("isExportable") || Boolean.parse(colItem["isExportable"])))
				    	        	{
				        				colText = item[colItem["dataField"]];
										if(colItem.hasOwnProperty("exportRenderer"))
										{
											colText = colItem["exportRenderer"](item,colItem["dataField"],item[grid.__fieldIndex],count);
										}
				        				strXML += '<column id="column-'+ colCounter++ +'">';
				        				strXML += colText;
				        				strXML += '</column>';
				    	        	}
				    	        }
				        		strXML += '</row>';
			        		}
			 	        }
			        	strXML += '</rows>';
					}
				}
			}
			else
			{
				if(this.__grid.tHead && this.__grid.tHead.rows && this.__grid.tHead.rows.length > 0)
				{
					var headerRow = this.__grid.tHead.rows[0];
					if(headerRow)
					{
						var arrCells = [];
						if(headerRow.getElementsByTagName("th").length > 0)
						{
							arrCells = headerRow.getElementsByTagName("th");
						}
						else if(headerRow.getElementsByTagName("td").length > 0)
						{
							arrCells = headerRow.getElementsByTagName("td");
						}
						strXML += '<columns>';
			    		var colIndex = 0;
			    		var cell = null;
				        for(colIndex = 0; colIndex < arrCells.length; colIndex++)
				        {
				        	if(!this.__isColumnIgnored(colIndex))
				        	{
					        	cell = arrCells[colIndex];
					        	strXML += "<column>" + cell.textContent.trim() + "</column>";
				        	}
				        }
				        strXML += '</columns>';
					}
				}
				if(this.__grid.tBodies && this.__grid.tBodies.length > 0 && this.__grid.tBodies[0].rows && this.__grid.tBodies[0].rows.length > 0)
				{
					var arrRows = this.__grid.tBodies[0].rows;
					strXML += '<rows>';
		        	var rowCounter = 1;
		    		var rowIndex = 0;
		    		var colIndex = 0;
		    		for(rowIndex = 0;rowIndex < arrRows.length;rowIndex++)
		 	        {
		    			strXML += '<row id="row-'+ rowCounter++ +'">';
		    			var colCounter = 1;
		        		var row = arrRows[rowIndex];
		        		var cells = row.cells;
		        		for(colIndex = 0;colIndex < cells.length;colIndex++)
		    	        {
		        			if(!this.__isColumnIgnored(colIndex))
				        	{
			        			var cell = cells[colIndex];
			        			strXML += '<column id="column-'+ colCounter++ +'">';
		        				strXML += cell.textContent.trim();
		        				strXML += '</column>';
				        	}
		    	        }
		        		strXML += '</row>';
		 	        }
		    		strXML += '</rows>';
				}
			}
			strXML += '</root>';
		}
		return strXML;
	};
	
	NSExport.prototype.__getTableAsJson = function() 
	{ 
		var retValue = { columns: [], rows: [] };
		if(this.__grid)
		{
			var grid = this.__getPrototype(this.__grid);
			if(grid && this.__isTypeNSGrid(grid))
			{
				var tblHeader = grid.__tblCenterHeader;
		    	var tblBody = grid.__tblCenterBody;
		    	if(tblHeader && tblHeader.tBodies && tblHeader.tBodies.length > 0 && tblHeader.tBodies[0].rows && tblHeader.tBodies[0].rows.length > 0)
				{
		    		var arrColumns = grid.__columns;
		    		if(grid.gridType === grid.GRID_TYPE_GROUP)
					{
						arrColumns = grid.util.cloneObject(arrColumns);
						arrColumns.splice(0, 1);
					}
		    		var rowIndex = 0;
		    		var colIndex = 0;
			        for(colIndex = 0; colIndex < arrColumns.length; colIndex++)
			        {
			        	var colItem = arrColumns[colIndex];
			        	if(colItem && (!colItem.hasOwnProperty(grid.__fieldColVisible) || colItem[grid.__fieldColVisible]) && (!colItem.hasOwnProperty("isExportable") || Boolean.parse(colItem["isExportable"])))
			        	{
				    		var headerText = colItem["headerText"];
				    		retValue.columns.push(headerText);
			        	}
			        }
			        if(tblBody && tblBody.tBodies && tblBody.tBodies.length > 0 && tblBody.tBodies[0].rows && tblBody.tBodies[0].rows.length > 0)
					{
			        	var arrItems = grid.__getAllItems();
			        	var colText = "";
			        	for(rowIndex = 0;rowIndex < arrItems.length;rowIndex++)
			 	        {
			        		var item = arrItems[rowIndex];
			        		if(!item.hasOwnProperty(grid.__fieldRowVisible) || item[grid.__fieldRowVisible])
			        		{
				        		var rowData = [];
				        		for(colIndex = 0;colIndex < arrColumns.length;colIndex++)
				    	        {
				        			var colItem = arrColumns[colIndex];
				        			if(colItem && (!colItem.hasOwnProperty(grid.__fieldColVisible) || colItem[grid.__fieldColVisible]) && (!colItem.hasOwnProperty("isExportable") || Boolean.parse(colItem["isExportable"])))
				    	        	{
				        				colText = item[colItem["dataField"]];
										if(colItem.hasOwnProperty("exportRenderer"))
										{
											colText = colItem["exportRenderer"](item,colItem["dataField"],item[grid.__fieldIndex],count);
										}
										rowData.push(colText ? colText : "");
				    	        	}
				    	        }
				        		retValue.rows.push(rowData);
			        		}
			 	        }
					}
				}
			}
			else
			{
				if(this.__grid.tHead && this.__grid.tHead.rows && this.__grid.tHead.rows.length > 0)
				{
					var headerRow = this.__grid.tHead.rows[0];
					if(headerRow)
					{
						var arrCells = [];
						if(headerRow.getElementsByTagName("th").length > 0)
						{
							arrCells = headerRow.getElementsByTagName("th");
						}
						else if(headerRow.getElementsByTagName("td").length > 0)
						{
							arrCells = headerRow.getElementsByTagName("td");
						}
			    		var colIndex = 0;
			    		var cell = null;
				        for(colIndex = 0; colIndex < arrCells.length; colIndex++)
				        {
				        	if(!this.__isColumnIgnored(colIndex))
				        	{
					        	cell = arrCells[colIndex];
					        	retValue.columns.push(typeof cell !== "undefined" ? cell.textContent.trim() : "");
				        	}
				        }
					}
				}
				if(this.__grid.tBodies && this.__grid.tBodies.length > 0 && this.__grid.tBodies[0].rows && this.__grid.tBodies[0].rows.length > 0)
				{
					var arrRows = this.__grid.tBodies[0].rows;
		        	var rowCounter = 1;
		    		var rowIndex = 0;
		    		var colIndex = 0;
		    		for(rowIndex = 0;rowIndex < arrRows.length;rowIndex++)
		 	        {
		        		var row = arrRows[rowIndex];
		        		var style = window.getComputedStyle(row);
		        		if (style.display !== "none") 
		        		{
		        			var rowData = [];
			        		var cells = row.cells;
			        		for(colIndex = 0;colIndex < cells.length;colIndex++)
			    	        {
			        			if(!this.__isColumnIgnored(colIndex))
					        	{
				        			var cell = cells[colIndex];
				        			rowData.push(typeof cell !== "undefined" ? cell.textContent.trim() : "");
					        	}
			    	        }
			        		retValue.rows.push(rowData);
		        		}
		 	        }
				}
			}
		}
		return JSON.stringify(retValue);
	};
	
	NSExport.prototype.__getTableAsArray = function() 
	{ 
		var arrSource = [];
		var arrColumns = [];
		var util = this.util;
		if(this.__grid)
		{
			var grid = this.__getPrototype(this.__grid);
			if(grid && this.__isTypeNSGrid(grid))
			{
		    	if(grid.__columns && grid.__columns.length > 0)
				{
		    		var arrColumnsTemp = grid.util.cloneObject(grid.__columns,true);
		    		if(grid.gridType === grid.GRID_TYPE_GROUP)
					{
		    			arrColumnsTemp.splice(0, 1);
					}
		    		var rowIndex = 0;
		    		var colIndex = 0;
			        for(colIndex = 0; colIndex < arrColumnsTemp.length; colIndex++)
			        {
			        	var colItem = arrColumnsTemp[colIndex];
			        	if(!(colItem && (!colItem.hasOwnProperty(grid.__fieldColVisible) || colItem[grid.__fieldColVisible]) && (!colItem.hasOwnProperty("isExportable") || Boolean.parse(colItem["isExportable"]))))
			        	{
			        		arrColumnsTemp.splice(colIndex, 1);
			        	}
			        	else
			        	{
			        		colItem.headerCellStyle = colItem["excelStyleHeaderFunction"] ? colItem["excelStyleHeaderFunction"](colItem,colIndex) : null;
			        		colItem.type = colItem.exportType;
			        		if(!util.isUndefinedOrNull(colItem.width))
				        	{
				        		var unit = util.getDimensionUnit(colItem.width);
				        		switch(unit)
				        		{
				        			case 1:
				        				colItem.widthInPercentage = parseInt(colItem.width.substring(0,colItem.width.length - 1));
				        				colItem.width = null;
				        			break;
				        			case 2:
				        				colItem.widthInPx = util.getDimensionAsNumber(null,colItem.width);
				        				colItem.width = null;
				        			break;
				        		}
				        	}
			        	}
			        }
			        var dataSource = grid.getFilteredData();
			        if(dataSource && dataSource.length > 0)
			        {
			        	for(rowIndex = 0;rowIndex < dataSource.length;rowIndex++)
			 	        {
			        		var data = dataSource[rowIndex];
			        		var item = {};
			        		for(colIndex = 0;colIndex < arrColumnsTemp.length;colIndex++)
			    	        {
			        			var colItem = arrColumnsTemp[colIndex];
			        			var dataField = colItem.dataField;
			        			var text = colItem["exportGetBodyTextFunction"] ? colItem["exportGetBodyTextFunction"](data,dataField,colItem) : data[dataField];
			        			var style = colItem["excelStyleBodyFunction"] ? colItem["excelStyleBodyFunction"](data,dataField,colItem,text) : null;
			        			item[dataField] = {value: text,style: style};
			    	        }
			        		arrSource.push(item);
			 	        }
			        	if(grid.__enableFooter)
			        	{
			        		var item = {};
			        		for (var colIndex = 0; colIndex < arrColumnsTemp.length; colIndex++)
			    		    {
			    		    	var colItem = arrColumnsTemp[colIndex];
			    		    	var dataField = colItem.dataField;
			    		    	var text = colItem["exportGetFooterTextFunction"] ? colItem["exportGetFooterTextFunction"](dataField,colItem,grid.getGroupedSource(),0,colIndex) : "";
			    		    	var style = colItem["excelStyleFooterFunction"] ? colItem["excelStyleFooterFunction"](dataField,colItem,grid.getGroupedSource(),0,colIndex,text) : null;
			        			item[dataField] = {value: text,style: style};
			    		    }
			        		arrSource.push(item);
			        	}
			        }
			        arrColumns = arrColumnsTemp;
				}
			}
			else
			{
				if(this.__grid.tHead && this.__grid.tHead.rows && this.__grid.tHead.rows.length > 0)
				{
					var headerRow = this.__grid.tHead.rows[0];
					if(headerRow)
					{
						var arrCells = [];
						if(headerRow.getElementsByTagName("th").length > 0)
						{
							arrCells = headerRow.getElementsByTagName("th");
						}
						else if(headerRow.getElementsByTagName("td").length > 0)
						{
							arrCells = headerRow.getElementsByTagName("td");
						}
			    		var colIndex = 0;
			    		var cell = null;
			    		var text = "";
			    		var headerText = "";
			    		var dataField = "";
				        for(colIndex = 0; colIndex < arrCells.length; colIndex++)
				        {
				        	if(!this.__isColumnIgnored(colIndex))
				        	{
					        	cell = arrCells[colIndex];
					        	var altText = "col" + colIndex;
					        	if(typeof cell == "undefined" || cell.textContent.trim() !== "")
					        	{
					        		text = "";
					        		headerText = "";
					        		dataField = altText;
					        	}
					        	else
					        	{
					        		text = cell.textContent.trim();
					        		headerText = text;
					        		dataField = text;
					        	}
					        	arrColumns.push({headerText:headerText,dataField:dataField,widthInPx:cell.offsetWidth});
				        	}
				        }
					}
				}
				if(this.__grid.tBodies && this.__grid.tBodies.length > 0 && this.__grid.tBodies[0].rows && this.__grid.tBodies[0].rows.length > 0)
				{
					var arrRows = this.__grid.tBodies[0].rows;
		    		var rowIndex = 0;
		    		var colIndex = 0;
		    		for(rowIndex = 0;rowIndex < arrRows.length;rowIndex++)
		 	        {
		        		var row = arrRows[rowIndex];
		        		var style = window.getComputedStyle(row);
		        		if (style.display !== "none") 
		        		{
			        		var cells = row.cells;
			        		var item = {};
			        		var arrColIndex = 0;
			        		for(colIndex = 0;colIndex < cells.length;colIndex++)
			    	        {
			        			if(!this.__isColumnIgnored(colIndex))
					        	{
				        			var cell = cells[colIndex];
				        			var objColumn = arrColumns[arrColIndex];
				        			var text = (typeof cell == "undefined" || cell.textContent.trim() !== "") ? cell.textContent.trim() : "";
				        			item[objColumn.dataField] = {value: text};
				        			arrColIndex++;
					        	}
			    	        }
			        		arrSource.push(item);
		        		}
		 	        }
				}
			}
		}
		return {columns:arrColumns,source:arrSource};
	};
	
	NSExport.prototype.__getStructureForPDF = function(width,fontSize) 
	{ 
		if(this.__grid)
		{
			var tblResult = this.__getTable();
			tblResult.style.width = width + "px";
			tblResult.style.fontSize = fontSize + "px";
			var divParent = this.util.createDiv("div" + this.util.getUniqueId());
			divParent.appendChild(tblResult);
			return divParent;
		}
	};
	
	NSExport.prototype.__getStructureForImage = function() 
	{ 
		var divReturn = null;
		if(this.__grid)
		{
			var grid = this.__getPrototype(this.__grid);
			if(grid && this.__isTypeNSGrid(grid))
			{
				divReturn = grid.__divOuterContainer;
			}
			else
			{
				divReturn = this.__grid.parentElement;
				if(divReturn && divReturn.nodeName === "BODY")
				{
					divReturn = null;
				}
			}
		}
		return divReturn;
	};
	
	NSExport.prototype.__isColumnIgnored = function(colIndex) 
	{
	    if(this.__ignoreColumn && this.__ignoreColumn.length > 0)
	    {
	    	for(var count = 0;count < this.__ignoreColumn.length;count++)
	    	{
	    		if(this.__ignoreColumn[count] === colIndex)
	    		{
	    			return true;
	    		}
	    	}
	    }
	    return false;
	};
	
	NSExport.prototype.__getFieldValue = function(value,delimiter) 
	{
		if(!value)
		{
			value = "";
		}
		value = "" + value;
	    var addQuotes = (value.indexOf(delimiter) !== -1) || (value.indexOf('\r') !== -1) || (value.indexOf('\n') !== -1);
	    var replaceDoubleQuotes = (value.indexOf('"') !== -1);
	    if (replaceDoubleQuotes) 
	    {
	    	value = fixedValue.replace(/"/g, '""');
	    }
	    if (addQuotes || replaceDoubleQuotes) 
	    {
	    	value = '"' + value + '"';
	    }
	    return value;
	};
	
	NSExport.prototype.__getFileName = function(format) 
	{
		var date = new Date();
	    var day = date.getDate();
	    var month = date.getMonth() + 1;
	    var year = date.getFullYear();
	    var hour = date.getHours();
	    var mins = date.getMinutes();
	    var timePart = day + "." + month + "." + year + "_" + hour + "." + mins;
	    var fileName = (this.__fileName? this.__fileName : "download");
	    fileName = fileName + "(" + timePart + ")" + "." + format;
	    
	    return fileName;
	};
	
	//taken from http://stackoverflow.com/questions/4998908/convert-data-uri-to-file-then-append-to-formdata
	NSExport.prototype.__dataURItoBlob = function(dataURI) 
	{
	    // convert base64/URLEncoded data component to raw binary data held in a string
	    var byteString = null;
	    var uintArray = null;
	    var mimeString = null;
	    if (dataURI.split(',')[0].indexOf('base64') >= 0)
	    {
	    	 byteString = window.atob(dataURI.split(',')[1]);
	    }
	    else
	    {
	    	 byteString = decodeURIComponent(dataURI.split(',')[1]);
	    }
	    // separate out the mime component
	    mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
	    // write the bytes of the string to a typed array
	    uintArray = new Uint8Array(byteString.length);
	    for (var count = 0; count < byteString.length; count++) 
	    {
	    	uintArray[count] = byteString.charCodeAt(count);
	    }
	
	    return new Blob([uintArray], {type:mimeString});
	};
	
	NSExport.prototype.__includeJavaScriptFile = function (filePath,callback,position)
	{
	    if(filePath)
	    {
	        if(!position)
	        {
	            position = "body";
	        }
	        var domPosition = document.getElementsByTagName(position)[0];
	        var script = document.createElement("script");
	        script.setAttribute("id", filePath);
	        script.setAttribute("type","text/javascript");
	        script.setAttribute("src",filePath);
	        if(callback)
	        {
	            script.onload = function()
	            {
	            	callback(filePath);
	            }; 
	        }
	        domPosition.appendChild(script);
	    }
	};
	
	NSExport.prototype.__getPrototype = function(grid) 
	{
		if(grid)
		{
			if(this.util.isElementOfType(grid,"NS-GRID"))
			{
				grid = grid.__nsGrid;
			}
		}
		return grid;
	};
	
	NSExport.prototype.__isTypeNSGrid = function(grid) 
	{
		try
		{
			if(grid)
			{
				if(grid instanceof NSGrid)
				{
					return true;
				}
			}
		}
		catch(error)
		{}
		return false;
	};
	
	NSExport.prototype.xslxExport = function(objNSExport,worksheetName,event,properties)
	{
		this.util = new NSUtil();
		this.__objNSExport = objNSExport;
		this.__worksheetName = worksheetName;
		this.__event = event;
		this.__properties = properties;
		var self = this;
		
		this.exportToxlsx = function() 
		{
			var processXSLX = function()
			{
				var objTableValue = self.__objNSExport.__getTableAsArray();
				if(objTableValue)
				{
					if(!self.__properties)
					{
						self.__properties = {};
					}
					var fileName = self.__objNSExport.__getFileName("xlsx");
					var headerStyle = {
							font: {bold: true, color: '#FFFFFF'},
							horizontal: 'center',
							pattern: {color: '#000000'}
					};
					var prop = {};
					for(var key in self.__properties)
					{
						prop[key] = self.__properties[key];
					}
					prop.dataSource = objTableValue.source;
					prop.columns = objTableValue.columns;
					prop.name = prop.name || "Sheet 1";
					prop.headerStyle = prop.headerStyle || headerStyle;
					var arrSheet=[prop];
					var setting = {fileName:fileName,sheets:arrSheet};
					var xlsxExport = new NSXlsxExport(setting);
					xlsxExport.process();
					if(self.__event)
				    {
						self.util.preventDefault(this.__event);
				    }
				}
			};
			processXSLX();
		};
	};
	return NSExport;
})();
nsModuleExport(this,"NSExport",NSExport);"use strict";
var NSFilter = (function()
{
	function NSFilter(data,filter,setting,recordLimit,isHierarchical,childField,filterFunction,hierarchyFilterChildren,arrIgnoreKeysInCloneDataSource) 
	{
		this.EXACT = "exact";
		this.STARTS_WITH = "startsWith";
		this.ENDS_WITH = "endsWith";
		this.CONTAINS = "contains";
		
		this.IS_FOUND_FIELD = "__nsFilter__found";
		
		this.util = new NSUtil();
		this.__data = data;
		this.__filter = filter;
		this.__setting = setting;
		this.__recordLimit = (parseInt(recordLimit) > 0) ? recordLimit : -1;
		this.__isHierarchical = this.util.isUndefined(isHierarchical) ? false : Boolean.parse(isHierarchical);
		this.__childField = childField ? childField : "children";
		this.__filterFunction = filterFunction;
		this.__hierarchyFilterChildren = hierarchyFilterChildren;
		this.__arrIgnoreKeysInCloneDataSource = arrIgnoreKeysInCloneDataSource;
		this.__ignoreSameLevelNode = true;
	}
	
	NSFilter.prototype.execute = function(data,filter,setting,recordLimit,isHierarchical,childField,filterFunction,hierarchyFilterChildren,arrIgnoreKeysInCloneDataSource) 
	{ 
		data = data ? data : this.__data;
		filter = filter ? filter : this.__filter;
		setting = setting ? setting : this.__setting;
		recordLimit = (parseInt(recordLimit) > 0) ? recordLimit : this.__recordLimit;
		isHierarchical = this.util.isUndefined(isHierarchical) ? Boolean.parse(this.__isHierarchical) : Boolean.parse(isHierarchical);
		childField = childField ? childField : this.__childField;
		filterFunction = filterFunction ? filterFunction : this.__filterFunction;
		hierarchyFilterChildren = hierarchyFilterChildren ? hierarchyFilterChildren : this.__hierarchyFilterChildren;
		arrIgnoreKeysInCloneDataSource = this.util.isUndefinedOrNull(arrIgnoreKeysInCloneDataSource) ? this.__arrIgnoreKeysInCloneDataSource : arrIgnoreKeysInCloneDataSource;
		if(data && filter)
		{
			var dataSource = data.slice(0);
			var arrFilter = [];
			var self = this;
			var callFilterFunction = function(source,level,parentItem)
			{
				var arrReturn = [];
				for (var count = 0; count < source.length; count++) 
				{
					var item = source[count];
					var found = false;
					if(isHierarchical && item[childField] && item[childField].length > 0 )
					{
						var arrChild = callFilterFunction(item[childField],level + 1,item);
						if(arrChild && arrChild.length > 0)
						{
							found = true;
							if(self.__ignoreSameLevelNode)
							{
					            item[childField] = arrChild;
							}
							arrReturn.push(item);
						}
					}
					if(!found && self.__filterItem(item,filter,setting,isHierarchical,childField,parentItem,filterFunction))
					{
						if(isHierarchical && hierarchyFilterChildren)
						{
							var arrChildren = item[childField];
							if(arrChildren && arrChildren.length > 0)
							{
								var childItem = null;
								var childLength = arrChildren.length;
								for(var childCount = childLength - 1;childCount > -1;childCount--)
								{
									childItem = arrChildren[childCount];
									if(childItem)
									{
										if(!hierarchyFilterChildren(childItem,childCount,childItem[self.IS_FOUND_FIELD],filter,setting,item))
										{
											arrChildren.splice(childCount, 1);
										}
									}
								}
							}
						}
						found = true;
						arrReturn.push(item);
						if(!isHierarchical && recordLimit > 0 && arrReturn.length >= recordLimit)
						{
							break;
						}
					}
				}
				//return false;
				return arrReturn;
			};
			var callNonHierarchicalFilterFunction = function(source)
			{
				var arrReturn = [];
				for (var count = 0; count < source.length; count++) 
				{
					var item = source[count];
					if(self.__filterItemNonHierarchical(item,filter,setting,filterFunction))
					{
						arrReturn.push(item);
					}
				}
				return arrReturn;
			};
			dataSource = this.util.cloneObject(dataSource,isHierarchical,[],arrIgnoreKeysInCloneDataSource);
			if(isHierarchical)
			{
				arrFilter = callFilterFunction(dataSource,1,null);
			}
			else
			{
				arrFilter = callNonHierarchicalFilterFunction(dataSource);
			}
			return arrFilter;
		}
		return data;
	};
	
	NSFilter.prototype.__filterItemNonHierarchical = function(item,filter,setting,filterFunction) 
	{
		var retValue = false;
		if(filterFunction)
		{
			retValue = filterFunction(item,filter,setting);
			this.__setItem(item,retValue);
			return retValue;
		}
		else if(filter instanceof Function) 
	    {
			retValue = filter(item,setting);
	        this.__setItem(item,retValue);
	        return retValue;
	    }
	    else if(filter instanceof Array) 
	    {
	        for (var count = 0; count < filter.length; ++count) 
	        {
	            if (this.__filterItemNonHierarchical(item,filter[count],setting,filterFunction))
	            {
	            	this.__setItem(item,true);
	            	return true;
	            }
	        }
	        return false;
	    }
	    else if(setting.type === "date" && filter)
	    {
	        return this.__filterDate(item,filter,setting);
	    }
	    else if(typeof(item) === "string" && filter)
	    {
	        return this.__filterString(item,filter,setting);
	    }
	    else if (item === item + 0 && filter)
	    {
	        return this.__filterNumeric(item,filter);
	    }
	    else if(typeof (filter) === "object") 
	    {
	        for(var key in filter) 
	        {
	        	var tempSetting = {};
	        	if(setting && setting[key])
	        	{
	        		tempSetting = setting[key];
	        	}
	            if(!this.__filterItemNonHierarchical(item[key],filter[key],tempSetting,filterFunction))
	            {
	            	return false;
	            }
	        }
	        this.__setItem(item,true);
	        return true;
	    }
		retValue = (filter == item);
	    this.__setItem(item,retValue);
	    return retValue;
	};
	
	NSFilter.prototype.__filterItem = function(item,filter,setting,isHierarchical,childField,parentItem,filterFunction) 
	{
		var retValue = false;
		if(filterFunction)
		{
			retValue = filterFunction(item,filter,setting,isHierarchical,childField,parentItem);
			this.__setItem(item,retValue);
			return retValue;
		}
		else if(filter instanceof Function) 
	    {
			retValue = filter(item,setting);
	        this.__setItem(item,retValue);
	        return retValue;
	    }
	    else if(filter instanceof Array) 
	    {
	        for (var count = 0; count < filter.length; ++count) 
	        {
	            if (this.__filterItem(item,filter[count],setting,isHierarchical,childField,parentItem,filterFunction))
	            {
	            	this.__setItem(item,true);
	            	return true;
	            }
	        }
	        return false;
	    }
	    else if(setting.type === "date" && filter)
	    {
	        return this.__filterDate(item,filter,setting);
	    }
	    else if(typeof(item) === "string" && filter)
	    {
	        return this.__filterString(item,filter,setting);
	    }
	    else if (item === item + 0 && filter)
	    {
	        return this.__filterNumeric(item,filter);
	    }
	    else if(typeof (filter) === "object") 
	    {
	        for(var key in filter) 
	        {
	        	if(isHierarchical && key === childField)
	        	{
	        		continue;
	        	}
	        	var tempSetting = {};
	        	if(setting && setting[key])
	        	{
	        		tempSetting = setting[key];
	        	}
	            if(!this.__filterItem(item[key],filter[key],tempSetting,isHierarchical,childField,parentItem,filterFunction))
	            {
	            	return false;
	            }
	        }
	        this.__setItem(item,true);
	        return true;
	    }
		retValue = (filter == item);
	    this.__setItem(item,retValue);
	    return retValue;
	};
	
	NSFilter.prototype.__setItem = function(item,isFound)
	{
		if(item && typeof (item) === "object" && isFound)
		{
			item[this.IS_FOUND_FIELD] = true;
		}
	};
	
	NSFilter.prototype.__filterNumeric= function(value,searchParam)
	{
		var retValue = false;
		value = parseFloat(value);
		if(!isNaN(value))
		{
			if(/<=/.test(searchParam)) // first checks if there is an operator (<,>,<=,>=)
			{
				retValue = (value <= parseFloat(searchParam.replace(/<=/,"")));
			}
			else if(/>=/.test(searchParam))
			{
				retValue = (value >= parseFloat(searchParam.replace(/>=/,"")));
			}
			else if(/</.test(searchParam))
			{
				retValue = (value < parseFloat(searchParam.replace(/</,"")));
			}
			else if(/>/.test(searchParam))
			{
				retValue = (value > parseFloat(searchParam.replace(/>/,"")));
			}
			else
			{
				retValue = (value === parseFloat(searchParam));
			}
		}
		return retValue;
	};
	
	NSFilter.prototype.__filterDate= function(value,searchParam,setting)
	{
		var retValue = false;
		var self = this;
		var matchValue = function(compareValue,opt)
		{
			var compValue = false;
			if(self.util.isUndefinedOrNull(value))
			{
				compValue = false;
			}
			else
			{
				var newVal = self.__getDate(value,setting.cellFormat);
				if(newVal)
				{
					newVal.setHours(0, 0, 0, 0);
					compareValue.setHours(0, 0, 0, 0);
					switch(opt)
					{
						case "equals":
							if (compareValue.getTime() === newVal.getTime()) 
							{
								compValue = true;
				            }
						break;
						case "greaterThan":
							if (compareValue.getTime() < newVal.getTime()) 
							{
								compValue = true;
				            }
						break;
						case "lessThan":
							if (compareValue.getTime() > newVal.getTime()) 
							{
								compValue = true;
				            }
						break;
						case "notEqual":
							if (compareValue.getTime() != newVal.getTime()) 
							{
								compValue = true;
				            }
						break;
					}
				}
				else
				{
					self.util.warning("NSFilter",value + " cannot be converted to date Object for given cell format");
					compValue = false;
				}
			}
			return compValue;
		};
		var processDate = function(date,type)
		{
			var compValue = false;
			if(date && matchType1)
			{
				if(!date || !Object.prototype.toString.call(date) === '[object Date]')
				{
					compValue = true;
				}
				else if(setting.comparator)
				{
					compValue = setting.comparator(value,date,setting);
				}
				else
				{
					compValue = matchValue(date,type);
				}
			}
			return compValue;
		};
		if(setting.matchType1 || setting.matchType2)
		{
			var matchType1 = setting.matchType1;
			var firstDate = setting.firstDate;
			var operation = setting.operation;
			var matchType2 = setting.matchType2;
			var secondDate = setting.secondDate;
			if(this.util.isUndefinedOrNull(value))
			{
				retValue = false;
			}
			else if(firstDate && secondDate && matchType1 && matchType2 && operation)
			{
				var firstVal = processDate(firstDate,matchType1);
				var secondVal = processDate(secondDate,matchType2);
				switch(operation)
				{
					case "and":
						retValue = (firstVal && secondVal);
					break;
					case "or":
						retValue = (firstVal || secondVal);
					break;
				}
			}
			else if(firstDate && matchType1)
			{
				retValue = processDate(firstDate,matchType1);
			}
			else if(secondDate && matchType2)
			{
				retValue = processDate(secondDate,matchType2);
			}
			else
			{
				retValue = true;
			}
		}
		else
		{
			if(!searchParam || !Object.prototype.toString.call(searchParam) === '[object Date]')
			{
				retValue = true;
			}
			else if(setting.comparator)
			{
				retValue = setting.comparator(value,searchParam,setting);
			}
			else if(this.util.isUndefinedOrNull(value))
			{
				retValue = false;
			}
			else
			{
				retValue = matchValue(searchParam,"equals");
			}
		}
		return retValue;
	};
	
	NSFilter.prototype.__filterString= function(value,searchParam,setting)
	{
		var regExp = null;
		var regExpModifier = "g";
		var startWithChar = "(^)";
		var endsWithChar = "($)";
		var searchString = "";
		var isCaseSensitive = false;
		var isMultiline = false;
		var matchType = this.CONTAINS;
		if(setting)
		{
			isCaseSensitive = Boolean.parse(setting["caseSensitive"]);
			isMultiline = Boolean.parse(setting["multiline"]);
			matchType = setting["matchType"] ? setting["matchType"] : matchType;
		}
		if(!isCaseSensitive)
		{
			regExpModifier += "i";
		}
		if(isMultiline)
		{
			regExpModifier += "m";
		}
		searchParam = this.__removeSpecialCharacter(searchParam);
		if(matchType === this.EXACT)
		{
			searchString = startWithChar + searchParam + endsWithChar;
		}
		else if(matchType === this.STARTS_WITH)
		{
			searchString = startWithChar + searchParam;
		}
		else if(matchType === this.ENDS_WITH)
		{
			searchString = searchParam + endsWithChar;
		}
		else 
		{
			searchString = searchParam;
		}
		regExp = new RegExp(searchString,regExpModifier);
		return regExp.test(value);
	};
	
	NSFilter.prototype.__removeSpecialCharacter = function(text)
	{
		function replaceEscape(char)
		{
			if(text)
			{
				var exp = new RegExp("\\" + char,"g");
				text = text.replace(exp,"\\" + char);
			}
		}
		var specialChar = ['\\','[','^','$','.','|','?','*','+','(',')'];
		for(var count = 0;count < specialChar.length;count++) 
		{
			replaceEscape(specialChar[count]);
		}
		return text;
	};
	
	//ref from : https://stackoverflow.com/questions/7445328/check-if-a-string-is-a-date-value
	NSFilter.prototype.__getDate = function(value,arrFormat) 
	{
		if(value)
		{
			var dateFormat;
		    if (Object.prototype.toString.call(value) === '[object Date]') 
		    {
		        return value;
		    }
		    if(arrFormat)
		    {
		    	var dateUtil = new NSDateUtil();
		    	if(!this.util.isArray(arrFormat))
		    	{
		    		arrFormat = [arrFormat];
		    	}
		    	for(var count = 0;count < arrFormat.length;count++)
		    	{
		    		var format = arrFormat[count];
		    		var date = dateUtil.parseString(value,format);
		    		if(date)
		    		{
		    			return date;
		    		}
		    	}
		    }
		    else
		    {
		    	if (typeof value.replace === 'function') 
			    {
			        value.replace(/^\s+|\s+$/gm, '');
			    }
			    dateFormat = /(^\d{1,4}[\.|\\/|-]\d{1,2}[\.|\\/|-]\d{1,4})(\s*(?:0?[1-9]:[0-5]|1(?=[012])\d:[0-5])\d\s*[ap]m)?$/;
			    if(dateFormat.test(value))
			    {
			    	return new Date(value);//Date.parse(value);
			    }
		    }
		}
	    return null;
	};
	
	return NSFilter;
})();
nsModuleExport(this,"NSFilter",NSFilter);"use strict";
var NSTouchToMouse = (function()
{
	function NSTouchToMouse(element,setting,doc,win) 
	{
		this.util = new NSUtil();
		this.doc = this.util.getDoc(doc);
		this.win = this.util.getWin(win);
		this.__element = this.util.getElement(element);
		this.__setting = setting;
		this.__config = null;
		this.__touchEventRef = null;
		this.__gestureChangeRef = null;
		this.__gestureEndRef = null;
		this.__objLocal = {documentClick: false,doubleTapWaiting: false,preTouchStart: false,gestureChanged: false};
		this.__objEvents = null;
		this.__useConstructor = false;
		this.__initialize();
	};
	
	NSTouchToMouse.prototype.isTouchSupported = function()
	{
		var isTouchSupported = (("ontouchstart" in this.win) || (this.win.navigator.msMaxTouchPoints > 0));
		return isTouchSupported;
	};

	NSTouchToMouse.prototype.isGestureSupported = function()
	{
		var isGestureSupported = ("ongesturestart" in this.win);
		return isGestureSupported;
	};

	NSTouchToMouse.prototype.destroy = function()
	{
		if(this.__touchEventRef)
		{
			this.util.removeEvent(this.__element,"touchstart",this.__touchEventRef);
			this.util.removeEvent(this.__element,"touchmove",this.__touchEventRef,true);
			this.util.removeEvent(this.__element,"touchend",this.__touchEventRef,true);
			this.util.removeEvent(this.__element,"touchcancel",this.__touchEventRef,true);
			this.__touchEventRef = null;
		}
		if(this.__gestureChangeRef)
		{
			this.util.removeEvent(this.__element,"gesturechange",this.__gestureChangeRef);
			this.__gestureChangeRef = null;
		}
		if(this.__gestureEndRef)
		{
			this.util.removeEvent(this.__element,"gestureend",this.__gestureEndRef);
			this.__gestureEndRef = null;
		}
		this.__objLocal = {documentClick: false,doubleTapWaiting: false,preTouchStart: false,gestureChanged: false};
	};
	
	NSTouchToMouse.prototype.__initialize = function()
	{
		if(!this.__element)
		{
			this.util.throwNSError("NSTouchToMouse","Element is not valid");
		}
		var setting = this.__setting || {};
		this.__config = {
			doubleTapInterval: this.util.isUndefinedOrNull(setting["doubleTapInterval"]) ? 500 : parseInt(setting["doubleTapInterval"]),
			suppressMouseEvent: Boolean.parse(setting["suppressMouseEvent"]),
			touchStartHandler: setting["touchStartHandler"],//format function(screenXPos,screenYPos,event)
			touchMoveHandler: setting["touchMoveHandler"],//format function(screenXPos,screenYPos,event)
			touchEndHandler: setting["touchEndHandler"],//format function(screenXPos,screenYPos,event)
			doubleTapHandler: setting["doubleTapHandler"],//format function(screenXPos,screenYPos,event)
			pinchHandler: setting["pinchHandler"],//format function(scale,event)
		};
		this.__initObjEvents();
		this.__addListeners();
		this.__useConstructor = this.__isMouseEventConstructorExists();
	};

	NSTouchToMouse.prototype.__initObjEvents = function()
	{
		this.__objEvents = {
			"touchstart":{mouseEventType: "mousedown",callback:this.__touchStartHandler.bind(this)},
			"touchmove":{mouseEventType: "mousemove",callback:this.__touchMoveHandler.bind(this)},
			"touchend":{mouseEventType: "mouseup",callback:this.__touchEndHandler.bind(this),fireExtraEvent:this.__fireClickEvent.bind(this)},
		};
	};

	NSTouchToMouse.prototype.__addListeners = function()
	{
		var isTouchSupported = this.isTouchSupported();
		var isGestureSupported = this.isGestureSupported();
		if (isTouchSupported) 
		{
			if(!this.__touchEventRef)
			{
				this.__touchEventRef = this.__touchEventHandler.bind(this);
				this.util.addEvent(this.__element,"touchstart",this.__touchEventRef);
				this.util.addEvent(this.__element,"touchmove",this.__touchEventRef,true);
				this.util.addEvent(this.__element,"touchend",this.__touchEventRef,true);
				this.util.addEvent(this.__element,"touchcancel",this.__touchEventRef,true);
			}
		}
		else
		{
			this.util.debug("NSTouchToMouse","Touch is not supported");
		}
		if(isGestureSupported)
		{
			if(!this.__gestureChangeRef)
			{
				this.__gestureChangeRef = this.__gestureChangeHandler.bind(this);
				this.util.addEvent(this.__element,"gesturechange",this.__gestureChangeRef);
			}
			if(!this.__gestureEndRef)
			{
				this.__gestureEndRef = this.__gestureEndHandler.bind(this);
				this.util.addEvent(this.__element,"gestureend",this.__gestureEndRef);
			}
		}
		else
		{
			this.util.debug("NSTouchToMouse","Gesture is not supported");
		}
	};

	NSTouchToMouse.prototype.__touchEventHandler = function(event)
	{
		if(!this.__objLocal.gestureChanged)
		{
			event = this.util.getEvent(event);
			var touch = event.touchEvent;
			var item = this.__objEvents[event.type];
			if(item)
			{
				var mouseEventType = item.mouseEventType;
				item.callback(event,touch);
				this.__fireMouseEvent(mouseEventType,event,touch);
				if(item.fireExtraEvent)
                {
                	item.fireExtraEvent(event,touch);
                }
                event.preventDefault();
			}
			else
			{
				this.util.debug("NSTouchToMouse",event.type + " is not supported");
			}
		}
	};

	NSTouchToMouse.prototype.__gestureChangeHandler = function(event)
	{
		event = this.util.getEvent(event);
		this.__objLocal.gestureChanged = true;
		if(this.__config.pinchHandler)
		{
			this.__config.pinchHandler(event.scale,event);
		}
		this.__objLocal.preTouchStart = true;
        event.preventDefault();
	};

	NSTouchToMouse.prototype.__gestureEndHandler = function(event)
	{
		event = this.util.getEvent(event);
		this.__objLocal.gestureChanged = false;
		event.preventDefault();
	};

	NSTouchToMouse.prototype.__touchStartHandler = function(event,touch)
	{
		this.__fireCallback("touchStartHandler",event,touch);
		this.__objLocal.preTouchStart = true;
		this.__objLocal.documentClick = true;
	};

	NSTouchToMouse.prototype.__touchMoveHandler = function(event,touch)
	{
		this.__fireCallback("touchMoveHandler",event,touch);
		this.__objLocal.preTouchStart = false;
		this.__objLocal.documentClick = false;
	};

	NSTouchToMouse.prototype.__touchEndHandler = function(event,touch)
	{
		if (this.__objLocal.doubleTapWaiting && this.__objLocal.preTouchStart) 
		{	
			this.__fireCallback("doubleTapHandler",event,touch);
		}
		else 
		{
			this.__objLocal.doubleTapWaiting = true;
			this.__fireCallback("touchEndHandler",event,touch);
			var self = this;
			window.setTimeout(function () 
			{
				self.__objLocal.doubleTapWaiting = false;
			}, this.__config.doubleTapInterval);							
		}
		this.__objLocal.preTouchStart = false;
	};
	
	NSTouchToMouse.prototype.__fireClickEvent = function(event,touch)
	{
		if(this.__objLocal.documentClick)
		{
			this.__fireMouseEvent("click",event,touch);
            this.__objLocal.documentClick = false;
		}
	};
	
	NSTouchToMouse.prototype.__fireMouseEvent = function(mouseEventType,event,touch)
	{
		if(!this.__config.suppressMouseEvent)
		{
			var mouseEvent = null;
			var option = {bubbles: true,cancelable: true,view:this.win,detail:1,screenX:touch.screenX,screenY:touch.screenY,clientX:touch.clientX,clientY:touch.clientY,ctrlKey:false,
						  altKey:false,shiftKey:false,metaKey:false,button:0,relatedTarget:null};
			if(this.__useConstructor)
			{
				mouseEvent = new MouseEvent(mouseEventType,option);
			}
			else
			{
				mouseEvent = this.doc.createEvent("MouseEvent");
				mouseEvent.initMouseEvent(mouseEventType,option.bubbles,option.cancelable,option.view,option.detail,
										  option.screenX,option.screenY,option.clientX,option.clientY,option.ctrlKey,
										  option.altKey,option.shiftKey,option.metaKey,option.button,option.relatedTarget);
			}
			touch.target.dispatchEvent(mouseEvent);
		}
	};
	
	NSTouchToMouse.prototype.__isMouseEventConstructorExists = function()
	{
		try 
		{
		    new MouseEvent("test");
		    return true;
		} 
		catch(error) 
		{
		}
		return false;
	};

	NSTouchToMouse.prototype.__fireCallback = function(callbackKey,event,touch)
	{
		if(this.__config[callbackKey])
		{
			this.__config[callbackKey](touch.screenX,touch.screenY,event);
		}
	};

	return NSTouchToMouse;
})();
nsModuleExport(this,"NSTouchToMouse",NSTouchToMouse); "use strict";
var NSVirtualScroll = (function()
{
	function NSVirtualScroll(setting) 
	{
		this.__setting = setting;
		this.util = null;
		this.__config = null;
		this.__internal = {};
		this.__objProp = {};
		this.__objSelectedProp = {};
		this.__domVariables = null;
		this.__doc = null;
		this.__win = null;
		this.__scrollHandlerRef = null;
		this.__resizeHandlerRef = null;
		
		this.__initialize();
	}
	
	NSVirtualScroll.prototype.dataSource = function(paramItems)
	{
		if(!this.util.isUndefinedOrNull(paramItems))
		{
			var reInit = false;
			if(!this.__internal.itemDimension)
			{
				reInit = true;
			}
			if(this.util.isNumber(paramItems))
			{
				this.__config.totalLength = parseInt(paramItems);
			}
			else if(this.util.isArray(paramItems))
			{
				this.__config.items = paramItems;
			}
			else
			{
				this.__config.totalLength = null;
				this.__config.items = [paramItems];
			}
            this.__internal.objItemComp = {};
            this.__internal.arrItem = [];
			if(reInit)
			{
                var item = this.__getItemAt(0);
				this.__internal.isItemHtml = this.util.isString(item);
				this.__setSize();
			}
			var scrollElement = this.__config.scrollElement;
			var scrollPos = scrollElement[this.__objSelectedProp.scroll];
			if(this.__internal.items && (this.__internal.items.length * this.__internal.itemDimension < scrollPos)) 
			{
				scrollElement[this.__objSelectedProp.scroll] = 0;
				this.__internal.lastPageNum = 0;
		    }
			this.__addItems();
			scrollElement[this.__objSelectedProp.scroll] = scrollPos;
		}
	};
	
	NSVirtualScroll.prototype.refresh = function(isReset)
	{
		var currItemSize = this.__internal.itemDimension;
		this.__setSize();
		var newItemSize = this.__internal.itemDimension;
		if((currItemSize != newItemSize) || isReset)
		{
			var criteria = null;
			if(this.__config.totalLength)
			{
				criteria = this.__config.totalLength;
			}
			else if(this.util.isArray(this.__config.items) && this.__config.items && this.__config.items.length)
			{
				criteria = this.__config.items;
			}
			else
			{
				criteria = 0;
			}
			this.dataSource(criteria);
		}
	};
	
	NSVirtualScroll.prototype.getScrollProgress = function()
	{
		var scrollPos = this.__internal.scrollPos;
		var itemSize = this.__internal.itemDimension;
		var totalSize = this.__internal.arrItem.length * itemSize;
		var progress = ((scrollPos / totalSize) * 100) || 0;
		return progress;
	};
	
	NSVirtualScroll.prototype.appendItems = function(arrItem)
	{
		this.__addNewItems(arrItem,false);
	};
	
	NSVirtualScroll.prototype.prependItems = function(arrItem)
	{
		this.__addNewItems(arrItem,true);
	};
	
	//assuming that size of all rows are same
	//if not same add offset
	//if variable Row size and utility user has original scroll Position then set scrollPosition and pass index as null
	NSVirtualScroll.prototype.scrollToIndex = function(index,animationRequired,offset,scrollPosition)
	{
		var arrItem = this.__internal.arrItem;
		if(arrItem && arrItem.length)
		{
			var scrollPos = null;
			if(!this.util.isUndefinedOrNull(index) && index > -1 && index < arrItem.length)
			{
				offset = this.util.isUndefinedOrNull(offset) ? 0 : parseInt(offset);
				scrollPos = (this.__internal.itemDimension * index) + offset;
			}
			else if(!this.util.isUndefinedOrNull(scrollPosition))
			{
				offset = 0;
				scrollPos = scrollPosition;
			}
			if(!this.util.isUndefinedOrNull(scrollPos))
			{
				var scrollElement = this.__config.scrollElement;
				if(animationRequired)
				{
					var animation = new this.util.animation(scrollElement,[
		       	  	    {
		       	  	      time: 500,
		       	  	      property:this.__objSelectedProp.scroll,
		       	  	      target: scrollPos,
		       	  	    }
		       	  	]);
		   	  	  	animation.animate();
				}
				else
				{
					scrollElement[this.__objSelectedProp.scroll] = scrollPos;
				}
			}
		}
	};
	
	//this function is used for updating items(dom elements) already generated 
	NSVirtualScroll.prototype.updateItems = function(updateCallback) 
	{
		if(this.__internal.arrItem && this.__internal.arrItem.length && updateCallback) 
		{
			var arrItem = this.__internal.arrItem;
			for(var count = 0;count < arrItem.length;count++) 
			{
				var item = arrItem[count]; 
				item = updateCallback(item);
				arrItem[count] = item;
			}
			this.__internal.arrItem = arrItem;
			this.__internal.origArrItem = this.__internal.arrItem;
		}
	}
	
	NSVirtualScroll.prototype.destroy = function()
	{
		var scrollElement = this.__config.scrollElement;
		var contentElement = this.__config.contentElement;
		if(this.__internal.contentTabIndex)
		{
			contentElement.setAttribute("tabindex",this.__internal.contentTabIndex);
		}
		this.util.removeStyleClass(scrollElement,"nsVirtualScrollElement nsVirtualScrollElement" + this.util.toCamelCase(this.__config.direction,true));
		this.util.removeStyleClass(contentElement,"nsVirtualScrollContent nsVirtualScrollContent" + this.util.toCamelCase(this.__config.direction,true));
		if(this.__scrollHandlerRef)
		{
			this.util.removeEvent(scrollElement,"scroll",this.__scrollHandlerRef);
			this.__scrollHandlerRef = null;
		}
		if(this.__resizeHandlerRef)
		{
			this.util.removeEvent(this.__win,"resize",this.__resizeHandlerRef);
			this.__resizeHandlerRef = null;
		}
		if(this.__internal.divLoader)
		{
			this.__internal.divLoader.parentNode.removeChild(this.__internal.divLoader);
		}
	};
	
	NSVirtualScroll.prototype.__initialize = function()
	{
		this.util = new NSUtil();
		if(this.__setting)
		{
			this.__config = {
					scrollElement: this.util.getElement(this.__setting["scrollElement"]),
					contentElement: this.util.getElement(this.__setting["contentElement"]),
					direction: this.__setting["direction"] || NSVirtualScroll.DIRECTION_VERTICAL,
					itemTag: this.__setting["itemTag"],
					pageSize: parseInt(this.__setting["pageSize"]) || 30,//number of items after the cache will be refreshed
					pagesRendered: parseInt(this.__setting["pagesRendered"]) || 3,//number of items(pageSize * pagesRendered) to be rendered
					items: this.__setting["items"],//array of items, can be html or nodes
					totalLength: parseInt(this.__setting["totalLength"]) || 0,//either mention items or totalLength and itemCreateCallback
					getItemComponent: this.__setting["getItemComponent"],
					getEmptyItemComponent: this.__setting["getEmptyItemComponent"],
					enableScrollDelay: Boolean.parse(this.__setting["enableScrollDelay"]),//for Mobile device which are slow in rendering
					scrollInterval: this.__setting["scrollInterval"],
					enableLoader: Boolean.parse(this.__setting["enableLoader"]),
					getLoaderComponent: this.__setting["getLoaderComponent"],
					resizeInterval: parseInt(this.__setting["resizeInterval"]) || 150,
					scrollingProgress: this.__setting["scrollingProgress"], //scrollingProgress callback while scrolling like  scrollingProgress(progress)
					pageWillChange: this.__setting["pageWillChange"], //pageWillChange callback before page change like  pageWillChange(oldPage,newPage)
					pageChanged: this.__setting["pageChanged"], //pageChanged callback before page change like  pageChanged(page)
				};
			if(!this.__config.scrollElement)
			{
				this.util.throwNSError("NSVirtualScroll","scrollElement is not valid");
			}
			if(!this.__config.contentElement)
			{
				this.util.throwNSError("NSVirtualScroll","contentElement is not valid");
			}
			this.__domVariables = this.util.getDomVariables();
			this.__doc = this.__domVariables.doc;
			this.__win = this.__domVariables.win;
			if((!this.__config.items || this.__config.items.length == 0) && !this.__config.totalLength)
			{
				this.__config.items = this.__fetchChildren(contentElement);
			}
			this.__setProps();
			this.__setInternalVars();
			this.__create();
			this.__addListeners();
		}
	};
	
	NSVirtualScroll.prototype.__setProps = function()
	{
		this.__objProp = {
			    vertical: {
			        direction:NSVirtualScroll.DIRECTION_VERTICAL,size: "height",offset: "offsetHeight",
			        scroll: "scrollTop", scrollSize: "scrollHeight",paddingStart:"paddingTop",
			        paddingEnd:"paddingBottom",marginStart:"marginTop",marginEnd:"marginBottom"
			    },
			    horizontal: {
			        direction:NSVirtualScroll.DIRECTION_HORIZONTAL,size: "width",offset: "offsetWidth",
			        scroll: "scrollLeft", scrollSize: "scrollWidth",paddingStart:"paddingLeft",
			        paddingEnd:"paddingRight",marginStart:"marginLeft",marginEnd:"marginRight"
			    }
		};
		this.__objSelectedProp = this.__objProp["vertical"];
		if(this.__config.direction == NSVirtualScroll.DIRECTION_HORIZONTAL)
		{
			this.__objSelectedProp = this.__objProp["horizontal"];
		}
	};
	
	//call this function only with init is needed
	NSVirtualScroll.prototype.__setInternalVars = function()
	{
		if(!this.__internal.itemDimension)
		{
			if(this.__config.contentElement.hasAttribute("tabindex"))
			{
				this.__internal.contentTabIndex = this.__config.contentElement.getAttribute("tabindex");
			}
			this.__internal.scrollIntervalID = -1;
			this.__internal.resizeIntervalID = -1;
			this.__internal.scrollPos = -1;
			this.__internal.lastPageNum = -1;
			this.__internal.objItemComp = {};
			this.__internal.objCache = {};
			this.__internal.cssExtraItem = "nsVirtualExtraItem" + this.util.toCamelCase(this.__objSelectedProp.direction,true);
			this.__internal.isMobile = this.util.isMobile().any;
			if(this.__config.enableScrollDelay && this.util.isUndefinedOrNull(this.__config.scrollInterval))
			{
				this.__config.scrollInterval = this.__internal.isMobile ? 300 : 0;
			}
			this.__internal.divLoader = null;
			this.__addLoader();
			this.__internal.pageSize = this.__config.pageSize;
			this.__internal.pagesRendered = this.__config.pagesRendered;
			var item = this.__getItemAt(0);
			if(item)
			{
				this.__internal.isItemHtml = this.util.isString(item);
				this.__setSize();
			}
			else
			{
				this.__internal.itemDimension = 0;
				this.__internal.pageDimension = 0;
				this.__internal.itemsRendered = 0;
				this.__internal.renderedSize = 0;
			}
		}
	};
	
	NSVirtualScroll.prototype.__setSize = function()
	{
		this.__internal.itemDimension = this.__getItemSize();
		this.__internal.pageDimension = this.__internal.itemDimension * this.__internal.pageSize;
		this.__internal.itemsRendered = this.__internal.pageSize * this.__internal.pagesRendered;
		this.__internal.renderedSize = this.__internal.pagesRendered * this.__internal.pageDimension;
	};
	
	NSVirtualScroll.prototype.__create = function()
	{
		var scrollElement = this.__config.scrollElement;
		var contentElement = this.__config.contentElement;
		this.util.addStyleClass(scrollElement,"nsVirtualScrollElement nsVirtualScrollElement" + this.util.toCamelCase(this.__config.direction,true));
		this.util.addStyleClass(contentElement,"nsVirtualScrollContent nsVirtualScrollContent" + this.util.toCamelCase(this.__config.direction,true));
		contentElement.setAttribute("tabindex",0);
		if((this.__config.items && this.__config.items.length) || this.__config.totalLength)
		{
			var scrollPos = scrollElement[this.__objSelectedProp.scroll];
			this.__addItems();
			scrollElement[this.__objSelectedProp.scroll] = scrollPos;
		}
	};
	
	NSVirtualScroll.prototype.__addListeners = function()
	{
		if(!this.__scrollHandlerRef)
		{
			this.__scrollHandlerRef = this.__config.enableScrollDelay ? this.__scrollHandlerWithDelay.bind(this) : this.__scrollHandler.bind(this);
			this.util.addEvent(this.__config.scrollElement,"scroll",this.__scrollHandlerRef);
		}
		if(!this.__resizeHandlerRef)
		{
			this.__resizeHandlerRef = this.__resizeHandler.bind(this);
			this.util.addEvent(this.__win,"resize",this.__resizeHandlerRef);
		}
	};
	
	NSVirtualScroll.prototype.__scrollHandlerWithDelay = function(event)
	{
		var self = this;
		clearTimeout(this.__internal.scrollIntervalID);
		this.__internal.scrollIntervalID = setTimeout(function(){
			self.__scrollHandler.call(self,event);
		},this.__config.scrollInterval);
	};
	
	NSVirtualScroll.prototype.__scrollHandler = function(event)
	{
		this.__internal.scrollIntervalID = -1;
		event = this.util.getEvent(event);
		var pageNumber = this.__getCurrentPageNum();
		var lastPageNum = this.__internal.lastPageNum;
		this.__internal.lastPageNum = pageNumber;
		/*console.log("lastPageNum::" + lastPageNum + " pageNumber::" + pageNumber);*/
		if(lastPageNum != pageNumber)
		{
			//console.log("In Scroll");
			this.__addItems();
			this.__fireCallback("scrollingProgress",this.getScrollProgress());
		}
	};
	
	//not used for now
	NSVirtualScroll.prototype.__isScrollingDown = function() {
		  var isScrollingDown = false;
		  var currentScrollPos = this.__config.scrollElement[this.__objSelectedProp.scroll];

		  if (currentScrollPos > this.__internal.prevScrollPos) {
		    isScrollingDown = true;
		  } else {
		    isScrollingDown = false;
		  }

		  this.__internal.prevScrollPos = currentScrollPos;
		  return isScrollingDown;
	};
	
	NSVirtualScroll.prototype.__resizeHandler = function(event)
	{
		event = this.util.getEvent(event);
		clearTimeout(this.__internal.resizeIntervalID);
		var self = this;
		this.__internal.resizeIntervalID = setTimeout(self.refresh.bind(self), this.__config.resizeInterval);
	};
	
	NSVirtualScroll.prototype.__getItemSize = function()
	{
		var contentElement = this.__config.contentElement;
		var isAdded = false;
		var size = null;
		if(!contentElement.children.length)
		{
            var itemHtml = this.__getItemAt(0);
			this.__setItemsInDom(itemHtml);
			isAdded = true;
		}
		var item = null;
		var length = contentElement.children.length;
		for(var count = 0;count < length;count++)
		{
			item = contentElement.children[count];
			if(!this.util.hasStyleClass(item,this.__internal.cssExtraItem))
			{
				break;
			}
		}
		if(!this.__config.itemTag)
		{
			this.__config.itemTag = item.tagName.toLowerCase();
		}
		size = item[this.__objSelectedProp.offset];
		if(this.__config.itemTag == "tr")
		{
			var border = this.util.getStyleValue(contentElement,"borderCollapse");
			if(border != "collapse")
			{
				var borderSpacing = this.util.getStyleValue(contentElement,"borderSpacing");
				size += this.__getInt(borderSpacing);
			}
		}
		else
		{
			var marginStart = this.util.getStyleValue(item,this.__objSelectedProp.marginStart);
	        var marginEnd = this.util.getStyleValue(item,this.__objSelectedProp.marginEnd);
	        marginStart = this.__getInt(marginStart);
	        marginEnd = this.__getInt(marginEnd);
	        size += Math.max(marginStart, marginEnd);
		}
		if(isAdded)
		{
			this.__setItemsInDom(null);
		}
		return size;
	};
	
	NSVirtualScroll.prototype.__addItems = function()
	{
		var arrItem = this.__internal.arrItem || [];
		var itemPage = this.__getPageData(arrItem,this.__getCurrentPageNum());
		var hasPageContentChanged = this.__hasCacheChanged("data",itemPage.arrItem);
        var hasStartOffsetChanged = this.__hasCacheChanged("top",itemPage.startOffset);
        var hasEndOffsetChanged = this.__hasCacheChanged("bottom",itemPage.endOffset);
        var contentElement = this.__config.contentElement;
        var arrSource = [];
        if(hasPageContentChanged || hasStartOffsetChanged) 
        {
            if(itemPage.startOffset) 
            {
            	arrSource.push(this.__getExtraItem("nsVirtualTopItem",itemPage.startOffset));
            }
            arrSource.push.apply(arrSource,itemPage.arrItem);
            if(itemPage.endOffset) 
            {
            	arrSource.push(this.__getExtraItem("nsVirtualBottomItem",itemPage.endOffset));
            }
            this.__fireCallback("pageWillChange",[this.__internal.currentItemPage,itemPage]);
            this.__setItemsInDom(arrSource);
            this.__handleTagAfterRender(itemPage);
            this.__fireCallback("pageChanged",[itemPage]);
            this.__internal.currentItemPage = itemPage;
        } 
        else if(hasEndOffsetChanged) 
        {
        	contentElement.lastChild.style[this.__objSelectedProp.size] = itemPage.endOffset + "px";
        }
	};
	
	NSVirtualScroll.prototype.__setItemsInDom = function(arrItem,isAdd)
	{
		this.__setLoaderVisibility(true);
		var contentElement = this.__config.contentElement;
		if(this.__internal.isItemHtml)
		{
			if(arrItem)
			{
				var html = this.__convertArrayToString(arrItem);
				isAdd ? contentElement.innerHTML += html : contentElement.innerHTML = html;
			}
			else
			{
				isAdd ? null : contentElement.innerHTML = "";
			}
		}
		else
		{
			if(!isAdd)
			{
				//IE Bug that when Html elements are added(i.e. when this.__internal.isItemHtml is false) you do contentElement.innerHTML = "" 
				//then the items being rendered in this.__internal.arrItem also becomes empty
				if(this.__internal.isItemHtml)
				{
					contentElement.innerHTML = "";
				}
				else
				{
					while(contentElement.firstChild) 
					{
						contentElement.removeChild(contentElement.lastChild);
					}
				}
			}
			if(arrItem)
			{
				arrItem = this.util.isArray(arrItem) ? arrItem : [arrItem];
				var item = null;
				var length = arrItem.length;
				for(var count =0;count < length;count++)
				{
					if(arrItem[count]) {
						item = arrItem[count];
						this.util.isString(item) ? contentElement.innerHTML += item : contentElement.appendChild(item);
					}
				}
			}
		}
		this.__setLoaderVisibility(false);
	};
	
	NSVirtualScroll.prototype.__getAllItems = function(fromIndex,toIndex)
	{
		if(this.__config.items && this.__config.items.length && this.__config.items.length > fromIndex)
		{
            toIndex = this.__config.items.length > toIndex ? toIndex : this.__config.items.length - 1;
            var arrCloned = this.__config.items.slice();
			var arrItem = arrCloned.splice(fromIndex,toIndex - fromIndex);
			return arrItem;
		}
		else if(this.__config.totalLength && this.__config.getItemComponent)
		{
            fromIndex = this.__config.totalLength > fromIndex ? fromIndex : this.__config.totalLength - 1;
            toIndex = this.__config.totalLength > toIndex ? toIndex : this.__config.totalLength - 1;
            if(!this.__internal.arrItem) {
				this.__internal.arrItem = [];
			}
			var arrItem = this.__internal.arrItem;
            var arrRet = [];
			for(var count = fromIndex;count < toIndex + 1;count++)
			{
                if(arrItem.length > count && arrItem[count]) {
                    arrRet.push(arrItem[count]);
                }
                else {
                    var item = this.__getItemFromComponent(count);
                    arrItem[count] = item;
                    arrRet.push(item);
                }
			}
			return arrRet;
		}
		return [];
	};

    NSVirtualScroll.prototype.__getItemAt = function(index) 
    {
        if(this.__config.items && this.__config.items.length && this.__config.items.length > index)
		{
           return this.__config.items[index];
		}
        else if(this.__config.arrItem && this.__config.arrItem.length && this.__config.arrItem.length > index && this.__config.arrItem[index])
		{
           return this.__config.arrItem[index];
		}
        else if(this.__config.totalLength > index && this.__config.getItemComponent) {
           return this.__getItemFromComponent(index);
        }
        return null;
    };
	
	NSVirtualScroll.prototype.__getItemFromComponent = function(index)
	{
		var item = null;
		if(this.__config.totalLength > index)
		{
			var comp = new this.__config.getItemComponent(index);
			item = comp.getElement();
			this.__internal.objItemComp[index.toString()] = comp;
		}
		return item;
	};
	
	NSVirtualScroll.prototype.__getPageData = function(arrItem,pageNum)
	{
		var internal = this.__internal;
		var retItem = null;
        if(this.__config.totalLength === 0)
		{
			retItem = {startOffset: 0,endOffset: 0,itemsBefore: 0,arrItem:[this.__getEmptyItem()]};
		}
		/*else if(arrItem.length < internal.pageSize)
		{
            var startIndex = 0;
	        var endIndex = internal.pageSize;
            var arrRet = this.__getAllItems(startIndex,endIndex);
			retItem = {startOffset: 0,endOffset: 0,itemsBefore: 0,arrItem:arrRet};
		}*/
		else
		{
			var startIndex = Math.max((internal.itemsRendered - internal.pageSize) * pageNum, 0);
	        var endIndex = startIndex + internal.itemsRendered;
            var totalLength = this.__getTotalLength();
	        var startOffset = Math.max(startIndex * internal.itemDimension, 0);
	        var endOffset = Math.max((totalLength - endIndex) * internal.itemDimension, 0);
	        var itemsBefore = startIndex;
	        if(startOffset < 1) 
	        {
	        	itemsBefore++;
	        }
	        var arrRet = this.__getAllItems(startIndex,endIndex);//arrItem.slice(startIndex,endIndex);
	        retItem = {startOffset: startOffset,endOffset: endOffset,itemsBefore: itemsBefore,arrItem:arrRet};
		}
		console.log(retItem);
		return retItem;
	};

    NSVirtualScroll.prototype.__getTotalLength = function() 
    {
        if(this.__config.items && this.__config.items.length)
		{
           return this.__config.items.length;
		}
        else if(this.__config.totalLength && this.__config.getItemComponent) {
           return this.__config.totalLength;
        }
        return 0;
    };
	
	NSVirtualScroll.prototype.__addNewItems = function(arrNewItem,isPrepend)
	{
		if(!this.util.isUndefinedOrNull(arrNewItem))
		{
			arrNewItem = this.util.isArray(arrNewItem) ? arrNewItem : [arrNewItem];
			if(arrNewItem && arrNewItem.length)
			{
				var arrItem = [];
				for(var count = 0;count < arrNewItem.length;count++)
				{
					arrItem.push(arrNewItem.items[count]);
				}
				var arrExisting = this.__internal.arrItem;
				this.__internal.arrItem = isPrepend ? arrItem.concat(arrExisting) : arrExisting.concat(arrItem);
				this.__addItems();
			}
		}
	};
	
	NSVirtualScroll.prototype.__handleTagAfterRender = function(itemPage)
	{
		var contentElement = this.__config.contentElement;
		if(this.__config.itemTag == "ol")
		{
			contentElement.setAttribute("start", itemPage.itemsBefore);
		}
	};
	
	NSVirtualScroll.prototype.__fetchChildren = function(element)
	{
		if(element)
		{
			var arrChildren = element.children;
			var arrRet = [];
			var length = arrChildren.length;
			var child = null;
			for(var count = 0;count < length;count++)
			{
				child = arrChildren[count];
				arrRet.push(this.__getItemHtml(child));
			}
			return arrRet;
		}
		return null;
	};
	
	NSVirtualScroll.prototype.__fireCallback = function(callbackName,args)
	{
		if(this.__config[callbackName]) {
			this.__config[callbackName](args);
		}
	};
	
	NSVirtualScroll.prototype.__hasCacheChanged = function(key,value)
	{
		var changed = (value != this.__internal.objCache[key]);
		this.__internal.objCache[key] = value;
	    return changed;
	};
	
	NSVirtualScroll.prototype.__getCurrentPageNum = function()
	{
		this.__internal.scrollPos = this.__config.scrollElement[this.__objSelectedProp.scroll];
		var pageNum = Math.floor(this.__internal.scrollPos / (this.__internal.renderedSize - this.__internal.pageDimension)) || 0;
		//console.log(this.__internal.scrollPos + "," + this.__internal.renderedSize + "," + this.__internal.pageDimension + "," + pageNum);
		return pageNum;
	};
	
	NSVirtualScroll.prototype.__getExtraItem = function(cssClass,size)
	{
		var item = this.util.createElement(this.__config.itemTag,null,this.__internal.cssExtraItem,this.__doc);
		cssClass && this.util.addStyleClass(item,cssClass);
		size && (item.style[this.__objSelectedProp.size] = size + "px");
		return (this.__internal.isItemHtml ? this.__getItemHtml(item) : item);
	};
	
	NSVirtualScroll.prototype.__getEmptyItem = function()
	{
		if(this.__config.getEmptyItemComponent)
		{
			var comp = new this.__config.getEmptyItemComponent();
			return (this.__internal.isItemHtml ? this.__getItemHtml(comp.getElement()) : comp.getElement());
		}
		var item = this.util.createElement(this.__config.itemTag,null,null,this.__doc);
		if(this.__config.itemTag == "tr")
		{
			item.innerHTML = "<td colSpan='1000'></td>";
		}
		return (this.__internal.isItemHtml ? this.__getItemHtml(item) : item);
	};
	
	NSVirtualScroll.prototype.__getItemHtml = function(item)
	{
		if(item)
		{
			return this.util.isString(item) ? item : item.outerHTML;
		}
		return "";
	};
	
	NSVirtualScroll.prototype.__addLoader = function()
	{
		if(this.__config.enableLoader)
		{
			this.__internal.divLoader = this.util.createDiv(null,"nsVirtualScrollLoader");
			var divText = null;
			if(this.__config.getLoaderComponent)
			{
				var comp = new this.__config.getLoaderComponent();
				divText = comp.getElement();
			}
			else
			{
				divText = this.util.createDiv(null,"nsVirtualScrollLoaderTextCon");
				divText.innerHTML = "<b class=\"nsVirtualScrollLoaderText\">Rendering...</b>";
			}
			this.__internal.divLoader.appendChild(divText);
			this.__setLoaderVisibility(false);
			this.__config.scrollElement.appendChild(this.__internal.divLoader);
		}
	};
	
	NSVirtualScroll.prototype.__setLoaderVisibility = function(isShow)
	{
		if(this.__internal.divLoader)
		{
			this.__internal.divLoader.style.display = isShow ? "" : "none";
		}
	};
	
	NSVirtualScroll.prototype.__convertArrayToString = function(arrItem,separator)
	{
		if(arrItem)
		{
			separator = separator ? separator : "";
			return this.util.isArray(arrItem) ? arrItem.join(separator) : arrItem;
		}
		return "";
	};
	
	NSVirtualScroll.prototype.__getInt = function(value)
	{
		return parseInt(value,10) || 0;
	};
	
	NSVirtualScroll.DIRECTION_VERTICAL = "vertical";
	NSVirtualScroll.DIRECTION_HORIZONTAL = "horizontal";
	
	return NSVirtualScroll;
})();
nsModuleExport(this,"NSVirtualScroll",NSVirtualScroll);
"use strict"; 
var NSFlatGrid = (function()
{
	function NSFlatGrid(nsGrid,nsUtil) 
	{
		this.__nsGrid = nsGrid;
		this.util = nsUtil;
	}
	/********************************Common Functions for Grid ****************************************/
	NSFlatGrid.prototype.__initialize = function ()
	{
		
	};
	
	
	NSFlatGrid.prototype.propertyChange = function(attrName, oldVal, newVal, setProperty) 
	{
		var attributeName = attrName.toLowerCase();
		if(attributeName === "pagesize" && parseInt(newVal) > 0)
		{
			this.__nsGrid.__pageSize = parseInt(newVal);
			this.__nsGrid.dataSource(this.__nsGrid.__dataSource,true);
		}
	};
	
	NSFlatGrid.prototype.dataSource = function(source)
	{
		this.__nsGrid.__arrWrapper = this.__nsGrid.__dataSource.slice(0);
		this.__nsGrid.__arrFilteredGroupedSource = this.__nsGrid.__arrWrapper.slice(0);
		this.__setWrapperSource(this.__nsGrid.__arrWrapper,0,-1,0,true);
		if(this.__nsGrid.__enablePagination)
		{
			/*if(!this.__nsGrid.__isPaginationTypeScroll)
			{
				this.__nsGrid.__createPaginationControl(this.__nsGrid.__divOuterContainer);
			}*/
			if(this.__nsGrid.__isPaginationModeAuto)
			{
				this.__nsGrid.__updateTotalRecords(this.__nsGrid.__arrWrapper.length);
				if(this.__nsGrid.__isPaginationTypeScroll)
				{
					this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrWrapper.slice(0);//this.__nsGrid.__arrWrapper.slice(0,this.__nsGrid.__INFINITE_SCROLL_INITIAL_LOAD);
					this.__nsGrid.__paginationFetchRecordCallBack = this.__addRowsforScrollPagination.bind(this);
				}
				else 
				{
					this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrWrapper.slice(0);
					this.__nsGrid.__paginationFetchRecordCallBack = this.__addRowsforPagePagination.bind(this);
				}
			}
			else
			{
				this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrWrapper.slice(0);
				this.__nsGrid.__updateTotalRecords();
			}
		}
		else
		{
			this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrWrapper.slice(0);
			this.__nsGrid.__updateTotalRecords();
		}
	};
	
	NSFlatGrid.prototype.addItemsAsChildren = function(item,arrChildren)
	{
	};
	
	NSFlatGrid.prototype.afterGridRendered = function()
	{
	};
	
	NSFlatGrid.prototype.arrowClickHandler = function(parentItem,isCollapse) 
	{
	};
	
	NSFlatGrid.prototype.expandCollapseHandler = function(item,isCollapse)
	{
	};
	
	NSFlatGrid.prototype.__createBody = function()
	{
	};
	
	NSFlatGrid.prototype.__createBodyBody= function(dataSet,startIndex,endIndex)
	{
	    if(dataSet && dataSet.length > 0)
	    {
	    	 for (var rowIndex = startIndex; rowIndex < endIndex; rowIndex++)
		     {
	    		var item = dataSet[rowIndex];
	    		this.__createRow(item);
		     }
	    }
	};
	
	NSFlatGrid.prototype.__setSourceForAsync= function()
	{
		this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrWrapper.slice(0);
	};
	
	NSFlatGrid.prototype.__createRowAsync= function(item,index,array)
	{
		this.__createRow(item);
	};
	
	NSFlatGrid.prototype.__createBodyBodyVirtual= function(dataSet,totalRows)
	{
		if(dataSet && dataSet.length > 0)
	    {
	    	if(totalRows > dataSet.length)
	    	{
	    		totalRows = dataSet.length;
	    	}
	    	else if(this.__nsGrid.__enableVariableRowHeight)
	    	{
	    		totalRows = totalRows + this.__nsGrid.__extraRowCountForVariableHeight;
	    	}
	    	this.__createBodyBody(dataSet,0,totalRows);
	    }
	};
	
	NSFlatGrid.prototype.__checkForAdditionalColumns = function()
	{
	};
	
	NSFlatGrid.prototype.__addSVGInPage = function(objSVG)
	{
	};
	
	NSFlatGrid.prototype.__setMeasurement = function()
	{
		
	};
	
	NSFlatGrid.prototype.__resetDataInBody= function(fromIndex,toIndex)
	{
		var row = null;
		var item = null;
		var arrRows = this.__nsGrid.__tblCenterBodyBody.rows;
		var rowLength = arrRows.length;
		var length = this.__nsGrid.__arrInternalSource.length;
		var rowCount = 0;
		for(var count = fromIndex; count < length; count++)
	    {
			if(rowLength <= rowCount) 
			{
				break;
			}
			row = arrRows[rowCount];
			item = this.__nsGrid.__arrInternalSource[count];
			if(item)
			{
				this.__resetRow(row,item[this.__nsGrid.__fieldIndex],item);
				rowCount++;
			}
	    }
		for(var rowIndex = rowCount;rowIndex < rowLength;rowIndex++)
		{
			row = arrRows[rowIndex];
			row.style.display = "none";
			row.setAttribute("ns-index",null);
		}
	};
	
	NSFlatGrid.prototype.__setWrapperSource = function(source,offset,parentIndex,level,setFieldIndex)
	{
		if(source)
		{
			if(!offset)
			{
				offset = 0;
			}
			var length = source.length;;
			var count = 0;
			var item = null;
			var index = -1; 
			if(this.__nsGrid.__renderInCachedMode)
			{
				for (count = 0; count < length; count++) 
				{
					item = source[count];
					index = offset + count;
					this.__setRowItemProperty(item,index,setFieldIndex);
					var colLength = this.__nsGrid.__columns.length;
					var arrCellsText = [];
					for (var colIndex = 0; colIndex < colLength; colIndex++)
			        {
			        	var colItem = this.__nsGrid.__columns[colIndex];
			            var cellDiv = this.util.createDiv(null);
			            this.util.addStyleClass(cellDiv,this.__nsGrid.__CLASS_CELL_CHILD);
			            this.__nsGrid.__addCellText(null,item,cellDiv,colItem,colIndex);
			            arrCellsText.push(cellDiv);
			        }
					item[this.__nsGrid.__fieldCellText] = arrCellsText;
				}
			}
			else
			{
				for (count = 0; count < length; count++) 
				{
					item = source[count];
					index = offset + count;
					this.__setRowItemProperty(item,index,setFieldIndex);
				}
			}
		}
	};
	
	NSFlatGrid.prototype.__updateCellText = function(row,cell,item,colItem,rowIndex,colIndex)
	{
		if(cell && item && colItem)
		{
			this.util.removeAllChildren(cell);
			if(this.__nsGrid.__renderInCachedMode)
	    	{
	    		this.__renderCellHTML(row,cell,item,colItem,colIndex);
	    	}
	    	else
	    	{
	    		 this.__renderCellNormal(row,cell,item,colItem,colIndex);
	    	}
		}
	};
	
	NSFlatGrid.prototype.__getFlatSource = function(onlySource)
	{
		return this.__nsGrid.__arrWrapper;
	};
	
	NSFlatGrid.prototype.__isCellEditable = function(objColumn,item,cell,cellIndex,row,rowIndex)
	{
		return true;
	};
	
	NSFlatGrid.prototype.__handleOnDemandClick = function(item,event)
	{
	};
	
	/********************************Common Functions for Grid ****************************************/
	NSFlatGrid.prototype.__createRow = function(item,itemIndex,isAdd)
	{
		if(item)
		{
			isAdd = this.util.isUndefinedOrNull(isAdd) ? true : Boolean.parse(isAdd);
			var row = document.createElement("TR");
			var index = item[this.__nsGrid.__fieldIndex];
			row.setAttribute("ns-index",index);
			item[this.__nsGrid.__fieldRowHtml] = row;
			this.__nsGrid.__setBodyRowProperty(row,item,index);
			this.__nsGrid.__applyCustomClass(row,"bodyRow");
			var colLength = this.__nsGrid.__columns.length;
			for (var colIndex = 0; colIndex < colLength; colIndex++)
		    {
		    	var colItem = this.__nsGrid.__columns[colIndex];
		    	var cell =  this.__nsGrid.__createBodyRowCell(row,colIndex,false);
		    	if(this.__nsGrid.__renderInCachedMode)
		    	{
		    		this.__renderCellHTML(row,cell,item,colItem,colIndex);
		    	}
		    	else
		    	{
		    		 this.__renderCellNormal(row,cell,item,colItem,colIndex);
		    	}
		    	this.__nsGrid.__setBodyCellProperties.bind(this.__nsGrid)(cell);
		    }
			if(isAdd)
			{
				var addRow = true;
				if(!this.util.isUndefinedOrNull(itemIndex) && itemIndex > -1 && this.__nsGrid.__tblCenterBodyBody.children 
						&& this.__nsGrid.__tblCenterBodyBody.children.length > itemIndex)
				{
					var prevRow = this.__nsGrid.__tblCenterBodyBody.children[itemIndex]; //this.__nsGrid.__getRowByIndex(itemIndex);
					if(prevRow)
					{
						this.__nsGrid.__tblCenterBodyBody.insertBefore(row,prevRow);
						addRow = false;
					}
				}
				if(addRow)
				{
					this.__nsGrid.__tblCenterBodyBody.appendChild(row);
				}
			}
			this.__nsGrid.__createFixedBodyRow(row);
			return row;
		}
		return null;
	};
	
	NSFlatGrid.prototype.__renderCellNormal = function(row,cell,item,colItem,colIndex)
	{
		 var cellDiv = this.util.createDiv(null);
	     this.util.addStyleClass(cellDiv,this.__nsGrid.__CLASS_CELL_CHILD);
	     this.__nsGrid.__addCellText(row,item,cellDiv,colItem,colIndex);
	     //this.__nsGrid.__highlightDiv(cellDiv,colIndex);
	     cell.appendChild(cellDiv);
	};
	
	NSFlatGrid.prototype.__renderCellHTML = function(row,cell,item,colItem,colIndex)
	{
		var arrCellsText = item[this.__nsGrid.__fieldCellText];
		cell.innerHTML = arrCellsText[colIndex].outerHTML;
		//this.__nsGrid.__highlightDiv(cell.firstChild,colIndex);
	};
	
	NSFlatGrid.prototype.__updateRow = function(row,item)
	{
		if(row && item)
		{
			if(item[this.__nsGrid.__fieldSelected])
			{
				this.util.addStyleClass(row,this.__nsGrid.__CLASS_SELECTED_ROW);
			}
			else
			{
				this.util.removeStyleClass(row,this.__nsGrid.__CLASS_SELECTED_ROW);
			}
			var index = item[this.__nsGrid.__fieldIndex];
			var cells = row.cells;
			for (var colIndex = 0; colIndex < this.__nsGrid.__columns.length; colIndex++)
	        {
				var cell = cells[colIndex];
	        	var colItem = this.__nsGrid.__columns[colIndex];
	        	this.__updateCellText(row,cell,item,colItem,index,colIndex);
	        }
		}
	};
	
	NSFlatGrid.prototype.__setRowItemProperty = function(item,rowIndex,setFieldIndex)
	{
		if(item)
		{
			if(setFieldIndex)
			{
				item[this.__nsGrid.__fieldIndex] = rowIndex;
			}
			item[this.__nsGrid.__fieldVisibleIndex] = rowIndex + 1;
			item[this.__nsGrid.__fieldRowVisible] = true;
		}
	};
	
	NSFlatGrid.prototype.__resetRow = function(row,index,item)
	{
		row.style.display = "";
		row.setAttribute("ns-index",index);
		item[this.__nsGrid.__fieldRowHtml] = row;
		this.__updateRow(row,item);
	};
	
	NSFlatGrid.prototype.__addRowsforScrollPagination = function(fromRecord,toRecord,pageSize)
	{
		//console.log("In __addRowsforScrollPagination " + fromRecord + "," + toRecord + "," + pageSize);
		var arrArray = this.__nsGrid.__arrInternalSource.slice(fromRecord,toRecord + 1); 
		this.__nsGrid.__addRemoveRowCallInternal = true;
		this.__nsGrid.addRows(arrArray);
	};
	
	NSFlatGrid.prototype.__addRowsforPagePagination = function(fromRecord,toRecord,pageSize)
	{
		//slice returns index range from fromRecord to toRecord - 1 hence adding 1 
		//this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrWrapper.slice(fromRecord,toRecord + 1);
		this.__nsGrid.__resetDataInBody(fromRecord,toRecord);
	};
	
	return NSFlatGrid;
})();
nsModuleExport(this,"NSFlatGrid",NSFlatGrid);
 "use strict"; 
var NSHierarchicalGrid = (function()
{
	function NSHierarchicalGrid(nsGrid,nsUtil) 
	{
		this.__nsGrid = nsGrid;
		this.util = nsUtil;
		
		this.__ARROW_COLLAPSE_PATH = "M 0 9.99994L 6.10352e-005 -3.05176e-005L 5 5.00006L 0 9.99994 Z";
		this.__ARROW_EXPANDED_PATH = "M 0 3.05176e-005L 9.99994 9.15527e-005L 4.99988 5.00003L 0 3.05176e-005 Z";
		this.__CLASS_ARROW = "nsGridArrowFill";
		this.__rowCounter = -1;
		this.__enableOnDemandHierarchy = false;
		this.__onDemandChildDetectionField = "hasChildren";
		this.__onDemandChildFetchCallback = null;
	}
	/********************************Common Functions for Grid ****************************************/
	NSHierarchicalGrid.prototype.__initialize = function ()
	{
		var setting = this.__nsGrid.__setting;
		if(setting.hasOwnProperty("enableOnDemandHierarchy"))
		{
			this.__enableOnDemandHierarchy = Boolean.parse(setting["enableOnDemandHierarchy"]);
		}
		if(this.__enableOnDemandHierarchy)
		{
			if(setting.hasOwnProperty("onDemandChildDetectionField"))
			{
				this.__onDemandChildDetectionField = setting["onDemandChildDetectionField"];
			}
			if(setting.hasOwnProperty("onDemandChildFetchCallback"))
			{
				this.__onDemandChildFetchCallback = setting["onDemandChildFetchCallback"];
				this.__onDemandChildFetchCallback = this.util.getFunction(this.__onDemandChildFetchCallback);
			}
			if(!this.__onDemandChildDetectionField)
			{
				this.util.throwNSError("NSGrid","Value for onDemandChildDetectionField is not valid");
			}
			if(!this.__onDemandChildFetchCallback)
			{
				this.util.throwNSError("NSGrid","Value for onDemandChildFetchCallback is not valid");
			}
			if(this.__enableVirtualScroll || (this.__nsGrid.__enablePagination && this.__nsGrid.__isPaginationModeAuto))
			{
				this.util.warning("NSGrid","As VirtualScroll or Pagination Mode is true so OnDemandHierarchy will have no impact.");
			}
		}
	};
	
	NSHierarchicalGrid.prototype.propertyChange = function(attrName, oldVal, newVal, setProperty) 
	{
		var attributeName = attrName.toLowerCase();
	};
	
	NSHierarchicalGrid.prototype.dataSource = function(source)
	{
		this.__nsGrid.__arrWrapper = this.__nsGrid.__dataSource.slice(0);
		this.__nsGrid.__arrFilteredGroupedSource = this.__nsGrid.__arrWrapper.slice(0);
		this.__setWrapperSource(this.__nsGrid.__arrWrapper,0,-1,0,true,true,true);
		this.__nsGrid.__updateTotalRecords(this.__rowCounter);
		if(this.__nsGrid.__enablePagination && this.__nsGrid.__isPaginationModeAuto)
		{
			if(this.__nsGrid.__isPaginationTypeScroll)
			{
				this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrFlatHierarchicalSource.slice(0);//this.__nsGrid.__arrFlatHierarchicalSource.slice(0,this.__nsGrid.__INFINITE_SCROLL_INITIAL_LOAD);
				this.__nsGrid.__paginationFetchRecordCallBack = this.__addRowsforScrollPagination.bind(this);
			}
			else 
			{
				this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrFlatHierarchicalSource.slice(0,this.__nsGrid.__pageSize);
				this.__nsGrid.__createPaginationControl(this.__nsGrid.__divOuterContainer);
				this.__nsGrid.__paginationFetchRecordCallBack = this.__addRowsforPagePagination.bind(this);
			}
		}
		else
		{
			this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrFlatHierarchicalSource.slice(0);//this.__nsGrid.__arrWrapper.slice(0);
		}
	};
	
	NSHierarchicalGrid.prototype.addItemsAsChildren = function(item,arrChildren)
	{
		if(item && arrChildren && arrChildren.length > 0)
		{
			if(!item[this.__nsGrid.__childField])
			{
				item[this.__nsGrid.__childField] = [];
			}
			item[this.__nsGrid.__childField].push.apply(item[this.__nsGrid.__childField], arrChildren);
			this.__setWrapperSource(this.__nsGrid.__arrWrapper,0,-1,0,true,false,false);
			this.__nsGrid.__updateTotalRecords(this.__rowCounter);
			if(!(this.__nsGrid.__enablePagination && this.__nsGrid.__isPaginationModeAuto))
			{
				this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrFlatHierarchicalSource.slice(0);
				item[this.__nsGrid.__fieldRowVisible] = true;
				item[this.__nsGrid.__fieldIsCollapsed] = false;
		   		var row = this.__nsGrid.__getRowFromItem(item);
		   		var rowIndex = this.__nsGrid.__getIndexByItem(item);
		   		this.__nsGrid.__showHideRow(rowIndex,null,false);
			}
		}
	};
	
	NSHierarchicalGrid.prototype.afterGridRendered = function()
	{
	};
	
	NSHierarchicalGrid.prototype.arrowClickHandler = function(parentItem,isCollapse) 
	{
	};
	
	NSHierarchicalGrid.prototype.expandCollapseHandler = function(item,isCollapse)
	{
	};
	
	NSHierarchicalGrid.prototype.__createBodyBody= function(dataSet,startIndex,endIndex)
	{
	    if(dataSet && dataSet.length > 0)
	    {
	    	for (var rowIndex = startIndex; rowIndex < endIndex; rowIndex++)
		    {
	    		var item = dataSet[rowIndex];
	    		this.__createRow(item);
		    }
	    }
	};
	
	NSHierarchicalGrid.prototype.__setSourceForAsync= function()
	{
		this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrFlatHierarchicalSource.slice(0);
	};
	
	NSHierarchicalGrid.prototype.__createRowAsync= function(item,index,array)
	{
		this.__createRow(item);
	};
	
	NSHierarchicalGrid.prototype.__createBodyBodyVirtual= function(dataSet,totalRows,level)
	{
		if(dataSet && dataSet.length > 0)
	    {
	    	if(totalRows > dataSet.length)
	    	{
	    		totalRows = dataSet.length;
	    	}
	    	else if(this.__nsGrid.__enableVariableRowHeight)
	    	{
	    		totalRows = totalRows + this.__nsGrid.__extraRowCountForVariableHeight;
	    	}
	    	this.__createBodyBody(dataSet,0,totalRows);
	    }
	};
	
	NSHierarchicalGrid.prototype.__createBody = function()
	{
	};
	
	NSHierarchicalGrid.prototype.__checkForAdditionalColumns = function()
	{
	};
	
	NSHierarchicalGrid.prototype.__setMeasurement = function()
	{
	};
	
	NSHierarchicalGrid.prototype.__addSVGInPage = function(objSVG)
	{
		objSVG.addPath("svgArrowDown",this.__ARROW_EXPANDED_PATH,"0 0 16 16");
		objSVG.addPath("svgArrowRight",this.__ARROW_COLLAPSE_PATH,"0 0 16 16");
	};
	
	NSHierarchicalGrid.prototype.__setWrapperSource = function(source,offset,parentIndex,level,setFieldIndex,setIsCollapsed,setItemVisible)
	{
		if(source)
		{
			if(level === 0)
			{
				if(!offset)
				{
					offset = 0;
				}
				this.__nsGrid.__arrFlatHierarchicalSource = [];
				this.__rowCounter = offset;
			}
			var length = source.length;
			var count = 0;
			var item = null;
			if(this.__nsGrid.__renderInCachedMode)
			{
				for (count = 0; count < length; count++) 
				{
					item = source[count];
					this.__rowCounter++;
					this.__nsGrid.__arrFlatHierarchicalSource.push(item);
					this.__setRowItemProperty(item,parentIndex,level,setFieldIndex,setIsCollapsed,setItemVisible);
					var colLength = this.__nsGrid.__columns.length;
					var arrCellsText = [];
					for (var colIndex = 0; colIndex < colLength; colIndex++)
			        {
			        	var colItem = this.__nsGrid.__columns[colIndex];
			            var cellDiv = this.util.createDiv(null);
			            this.__nsGrid.__addCellText(null,item,cellDiv,colItem,colIndex);
			            arrCellsText.push(cellDiv);
			        }
					item[this.__nsGrid.__fieldCellText] = arrCellsText;
				}
			}
			else
			{
				for (count = 0; count < length; count++) 
				{
					item = source[count];
					this.__rowCounter++;
					this.__nsGrid.__arrFlatHierarchicalSource.push(item);
					this.__setRowItemProperty(item,parentIndex,level,setFieldIndex,setIsCollapsed,setItemVisible);
				}
			}
		}
	};
	
	/*useVisibleIndex flag is used when we want to use visible index,generally true for all cases except for expandCollapse all due to performance issues*/  
	NSHierarchicalGrid.prototype.__resetDataInBody= function(fromIndex,toIndex,fromRowIndex,useVisibleIndex)
	{
		if(!fromRowIndex)
		{
			fromRowIndex = 0;
		}
		var row = null;
		var item = null;
		var arrRows = this.__nsGrid.__tblCenterBodyBody.rows;
		var rowLength = arrRows.length;
		var length = this.__nsGrid.__arrFlatHierarchicalSource.length;
		var indexCount = fromIndex;
		var rowCount = fromRowIndex;
		for(var count = fromIndex; count < length; count++)
		{
			if(this.__nsGrid.__enableVirtualScroll && useVisibleIndex)
			{
				item = this.__nsGrid.__getVisibleItemByIndex(this.__nsGrid.__arrFlatHierarchicalSource,count);
			}
			else
			{
				item = this.__nsGrid.__arrFlatHierarchicalSource[count];
			}
			//breaking if item not found as if large data set is rendered and after collapse all the while scrolling after a while item is null still it goes to end of data set which are hidden
			if(item)
			{
				if(item[this.__nsGrid.__fieldRowVisible])
				{
					if(rowLength <= rowCount) // || indexCount > toIndex
					{
						break;
					}
					row = arrRows[rowCount];
					this.__resetRow(row,item);
					indexCount++;
					rowCount++;
				}
			}
			else
			{
				break;
			}
		}
		for(var rowIndex = rowCount;rowIndex < rowLength;rowIndex++)
		{
			row = arrRows[rowIndex];
			row.style.display = "none";
			row.setAttribute("ns-index",null);
			row.setAttribute("ns-level",null);
			row.setAttribute("ns-parent-index",null);
		}
	};
	
	NSHierarchicalGrid.prototype.__updateCellText = function(row,cell,item,colItem,rowIndex,colIndex)
	{
		if(cell && item && colItem)
		{
			this.util.removeAllChildren(cell);
			var cellDiv = this.util.createDiv(null);
			var divText = this.__setBodyCellProperty(row,cell,cellDiv,item,rowIndex,colItem,colIndex,item[this.__nsGrid.__fieldParentIndex],item[this.__nsGrid.__fieldRowLevel]);
			//this.__nsGrid.__highlightDiv(divText,colIndex);
			cell.appendChild(cellDiv);
		}
	};
	
	NSHierarchicalGrid.prototype.__getFlatSource = function()
	{
		return this.__nsGrid.__arrFlatHierarchicalSource;
	};
	
	NSHierarchicalGrid.prototype.__isCellEditable = function(objColumn,item,cell,cellIndex,row,rowIndex)
	{
		return true;
	};
	
	NSHierarchicalGrid.prototype.__isOnDemandHasChildren = function(item)
	{
		return (this.__enableOnDemandHierarchy && item[this.__onDemandChildDetectionField]);
	};
	
	NSHierarchicalGrid.prototype.__handleOnDemandClick = function(item,event)
	{
		if(item && this.__isOnDemandHasChildren(item))
		{
			if(this.__onDemandChildFetchCallback)
			{
				event = this.util.getEvent(event);
				var rowLevel = item[this.__nsGrid.__fieldRowLevel];
				var rowIndex = this.__nsGrid.__getIndexByItem(item);
				this.__onDemandChildFetchCallback(item,rowIndex,rowLevel,event);
			}
		}
	};
	/********************************End of Common Functions for Grid ****************************************/
	NSHierarchicalGrid.prototype.__createRow = function(item,itemIndex,isAdd)
	{
		if(item && item[this.__nsGrid.__fieldRowVisible])
		{
			isAdd = this.util.isUndefinedOrNull(isAdd) ? true : Boolean.parse(isAdd);
			var row = document.createElement("TR");
			item[this.__nsGrid.__fieldRowHtml] = row;
			var index = item[this.__nsGrid.__fieldIndex];
			var level = item[this.__nsGrid.__fieldRowLevel];
			var parentIndex = item[this.__nsGrid.__fieldParentIndex];
			row.setAttribute("ns-index",index);
			row.setAttribute("ns-level",level);
			if(item[this.__nsGrid.__fieldHasParent])
		    {
				row.setAttribute("ns-parent-index",parentIndex);
		    }
			this.__nsGrid.__setBodyRowProperty(row,item,index);
			this.__nsGrid.__applyCustomClass(row,"bodyRow");
			var colLength = this.__nsGrid.__columns.length;
			for (var colIndex = 0; colIndex < colLength; colIndex++)
		    {
				var colItem = this.__nsGrid.__columns[colIndex];
				var cell =  this.__nsGrid.__createBodyRowCell(row,colIndex,true);
	            var cellDiv = cell.firstChild;
	            var divText = this.__setBodyCellProperty(row,cell,cellDiv,item,index,colItem,colIndex,parentIndex,level);
	            //this.__nsGrid.__highlightDiv(divText,colIndex);
	            cell.appendChild(cellDiv);
	            this.__nsGrid.__setBodyCellProperties.bind(this.__nsGrid)(cell);
		    }
			if(isAdd)
			{
				var addRow = true;
				if(!this.util.isUndefinedOrNull(itemIndex) && itemIndex > 0 && this.__nsGrid.__tblCenterBodyBody.children 
						&& this.__nsGrid.__tblCenterBodyBody.children.length >= itemIndex)
				{
					var prevRow = this.__nsGrid.__tblCenterBodyBody.children[itemIndex - 1]; //this.__nsGrid.__getRowByIndex(itemIndex);
					if(prevRow)
					{
						this.__nsGrid.__tblCenterBodyBody.insertBefore(row,prevRow);
						addRow = false;
					}
				}
				if(addRow)
				{
					this.__nsGrid.__tblCenterBodyBody.appendChild(row);
				}
			}
			this.__nsGrid.__createFixedBodyRow(row);
			return row;
		}
		return null;
	};
	
	NSHierarchicalGrid.prototype.__updateRow = function(row,item)
	{
		if(row && item)
		{
			var index = item[this.__nsGrid.__fieldIndex];
			var level = item[this.__nsGrid.__fieldRowLevel];
			var parentIndex = item[this.__nsGrid.__fieldParentIndex];
			row.setAttribute("ns-index",index);
			row.setAttribute("ns-level",level);
			if(item[this.__nsGrid.__fieldHasParent])
		    {
				row.setAttribute("ns-parent-index",parentIndex);
		    }
			else
			{
				row.setAttribute("ns-parent-index",null);
			}
			if(item[this.__nsGrid.__fieldSelected])
			{
				this.util.addStyleClass(row,this.__nsGrid.__CLASS_SELECTED_ROW);
			}
			else
			{
				this.util.removeStyleClass(row,this.__nsGrid.__CLASS_SELECTED_ROW);
			}
			var cells = row.cells;
			for (var colIndex = 0; colIndex < this.__nsGrid.__columns.length; colIndex++)
	        {
				var cell = cells[colIndex];
				var colItem = this.__nsGrid.__columns[colIndex];
				this.__updateCellText(row,cell,item,colItem,index,colIndex);
	        }
		}
	};
	
	NSHierarchicalGrid.prototype.__setRowItemProperty = function(item,parentIndex,level,setFieldIndex,setIsCollapsed,setItemVisible)
	{
		if(item)
		{
			var totalRowCount = this.__rowCounter;
			if(setFieldIndex || this.util.isUndefinedOrNull(item[this.__nsGrid.__fieldIndex]))
			{
				item[this.__nsGrid.__fieldIndex] = totalRowCount;
			}
			item[this.__nsGrid.__fieldVisibleIndex] = totalRowCount;
			item[this.__nsGrid.__fieldRowLevel] = level;
			var hasChild = false;
			if((item[this.__nsGrid.__childField] && item[this.__nsGrid.__childField].length > 0)  || (this.__isOnDemandHasChildren(item)))
		    {
		    	hasChild = true;
		    	this.__setWrapperSource(item[this.__nsGrid.__childField],0,totalRowCount,level + 1,setFieldIndex,setIsCollapsed,setItemVisible);
		    }
			item[this.__nsGrid.__fieldParentIndex] = parentIndex;
			if(parentIndex > -1)
		    {
				item[this.__nsGrid.__fieldHasParent] = true;
		    }
			else
			{
				item[this.__nsGrid.__fieldHasParent] = false;
			}
			item[this.__nsGrid.__fieldHasChild] = hasChild;
			if(setItemVisible || this.util.isUndefinedOrNull(item[this.__nsGrid.__fieldRowVisible]))
			{
				item[this.__nsGrid.__fieldRowVisible] = true;
			}
			if(setIsCollapsed || this.util.isUndefinedOrNull(item[this.__nsGrid.__fieldIsCollapsed]))
			{
				item[this.__nsGrid.__fieldIsCollapsed] = this.__isOnDemandHasChildren(item);
			}
		}
	};
	
	
	NSHierarchicalGrid.prototype.__setBodyCellProperty = function(row,cell,cellDiv,item,currentIndex,colItem,colIndex,parentIndex,level)
	{
		var hierarchicalPadding = 0;
		var divText = null;
		if(colItem && colItem.hasOwnProperty("dataField") && colItem["dataField"])
		{
	        if(colIndex == 0 && ((item[this.__nsGrid.__childField]  && item[this.__nsGrid.__childField].length > 0) || (this.__isOnDemandHasChildren(item))))
	        {
	        	this.util.addStyleClass(cellDiv,this.__nsGrid.__CLASS_GROUP_CELL);
	        	this.__nsGrid.__createArrow(item,currentIndex,cellDiv,item[this.__nsGrid.__fieldIsCollapsed],colItem);
	        	var cellText = this.util.createDiv(null,this.__nsGrid.__CLASS_CELL_CHILD);
	        	cellText.style.verticalAlign = "top";
	        	divText = cellText;
	        	if(this.__nsGrid.__renderInCachedMode)
	        	{
	        		var arrCellsText = item[this.__nsGrid.__fieldCellText];
	        		cellText.innerHTML = arrCellsText[colIndex].outerHTML;
	        	}
	        	else
	        	{
	        		this.__nsGrid.__addCellText(row,item,cellText,colItem,colIndex);
	        	}
	        	this.util.addStyleClass(cellText,"nsGroupCellText");
	        	cellDiv.appendChild(cellText);
	        }
	        else
	        {
	        	this.util.addStyleClass(cellDiv,this.__nsGrid.__CLASS_CELL_CHILD);
	        	if(this.__nsGrid.__renderInCachedMode)
	        	{
	        		var arrCellsText = item[this.__nsGrid.__fieldCellText];
	        		cellDiv.innerHTML = arrCellsText[colIndex].outerHTML;
	        	}
	        	else
	        	{
	        		this.__nsGrid.__addCellText(row,item,cellDiv,colItem,colIndex);
	        	}
	        	divText = cellDiv;
	        	//24 = 16(Arrow Width) + 6(Arrow Parent Padding) + 2(cellDiv horizontalGap between elements shown in debugger)
	        	hierarchicalPadding = 24;
	        }
	        if(colIndex == 0)
	        {
	        	if(level === 0 || !this.__nsGrid.__showExpandCollapseIcon)
	        	{
	        		cell.style.paddingLeft = "1px";
	        	}
	        	else
	        	{
	        		var paddingLeft = (10 * level) + hierarchicalPadding;
	        		cell.style.paddingLeft = paddingLeft + "px";
	        	}
	        }
		}
		this.__nsGrid.__addPriorityClassInCell(cell,colItem);
		return divText;
	};
	
	NSHierarchicalGrid.prototype.__createArrow = function(compArrow,objSVG,arrowID,isCollapsed,item,colItem)
	{
		 if(this.__nsGrid.__isRowExpansionIconCustom())
		 {
			 this.__setArrowDirection(compArrow,isCollapsed,colItem);
		 }
		 else
		 {
			 var svg = objSVG.addSVG(compArrow,arrowID + "svg",this.__CLASS_ARROW,null,null,null,null,null,null,true);
			 this.util.addStyleClass(svg,this.__CLASS_ARROW + "Theme");
			 if(isCollapsed)
			 {
				 objSVG.addUse(svg,arrowID + "use",null,"#svgArrowRight");
			 }
			 else
			 {
				 objSVG.addUse(svg,arrowID + "use",null,"#svgArrowDown");
			 }
		 }
	};
	
	NSHierarchicalGrid.prototype.__setArrowDirection = function(compArrow,isCollapsed,colItem)
	{
		if(this.__nsGrid.__isRowExpansionIconCustom())
		{
			if(isCollapsed)
			{
				compArrow.innerHTML = this.__nsGrid.__getCustomIcon("rowCollapsed");
			}
			else
			{
				compArrow.innerHTML = this.__nsGrid.__getCustomIcon("rowExpanded");
			}
		}
		else
		{
			var objSVG = new NSSvg();
			var useID = compArrow.getAttribute("id") + "use";
			if(isCollapsed)
			{
				objSVG.changeUseHref(useID,"#svgArrowRight");
			}
			else
			{
				objSVG.changeUseHref(useID,"#svgArrowDown");
			}
		}
	};
	
	NSHierarchicalGrid.prototype.__resetRow = function(row,item)
	{
		var index = item[this.__nsGrid.__fieldIndex];
		row.style.display = "";
		row.setAttribute("ns-index",index);
		item[this.__nsGrid.__fieldRowHtml] = row;
		this.__updateRow(row,item);
	};
	
	NSHierarchicalGrid.prototype.__addRowsforScrollPagination = function(fromRecord,toRecord,pageSize)
	{
		//console.log("In __addRowsforScrollPagination " + fromRecord + "," + toRecord + "," + pageSize);
		var arrArray = this.__nsGrid.__arrFlatHierarchicalSource.slice(fromRecord,toRecord + 1); 
		this.__nsGrid.__addRemoveRowCallInternal = true;
		this.__nsGrid.addRows(arrArray);
	};
	
	NSHierarchicalGrid.prototype.__addRowsforPagePagination = function(fromRecord,toRecord,pageSize)
	{
		//slice returns index range from fromRecord to toRecord - 1 hence adding 1 
		//this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrWrapper.slice(fromRecord,toRecord + 1);
		this.__nsGrid.__resetDataInBody(fromRecord,toRecord);
	};
	
	return NSHierarchicalGrid;
})();
nsModuleExport(this,"NSHierarchicalGrid",NSHierarchicalGrid); "use strict";
var NSGroupingGrid = (function()
{
	function NSGroupingGrid(nsGrid,nsUtil) 
	{
		this.__nsGrid = nsGrid;
		this.util = nsUtil;
		
		this.__ARROW_COLLAPSE_PATH = "M 10,5.99994L 6,5.99994L 6,9.99994L 4,9.99994L 4,5.99994L 0,5.99994L 0,3.99994L 4,3.99994L 4,-6.10352e-005L 6,-6.10352e-005L 6,3.99994L 10,3.99994L 10,5.99994 Z";
		
		this.__isSingleLevelMode = true; 
		this.__groupSource = null;
		this.__fieldColNameArrow = this.__nsGrid.getID() + "_arrow_field";
		this.__groupColumnFieldName = this.__nsGrid.getID() + "_group_field";
		this.__childrenCountField = this.__nsGrid.getID() + "_children_count_field";
		this.__rowCounter = -1;
	}
	 /********************************Common Functions for Grid ****************************************/
	NSGroupingGrid.prototype.__initialize = function ()
	{
		var setGroupColumn = false;
		if(this.__nsGrid.hasAttribute("isSingleLevelGrouping"))
		{
			this.__isSingleLevelMode =  Boolean.parse(this.__nsGrid.getAttribute("isSingleLevelGrouping"));
		}
		if(this.__nsGrid.hasAttribute("multiLevelGroupColumn"))
		{
			this.__multiLevelGroupColumn = this.__nsGrid.getAttribute("multiLevelGroupColumn");
			if(this.__multiLevelGroupColumn)
			{
				if(this.__multiLevelGroupColumn.dataField)
				{
					this.__groupColumnFieldName = this.__multiLevelGroupColumn.dataField;
				}
				else
				{
					this.__multiLevelGroupColumn.dataField = this.__groupColumnFieldName;
				}
				if(!this.__multiLevelGroupColumn.groupRenderer)
				{
					this.__multiLevelGroupColumn.groupRenderer = this.__groupTextRenderer.bind(this);
				}
			}
			else
			{
				setGroupColumn = true;
			}
		}
		else
		{
			setGroupColumn = true;
		}
		if(setGroupColumn)
		{
			this.__multiLevelGroupColumn = {headerText:"Group",dataField:this.__groupColumnFieldName,width:"100px",enableFilter:true,groupRenderer:this.__groupTextRenderer.bind(this)};
		}
	};
	
	NSGroupingGrid.prototype.propertyChange = function(attrName, oldVal, newVal, setProperty) 
	{
		var attributeName = attrName.toLowerCase();
		if(attributeName === "groupbyfield")
		{
			this.__nsGrid.__groupByField = newVal;
			this.__nsGrid.dataSource(this.__nsGrid.__dataSource,true);
		}
	};
	
	NSGroupingGrid.prototype.dataSource = function(source)
	{
		if(this.__nsGrid.__groupByField && this.__nsGrid.__groupByField.length > 0)
		{
			var arrGroupField = this.__nsGrid.__groupByField.split(",");
			var setting = {childField:this.__nsGrid.__childField,parentLevelIndicatorField:this.__nsGrid.__isParentRowField,isSingleLevel:this.__isSingleLevelMode,groupField:this.__multiLevelGroupColumn.dataField,childrenCountField:this.__childrenCountField};
			var groupCollection = new this.util.groupCollection(this.__nsGrid.__dataSource,setting);
			this.__groupSource = groupCollection.groupBy(arrGroupField);
			if(this.__groupSource)
			{
				this.__nsGrid.__arrWrapper = this.__groupSource.slice(0);
				this.__nsGrid.__arrFilteredGroupedSource =  this.__groupSource.slice(0);
				this.__setWrapperSource(this.__nsGrid.__arrWrapper,0,-1,0,true);
			}
			else
			{
				this.__nsGrid.__arrWrapper = [];
				this.__nsGrid.__arrFilteredGroupedSource =  [];
			}
			this.__nsGrid.__updateTotalRecords(this.__rowCounter);
			if(this.__nsGrid.__enablePagination && this.__nsGrid.__isPaginationModeAuto)
			{
				if(this.__nsGrid.__isPaginationTypeScroll)
				{
					this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrFlatHierarchicalSource.slice(0);//this.__nsGrid.__arrFlatHierarchicalSource.slice(0,this.__nsGrid.__INFINITE_SCROLL_INITIAL_LOAD);
					this.__nsGrid.__paginationFetchRecordCallBack = this.__addRowsforScrollPagination.bind(this);
				}
				else 
				{
					this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrFlatHierarchicalSource.slice(0,this.__nsGrid.__pageSize);
					this.__nsGrid.__createPaginationControl(this.__nsGrid.__divOuterContainer);
					this.__nsGrid.__paginationFetchRecordCallBack = this.__addRowsforPagePagination.bind(this);
				}
			}
			else
			{
				this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrFlatHierarchicalSource.slice(0);//this.__nsGrid.__arrWrapper.slice(0);
			}
		}
	};
	
	NSGroupingGrid.prototype.addItemsAsChildren = function(item,arrChildren)
	{
	};
	
	NSGroupingGrid.prototype.afterGridRendered = function()
	{
	};
	
	NSGroupingGrid.prototype.arrowClickHandler = function(parentItem,isCollapse) 
	{
	};
	
	NSGroupingGrid.prototype.expandCollapseHandler = function(item,isCollapse)
	{
	};
	
	NSGroupingGrid.prototype.__createBody = function()
	{
	};
	
	NSGroupingGrid.prototype.__createBodyBody= function(dataSet,startIndex,endIndex)
	{
	    if(dataSet && dataSet.length > 0)
	    {
	    	for (var rowIndex = startIndex; rowIndex < endIndex; rowIndex++)
		    {
	    		var item = dataSet[rowIndex];
	    		this.__createRow(item);
		    }
	    }
	};
	
	NSGroupingGrid.prototype.__setSourceForAsync= function()
	{
		this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrFlatHierarchicalSource.slice(0);
	};
	
	NSGroupingGrid.prototype.__createRowAsync= function(item,index,array)
	{
		this.__createRow(item);
	};
	
	NSGroupingGrid.prototype.__createBodyBodyVirtual= function(dataSet,totalRows,level)
	{
		if(dataSet && dataSet.length > 0)
	    {
	    	if(totalRows > dataSet.length)
	    	{
	    		totalRows = dataSet.length;
	    	}
	    	else if(this.__nsGrid.__enableVariableRowHeight)
	    	{
	    		totalRows = totalRows + this.__nsGrid.__extraRowCountForVariableHeight;
	    	}
	    	this.__createBodyBody(dataSet,0,totalRows);
	    }
	};
	
	NSGroupingGrid.prototype.__checkForAdditionalColumns = function()
	{
		var colArrow = {};
		if(this.__isSingleLevelMode)
		{
			colArrow.headerText = "";
			colArrow.dataField = this.__fieldColNameArrow;
			colArrow.width = "50px";
			colArrow.enableFilter = false;
		}
		else
		{
			colArrow = this.__multiLevelGroupColumn;
			var arrGroupField = this.__nsGrid.__groupByField.split(",");
			for(var count = 0;count < arrGroupField.length;count++)
			{
				var field = arrGroupField[count];
				var objField = this.__nsGrid.__getColumnObjectByDataField(field,this.__nsGrid.__orignalColumns);
				if(objField)
				{
					objField[this.__nsGrid.__fieldColVisible] = false;
				}
			}
		}
		colArrow.sortable = false;
		colArrow.sortDescending = true;
		colArrow.draggable = false;
		colArrow.resizable = true;
		colArrow.isExportable = false;
		colArrow.enableEditable = false;
		
		this.__nsGrid.__orignalColumns.splice(0, 0, colArrow);
	};
	
	NSGroupingGrid.prototype.__setMeasurement = function()
	{
	};
	
	NSGroupingGrid.prototype.__addSVGInPage = function(objSVG)
	{
		var minusID = "svgMinus";
		var minusRect = objSVG.createRect(minusID + "Rect",0,0,10,2,null);
		objSVG.addElementInSymbol(minusID,"0 0 16 16",minusRect);
		var plusID = "svgPlus";
		objSVG.addPath(plusID,this.__ARROW_COLLAPSE_PATH,"0 0 16 16");
	};
	
	NSGroupingGrid.prototype.__setWrapperSource = function(source,offset,parentIndex,level,setFieldIndex)
	{
		if(source)
		{
			if(level === 0)
			{
				if(!offset)
				{
					offset = 0;
				}
				this.__nsGrid.__arrFlatHierarchicalSource = [];
				this.__rowCounter = offset;
			}
			var length = source.length;
			var count = 0;
			var item = null;
			if(this.__nsGrid.__renderInCachedMode)
			{
				for (count = 0; count < length; count++) 
				{
					item = source[count];
					this.__rowCounter++;
					this.__nsGrid.__arrFlatHierarchicalSource.push(item);
					this.__setRowItemProperty(item,parentIndex,level,setFieldIndex);
					var colLength = this.__nsGrid.__columns.length;
					var arrCellsText = [];
					for (var colIndex = 0; colIndex < colLength; colIndex++)
			        {
			        	var colItem = this.__nsGrid.__columns[colIndex];
			            var cellDiv = this.util.createDiv(null);
			            this.__nsGrid.__addCellText(null,item,cellDiv,colItem,colIndex);
			            arrCellsText.push(cellDiv);
			        }
					item[this.__nsGrid.__fieldCellText] = arrCellsText;
				}
			}
			else
			{
				for (count = 0; count < length; count++) 
				{
					item = source[count];
					this.__rowCounter++;
					this.__nsGrid.__arrFlatHierarchicalSource.push(item);
					this.__setRowItemProperty(item,parentIndex,level,setFieldIndex);
				}
			}
		}
	};
	
	/*useVisibleIndex flag is used when we want to use visible index,generally true for all cases except for expandCollapse all due to performance issues*/  
	NSGroupingGrid.prototype.__resetDataInBody= function(fromIndex,toIndex,fromRowIndex,useVisibleIndex)
	{
		if(!fromRowIndex)
		{
			fromRowIndex = 0;
		}
		if(!useVisibleIndex)
		{
			useVisibleIndex = false;
		}
		var row = null;
		var item = null;
		var arrRows = this.__nsGrid.__tblCenterBodyBody.rows;
		var rowLength = arrRows.length;
		var length = this.__nsGrid.__arrFlatHierarchicalSource.length;
		var indexCount = fromIndex;
		var rowCount = fromRowIndex;
		for(var count = fromIndex; count < length; count++)
		{
			if(this.__nsGrid.__enableVirtualScroll && useVisibleIndex)
			{
				item = this.__nsGrid.__getVisibleItemByIndex(this.__nsGrid.__arrFlatHierarchicalSource,count);
			}
			else
			{
				item = this.__nsGrid.__arrFlatHierarchicalSource[count];
			}
			//breaking if item not found as if large data set is rendered and after collapse all the while scrolling after a while item is null still it goes to end of data set which are hidden
			if(item)
			{
				if(item[this.__nsGrid.__fieldRowVisible])
				{
					if(rowLength <= rowCount) // || indexCount > toIndex
					{
						break;
					}
					row = arrRows[rowCount];
					this.__resetRow(row,item);
					indexCount++;
					rowCount++;
				}
			}
			else
			{
				break;
			}
		}
		for(var rowIndex = rowCount;rowIndex < rowLength;rowIndex++)
		{
			row = arrRows[rowIndex];
			row.style.display = "none";
			row.setAttribute("ns-index",null);
			row.setAttribute("ns-level",null);
			row.setAttribute("ns-parent-index",null);
		}
	};
	
	NSGroupingGrid.prototype.__updateCellText = function(row,cell,item,colItem,rowIndex,colIndex)
	{
		if(cell && item && colItem)
		{
			this.util.removeAllChildren(cell);
			var cellDiv = this.util.createDiv(null);
			var divText = this.__setBodyCellProperty(row,cell,cellDiv,item,rowIndex,colItem,colIndex,item[this.__nsGrid.__fieldParentIndex],item[this.__nsGrid.__fieldRowLevel]);
			//this.__nsGrid.__highlightDiv(divText,colIndex);
			cell.appendChild(cellDiv);
		}
	};
	
	NSGroupingGrid.prototype.__getFlatSource = function()
	{
		return this.__nsGrid.__arrFlatHierarchicalSource;
	};
	
	NSGroupingGrid.prototype.__isCellEditable = function(objColumn,item,cell,cellIndex,row,rowIndex)
	{
		if(item && item[this.__nsGrid.__fieldHasChild] > 0)
		{
			return false;
		}
		return true;
	};
	
	NSGroupingGrid.prototype.__handleOnDemandClick = function(item,event)
	{
	};
	
	/********************************End of Common Functions for Grid ****************************************/
	NSGroupingGrid.prototype.__createRow = function(item,itemIndex,isAdd)
	{
		if(item && item[this.__nsGrid.__fieldRowVisible])
		{
			isAdd = this.util.isUndefinedOrNull(isAdd) ? true : Boolean.parse(isAdd);
			var row = document.createElement("TR");
			item[this.__nsGrid.__fieldRowHtml] = row;
			var index = item[this.__nsGrid.__fieldIndex];
			var level = item[this.__nsGrid.__fieldRowLevel];
			var parentIndex = item[this.__nsGrid.__fieldParentIndex];
			row.setAttribute("ns-index",index);
			row.setAttribute("ns-level",level);
			if(item[this.__nsGrid.__fieldHasParent])
		    {
				row.setAttribute("ns-parent-index",parentIndex);
		    }
			this.__nsGrid.__setBodyRowProperty(row,item,index);
			this.__nsGrid.__applyCustomClass(row,"bodyRow");
			var colLength = this.__nsGrid.__columns.length;
			for (var colIndex = 0; colIndex < colLength; colIndex++)
		    {
				var colItem = this.__nsGrid.__columns[colIndex];
				var cell =  this.__nsGrid.__createBodyRowCell(row,colIndex,true);
	            var cellDiv = cell.firstChild;
	            var divText = this.__setBodyCellProperty(row,cell,cellDiv,item,index,colItem,colIndex,parentIndex,level);
	            //this.__nsGrid.__highlightDiv(divText,colIndex);
	            cell.appendChild(cellDiv);
	            this.__nsGrid.__setBodyCellProperties.bind(this.__nsGrid)(cell);
		    }
			if(isAdd)
			{
				var addRow = true;
				if(!this.util.isUndefinedOrNull(itemIndex) && itemIndex > 0 && this.__nsGrid.__tblCenterBodyBody.children 
						&& this.__nsGrid.__tblCenterBodyBody.children.length >= itemIndex)
				{
					var prevRow = this.__nsGrid.__tblCenterBodyBody.children[itemIndex - 1]; //this.__nsGrid.__getRowByIndex(itemIndex);
					if(prevRow)
					{
						this.__nsGrid.__tblCenterBodyBody.insertBefore(row,prevRow);
						addRow = false;
					}
				}
				if(addRow)
				{
					this.__nsGrid.__tblCenterBodyBody.appendChild(row);
				}
			}
			this.__nsGrid.__createFixedBodyRow(row);
			return row;
		}
		return null;
	};
	
	NSGroupingGrid.prototype.__updateRow = function(row,item)
	{
		if(row && item)
		{
			var index = item[this.__nsGrid.__fieldIndex];
			var level = item[this.__nsGrid.__fieldRowLevel];
			var parentIndex = item[this.__nsGrid.__fieldParentIndex];
			row.setAttribute("ns-index",index);
			row.setAttribute("ns-level",level);
			if(item[this.__nsGrid.__fieldHasParent])
		    {
				row.setAttribute("ns-parent-index",parentIndex);
		    }
			else
			{
				row.setAttribute("ns-parent-index",null);
			}
			if(item[this.__nsGrid.__fieldSelected])
			{
				this.util.addStyleClass(row,this.__nsGrid.__CLASS_SELECTED_ROW);
			}
			else
			{
				this.util.removeStyleClass(row,this.__nsGrid.__CLASS_SELECTED_ROW);
			}
			var cells = row.cells;
			for (var colIndex = 0; colIndex < this.__nsGrid.__columns.length; colIndex++)
	        {
				var cell = cells[colIndex];
				var colItem = this.__nsGrid.__columns[colIndex];
				this.__updateCellText(row,cell,item,colItem,index,colIndex);
	        }
		}
	};
	
	NSGroupingGrid.prototype.__setRowItemProperty = function(item,parentIndex,level,setFieldIndex)
	{
		if(item)
		{
			var totalRowCount = this.__rowCounter;
			if(setFieldIndex)
			{
				item[this.__nsGrid.__fieldIndex] = totalRowCount;
			}
			item[this.__nsGrid.__fieldVisibleIndex] = totalRowCount;
			item[this.__nsGrid.__fieldRowLevel] = level;
			var hasChild = false;
			if(item.hasOwnProperty(this.__nsGrid.__childField) && item[this.__nsGrid.__childField] && item[this.__nsGrid.__childField].length > 0)
		    {
		    	hasChild = true;
		    	this.__setWrapperSource(item[this.__nsGrid.__childField],0,totalRowCount,level + 1,setFieldIndex);
		    }
			item[this.__nsGrid.__fieldParentIndex] = parentIndex;
			if(parentIndex > -1)
		    {
				item[this.__nsGrid.__fieldHasParent] = true;
		    }
			else
			{
				item[this.__nsGrid.__fieldHasParent] = false;
			}
			item[this.__nsGrid.__fieldHasChild] = hasChild;
			item[this.__nsGrid.__fieldRowVisible] = true;
			item[this.__nsGrid.__fieldIsCollapsed] = false;
		}
	};
	
	NSGroupingGrid.prototype.__setBodyCellProperty = function(row,cell,cellDiv,item,currentIndex,colItem,colIndex,parentIndex,level)
	{
		var hierarchicalPadding = 0;
		var divText = null;
		if(colItem && colItem.hasOwnProperty("dataField") && colItem["dataField"])
		{
	        if(colIndex == 0 && item[this.__nsGrid.__childField]  && item[this.__nsGrid.__childField].length > 0)
	        {
	        	this.util.addStyleClass(cellDiv,this.__nsGrid.__CLASS_GROUP_CELL);
	        	this.__nsGrid.__createArrow(item,currentIndex,cellDiv,item[this.__nsGrid.__fieldIsCollapsed],colItem);
	        	var cellText = this.util.createDiv(null,this.__nsGrid.__CLASS_CELL_CHILD);
	        	cellText.style.verticalAlign = "top";
	        	divText = cellText;
	        	if(this.__nsGrid.__renderInCachedMode)
	        	{
	        		var arrCellsText = item[this.__nsGrid.__fieldCellText];
	        		cellText.innerHTML = arrCellsText[colIndex].outerHTML;
	        	}
	        	else
	        	{
	        		this.__nsGrid.__addCellText(row,item,cellText,colItem,colIndex);
	        	}
	        	if(this.__nsGrid.__showExpandCollapseIcon)
	        	{
	        		this.util.addStyleClass(cellText,"nsGroupCellText");
	        	}
	        	cellDiv.appendChild(cellText);
	        }
	        else
	        {
	        	this.util.addStyleClass(cellDiv,this.__nsGrid.__CLASS_CELL_CHILD);
	        	if(this.__nsGrid.__renderInCachedMode)
	        	{
	        		var arrCellsText = item[this.__nsGrid.__fieldCellText];
	        		cellDiv.innerHTML = arrCellsText[colIndex].outerHTML;
	        	}
	        	else
	        	{
	        		this.__nsGrid.__addCellText(row,item,cellDiv,colItem,colIndex);
	        	}
	        	divText = cellDiv;
	        	//24 = 16(Arrow Width) + 6(Arrow Parent Padding) + 2(cellDiv horizontalGap between elements shown in debugger)
	        	hierarchicalPadding = 24;
	        }
	        if(colIndex == 0)
	        {
	        	if(level === 0 || !this.__nsGrid.__showExpandCollapseIcon)
	        	{
	        		cell.style.paddingLeft = "1px";
	        	}
	        	else
	        	{
	        		var paddingLeft = (10 * level) + hierarchicalPadding;
	        		cell.style.paddingLeft = paddingLeft + "px";
	        	}
	        }
		}
		this.__nsGrid.__addPriorityClassInCell(cell,colItem);
		return divText;
	};
	
	NSGroupingGrid.prototype.__createArrow = function(compArrow,objSVG,arrowID,isCollapsed,item,colItem)
	{
		 compArrow.style.paddingTop = "0px";
		 if(this.__nsGrid.__isRowExpansionIconCustom())
		 {
			 this.__setArrowDirection(compArrow,isCollapsed,colItem);
		 }
		 else
		 {
			 var classArrow = "nsGridGroupIcon"; 
			 var svg = objSVG.addSVG(compArrow,arrowID + "svg","nsGridGroupSVG",null,null,null,null,null,null,true);
			 this.util.addStyleClass(svg,classArrow);
			 this.util.addStyleClass(svg,classArrow + "Theme");
			 if(isCollapsed)
			 {
				 objSVG.addUse(svg,arrowID + "use",null,"#svgPlus");
			 }
			 else
			 {
				 objSVG.addUse(svg,arrowID + "use",null,"#svgMinus");
			 }
		 }
	};
	
	NSGroupingGrid.prototype.__setArrowDirection = function(compArrow,isCollapsed,colItem)
	{
		if(this.__nsGrid.__isRowExpansionIconCustom())
		{
			if(isCollapsed)
			{
				compArrow.innerHTML = this.__nsGrid.__getCustomIcon("rowCollapsed");
			}
			else
			{
				compArrow.innerHTML = this.__nsGrid.__getCustomIcon("rowExpanded");
			}
		}
		else
		{
			var objSVG = new NSSvg();
			var useID = compArrow.getAttribute("id") + "use";
			if(isCollapsed)
			{
				objSVG.changeUseHref(useID,"#svgPlus");
			}
			else
			{
				objSVG.changeUseHref(useID,"#svgMinus");
			}
		}
	};
	
	NSGroupingGrid.prototype.__resetRow = function(row,item)
	{
		var index = item[this.__nsGrid.__fieldIndex];
		row.style.display = "";
		row.setAttribute("ns-index",index);
		item[this.__nsGrid.__fieldRowHtml] = row;
		this.__updateRow(row,item);
	};
	
	NSGroupingGrid.prototype.__addRowsforScrollPagination = function(fromRecord,toRecord,pageSize)
	{
		//console.log("In __addRowsforScrollPagination " + fromRecord + "," + toRecord + "," + pageSize);
		var arrArray = this.__nsGrid.__arrFlatHierarchicalSource.slice(fromRecord,toRecord + 1); 
		this.__nsGrid.__addRemoveRowCallInternal = true;
		this.__nsGrid.addRows(arrArray);
	};
	
	NSGroupingGrid.prototype.__addRowsforPagePagination = function(fromRecord,toRecord,pageSize)
	{
		//slice returns index range from fromRecord to toRecord - 1 hence adding 1 
		//this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrWrapper.slice(fromRecord,toRecord + 1);
		this.__nsGrid.__resetDataInBody(fromRecord,toRecord);
	};
	
	NSGroupingGrid.prototype.__groupTextRenderer = function(data,dataField,rowIndex,columnIndex,row,arrChildren,childrenCount,arrAllChildItems,groupLevel)
	{
		if(data && data.hasOwnProperty(dataField))
		{
			var innerHTML = "<span>" + data[dataField];
			if(childrenCount)
			{
				innerHTML += " &#40;" + childrenCount + "&#41;";
			}
			innerHTML += "</span>";
			return innerHTML;
		}
		return "";
	};
	
	return NSGroupingGrid;
})();
nsModuleExport(this,"NSGroupingGrid",NSGroupingGrid);
 "use strict"; 
var NSMasterDetailGrid = (function()
{
	function NSMasterDetailGrid(nsGrid,nsUtil) 
	{
		this.__nsGrid = nsGrid;
		this.util = nsUtil;
		
		this.__ARROW_COLLAPSE_PATH = "M 0 9.99994L 6.10352e-005 -3.05176e-005L 5 5.00006L 0 9.99994 Z";
		this.__ARROW_EXPANDED_PATH = "M 0 3.05176e-005L 9.99994 9.15527e-005L 4.99988 5.00003L 0 3.05176e-005 Z";
		this.__CLASS_ARROW = "nsGridArrowFill";
		this.__rowCounter = -1;
		this.__masterDetailHasChildField = "hasChildren";
		this.__masterDetailHasChildCallback = null;
		//Detail Grid Settings
		this.__masterDetailColumns = null;
		this.__masterDetailGetDataSourceCallback = null;
		this.__masterDetailGridSetting = null;
		this.__masterDetailDoesGridRefreshEverytimeCallback = null;
		this.__masterDetailGridDetailHtmlCallback = null;
		//End of Detail Grid Settings
		//Custom Detail Renderer
		this.__masterDetailDetailRenderer = null;
		this.__masterDetailDetailRendererParam = null;
		//End of Custom Detail Renderer
		this.__masterDetailHeight = -1;
		this.__filteringRendering = false;//flag which stops the Detail Component being Rendered while filtering id going on 
		
		this.__detailCell = this.__nsGrid.__fieldPrefix + "_detail_cell";
		this.__detailIndicatorField = this.__nsGrid.__fieldPrefix + "_detail_indicator_field";
		this.__detailCompInstance = this.__nsGrid.__fieldPrefix + "_detail_component_instance";
		this.__detailCompParentItem = this.__nsGrid.__fieldPrefix + "_detail_parent_item";
		this.__detailCompElement = this.__nsGrid.__fieldPrefix + "_detail_element";
		this.__detailCompGridIns = this.__nsGrid.__fieldPrefix + "_grid_instance";
	}
	/********************************Common Functions for Grid ****************************************/
	NSMasterDetailGrid.prototype.__initialize = function ()
	{
		var gridSetting = this.__nsGrid.__setting;
		var setting = gridSetting.masterDetailSetting;
		if(setting)
		{
			if(setting.hasOwnProperty("hasChildField"))
			{
				this.__masterDetailHasChildField = setting["hasChildField"];
			}
			else if(setting.hasOwnProperty("hasChildCallback"))
			{
				this.__masterDetailHasChildCallback = setting["hasChildCallback"];
				this.__masterDetailHasChildCallback = this.util.getFunction(this.__masterDetailHasChildCallback);
			}
			if(setting.hasOwnProperty("detailColumns"))
			{
				this.__masterDetailColumns = setting["detailColumns"];
			}
			if(setting.hasOwnProperty("detailDataSourceCallback"))
			{
				this.__masterDetailGetDataSourceCallback = setting["detailDataSourceCallback"];
				this.__masterDetailGetDataSourceCallback = this.util.getFunction(this.__masterDetailGetDataSourceCallback);
			}
			if(setting.hasOwnProperty("detailGridSetting"))
			{
				this.__masterDetailGridSetting = setting["detailGridSetting"];
			}
			if(setting.hasOwnProperty("gridRefreshEverytimeCallback"))
			{
				this.__masterDetailDoesGridRefreshEverytimeCallback = setting["gridRefreshEverytimeCallback"];
				this.__masterDetailDoesGridRefreshEverytimeCallback = this.util.getFunction(this.__masterDetailDoesGridRefreshEverytimeCallback);
			}
			if(setting.hasOwnProperty("gridHtmlCallback"))
			{
				this.__masterDetailGridDetailHtmlCallback = setting["gridHtmlCallback"];
				this.__masterDetailGridDetailHtmlCallback = this.util.getFunction(this.__masterDetailGridDetailHtmlCallback);
			}
			if(setting.hasOwnProperty("detailRenderer"))
			{
				this.__masterDetailDetailRenderer = setting["detailRenderer"];
				this.__masterDetailDetailRenderer = this.util.getFunction(this.__masterDetailDetailRenderer);
			}
			if(setting.hasOwnProperty("detailRendererParam"))
			{
				this.__masterDetailDetailRendererParam = setting["detailRendererParam"];
			}
			if(setting.hasOwnProperty("detailHeight"))
			{
				this.__masterDetailHeight = parseInt(setting["detailHeight"]);
			}
			if(!this.__masterDetailHasChildField && !this.__masterDetailHasChildCallback)
			{
				this.util.throwNSError("NSGrid","Enter either childDetectionField or childDetectionCallback value in masterDetailSetting.");
			}
			if(!(((this.__masterDetailColumns && this.__masterDetailColumns.length) && this.__masterDetailGetDataSourceCallback) || this.__masterDetailDetailRenderer))
			{
				this.util.throwNSError("NSGrid","Enter either detailColumns and detailDataSourceCallback or detailRenderer value in masterDetailSetting.");
			}
		}
	};
	
	NSMasterDetailGrid.prototype.propertyChange = function(attrName, oldVal, newVal, setProperty) 
	{
		var attributeName = attrName.toLowerCase();
	};
	
	NSMasterDetailGrid.prototype.dataSource = function(source)
	{
		this.__addChildrenToSource(this.__nsGrid.__dataSource);
		this.__nsGrid.__arrWrapper = this.__nsGrid.__dataSource.slice(0);
		this.__nsGrid.__arrFilteredGroupedSource = this.__nsGrid.__arrWrapper.slice(0);
		this.__setWrapperSource(this.__nsGrid.__arrWrapper,0,-1,0,true,true,true);
		this.__nsGrid.__updateTotalRecords(this.__rowCounter);
		if(this.__nsGrid.__enablePagination && this.__nsGrid.__isPaginationModeAuto)
		{
			if(this.__nsGrid.__isPaginationTypeScroll)
			{
				this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrFlatHierarchicalSource.slice(0);//this.__nsGrid.__arrFlatHierarchicalSource.slice(0,this.__nsGrid.__INFINITE_SCROLL_INITIAL_LOAD);
				this.__nsGrid.__paginationFetchRecordCallBack = this.__addRowsforScrollPagination.bind(this);
			}
			else 
			{
				this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrFlatHierarchicalSource.slice(0,this.__nsGrid.__pageSize);
				this.__nsGrid.__createPaginationControl(this.__nsGrid.__divOuterContainer);
				this.__nsGrid.__paginationFetchRecordCallBack = this.__addRowsforPagePagination.bind(this);
			}
		}
		else
		{
			this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrFlatHierarchicalSource.slice(0);//this.__nsGrid.__arrWrapper.slice(0);
		}
	};
	
	NSMasterDetailGrid.prototype.addItemsAsChildren = function(item,arrChildren)
	{
		if(item && arrChildren && arrChildren.length > 0)
		{
			if(!item[this.__nsGrid.__childField])
			{
				item[this.__nsGrid.__childField] = [];
			}
			item[this.__nsGrid.__childField].push.apply(item[this.__nsGrid.__childField], arrChildren);
			this.__setWrapperSource(this.__nsGrid.__arrWrapper,0,-1,0,true,false,false);
			this.__nsGrid.__updateTotalRecords(this.__rowCounter);
			if(!(this.__nsGrid.__enablePagination && this.__nsGrid.__isPaginationModeAuto))
			{
				this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrFlatHierarchicalSource.slice(0);
				item[this.__nsGrid.__fieldRowVisible] = true;
				item[this.__nsGrid.__fieldIsCollapsed] = false;
		   		var row = this.__nsGrid.__getRowFromItem(item);
		   		var rowIndex = this.__nsGrid.__getIndexByItem(item);
		   		this.__nsGrid.__showHideRow(rowIndex,null,false);
			}
		}
	};
	
	NSMasterDetailGrid.prototype.afterGridRendered = function()
	{
		this.__nsGrid.__expandCollapseAll(true);
	};
	
	NSMasterDetailGrid.prototype.afterFiltering = function(isReset)
	{
		var self = this;
		//first expand all the rows so that the indexes of detail items are valid and then collapse the rows after 0 sec.
		//while this collapsing and expanding happens .. disable the detail component to be called/created for performance.
		this.__filteringRendering = true;
		this.__nsGrid.__expandCollapseAll(false);
		setTimeout(function() {
			self.__nsGrid.__expandCollapseAll(true);
			setTimeout(function(){
				//reset the flag so that the detail compoent can be created again
				self.__filteringRendering = false;
			}, 50);
		},0);
	};
	
	NSMasterDetailGrid.prototype.arrowClickHandler = function(parentItem,isCollapse)
	{
		if(!isCollapse && parentItem && parentItem[this.__nsGrid.__fieldHasChild]) 
		{
			var childIndex = parentItem[this.__nsGrid.__fieldIndex] + 1;
			var childItem = this.__nsGrid.__getItemByIndex(childIndex);
			if(childItem) {
				/*var childRow = childItem[this.__nsGrid.__fieldRow];
				if(childRow) {
					var childCell = childRow.firstChild;
					this.__renderDetailCell(childCell,childItem,item,childRow);
				}*/
				this.expandCollapseHandler(childItem,isCollapse);
			}
		}
	};
	
	NSMasterDetailGrid.prototype.expandCollapseHandler = function(item,isCollapse)
	{
		if(!isCollapse && item && item[this.__detailIndicatorField]) 
		{
			var row = item[this.__nsGrid.__fieldRow];
			if(row) 
			{
				var cell = row.firstChild;
				this.__renderDetailCell(cell,item,null,row);
			}
		}
	};
	
	NSMasterDetailGrid.prototype.__createBodyBody = function(dataSet,startIndex,endIndex)
	{
	    if(dataSet && dataSet.length > 0)
	    {
	    	for (var rowIndex = startIndex; rowIndex < endIndex; rowIndex++)
		    {
	    		var item = dataSet[rowIndex];
	    		this.__createRow(item);
		    }
	    }
	};
	
	NSMasterDetailGrid.prototype.__setSourceForAsync = function()
	{
		this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrFlatHierarchicalSource.slice(0);
	};
	
	NSMasterDetailGrid.prototype.__createRowAsync = function(item,index,array)
	{
		this.__createRow(item);
	};
	
	NSMasterDetailGrid.prototype.__createBodyBodyVirtual = function(dataSet,totalRows,level)
	{
		if(dataSet && dataSet.length > 0)
	    {
	    	if(totalRows > dataSet.length)
	    	{
	    		totalRows = dataSet.length;
	    	}
	    	else if(this.__nsGrid.__enableVariableRowHeight)
	    	{
	    		totalRows = totalRows + this.__nsGrid.__extraRowCountForVariableHeight;
	    	}
	    	this.__createBodyBody(dataSet,0,totalRows);
	    }
	};
	
	NSMasterDetailGrid.prototype.__createBody = function()
	{
	};
	
	NSMasterDetailGrid.prototype.__checkForAdditionalColumns = function()
	{
	};
	
	NSMasterDetailGrid.prototype.__setMeasurement = function()
	{
	};
	
	NSMasterDetailGrid.prototype.__addSVGInPage = function(objSVG)
	{
		objSVG.addPath("svgArrowDown",this.__ARROW_EXPANDED_PATH,"0 0 16 16");
		objSVG.addPath("svgArrowRight",this.__ARROW_COLLAPSE_PATH,"0 0 16 16");
	};
	
	NSMasterDetailGrid.prototype.__setWrapperSource = function(source,offset,parentIndex,level,setFieldIndex,setIsCollapsed,setItemVisible)
	{
		if(source)
		{
			if(level === 0)
			{
				if(!offset)
				{
					offset = 0;
				}
				this.__nsGrid.__arrFlatHierarchicalSource = [];
				this.__rowCounter = offset;
			}
			var length = source.length;
			var count = 0;
			var item = null;
			/*if(this.__nsGrid.__renderInCachedMode)
			{
				for (count = 0; count < length; count++) 
				{
					item = source[count];
					this.__rowCounter++;
					this.__nsGrid.__arrFlatHierarchicalSource.push(item);
					this.__setRowItemProperty(item,parentIndex,level,setFieldIndex,setIsCollapsed,setItemVisible);
					var colLength = this.__nsGrid.__columns.length;
					var arrCellsText = [];
					for (var colIndex = 0; colIndex < colLength; colIndex++)
			        {
			        	var colItem = this.__nsGrid.__columns[colIndex];
			            var cellDiv = this.util.createDiv(null);
			            this.__nsGrid.__addCellText(null,item,cellDiv,colItem,colIndex);
			            arrCellsText.push(cellDiv);
			        }
					item[this.__nsGrid.__fieldCellText] = arrCellsText;
				}
			}
			else
			{*/
			for (count = 0; count < length; count++) 
			{
				item = source[count];
				this.__rowCounter++;
				this.__nsGrid.__arrFlatHierarchicalSource.push(item);
				this.__setRowItemProperty(item,parentIndex,level,setFieldIndex,setIsCollapsed,setItemVisible);
			}
			//}
		}
	};
	
	/*useVisibleIndex flag is used when we want to use visible index,generally true for all cases except for expandCollapse all due to performance issues*/  
	NSMasterDetailGrid.prototype.__resetDataInBody = function(fromIndex,toIndex,fromRowIndex,useVisibleIndex)
	{
		if(!fromRowIndex)
		{
			fromRowIndex = 0;
		}
		var row = null;
		var item = null;
		var arrRows = this.__nsGrid.__tblCenterBodyBody.rows;
		var rowLength = arrRows.length;
		var length = this.__nsGrid.__arrFlatHierarchicalSource.length;
		var indexCount = fromIndex;
		var rowCount = fromRowIndex;
		for(var count = fromIndex; count < length; count++)
		{
			if(this.__nsGrid.__enableVirtualScroll && useVisibleIndex)
			{
				item = this.__nsGrid.__getVisibleItemByIndex(this.__nsGrid.__arrFlatHierarchicalSource,count);
			}
			else
			{
				item = this.__nsGrid.__arrFlatHierarchicalSource[count];
			}
			//breaking if item not found as if large data set is rendered and after collapse all the while scrolling after a while item is null still it goes to end of data set which are hidden
			if(item)
			{
				if(item[this.__nsGrid.__fieldRowVisible])
				{
					if(rowLength <= rowCount) // || indexCount > toIndex
					{
						break;
					}
					row = arrRows[rowCount];
					this.__resetRow(row,item);
					indexCount++;
					rowCount++;
				}
			}
			else
			{
				break;
			}
		}
		for(var rowIndex = rowCount;rowIndex < rowLength;rowIndex++)
		{
			row = arrRows[rowIndex];
			row.style.display = "none";
			row.setAttribute("ns-index",null);
			row.setAttribute("ns-level",null);
			row.setAttribute("ns-parent-index",null);
		}
	};
	
	NSMasterDetailGrid.prototype.__updateCellText = function(row,cell,item,colItem,rowIndex,colIndex)
	{
		if(cell && item && colItem)
		{
			this.util.removeAllChildren(cell);
			var cellDiv = this.util.createDiv(null);
			var divText = this.__setBodyCellProperty(row,cell,cellDiv,item,rowIndex,colItem,colIndex,item[this.__nsGrid.__fieldParentIndex],item[this.__nsGrid.__fieldRowLevel]);
			//this.__nsGrid.__highlightDiv(divText,colIndex);
			cell.appendChild(cellDiv);
		}
	};
	
	NSMasterDetailGrid.prototype.__getFlatSource = function()
	{
		return this.__nsGrid.__arrFlatHierarchicalSource;
	};
	
	NSMasterDetailGrid.prototype.__isCellEditable = function(objColumn,item,cell,cellIndex,row,rowIndex)
	{
		return true;
	};
	
	NSMasterDetailGrid.prototype.__handleOnDemandClick = function(item,event)
	{
	};
	NSMasterDetailGrid.prototype.__ignoreFieldsForDeepCopy = function()
	{
		return [this.__detailCompInstance, this.__detailCompParentItem];
	};
	/********************************End of Common Functions for Grid ****************************************/
	NSMasterDetailGrid.prototype.__createRow = function(item,itemIndex,isAdd)
	{
		// && (!item[this.__detailCompParentItem] || item[this.__detailCompParentItem][this.__nsGrid.__fieldIsCollapsed])
		if(item && item[this.__nsGrid.__fieldRowVisible])
		{
			isAdd = this.util.isUndefinedOrNull(isAdd) ? true : Boolean.parse(isAdd);
			var row = this.util.createElement("TR");
			item[this.__nsGrid.__fieldRowHtml] = row;
			var index = item[this.__nsGrid.__fieldIndex];
			var level = item[this.__nsGrid.__fieldRowLevel];
			var parentIndex = item[this.__nsGrid.__fieldParentIndex];
			row.setAttribute("ns-index",index);
			row.setAttribute("ns-level",level);
			if(item[this.__nsGrid.__fieldHasParent])
		    {
				row.setAttribute("ns-parent-index",parentIndex);
		    }
			this.__nsGrid.__setBodyRowProperty(row,item,index);
			this.__nsGrid.__applyCustomClass(row,"bodyRow");
			var colLength = this.__nsGrid.__columns.length;
			if(item[this.__detailIndicatorField]) {
				if(!item[this.__detailCell]) {
					var cell =  this.__nsGrid.__createBodyRowCell(row,0,true);
					cell.setAttribute("colspan",this.__nsGrid.__columns.length);
					var cellDiv = cell.firstChild;
					if(this.__masterDetailHeight > 0) {
						cell.style.height = this.__masterDetailHeight + "px";
						cellDiv.style.height = "100%";
					}
					else {
						cell.style.height = "auto";
					}
					if(item[this.__detailCompElement]) {
						cellDiv.appendChild(item[this.__detailCompElement]);
					}
					else {
						//this.__renderDetailCell(cell,item,null,row);
					}
					item[this.__detailCell] = cell;
				}
				else {
					row.appendChild(item[this.__detailCell]);
				}
			}
			else {
				for (var colIndex = 0; colIndex < colLength; colIndex++)
			    {
					var colItem = this.__nsGrid.__columns[colIndex];
					var cell =  this.__nsGrid.__createBodyRowCell(row,colIndex,true);
		            var cellDiv = cell.firstChild;
		            var divText = this.__setBodyCellProperty(row,cell,cellDiv,item,index,colItem,colIndex,parentIndex,level);
		            //this.__nsGrid.__highlightDiv(divText,colIndex);
		            cell.appendChild(cellDiv);
		            this.__nsGrid.__setBodyCellProperties.bind(this.__nsGrid)(cell);
			    }
			}
			if(isAdd)
			{
				var addRow = true;
				if(!this.util.isUndefinedOrNull(itemIndex) && itemIndex > 0 && this.__nsGrid.__tblCenterBodyBody.children 
						&& this.__nsGrid.__tblCenterBodyBody.children.length >= itemIndex)
				{
					var prevRow = this.__nsGrid.__tblCenterBodyBody.children[itemIndex - 1]; //this.__nsGrid.__getRowByIndex(itemIndex);
					if(prevRow)
					{
						this.__nsGrid.__tblCenterBodyBody.insertBefore(row,prevRow);
						addRow = false;
					}
				}
				if(addRow)
				{
					this.__nsGrid.__tblCenterBodyBody.appendChild(row);
				}
			}
			this.__nsGrid.__createFixedBodyRow(row);
			return row;
		}
		return null;
	};
	
	NSMasterDetailGrid.prototype.__updateRow = function(row,item)
	{
		if(row && item)
		{
			var index = item[this.__nsGrid.__fieldIndex];
			var level = item[this.__nsGrid.__fieldRowLevel];
			var parentIndex = item[this.__nsGrid.__fieldParentIndex];
			row.setAttribute("ns-index",index);
			row.setAttribute("ns-level",level);
			if(item[this.__nsGrid.__fieldHasParent])
		    {
				row.setAttribute("ns-parent-index",parentIndex);
		    }
			else
			{
				row.setAttribute("ns-parent-index",null);
			}
			if(item[this.__nsGrid.__fieldSelected])
			{
				this.util.addStyleClass(row,this.__nsGrid.__CLASS_SELECTED_ROW);
			}
			else
			{
				this.util.removeStyleClass(row,this.__nsGrid.__CLASS_SELECTED_ROW);
			}
			var cells = row.cells;
			for (var colIndex = 0; colIndex < this.__nsGrid.__columns.length; colIndex++)
	        {
				var cell = cells[colIndex];
				var colItem = this.__nsGrid.__columns[colIndex];
				this.__updateCellText(row,cell,item,colItem,index,colIndex);
	        }
		}
	};
	
	NSMasterDetailGrid.prototype.__setRowItemProperty = function(item,parentIndex,level,setFieldIndex,setIsCollapsed,setItemVisible)
	{
		if(item)
		{
			var totalRowCount = this.__rowCounter;
			if(setFieldIndex || this.util.isUndefinedOrNull(item[this.__nsGrid.__fieldIndex]))
			{
				item[this.__nsGrid.__fieldIndex] = totalRowCount;
			}
			item[this.__nsGrid.__fieldVisibleIndex] = totalRowCount;
			item[this.__nsGrid.__fieldRowLevel] = level;
			var hasChild = false;
			if((item[this.__nsGrid.__childField] && item[this.__nsGrid.__childField].length > 0))
		    {
		    	hasChild = true;
		    	this.__setWrapperSource(item[this.__nsGrid.__childField],0,totalRowCount,level + 1,setFieldIndex,setIsCollapsed,setItemVisible);
		    }
			item[this.__nsGrid.__fieldParentIndex] = parentIndex;
			if(parentIndex > -1)
		    {
				item[this.__nsGrid.__fieldHasParent] = true;
		    }
			else
			{
				item[this.__nsGrid.__fieldHasParent] = false;
			}
			item[this.__nsGrid.__fieldHasChild] = hasChild;
			if(setItemVisible || this.util.isUndefinedOrNull(item[this.__nsGrid.__fieldRowVisible]))
			{
				item[this.__nsGrid.__fieldRowVisible] = true;
				
			}
			if(setIsCollapsed || this.util.isUndefinedOrNull(item[this.__nsGrid.__fieldIsCollapsed]))
			{
				item[this.__nsGrid.__fieldIsCollapsed] = true;//Boolean.parse(item[this.__detailIndicatorField]);
			}
		}
	};
	
	
	NSMasterDetailGrid.prototype.__setBodyCellProperty = function(row,cell,cellDiv,item,currentIndex,colItem,colIndex,parentIndex,level)
	{
		var hierarchicalPadding = 0;
		var divText = null;
		if(colItem && colItem.hasOwnProperty("dataField") && colItem["dataField"])
		{
			if(colIndex == 0 && item[this.__nsGrid.__childField]  && item[this.__nsGrid.__childField].length > 0)
	        {
	        	this.util.addStyleClass(cellDiv,this.__nsGrid.__CLASS_GROUP_CELL);
	        	this.__nsGrid.__createArrow(item,currentIndex,cellDiv,item[this.__nsGrid.__fieldIsCollapsed],colItem);
	        	var cellText = this.util.createDiv(null,this.__nsGrid.__CLASS_CELL_CHILD);
	        	cellText.style.verticalAlign = "top";
	        	divText = cellText;
	        	if(this.__nsGrid.__renderInCachedMode)
	        	{
	        		var arrCellsText = item[this.__nsGrid.__fieldCellText];
	        		cellText.innerHTML = arrCellsText[colIndex].outerHTML;
	        	}
	        	else
	        	{
	        		this.__nsGrid.__addCellText(row,item,cellText,colItem,colIndex);
	        	}
	        	this.util.addStyleClass(cellText,"nsGroupCellText");
	        	cellDiv.appendChild(cellText);
	        }
	        else
	        {
	        	this.util.addStyleClass(cellDiv,this.__nsGrid.__CLASS_CELL_CHILD);
	        	if(this.__nsGrid.__renderInCachedMode)
	        	{
	        		var arrCellsText = item[this.__nsGrid.__fieldCellText];
	        		cellDiv.innerHTML = arrCellsText[colIndex].outerHTML;
	        	}
	        	else
	        	{
	        		this.__nsGrid.__addCellText(row,item,cellDiv,colItem,colIndex);
	        	}
	        	divText = cellDiv;
	        	//24 = 16(Arrow Width) + 6(Arrow Parent Padding) + 2(cellDiv horizontalGap between elements shown in debugger)
	        	hierarchicalPadding = 24;
	        }
	        if(colIndex == 0)
	        {
	        	var paddingLeft = (10 * level) + hierarchicalPadding;
	        	if(level === 0 || !this.__nsGrid.__showExpandCollapseIcon)
	        	{
	        		paddingLeft += 2;
	        	}
	        	cell.style.paddingLeft = paddingLeft + "px";
	        }
		}
		this.__nsGrid.__addPriorityClassInCell(cell,colItem);
		return divText;
	};
	
	NSMasterDetailGrid.prototype.__createArrow = function(compArrow,objSVG,arrowID,isCollapsed,item,colItem)
	{
		 if(this.__nsGrid.__isRowExpansionIconCustom())
		 {
			 this.__setArrowDirection(compArrow,isCollapsed,colItem);
		 }
		 else
		 {
			 var svg = objSVG.addSVG(compArrow,arrowID + "svg",this.__CLASS_ARROW,null,null,null,null,null,null,true);
			 this.util.addStyleClass(svg,this.__CLASS_ARROW + "Theme");
			 if(isCollapsed)
			 {
				 objSVG.addUse(svg,arrowID + "use",null,"#svgArrowRight");
			 }
			 else
			 {
				 objSVG.addUse(svg,arrowID + "use",null,"#svgArrowDown");
			 }
		 }
	};
	
	NSMasterDetailGrid.prototype.__setArrowDirection = function(compArrow,isCollapsed,colItem)
	{
		if(this.__nsGrid.__isRowExpansionIconCustom())
		{
			if(isCollapsed)
			{
				compArrow.innerHTML = this.__nsGrid.__getCustomIcon("rowCollapsed");
			}
			else
			{
				compArrow.innerHTML = this.__nsGrid.__getCustomIcon("rowExpanded");
			}
		}
		else
		{
			var objSVG = new NSSvg();
			var useID = compArrow.getAttribute("id") + "use";
			if(isCollapsed)
			{
				objSVG.changeUseHref(useID,"#svgArrowRight");
			}
			else
			{
				objSVG.changeUseHref(useID,"#svgArrowDown");
			}
		}
	};
	
	NSMasterDetailGrid.prototype.__resetRow = function(row,item)
	{
		var index = item[this.__nsGrid.__fieldIndex];
		row.style.display = "";
		row.setAttribute("ns-index",index);
		item[this.__nsGrid.__fieldRowHtml] = row;
		this.__updateRow(row,item);
	};
	
	NSMasterDetailGrid.prototype.__addRowsforScrollPagination = function(fromRecord,toRecord,pageSize)
	{
		var arrArray = this.__nsGrid.__arrFlatHierarchicalSource.slice(fromRecord,toRecord + 1); 
		this.__nsGrid.__addRemoveRowCallInternal = true;
		this.__nsGrid.addRows(arrArray);
	};
	
	NSMasterDetailGrid.prototype.__addRowsforPagePagination = function(fromRecord,toRecord,pageSize)
	{
		//slice returns index range from fromRecord to toRecord - 1 hence adding 1 
		//this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrWrapper.slice(fromRecord,toRecord + 1);
		this.__nsGrid.__resetDataInBody(fromRecord,toRecord);
	};
	
	NSMasterDetailGrid.prototype.__addChildrenToSource = function(arrSource)
	{
		if(arrSource) {
			for(var count = 0;count < arrSource.length;count++) {
				var item = arrSource[count];
				if(!item[this.__nsGrid.__childField] || !item[this.__nsGrid.__childField].length) {
					var hasChildren = this.__hasChildren(item);
					if(hasChildren) {
						var childItem = this.util.cloneObject(item, true);
						childItem[this.__detailIndicatorField] = true;
						//only call detail component when its not between filtering
						if(!this.__filteringRendering) {
							childItem[this.__detailCompInstance] = this.__getRendererInstance(item);
						}
						childItem[this.__detailCompParentItem] = item;
						item[this.__nsGrid.__childField] = [childItem];
					}
				}
			}
		}
	};
	
	NSMasterDetailGrid.prototype.__getRendererInstance = function(parentItem)
	{
		var objRenderer = null;
		if(this.__masterDetailColumns && this.__masterDetailColumns.length) 
		{
			objRenderer = this.__getGridRenderer(this,this.__masterDetailColumns,this.__masterDetailGridSetting);
		}
		else 
		{
			objRenderer = new this.__masterDetailDetailRenderer();
		}
		return objRenderer;
	};
	
	NSMasterDetailGrid.prototype.__hasChildren = function(item)
	{
		if(item) {
			if(item.hasOwnProperty(this.__masterDetailHasChildField)) {
				return Boolean.parse(item[this.__masterDetailHasChildField]);
			}
			if(this.__masterDetailHasChildCallback) {
				return this.__masterDetailHasChildCallback(item);
			}
		}
		return false;
	};
	
	NSMasterDetailGrid.prototype.__renderDetailCell = function(cell,item,parentItem,row)
	{
		if(cell && item) {
			if(!parentItem) {
				parentItem = item[this.__detailCompParentItem];
			}
			var compInstance = item[this.__detailCompInstance];
			var cellDiv = cell.firstChild;
	        this.util.addStyleClass(cellDiv,"nsBodyDataGridCellMasterDetailCon");
	        var params = {};
	        if(this.__masterDetailDetailRendererParam) {
	        	params = this.util.cloneObject(this.__masterDetailDetailRendererParam,true);
	        }
	        params.masterData = parentItem;
	        params.container = cellDiv;
	        params.cell = cell;
	        params.row = row;
	        params.rowIndex = item[this.__nsGrid.__fieldIndex];
	        //only call detail component when its not between filtering
	        if(compInstance && !this.__filteringRendering) {
		        if(!item[this.__detailCompElement] || !compInstance.renderEverytime || compInstance.renderEverytime(params)) {
		        	var callback = function() {
		        		var childComp = this.__callComponentFunction(compInstance,"getElement",null,null,true);
				        //var childComp = compInstance.getElement();
				        cellDiv.innerHTML = "";
				        cellDiv.appendChild(childComp);
				        item[this.__detailCompElement] = childComp;
				        this.__callComponentFunction(compInstance,"elementAdded",params,null,false);
		        	};
		        	var res = this.__callComponentFunction(compInstance,"init",params,null,true);
		        	this.util.resolveFunctionOrPromise(res,callback.bind(this));
		        }
		    }
		}
	}
	
	NSMasterDetailGrid.prototype.__callComponentFunction = function(compIns,functionRef,param,defaultValue,throwError)
	{
		if(compIns && compIns[functionRef] && this.util.isFunction(compIns[functionRef]))
		{
			var retValue = null;
			var retValue = null;
			if(param && this.util.isArray(param) && param.length > 0)
			{
				retValue = compIns[functionRef].apply(null,param);
			}
			else
			{
				retValue = compIns[functionRef](param);
			}
			if(!this.util.isUndefinedOrNull(retValue))
			{
				return retValue;
			}
		}
		else if(throwError) {
			this.util.throwNSError("NSGrid","Function " + functionRef + " should be present in detail renderer.");
		}
		return defaultValue;
	};
	
	NSMasterDetailGrid.prototype.__getGridRenderer = function(parent,columns,setting) 
	{
		function GridRenderer() {
		  this.con = null;
		  this.gridCon = null;
		  this.params = null;
		  this.item = null;
		  this.objGrid = null;
		  this.arrSource = [];
		}
		
		GridRenderer.prototype.init = function(params) {
			this.params = parent.util.cloneObject(params);
			this.item = params.masterData;
			if(parent.__masterDetailGridDetailHtmlCallback) 
			{
				var html = parent.__masterDetailGridDetailHtmlCallback(params);
				if(html) 
				{
					var objComp = parent.util.getReferenceFromHtml(html);
					if(objComp.refs && objComp.refs["detailGrid"]) 
					{
						this.con = objComp.element;
						this.gridCon = objComp.refs["detailGrid"];
						return;
					}
				}
			}
			this.con = parent.util.createElement("div");
			this.con.style.height = "100%";
			this.gridCon = this.con;
			var container = params.container;
			parent.util.addStyleClass(container,"nsMasterDetailGridContainer");
		};
		
		GridRenderer.prototype.getElement = function() {
		  	return this.con;
		};
		
		GridRenderer.prototype.elementAdded = function(params) {
			this.__getGridObject();
		};
		
		GridRenderer.prototype.renderEverytime = function(params) {
			if(parent.__masterDetailDoesGridRefreshEverytimeCallback) {
				return parent.__masterDetailDoesGridRefreshEverytimeCallback(params);
			}
			return true;
		};
		//private function
		GridRenderer.prototype.__setGridSource = function(arrSource)
		{
			this.arrSource = arrSource;
			this.objGrid.dataSource.call(this.objGrid,this.arrSource);
		};
		
		GridRenderer.prototype.__getGridObject = function(arrSource) {
			
			var masterItem = this.item;
			this.objGrid = new NSGrid(this.gridCon,setting);
			this.objGrid.setColumn(columns);
			this.params.gridContainer = this.gridCon;
			this.params.setDataSource = this.__setGridSource.bind(this);
			parent.__masterDetailGetDataSourceCallback(this.params);
			return this.objGrid;
		};
		return new GridRenderer();
	};
	
	return NSMasterDetailGrid;
})();
nsModuleExport(this,"NSMasterDetailGrid",NSMasterDetailGrid);"use strict";
var NSGridEditor = (function()
{
	var NSGridEditor = function(nsGrid)
	{
		this.__nsGrid = nsGrid;
		this.util = this.__nsGrid.util;
		
		this.__config = {editType:NSGrid.EDITOR_EDITTYPE_CELL,clickType:NSGrid.EDITOR_EDITING_DOUBLECLICK,stopEditingOnGridFocusOut:false,enableMultipleEdit:false};
		this.__defaultCellSetting = {type:NSGrid.EDITOR_TYPE_TEXT,params:null,customEditor:null,validator:null,isCellEditableCallback:null};
		
		this.__table = null;
		
		this.__objEditor = {};
		this.__tblClickRef = null;
		this.__tblEventRef = null;
		
		this.initialize = function()
		{
			if(this.__nsGrid.__enableEditable)
			{
				var editorSetting = this.__nsGrid.__editorSetting;
				if(!editorSetting)
				{
					editorSetting = {};
				}
				this.__config = {
						editType:editorSetting.editType || this.__config.editType,
						clickType:editorSetting.clickType || this.__config.clickType,
						stopEditingOnGridFocusOut: Boolean.parse(editorSetting.stopEditingOnGridFocusOut),
						enableMultipleEdit: Boolean.parse(editorSetting.enableMultipleEdit)
				};
				this.__table = this.__nsGrid.__tblCenterBody;
				if(this.__config.editType != NSGrid.EDITOR_EDITING_NOCLICK)
				{
					//if(!this.__tblClickRef)
					//{
						this.__tblClickRef = this.__tblClickHandler.bind(this);
						this.util.addEvent(this.__table,"click", this.__tblClickRef);
					//}
					//if(!this.__tblEventRef)
					//{
						var mouseEvent = this.__getMouseEventType();
						this.__tblEventRef = this.__tblEventHandler.bind(this);
						this.util.addEvent(this.__table,mouseEvent, this.__tblEventRef);
					//}
				}
				if(!this.__documentKeyEventRef)
				{
					this.__documentKeyEventRef = this.__documentKeyEventHandler.bind(this);
					this.util.addEvent(document,"keydown", this.__documentKeyEventRef);
				}
				if(this.__config.stopEditingOnGridFocusOut)
				{
					this.__nsGrid.__listenInternalEvent("blur",this.__tblBlurHandler.bind(this));
				}
			}
		};
		
		this.edit = function(element,rowIndex)
		{
			element = this.__getElement(element,rowIndex);
			if(element)
			{
				this.__handleEditors(element);
			}
		};
		
		this.cancelEdit = function(element,rowIndex)
		{
			element = this.__getElement(element,rowIndex);
			this.__callCancelForEditors(element);
		};
		
		this.saveEdit = function(element,rowIndex)
		{
			element = this.__getElement(element,rowIndex);
			this.__callSaveForEditors(element);
		};
		
		/*
		 * returns array of key and value
		 * if element is null then it returns all editor instances
		 */
		this.getEditorInstances = function(element,rowIndex)
		{
			element = this.__getElement(element,rowIndex);
			return this.__getAllEditors(element);
		};
		
		this.processColumnObject = function(objColumn)
		{
			if(objColumn)
			{
				if(!objColumn.hasOwnProperty("enableEditable"))
				{
					objColumn.enableEditable = this.__nsGrid.__enableEditable;
				}
				if(objColumn["editorSetting"])
				{
					if(!objColumn["editorSetting"].hasOwnProperty("type") || !objColumn["editorSetting"]["type"])
					{
						objColumn["editorSetting"]["type"] = this.__defaultCellSetting.type;
					}
					if(objColumn["editorSetting"].hasOwnProperty("customEditor"))
					{
						var customEditor = objColumn["editorSetting"]["customEditor"];
						if (typeof customEditor === "string" || customEditor instanceof String)
						{
							if(this.util.isFunction(customEditor))
							{
								objColumn["editorSetting"]["customEditor"] = this.__nsGrid.__context[customEditor];
							}
						}
					}
				}
			}
		};
		
		this.isOtherKeyNavigationValid = function(event,cell)
		{
			var hasFocus = false;
			if(this.__config.editType == NSGrid.EDITOR_EDITTYPE_CELL)
			{
				hasFocus = this.__hasCellFocus(cell);
			}
			else
			{
				var row = this.util.findParent(cell,"TR");
				hasFocus = this.__hasRowFocus(row);
			}
			return !hasFocus;
		};
		
		this.resetVariables = function() 
		{
			this.__objEditor = {};
		};
		
		this.__documentKeyEventHandler = function(event)
		{
			if(this.__hasEditor())
			{
				event = this.util.getEvent(event);
		    	var keyCode = this.util.KEYCODE;
		    	if (event.keyCode == keyCode.ENTER) 
		      	{
		    		this.__callSaveForEditors();
		      	}
		      	else if (event.keyCode == keyCode.TAB) 
		      	{
		      		this.__callSaveForEditors();
		      		event.preventDefault();
		      	}
		      	else if (event.keyCode == keyCode.ESC) 
		      	{
		      		this.__callCancelForEditors();
		      		this.__callDestroyForRowEditors();
		        	event.preventDefault();
		      	}
		    	this.__callRowEditorsFunction("handleKeyDown",[event,event.keyCode]);
			}
		};
		
		/*
		 * for editType = cell 
		 * combination can be this.__getElement(cellIndex,rowIndex),this.__getElement(cell),this.__getElement(dataField,rowIndex)
		 * 
		 * for editType = row 
		 * combination can be this.__getElement(rowIndex),this.__getElement(row)
		 * 
		 */
		
		this.__getElement = function(element,rowIndex)
		{
			var retValue = null;
			if(!this.util.isUndefinedOrNull(element))
			{
				if(this.__config.editType == NSGrid.EDITOR_EDITTYPE_CELL)
				{
					if(this.util.isNumber(element))
					{
						if(this.util.isUndefinedOrNull(rowIndex))
						{
							return null;
						}
						var row = this.__nsGrid.__getRowByIndex(parseInt(rowIndex));
						if(row && row.cells && row.cells.length > element)
						{
							retValue = row.cells[element];
						}
					}
					else if(this.util.isElement(element))
					{
						if(element.nodeName == "TD")
						{
							retValue = element;
						}
					}
					else if(this.util.isString(element))
					{
						if(this.util.isUndefinedOrNull(rowIndex))
						{
							return null;
						}
						var cellIndex = this.__nsGrid.__getColumnIndexByObject(this.__nsGrid.__getColumnObjectByDataField(element));
						if(!this.util.isUndefinedOrNull(cellIndex))
						{
							var row = this.__nsGrid.__getRowByIndex(parseInt(rowIndex));
							if(row && row.cells && row.cells.length > cellIndex)
							{
								retValue = row.cells[cellIndex];
							}
						}
					}
				}
				else
				{
					if(this.util.isNumber(element))
					{
						retValue = this.__nsGrid.__getRowByIndex(element);
					}
					else if(this.util.isElement(element))
					{
						if(element.nodeName == "TR")
						{
							retValue = element;
						}
						else
						{
							retValue = this.util.findParent(element,"TR");
						}
					}
					//in this case row will be blank as through dataField we cannot fetch row 
					else if(this.util.isString(element))
					{
						
					}
				}
			}
			return retValue;
		};
		
		this.__tblClickHandler = function(event)
		{
			event = this.util.getEvent(event);
			var target = this.util.getTarget(event);
			var parentType = this.__getTargetType();
			var parent = this.util.findParent(target,parentType);
			if(parent)
			{
				var arrRowIndexes = Object.keys(this.__objEditor);
				if(arrRowIndexes && arrRowIndexes.length > 0)
				{
					if(!this.__config.enableMultipleEdit)
					{
						if(parentType == "TR")
						{
							//same row clicked so just return;
							var objEditors = this.__getEditorsForRow(parent);
							if(objEditors)
							{
								var arrCellIndex = Object.keys(objEditors);
								if(arrCellIndex && arrCellIndex.length > 0)
								{
									/*var cellIndex = arrCellIndex[0];
									var cellItem = objEditors[cellIndex];
									cellItem.editor.setFocus();*/
									return;
								}
							}
							else
							{
								this.__commitRowEditorChanges();
							}
						}
						else
						{
							//same cell clicked so just return;
							var editor = this.__getEditor(null,parent);
							if(editor)
							{
								editor.setFocus();
								return;
							}
							else
							{
								this.__commitRowEditorChanges();
							}
						}
					}
				}
			}
		};
		
		this.__tblEventHandler = function(event)
		{
			event = this.util.getEvent(event);
			var target = this.util.getTarget(event);
			var parentType = this.__getTargetType();
			var parent = this.util.findParent(target,parentType);
			if(parent)
			{
				this.__handleEditors(parent);
			}
		};
		
		this.__tblBlurHandler = function(event,detail)
		{
			this.__callSaveForEditors();
		};
		
		this.__popUpWrapperMouseDownHandler = function(event)
		{
			event = this.util.getEvent(event);
			event.stopPropagation();
		};
		
		this.__hasCellFocus = function(cell,editor)
		{
			var hasFocus = false;
			editor = cell ? this.__getEditor(null,cell) : editor;
			if(editor)
			{
				var element = editor.getElement();
				var hasFocusFunction = editor.hasFocus;
				if(hasFocusFunction && this.util.isFunction(hasFocusFunction))
				{
					hasFocus = hasFocusFunction(); 
				}
				else
				{
					hasFocus = (element === document.activeElement);
				}
			}
			return hasFocus;
		};
		
		this.__hasRowFocus = function(row)
		{
			if(row)
			{
				var arrEditor = this.__getOnlyEditors(row);
				if(arrEditor && arrEditor.length > 0)
				{
					for(var count = 0;count < arrEditor.length;count++)
					{
						var hasFocus = this.__hasCellFocus(null,arrEditor[count]);
						if(hasFocus)
						{
							return true;
						}
					}
					var activeElement = document.activeElement;
					if(activeElement)
					{
						var activeRow = this.util.findParent(activeElement,"TR");
						if(activeRow && activeRow == row)
						{
							return true;
						}
					}
				}
			}
			return false;
		};
		
		this.__handleEditors = function(element)
		{
			if(element.nodeName == "TD")
			{
				this.__handleCellEditor(element);
			}
			else
			{
				this.__handleRowEditors(element);
			}
		};
		
		this.__callSaveForEditors = function(element)
		{
			if(element && element.nodeName == "TD")
			{
				this.__callSaveForEditor(element);
			}
			else
			{
				this.__callSaveForRowEditors(element);
			}
		};
		
		this.__callCancelForEditors = function(element)
		{
			if(element && element.nodeName == "TD")
			{
				this.__callCancelForEditor(element);
			}
			else
			{
				this.__callCancelForRowEditors(element);
			}
		};
		
		this.__handleRowEditors = function(row)
		{
			if(row)
			{
				var arrCells = row.cells;
				if(arrCells && arrCells.length > 0)
				{
					for(var count = 0;count < arrCells.length;count++)
					{
						this.__handleCellEditor(arrCells[count]);
					}
				}
			}
		};
		
		this.__commitRowEditorChanges = function(row)
		{
			var arrEditor = this.__getOnlyEditors(row);
			if(arrEditor && arrEditor.length > 0)
			{
				for(var count = 0;count < arrEditor.length;count++)
				{
					this.__commitEditorChanges(null,arrEditor[count]);
				}
			}
		};
		
		this.__callSaveForRowEditors = function(row)
		{
			var arrEditor = this.__getOnlyEditors(row);
			if(arrEditor && arrEditor.length > 0)
			{
				for(var count = 0;count < arrEditor.length;count++)
				{
					this.__callSaveForEditor(null,arrEditor[count]);
				}
			}
		};
		
		this.__callCancelForRowEditors = function(row)
		{
			var arrEditor = this.__getOnlyEditors(row);
			if(arrEditor && arrEditor.length > 0)
			{
				for(var count = 0;count < arrEditor.length;count++)
				{
					this.__callCancelForEditor(null,arrEditor[count]);
				}
			}
		};
		
		this.__callDestroyForRowEditors = function(row)
		{
			var arrEditor = this.__getOnlyEditors(row);
			if(arrEditor && arrEditor.length > 0)
			{
				for(var count = 0;count < arrEditor.length;count++)
				{
					this.__callDestroyForEditor(null,arrEditor[count]);
				}
			}
		};
		
		this.__callRowEditorsFunction = function(functionRef,param,defaultValue,row)
		{
			var arrEditor = this.__getOnlyEditors(row);
			if(arrEditor && arrEditor.length > 0)
			{
				for(var count = 0;count < arrEditor.length;count++)
				{
					this.__callEditorFunction(arrEditor[count],functionRef,param,defaultValue,true);
				}
			}
		};
		
		this.__hasEditor = function()
		{
			var arrEditor = this.__getOnlyEditors();
			if(arrEditor && arrEditor.length > 0)
			{
				return true;
			}
			return false;
		};
		
		this.__getOnlyEditors = function(row)
		{
			var arrRet = [];
			if(this.util.isUndefinedOrNull(row))
			{
				var arrEditor = this.__getAllEditors();
				for(var count = 0;count < arrEditor.length;count++)
				{
					var cellItem = arrEditor[count];
					arrRet.push(cellItem.editor);
				}
			}
			else
			{
				if(this.util.isNumber(row))
				{
					row = this.__nsGrid.__getRowByIndex(row);
				}
				var objEditors = this.__getEditorsForRow(row);
				if(objEditors)
				{
					for(var cellIndex in objEditors)
					{
						var cellItem = objEditors[cellIndex];
						arrRet.push(cellItem.editor);
					}
				}
			}
			return arrRet;
		};
		
		this.__getAllEditors = function(element)
		{
			var arrRet = [];
			if(this.__objEditor)
			{
				if(element)
				{
					if(element.nodeName == "TD")
					{
						element = this.util.findParent(element,"TR");
					}
					if(element)
					{
						var objEditors = this.__getEditorsForRow(element);
						if(objEditors)
						{
							var rowIndex = parseInt(element.getAttribute("ns-index"));
							var itemInfo = this.__nsGrid.__getItemByIndex(rowIndex);
							for(var cellIndex in objEditors)
							{
								var cellItem = rowItem[cellIndex];
								var colInfo = this.__nsGrid.__getColumnObject(cellIndex);
								arrRet.push({rowIndex: rowIndex,item: itemInfo,cellIndex: cellIndex,colInfo: colInfo,cellItem: cellItem,editor: cellItem.editor});
							}
						}
					}
				}
				else
				{
					for(var rowIndex in this.__objEditor)
					{
						var rowItem = this.__objEditor[rowIndex];
						var itemInfo = this.__nsGrid.__getItemByIndex(rowIndex);
						for(var cellIndex in rowItem)
						{
							var cellItem = rowItem[cellIndex];
							var colInfo = this.__nsGrid.__getColumnObject(cellIndex);
							arrRet.push({rowIndex: rowIndex,item: itemInfo,cellIndex: cellIndex,colInfo: colInfo,cellItem: cellItem,editor: cellItem.editor});
						}
					}
				}
			}
			return arrRet;
		};
		
		this.__handleCellEditor = function(cell,event,item)
		{
			if(cell)
			{
				var editor = this.__getEditor(null,cell);
				if(!editor)
				{
					var colIndex = cell.cellIndex;
					var objColumn = this.__nsGrid.__getColumnObject(colIndex);
					if(objColumn && objColumn.enableEditable)
					{
						var row = cell.parentNode;
						var rowIndex = this.__nsGrid.__getIndexFromRow(row);
						if(!item)
						{
							item = this.__nsGrid.__getItemByIndex(rowIndex);
						}
						if(item)
						{
							if(this.__isCellEditable(objColumn,item,cell,colIndex,row,rowIndex))
						    {
								var callback = function(row,cell,editor)
						    	{
						    		this.__insertEditorInObj(editor,row,cell);
						    	};
						    	this.__createEditor(cell,objColumn,row,rowIndex,item,callback.bind(this,row,cell));
						    	
								if(event)
								{
									event.preventDefault();
								}
						    }
						}
					}
				}
			}
		};
		
		this.__createEditor = function(cell,objColumn,row,rowIndex,item,paramCallback)
		{
			var self = this;
			var createPopUpWrapper = function()
			{
				var container = document.body;
		      	var wrapper = self.util.createDiv(null,"nsGridEditorPopUp");
		      	container.appendChild(wrapper);
		      	return wrapper;
			};
			var addChildInPopUp = function(element,parent)
			{
				parent.appendChild(element);
			};
			var addChild = function(element)
			{
				divChild.innerHTML = "";
				divChild.appendChild(element);
			};
			var commitChanges = function()
			{
				self.__callSaveForEditor.call(self,cell,editor);
			};
			var cancelChanges = function()
			{
				self.__callCancelForEditor.call(self,cell,editor);
			};
			var position = this.__getPosition(cell);
			var editorSetting = this.__getEditorSetting(objColumn);
			var divChild = cell.querySelector("." + this.__nsGrid.__CLASS_CELL_CHILD);
		    var currentValue = item[objColumn.dataField];
			var editorFunction = this.__getEditorFunction(editorSetting);
			var setting = {cell:cell,row:row,item:item,rowIndex:rowIndex,cellIndex:cell.cellIndex,position:position,defaultValue:currentValue,
					commitChanges:commitChanges,cancelChanges:cancelChanges,validator:editorSetting.validator,setting:editorSetting,column:objColumn,api:this.__nsGrid};
			var callback = function(editorFunction)
			{
				var editor = new editorFunction();
				var retVal = editor.init(setting);
				var initCallback = function(bodyCompInstance)
				{
					var element = editor.getElement();
					var isPopUp = editor.isPopUp();
					var popUpWrapper = null;
					if(isPopUp)
					{
						popUpWrapper = createPopUpWrapper();
						popUpWrapper.style.top = (position.top - 5) + "px";
						popUpWrapper.style.left = (position.left - 5) + "px";
						this.__callEditorFunction(editor,"setPopUpWrapper",popUpWrapper,null,false);
						addChildInPopUp(element,popUpWrapper);
						if(this.__config.stopEditingOnGridFocusOut)
						{
							//stop propagation of event on document level so that pop up is not closed
							this.util.addEvent(popUpWrapper,"mousedown", this.__popUpWrapperMouseDownHandler.bind(this));
							this.__nsGrid.__addTouchEvent(popUpWrapper);
						}
					}
					else
					{
						addChild(element);
					}
					this.__callEditorFunction(editor,"elementAdded",null,null,false);
					var config = {cell:cell,row:row,divChild:divChild,setting:editorSetting,column:objColumn,item:item,isPopUp:isPopUp,element:element,popUpWrapper:popUpWrapper};
					editor[this.__getAttributeKey("config")] = config;
				};
				this.util.resolveFunctionOrPromise(retVal,initCallback.bind(this));
				paramCallback && paramCallback(editor);
			};
			this.util.resolveFunctionOrPromise(editorFunction,callback.bind(this));
		};
		
		this.__isCellEditable = function(objColumn,item,cell,cellIndex,row,rowIndex)
		{
			if(this.__nsGrid.__isCellEditable(objColumn,item,cell,cellIndex,row,rowIndex))
			{
				var editorSetting = this.__getEditorSetting(objColumn);
				if(editorSetting && editorSetting.isCellEditableCallback)
				{
					return editorSetting.isCellEditableCallback(objColumn,item,cell,cellIndex,row,rowIndex,item[this.__nsGrid.__fieldRowLevel]);
				}
				return true;
			}
			return false;
		};
		
		this.__callSaveForEditor = function(cell,editor)
		{
			editor = cell ? this.__getEditor(null,cell) : editor;
			if(editor)
			{
				this.__callEditorFunction(editor,"save",null,null,false);
				this.__commitEditorChanges(cell,editor);
			}
			else
			{
				this.util.warning("NSGrid","Editor For cell could not be found");
			}
		};
		
		this.__callCancelForEditor = function(cell,editor)
		{
			editor = cell ? this.__getEditor(null,cell) : editor;
			if(editor)
			{
				this.__callEditorFunction(editor,"cancel",null,null,false);
				var config = editor[this.__getAttributeKey("config")];
				var cell = config.cell;
				var row = config.row;
				var objColumn = config.column;
				var item = config.item;
				var editorSetting = config.setting;
				var setValue = item[objColumn.dataField];
				this.__setCellValue(cell,setValue,item,row,objColumn,editorSetting);
				this.__callDestroyForEditor(cell,editor);
			}
			else
			{
				this.util.warning("NSGrid","Editor For cell could not be found");
			}
		};
		
		this.__callDestroyForEditor = function(cell,editor)
		{
			editor = cell ? this.__getEditor(null,cell) : editor;
			if(editor)
			{
				this.__callEditorFunction(editor,"destroy",null,null,false);
				var config = editor[this.__getAttributeKey("config")];
				var element = null;
				if(config.isPopUp)
				{
					element = config.popUpWrapper;
				}
				else
				{
					element = editor.getElement();
					
				}
				if(element && element.parentNode)
		    	{
					element.parentNode.removeChild(element);
		    	}
				this.__deleteEditor(null,cell,editor);
			}
			else
			{
				this.util.warning("NSGrid","Editor For cell could not be found");
			}
		};
		
		this.__commitEditorChanges = function(cell,editor)
		{
			editor = cell ? this.__getEditor(null,cell) : editor;
			if(editor)
			{
				var self = this;
				var destroyEditor = function()
				{
					self.__callDestroyForEditor.call(self,cell);
				};
				var config = editor[this.__getAttributeKey("config")];
				var cell = config.cell;
				var row = config.row;
				var objColumn = config.column;
				var item = config.item;
				var editorSetting = config.setting;
				var value = editor.getValue();
				var isValid = this.__callEditorFunction(editor,"validate",null,true,false);
				if(isValid)
				{
					var setValue = item[objColumn.dataField];
					
					var hasValueChanged = this.__callEditorFunction(editor,"hasValueChanged",setValue,null,null,false);
					if(hasValueChanged == null)
					{
						hasValueChanged = !(setValue === value);
					}
					destroyEditor();
					if(hasValueChanged)
					{
						setValue = value;
					}
					this.__setCellValue(cell,setValue,item,row,objColumn,editorSetting);
				}
			}
			else
			{
				//this.util.warning("NSGrid","Editor For cell could not be found");
			}
		};
		
		this.__callEditorFunction = function(editor,functionRef,param,defaultValue,checkCellFocus)
		{
			if(editor && editor[functionRef] && this.util.isFunction(editor[functionRef]))
			{
				checkCellFocus = Boolean.parse(checkCellFocus);
				if(!checkCellFocus || this.__hasCellFocus(null,editor))
				{
					var retValue = null;
					/*var config = editor[this.__getAttributeKey("config")];
					if(config)
					{
						console.log(config.column.dataField + " :: " + config.item[config.column.dataField]);
					}*/
					var retValue = null;
					if(param && this.util.isArray(param) && param.length > 0)
					{
						retValue = editor[functionRef].apply(null,param);
					}
					else
					{
						retValue = editor[functionRef](param);
					}
					if(!this.util.isUndefinedOrNull(retValue))
					{
						return retValue;
					}
				}
			}
			return defaultValue;
		};
		
		this.__setCellValue = function(cell,newValue,item,row,objColumn,editorSetting)
		{
			if(cell)
			{
				var colIndex = cell.cellIndex;
				var rowIndex = this.__nsGrid.__getIndexFromRow(row);
				var currentValue = item[objColumn.dataField];
				item[objColumn.dataField] = newValue;
				this.__nsGrid.updateItemInDataSource(item);
				this.__nsGrid.updateRowByIndex(rowIndex);
				this.__nsGrid.__dispatchEvent(NSGrid.EDITOR_CELL_VALUE_CHANGED,cell,{cellIndex:colIndex,rowIndex:rowIndex,cell:cell,row:row,newValue:newValue,oldValue:currentValue,item:item});
			}
		};
		
		this.__getAttributeKey = function(key)
		{
			return "__" + this.__nsGrid.__fieldPrefix + "_" + key;
		};
		
		this.__getPosition = function(element) 
		{
		      var position = {
		        top: element.offsetTop,
		        left: element.offsetLeft,
		        bottom: 0,
		        right: 0,
		        width: this.util.getOuterWidth(element),
		        height: this.util.getOuterHeight(element),
		        visible: true};
		      position.bottom = position.top + position.height;
		      position.right = position.left + position.width;
	
		      // walk up the tree
		      var offsetParent = element.offsetParent;
		      while ((element = element.parentNode) != document.body) 
		      {
		        if (position.visible && element.scrollHeight != element.offsetHeight && this.util.getStyleValue(element,"overflowY",false) != "visible") 
		        {
		          	position.visible = position.bottom > element.scrollTop && position.top < element.scrollTop + element.clientHeight;
		        }
		        if (position.visible && element.scrollWidth != element.offsetWidth && this.util.getStyleValue(element,"overflowX",false) != "visible") 
		        {
		          	position.visible = position.right > element.scrollLeft && position.left < element.scrollLeft + element.clientWidth;
		        }
		        position.left -= element.scrollLeft;
		        position.top -= element.scrollTop;
		        if (element === offsetParent) 
		        {
		          	position.left += element.offsetLeft;
		          	position.top += element.offsetTop;
		          	offsetParent = element.offsetParent;
		        }
		        position.bottom = position.top + position.height;
		        position.right = position.left + position.width;
		      }
	
		      return position;
		};
		
		this.__getMouseEventType = function()
		{
			var retValue = "dblclick";
			switch(this.__config.clickType)
			{
				case NSGrid.EDITOR_EDITING_SINGLECLICK:
					retValue = "click";
				break;
				case NSGrid.EDITOR_EDITING_DOUBLECLICK:
					retValue = "dblclick";
				break;
				case NSGrid.EDITOR_EDITING_NOCLICK:
					retValue = "";
				break;
			}
			return retValue;
		};
		
		this.__getEditorSetting = function(objColumn)
		{
			var editorSetting = objColumn.editorSetting;
			if(!editorSetting)
			{
				editorSetting = this.__defaultCellSetting;
			}
			return editorSetting;
		};
		
		this.__getEditorFunction = function(editorSetting)
		{
			var retFunction = null;
			if(editorSetting)
			{
				switch(editorSetting.type)
				{
					case NSGrid.EDITOR_TYPE_TEXT:
						retFunction = this.__nsTextEditor;
					break;
					case NSGrid.EDITOR_TYPE_TEXTAREA:
						retFunction = this.__nsTextAreaEditor;
					break;
					case NSGrid.EDITOR_TYPE_CUSTOM:
						retFunction = editorSetting.customEditor;
					break;
				}
			}
			return retFunction;
		};
		
		this.__getTargetType = function()
		{
			if(this.__config.editType == NSGrid.EDITOR_EDITTYPE_ROW)
			{
				return "TR";
			}
			return "TD";
		};
		
		this.__insertEditorInObj = function(editor,row,cell)
		{
			var item = this.__getRowCellInfo(row,cell);
			if(item && item.cellIndex > -1)
			{
				if(!this.__config.enableMultipleEdit)
				{
					var parentType = this.__getTargetType();
					if(parentType == "TR")
					{
						if(this.__objEditor[item.rowIndex] && this.__objEditor[item.rowIndex][item.cellIndex])
						{
							this.__objEditor[item.rowIndex][item.cellIndex] = {};
						}
					}
					else
					{
						this.__objEditor = {};
					}
				}
				if(!this.__objEditor[item.rowIndex])
				{
					this.__objEditor[item.rowIndex] = {};
				}
				if(!this.__objEditor[item.rowIndex][item.cellIndex])
				{
					this.__objEditor[item.rowIndex][item.cellIndex] = {};
				}
				if(!this.__objEditor[item.rowIndex][item.cellIndex].editor)
				{
					this.__objEditor[item.rowIndex][item.cellIndex].editor = editor;
				}
			}
		};
		
		this.__getEditor = function(row,cell)
		{
			var item = this.__getRowCellInfo(row,cell);
			if(item && item.cellIndex > -1)
			{
				if(this.__objEditor && this.__objEditor[item.rowIndex] && this.__objEditor[item.rowIndex][item.cellIndex] && this.__objEditor[item.rowIndex][item.cellIndex].editor)
				{
					return this.__objEditor[item.rowIndex][item.cellIndex].editor;
				}
			}
			return null;
		};
		
		this.__getEditorsForRow = function(row)
		{
			var item = this.__getRowCellInfo(row,null);
			if(item)
			{
				if(this.__objEditor && this.__objEditor[item.rowIndex])
				{
					return this.__objEditor[item.rowIndex];
				}
			}
			return null;
		};
		
		this.__deleteEditor = function(row,cell,editor)
		{
			if(editor)
			{
				cell = cell ? cell : this.util.findParent(editor.getElement(),"TD");
			}
			var item = this.__getRowCellInfo(row,cell);
			if(item && item.cellIndex > -1)
			{
				if(this.__objEditor && this.__objEditor[item.rowIndex] && this.__objEditor[item.rowIndex][item.cellIndex] && this.__objEditor[item.rowIndex][item.cellIndex].editor)
				{
					delete this.__objEditor[item.rowIndex][item.cellIndex];
					var objKeys = Object.keys(this.__objEditor[item.rowIndex]);
					if(!objKeys || objKeys.length == 0)
					{
						delete this.__objEditor[item.rowIndex];
					}
				}
			}
		};
		
		this.__deleteEditorsForRow = function(row)
		{
			var item = this.__getRowCellInfo(row,null);
			if(item)
			{
				if(this.__objEditor && this.__objEditor[item.rowIndex])
				{
					var rowEditors = this.__objEditor[item.rowIndex];
					for(var cellIndex in rowEditors)
					{
						if(rowEditors[cellIndex].editor)
						{
							delete rowEditors[cellIndex].editor;
						}
					}
				}
			}
		};
		
		this.__getRowCellInfo = function(row,cell)
		{
			var self = this;
			var getInfo = function(rowIndex,cellIndex,rowRet,cellRet)
			{
				var itemInfo = self.__nsGrid.__getItemByIndex(rowIndex);
				var colInfo = self.__nsGrid.__getColumnObject(cellIndex);
				return {rowIndex: rowIndex,cellIndex: cellIndex,rowInfo: itemInfo,colInfo: colInfo,row: rowRet,cell: cellRet};
			};
			
			if(!this.util.isUndefinedOrNull(row) && !this.util.isUndefinedOrNull(cell))
			{
				var rowIndex = -1;
				var cellIndex = -1;
				var rowRet = null;
				var cellRet = null;
				if(this.util.isElement(row))
				{
					rowIndex = parseInt(row.getAttribute("ns-index"));
					rowRet = row;
				}
				if(this.util.isNumber(row))
				{
					rowIndex = parseInt(row);
					rowRet = this.__nsGrid.__getRowByIndex(rowIndex);
				}
				if(this.util.isElement(cell))
				{
					cellIndex = parseInt(cell.cellIndex);
					cellRet = cell;
				}
				if(this.util.isNumber(cell))
				{
					cellIndex = parseInt(cell);
					cellRet = rowRet.cells[cellIndex];
				}
				var retItem = getInfo(rowIndex,cellIndex,rowRet,cellRet);
				return retItem;
			}
			else if(!this.util.isUndefinedOrNull(cell))
			{
				var rowIndex = -1;
				var cellIndex = -1;
				var rowRet = null;
				var cellRet = null;
				if(this.util.isElement(cell))
				{
					cellIndex = parseInt(cell.cellIndex);
					cellRet = cell;
				}
				if(this.util.isNumber(cell))
				{
					cellIndex = parseInt(cell);
					cellRet = rowRet.cells[cellIndex];
				}
				rowRet = cellRet.parentElement;
				rowIndex = parseInt(rowRet.getAttribute("ns-index"));
				var retItem = getInfo(rowIndex,cellIndex,rowRet,cellRet);
				return retItem;
			}
			
			else if(!this.util.isUndefinedOrNull(row))
			{
				var rowIndex = -1;
				var rowRet = null;
				
				if(this.util.isElement(row))
				{
					rowIndex = parseInt(row.getAttribute("ns-index"));
					rowRet = row;
				}
				if(this.util.isNumber(row))
				{
					rowIndex = parseInt(row);
					rowRet = this.__nsGrid.__getRowByIndex(rowIndex);
				}
				var itemInfo = this.__nsGrid.__getItemByIndex(rowIndex);
				return {rowIndex: rowIndex,cellIndex: -1,rowInfo: itemInfo,colInfo: null,row: rowRet,cell: null};
			}
			
			return null;
		};
    
		this.__destroy = function()
		{
			if(this.__tblClickRef)
			{
				this.__nsGrid.__removeTouchEvent(this.__table);
				this.util.removeEvent(this.__table,"click", this.__tblClickRef);
				this.__tblClickRef = null;
			}
			if(this.__tblEventRef)
			{
				var mouseEvent = this.__getMouseEventType();
				this.util.removeEvent(this.__table,mouseEvent, this.__tblEventRef);
				this.__tblEventRef = null;
			}
			
			if(this.__documentKeyEventRef)
			{
				this.util.removeEvent(document,"keydown", this.__documentKeyEventRef);
				this.__documentKeyEventRef = null;
			}
		};
		
		this.__nsTextEditor = function() 
		{
		    var input;
		    var defaultValue;
		    var setting = null;
		    var self = this;
		    var util = new NSUtil();
		    
		    this.init = function(config) 
		    {
		    	setting = config;
		    	var editorSetting = setting.setting;
		    	var params = this.__getParams(editorSetting.params);
		    	input = util.createElement("input",null,"nsTextEditor"); 
		    	defaultValue = setting.defaultValue;
		      	input.value = defaultValue;
		      	input.style.width = "98%";
		      	if(params.cssClass)
		      	{
		      		util.addStyleClass(input,params.cssClass);
		      	}
		    };
		    
		    this.getElement = function()
		    {
		    	return input;
		    };
		    
		    this.elementAdded = function()
		    {
		    	util.addEvent(input,"click",function(event){
		    		event = util.getEvent(event);
		    		self.setFocus();
		    		//the below line stops propagation and hence document click handler is not fired in handleCellSelector
		    		//event.stopPropagation();
		    		//event.stopImmediatePropagation();
		    		event.preventDefault();
		    	});
		    	input.focus();
		      	input.select();
		    };
		    
		    this.handleKeyDown = function(event,keyCode) 
		    {
		    	var objKeyCode = util.KEYCODE;
		    	if (keyCode == objKeyCode.LEFT && keyCode == objKeyCode.RIGHT) 
		      	{
		    		event.stopImmediatePropagation();
		      	} 
		    };
		    
		    this.getValue = function() 
		    {
		      	return input.value;
		    };
		    
		    this.destroy = function() 
		    {
		    	
		    };
		    
		    this.setFocus = function()
		    {
		    	input.focus();
		    	//setTimeout(function(){input.selectionStart = input.selectionEnd = 10000; }, 0);
		    	input.selectionEnd = input.selectionStart = input.value.length;
		    };
		    
		    this.hasValueChanged = function(currentValue) 
		    {
		      	return (!(input.value == "" && currentValue == null)) && (input.value != currentValue);
		    };
			
		    this.validate = function() 
		    {
		    	if(setting.validator)
		    	{
		    		return setting.validator(input,input.value);
		    	}
		      	return true;
		    };
		    
		    this.isPopUp = function()
		    {
		    	return false;
		    };
		    
		    this.save = function() 
		    {
		    	
		    };
	
		    this.cancel = function() 
		    {
		      	input.value = defaultValue;
		    };
		    
		    this.setPopUpWrapper = function(popUpWrapper) 
		    {
		    	
		    };
		    
		    this.__getParams = function(params)
		    {
		    	if(!params)
		    	{
		    		params = {};
		    	}
		    	params = {
		    		cssClass: params.cssClass || null,
		    	};
		    	
		    	return params;
		    };
	
		};
	
		this.__nsTextAreaEditor = function() 
		{
		    var input, wrapper, parentWrapper;
		    var defaultValue;
		    var util = new NSUtil();
		    var setting = null;
		    var self = this;
			
		    this.init = function (config) 
		    {
		    	setting = config;
		    	var editorSetting = setting.setting;
		    	var params = this.__getParams(editorSetting.params);
		      	wrapper = util.createDiv(null,"nsGridTextAreaEditor");
		      	input = util.createElement("textarea",null,"nsGridTextArea"); 
		      	if(params.cssClass.textArea)
		      	{
		      		util.addStyleClass(input,params.cssClass.textArea);
		      	}
		      	input.setAttribute("hidefocus",true);
		      	input.setAttribute("rows",params.rows);
		      	wrapper.appendChild(input);
		      	wrapper.appendChild(document.createElement("br"));
		      	var buttonWrapper = util.createDiv(null);
		      	buttonWrapper.style.textAlign = "right";
		      	wrapper.appendChild(buttonWrapper);
		      	var btnSave = util.createElement("button",null,params.cssClass.saveButton);
		      	btnSave.appendChild(document.createTextNode(params.saveButtonText));
		      	util.addEvent(btnSave,"click",this.__saveHandler);
		      	buttonWrapper.appendChild(btnSave);
		      	buttonWrapper.appendChild(document.createTextNode(" "));
		      	var btnCancel = util.createElement("button",null,params.cssClass.cancelButton);
		      	btnCancel.appendChild(document.createTextNode(params.cancelButtonText));
		      	buttonWrapper.appendChild(btnCancel);
		      	util.addEvent(btnCancel,"click",this.__cancelHandler);
		      	defaultValue = setting.defaultValue;
		      	input.value = defaultValue;
		    };
		    
		    this.getElement = function()
		    {
		    	return wrapper;
		    };
		    
		    this.elementAdded = function()
		    {
		    	input.focus();
		      	input.select();
		    };
	
		    this.handleKeyDown = function(event,keyCode) 
		    {
		    	event = util.getEvent(event);
		    	var objKeyCode = util.KEYCODE;
		      	if (keyCode == objKeyCode.ENTER && event.ctrlKey) 
		      	{
		        	self.save();
		      	} 
		    };
		    
		    this.getValue = function() 
		    {
		      	return input.value;
		    };
		    
		    this.destroy = function() 
		    {
		    	
		    };
		    
		    this.setFocus = function()
		    {
		    	input.focus();
		    };
		    
		    this.hasFocus = function()
		    {
		    	return input === document.activeElement;
		    };
	
		    this.hasValueChanged = function(currentValue) 
		    {
		      	return (!(input.value == "" && currentValue == null)) && (input.value != currentValue);
		    };
	
		    this.validate = function() 
		    {
		    	if(setting.validator)
		    	{
		    		return setting.validator(input,input.value);
		    	}
		      	return true;
		    };
		    
		    this.isPopUp = function()
		    {
		    	return true;
		    };
		    
		    this.save = function () 
		    {
		    	
		    };
	
		    this.cancel = function () 
		    {
		      	input.value = defaultValue;
		      	
		    };
		    
		    this.setPopUpWrapper = function(popUpWrapper) 
		    {
		    	parentWrapper = popUpWrapper;
		    };
		    
		    //non framework function
		    this.__saveHandler = function(event)
		    {
		    	setting.commitChanges();
		    };
		    
		    this.__cancelHandler = function(event)
		    {
		    	setting.cancelChanges();
		    };
		    
		    this.__getParams = function(params)
		    {
		    	if(!params)
		    	{
		    		params = {};
		    	}
		    	if(!params.cssClass)
		    	{
		    		 params.cssClass = {};
		    	}
		    	var cssClass = {
		    			textArea: params.cssClass["textArea"] || null,
		    			saveButton: params.cssClass["saveButton"] || null,
		    			cancelButton: params.cssClass["cancelButton"] || null
		    	};
		    	params = {
		    		rows: params.rows || 5,
		    		cssClass: cssClass,
		    		saveButtonText: params.saveButtonText || "Save",
		    		cancelButtonText: params.cancelButtonText || "Cancel",
		    	};
		    	
		    	return params;
		    };
		    
		};
		
	};
	return NSGridEditor;
})();
nsModuleExport(this,"NSGridEditor",NSGridEditor);

var NSGridKeyboard = (function()
{
	var NSGridKeyboard = function(nsGrid)
	{
		this.__nsGrid = nsGrid;
		this.util = this.__nsGrid.util;
		
		var self = this;
		
		this.keyDownHandler = function(event,keyCode)
		{
			var isShiftCtrlPressed = this.__nsGrid.__isShiftPressed || this.__nsGrid.__isCtrlPressed;
			var source = this.__nsGrid.__objGrid.__getFlatSource();
			//key Up
			if(keyCode === this.util.KEYCODE.UP && isShiftCtrlPressed && this.__enableMultipleSelection)
			{
				if(this.__nsGrid.__lastNavigationDirection && this.__nsGrid.__lastNavigationDirection === this.__nsGrid.NAVIGATION_DOWN)
				{
					return this.__keyBoardSelectionHandler(event,this.__nsGrid.NAVIGATION_UP);
				}
				if(this.__nsGrid.__selectedIndex != 0)
				{
					this.__nsGrid.__selectedIndex--;
					this.__nsGrid.__navigationIndex--;
					while(!this.__nsGrid.__isMouseHoverAllowed(this.__nsGrid.__selectedIndex))
					{
						this.__nsGrid.__selectedIndex--;
						this.__nsGrid.__navigationIndex--;
					}
					return this.__keyBoardSelectionHandler(event,this.__nsGrid.NAVIGATION_UP);
				}
			}
			//key down
			else if(keyCode === this.util.KEYCODE.DOWN && isShiftCtrlPressed && this.__nsGrid.__enableMultipleSelection)
			{
				if(this.__nsGrid.__lastNavigationDirection && this.__nsGrid.__lastNavigationDirection === this.__nsGrid.NAVIGATION_UP)
				{
					return this.__keyBoardSelectionHandler(event,this.__nsGrid.NAVIGATION_DOWN);
				}
				if(source && this.__nsGrid.__selectedIndex != source.length - 1)
				{
					this.__nsGrid.__selectedIndex++;
					this.__nsGrid.__navigationIndex++;
					while(!this.__nsGrid.__isMouseHoverAllowed(this.__nsGrid.__selectedIndex))
					{
						this.__nsGrid.__selectedIndex++;
						this.__nsGrid.__navigationIndex++;
					}
					return this.__keyBoardSelectionHandler(event,this.__nsGrid.NAVIGATION_DOWN);
				}
			}
			else if(keyCode === this.__nsGrid.util.KEYCODE.UP)
			{
				if(source && this.__nsGrid.__navigationIndex === -1)
				{
					this.__nsGrid.__navigationIndex = source.length - 1;
				}
				if(this.__nsGrid.__navigationIndex > 0)
				{
					return this.__keyBoardNavigationHandler(event,this.__nsGrid.NAVIGATION_UP);
				}
			}
			else if(keyCode === this.util.KEYCODE.DOWN)
			{
				if(source)
				{
					return this.__keyBoardNavigationHandler(event,this.__nsGrid.NAVIGATION_DOWN);
				}
			}
			else if(keyCode === this.util.KEYCODE.ENTER)
			{
				this.__nsGrid.__clearAllRowSelection(false);
				var row = this.__getkeyboardNavigationRow();
				if(row)
				{
					this.__nsGrid.__markRowSelected(this.__nsGrid.__getIndexFromRow(row));
				}
			}
		};
		
		this.__keyBoardNavigationHandler = function(event,direction)
		{
			var self = this;
			var lastIndex = this.__nsGrid.__navigationIndex;
			var currentIndex = this.__nsGrid.__navigationIndex;
			(direction === this.__nsGrid.NAVIGATION_UP) ? currentIndex--:currentIndex++;
			while(!this.__nsGrid.__isMouseHoverAllowed(currentIndex))
			{
				(direction === this.__nsGrid.NAVIGATION_UP) ? currentIndex--:currentIndex++;
			}
			var endHandler = function()
			{
				self.__nsGrid.__navigationIndex = currentIndex;
				var row = self.__getkeyboardNavigationRow();
				var index = -1;
				var item = null;
				if(row)
				{
					var source = self.__nsGrid.__objGrid.__getFlatSource();
					index = self.__nsGrid.__getIndexFromRow(row);
					item = self.__nsGrid.__getItemByIndex(index, source);
				}
				self.__nsGrid.__dispatchEvent(NSGrid.ROW_NAVIGATED,item,{rowIndex:index,item:item,row:row});
				self.__nsGrid.__lastNavigationDirection = null;
			};
			if(this.__nsGrid.__enableVirtualScroll)
			{
				var virtualHandler = function()
				{
					var item = self.__nsGrid.__getVisibleItemByIndex.call(self.__nsGrid,null,currentIndex);
					if(item)
					{
						var index = item[self.__nsGrid.__fieldIndex];
						self.__setVirtualRowHoverField.call(self,index);
						self.__virtualRowHover.call(self);
						endHandler();
					}
				};
				this.__nsGrid.scrollToIndex(currentIndex,false);
				
				setTimeout(function()
				{ 
					virtualHandler();
				},0);
				//this.__setVirtualRowHover(currentIndex);
			}
			else
			{
				var row = this.__nsGrid.__getRowFromContainer(lastIndex);
				var currentRow = this.__nsGrid.__getRowFromContainer(currentIndex);
				if(currentRow)
				{
					this.util.removeStyleClass(row,"nsRowHover");
					this.util.addStyleClass(currentRow,"nsRowHover");
					this.__refreshScrollPosition(currentRow,direction);
					endHandler();
				}
			}
			event.preventDefault();
			return false;
		};
	
		this.__keyBoardSelectionHandler = function(event,direction)
		{
			var selectedIndex = this.__nsGrid.__selectedIndex;
			if(this.__nsGrid.__isRowSelected(selectedIndex))
			{
				this.__nsGrid.__markRowUnselected(selectedIndex);
			}
			else
			{
				this.__nsGrid.__markRowSelected(selectedIndex);
			}
			if(direction === this.__nsGrid.NAVIGATION_DOWN)
			{
				if(this.__nsGrid.__enableVirtualScroll)
				{
					this.__nsGrid.scrollToIndex(selectedIndex,false);
				}
				else if(Math.floor(selectedIndex % this.__nsGrid.__pageSize) === 0)
				{
					var row = this.__nsGrid.__getRowByIndex(selectedIndex);
					this.__refreshScrollPosition(row,this.__nsGrid.NAVIGATION_DOWN);
				}
			}
			else if(direction === this.__nsGrid.NAVIGATION_UP)
			{
				if(this.__nsGrid.__enableVirtualScroll)
				{
					this.__nsGrid.scrollToIndex(selectedIndex,false);
				}
				else
				{
					var row = this.__nsGrid.__getRowByIndex(selectedIndex);
					this.__refreshScrollPosition(row,this.__nsGrid.NAVIGATION_UP);
				}
			}
			this.__nsGrid.__lastNavigationDirection = direction;
			event.preventDefault();
			return false;
		};
	
		this.__refreshScrollPosition = function(row,direction)
		{
			if(!this.__isElementInView(row))
			{
				this.__scrollToRow(row,direction);
			}
		};
		
		this.__isElementInView = function(row)
		{
			var cellBottom = 0;
		    var parentBottom = 0;
		    var cellTop = 0;
		    var parentTop = 0;
			if(row)
			{
				var scrollParent = this.__nsGrid.__divCenterTableBodyContainer;
				var listChild = row;//.querySelector(".nsListChild");
				if(scrollParent && listChild)
				{
					var cellRect = listChild.getBoundingClientRect();
		            parentTop = 0;
		            var rectScrollParent = scrollParent.getBoundingClientRect();
		            parentBottom = rectScrollParent.height;
		            cellTop =  cellRect.top - rectScrollParent.top;
		            cellBottom = cellTop + cellRect.height;
				}
			}
			return cellBottom <= parentBottom && cellTop >= parentTop;
		};
	
		this.__scrollToRow = function(row,direction)
		{
			if(row)
			{
				var scrollParent = this.__nsGrid.__divCenterTableBodyContainer;
				var rowRect = row.getBoundingClientRect();
				var currentScroll = scrollParent.scrollTop;
				scrollParent.scrollTop = (direction === this.__nsGrid.NAVIGATION_UP) ? (currentScroll - rowRect.height) : (currentScroll + rowRect.height);
			}
			/*if(row)
			{
				var scrollParent = this.__nsGrid.__divCenterTableBodyContainer;
				var rowRect = row.getBoundingClientRect();
				var rowTop = rowRect.top;
				var rowBottom = rowTop + rowRect.height;
				var scrollParentHeight = scrollParent.getBoundingClientRect().height;
				var currentScroll = scrollParent.scrollTop;
				// scroll up
				if (rowTop < 0)// && 
				{
					scrollParent.scrollTop = currentScroll + rowTop;
					return;
				}
				// scroll down
				//else if (direction === this.__nsGrid.NAVIGATION_UP)//rowBottom  > scrollParentHeight
				//{
					var scrollAmount = rowBottom - scrollParentHeight;
					console.log(rowBottom + "-" + scrollParentHeight + " = " + scrollAmount)
					scrollParent.scrollTop = currentScroll + scrollAmount;
				//}
			}*/
		};
	
		this.__getkeyboardNavigationRow = function()
		{
			var row = null;
			if(this.__nsGrid.__enableVirtualScroll)
			{
				row = this.__nsGrid.__tblCenterBody.tBodies[0].querySelector(".nsRowHover");
			}
			else
			{
				row = this.__nsGrid.__getRowFromContainer(this.__nsGrid.__navigationIndex);
			}
			return row;
		};
		
		this.__virtualRowHover = function()
		{
			var arrRows = this.__nsGrid.__getBodyBodyRow(this.__nsGrid.__tblCenterBody);
			if(this.__nsGrid.__hasBodyRows() && arrRows.length > 0 && this.__nsGrid.__arrInternalSource)
			{
				var row = null;
				var index = null;
				var item = null;
				for(var count = 0; count < arrRows.length; count++) 
				{
					row = arrRows[count];
					index = this.__nsGrid.__getIndexFromRow(row);
					item = this.__nsGrid.__getItemByIndex(index);
					(item && item[this.__nsGrid.__fieldHover]) ? this.util.addStyleClass(row,"nsRowHover") : this.util.removeStyleClass(row,"nsRowHover");
				}
			}
		};
		
		this.__setVirtualRowHoverField = function(indexToSet)
		{
			if(this.util.isUndefinedOrNull(indexToSet))
			{
				indexToSet = -1;
			}
			var source = this.__nsGrid.__objGrid.__getFlatSource();
			if(source)
			{
				var item = null;
				for(var count = 0; count < source.length; count++) 
				{
					var item = source[count];
					if(item)
					{
						item[this.__nsGrid.__fieldHover] = (item[this.__nsGrid.__fieldIndex] === indexToSet); 
					}
				}
			}
		};
		
		this.__setVirtualRowHover = function(indexToSet)
		{
			if(this.__nsGrid.__enableVirtualScroll)
			{
				if(this.util.isUndefinedOrNull(indexToSet))
				{
					indexToSet = 0;
				}
				var item = this.__nsGrid.__getVisibleItemByIndex(null,indexToSet);
				if(item)
				{
					this.__nsGrid.__navigationIndex = indexToSet;
					var index = item[this.__nsGrid.__fieldIndex];
					this.__setVirtualRowHoverField(index);
					this.__virtualRowHover();
				}
				
			}
		};
		
		this.__setRowHover = function(indexToSet)
		{
			if(this.util.isUndefinedOrNull(indexToSet))
			{
				indexToSet = 0;
			}
			if(this.__nsGrid.__enableVirtualScroll)
			{
				this.__setVirtualRowHover(indexToSet);
			}
			else
			{
				if(this.util.isUndefinedOrNull(indexToSet))
				{
					indexToSet = 0;
				}
				this.__nsGrid.__navigationIndex = indexToSet;
				var row = this.__nsGrid.__getRowFromContainer(this.__nsGrid.__navigationIndex);
				this.util.addStyleClass(row,"nsRowHover");
			}
		};
	};
	return NSGridKeyboard;
})();
nsModuleExport(this,"NSGridKeyboard",NSGridKeyboard);

var NSGridSort = (function()
{
	var NSGridSort = function(nsGrid)
	{
		this.__nsGrid = nsGrid;
		this.util = this.__nsGrid.util;
		this.__arrFields = [];
		
		this.__CLASS_SORTING_ASC = "nsSortedAsc";
		this.__CLASS_SORTING_DESC = "nsSortedDesc";
		
		this.determineSortFunction = function(item,colItem)
		{
			return this.__determineSortFunction(item,colItem);
		};
		
		this.handle = function(header,columnDetail,isMultiColumnSort,customIsAscending)
		{
			this.__handleSorting(header,columnDetail,isMultiColumnSort,customIsAscending);
		};
		
		this.reset = function()
		{
			this.__resetColumnHeaders(false);
		};
		
		this.__handleSorting= function(header,columnDetail,isMultiColumnSort,customIsAscending)
		{
			if(header && columnDetail && columnDetail.sortable)
		    {
				var sortAscending = true;
				var isCustomSort = !this.util.isUndefined(customIsAscending);
				isMultiColumnSort = Boolean.parse(isMultiColumnSort);
				this.__nsGrid.__dispatchEvent(NSGrid.SORT_CHANGING,columnDetail,{columnDetail:columnDetail});
				if (this.util.hasStyleClass(header,this.__CLASS_SORTING_ASC) || this.util.hasStyleClass(header,this.__CLASS_SORTING_DESC))
				{
			        if(this.util.hasStyleClass(header,this.__CLASS_SORTING_ASC))
			        {
			             this.__removeAscendingIndicator(header,columnDetail);
			             sortAscending = false;
			        }
			        else if(this.util.hasStyleClass(header,this.__CLASS_SORTING_DESC))
			        {
			        	this.__removeDescendingIndicators(header,columnDetail);
				       	sortAscending = true;
			        }
				}
			   	else
			   	{
			   		sortAscending = !columnDetail.sortDescending;
			   	}
				if(!isMultiColumnSort)
				{
					this.__arrFields = [];
					this.__resetColumnHeaders(true);
				}
				var isColumnExisting = false;
				for(var count = 0;count < this.__arrFields.length;count++)
				{
					if(this.__arrFields[count]["field"] === columnDetail["sortField"])
					{
						isColumnExisting = true;
						this.__arrFields[count]["sortAscending"] = sortAscending;
					}
				}
				if(!isColumnExisting)
				{
					this.__arrFields.push({field:columnDetail.sortField,sortFunction:columnDetail.sortFunction,sortAscending:sortAscending});
				}
			   	//customIsAscending is passed it overrides the setting in columnDetail
			   	if(isCustomSort)
			   	{
			   		sortAscending = customIsAscending;
			   	}
			   	if(sortAscending)
			    {
			   		this.__addAscendingIndicator(header,columnDetail);
			    }
			   	else
			   	{
			   		this.__addDescendingIndicator(header,columnDetail);
			   	}
			   	if(this.__nsGrid.__enableHierarchical || this.__nsGrid.__enableGrouping || this.__nsGrid.__enableMasterDetail)
			   	{
			   		  this.__sortHierarchicalStructure(this.__nsGrid.__arrWrapper,this.__arrFields); 
			   		  this.__nsGrid.__objGrid.__setWrapperSource(this.__nsGrid.__arrWrapper,0,-1,0,false);
			   		  this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrFlatHierarchicalSource.slice(0);
			   	}
			   	else
			   	{
			   		  this.__sortArrOfObjectsByParam(this.__nsGrid.__arrWrapper,this.__arrFields);
			   		  this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrWrapper.slice(0);
			   	}
			   	//to stop error of horizontal scrollbar position getting reset when sorting
			   	var horScrollPos = 0;
			   	if(this.__nsGrid.__divCenterTableBodyContainer)
			   	{
					horScrollPos = this.__nsGrid.__divCenterTableBodyContainer.scrollLeft;
			   	}
			   	this.__nsGrid.resetFilters();
			   	this.__nsGrid.__renderBody(true,false);
			   	columnDetail[this.__nsGrid.__fieldColSortedAsc] = sortAscending;
			   	if(this.__nsGrid.__divCenterTableBodyContainer && horScrollPos > 0)
			   	{
			   		this.__nsGrid.__divCenterTableBodyContainer.scrollLeft = horScrollPos;
			   	}
			   	this.__nsGrid.__dispatchEvent(NSGrid.SORT_CHANGED,this.__arrFields,{fieldDetails:this.__arrFields});
		    }
			else
			{
				this.util.warning("NSGrid","This column is not sortable.");
			}
		};
	
		this.__sortHierarchicalStructure= function(dataSource,arrFields)
		{
			if(dataSource && dataSource.length > 0)
			{
				for(var count = 0;count < dataSource.length;count++)
				{
					var item = dataSource[count];
					if(this.__nsGrid.__isNodeLastParent(item))
					{
						this.__sortArrOfObjectsByParam(item[this.__nsGrid.__childField],arrFields);
					}
					else if(item[this.__nsGrid.__fieldHasChild])
					{
						this.__sortHierarchicalStructure(item[this.__nsGrid.__childField],arrFields);
					}
				}
			}
		};
		
		//This method is based on Stuart Langridge's "sorttable" code
		this.__determineSortFunction= function(item,colItem)
		{
			  var sortType = colItem.sortType;
			  var sortFunction = "__sortCaseInsensitive";
			  if(sortType == null)
			  {
				  var value = item.toString();
			      if(this.__isDate(item) || value.match(/^\d\d[\/-]\d\d[\/-]\d\d\d\d$/) || value.match(/^\d\d[\/-]\d\d[\/-]\d\d$/))
			      {
			          sortFunction = "__sortDate";
			      }
			      if (value.match(/^[$]/))
			      {
			          sortFunction = "__sortCurrency";
			      }
			      if (value.match(/^[\d\.]+$/) || value.match(/^[+-]?\d*\.?\d+([eE]-?\d+)?$/) || !isNaN(value))
			      {
			          sortFunction = "__sortNumeric";
			      }
			  }
			  else
			  {
				  var objVal = {"date": {func: "__sortDate"},"currency": {func: "__sortCurrency"},"number": {func: "__sortNumeric"},"string": {func: "__sortCaseInsensitive"}};
				  if(objVal[sortType.toLowerCase()])
				  {
					  sortFunction = objVal[sortType.toLowerCase()].func;
				  }
			  }
		      return sortFunction;
		};
	
		this.__sortArrOfObjectsByParam= function(arrToSort,arrFields)
		{
		    arrToSort.sort(function (item1, item2)
		    {
		        var retValue = 0;
		        var objField = null;
		        for (var count = 0; count < arrFields.length; count++) 
		        {
		        	objField = arrFields[count];
		        	if(objField["sortAscending"] == null || objField["sortAscending"] == undefined)
		     	    {
		        		objField["sortAscending"] = true;  // default to true
		     	    }
		        	if (typeof this[objField["sortFunction"]] === "function")
			        {
		        		retValue = this[objField["sortFunction"]](item1,item2,objField["field"],objField["sortAscending"]);
			        }
		        	if (retValue !== 0) 
		        	{
		        		break;
		        	}
		        }
		        return retValue;
		    }.bind(this));
		};
		
		this.__sortCaseInsensitive= function(item1, item2 , sortField, sortAscending)
		{
			if(!item1[sortField] && !item2[sortField])
			{
				return 0;
			}
			var retValue = -1;
			if(!item1[sortField])
			{
				retValue = -1;
			}
			else if(!item2[sortField])
			{
				retValue = 1;
			}
			else
			{
				var firstString = item1[sortField].toLowerCase();
			    var secondString = item2[sortField].toLowerCase();
			      
			    if(firstString == secondString)
			    {
			    	return 0;
			    }
			    if (firstString < secondString)
			    {
			        retValue = -1;
			    }
			    else
			    {
			        retValue = 1;
			    }
			}
			
		    if(sortAscending)
		    {
		        return retValue; 
		    }
		    return (retValue * -1);
		};
		 
		this.__sortDate= function(item1, item2 , sortField, sortAscending)
		{
		      // y2k notes: two digit years less than 50 are treated as 20XX, greater than 50 are treated as 19XX
		      var firstDateString = item1[sortField];
		      var secondDateString = item2[sortField];
		      var firstDate, secondDate, year = -1;
		      if(this.util.isUndefinedOrNull(firstDateString) || this.util.isUndefinedOrNull(secondDateString))
		      {
		    	  var retValue = -1;
		    	  if(this.util.isUndefinedOrNull(firstDateString) && this.util.isUndefinedOrNull(secondDateString))
			      {
			    	  retValue = 0;
			      }
		    	  if(this.util.isUndefinedOrNull(firstDateString))
		    	  {
		    		  retValue = -1;
				  }
				  else if(this.util.isUndefinedOrNull(secondDateString))
				  {
					  retValue = 1;
				  }
		    	  if(sortAscending)
				  {
		    		  return retValue; 
				  }
				  return (retValue * -1);
		      }
		      if(this.__isDate(firstDateString) && this.__isDate(secondDateString))
		      {
		    	  firstDate = this.__convertToDate(firstDateString);
		    	  secondDate = this.__convertToDate(secondDateString);
		    	  if(sortAscending)
		    	  {
		    		  if (firstDate > secondDate) 
		    		  {
		    			  return 1;
		    		  }
		    		  if (firstDate < secondDate)
		    		  {
		    			  return -1;
		    		  }
		    		  return 0;
		    	  }
		    	  else
		    	  {
		    		  if (firstDate > secondDate) 
		    		  {
		    			  return -1;
		    		  }
		    		  if (firstDate < secondDate)
		    		  {
		    			  return 1;
		    		  }
		    		  return 0;
		    	  }
		      }
		     
		      if (firstDateString.length == 10)
		      {
		           firstDate = firstDateString.substr(6,4) + firstDateString.substr(3,2) + firstDateString.substr(0,2);
		      }
		      else
		      {
		           year = firstDateString.substr(6,2);
		           if (parseInt(year) < 50)
		           {
		                year = "20" + year;
		           }
		           else
		           {
		                year = "19" + year;
		           }
		           firstDate = year + firstDateString.substr(3,2) + firstDateString.substr(0,2);
		      }
		     
		      if (secondDateString.length == 10)
		      {
		           secondDate = secondDateString.substr(6,4)+secondDateString.substr(3,2)+secondDateString.substr(0,2);
		      }
		      else
		      {
		           year = secondDateString.substr(6,2);
		           if (parseInt(year) < 50)
		           {
		                year = "20" + year;
		           }
		           else
		           {
		                year = "19" + year;
		           }
		           secondDate = year + secondDateString.substr(3,2) + secondDateString.substr(0,2);
		      }
		     
		      if (firstDate == secondDate)
		      {
		          return 0;
		      }
		      var retValue = -1;
		      if (firstDate < secondDate)
		      {
		          retValue = -1;
		      }
		      else
		      {
		          retValue = 1;
		      }
		      if(sortAscending)
		      {
		          return retValue; 
		      }
		      return (retValue * -1);
		};
	
		this.__sortCurrency= function(item1, item2 , sortField, sortAscending)
		{
		      var firstCurrency = item1[sortField].replace(/[^0-9.]/g,"");
		      var secondCurrency = item2[sortField].replace(/[^0-9.]/g,"");
		      if(sortAscending)
		      {
		          return parseFloat(firstCurrency) - parseFloat(secondCurrency); 
		      }
		      return parseFloat(secondCurrency) - parseFloat(firstCurrency);
		};
	
		this.__sortNumeric= function(item1, item2 , sortField, sortAscending)
		{
		      var firstNumber = parseFloat(item1[sortField]);
		      if (isNaN(firstNumber))
		      {
		          firstNumber = 0;
		      }
		      var secondNumber = parseFloat(item2[sortField]);
		      if (isNaN(secondNumber))
		      {
		          secondNumber = 0;
		      }
		      if(sortAscending)
		      {
		          return (firstNumber - secondNumber);
		      }
		      return (secondNumber - firstNumber);
		};
		
		this.__isDate = function(value) 
		{
			if (Object.prototype.toString.call(value) === '[object Date]') 
			{
				return true;
			}
			if (typeof value.replace === 'function') 
			{
			    value.replace(/^\s+|\s+$/gm, '');
			}
			var dateFormat = /(^\d{1,4}[\.|\\/|-]\d{1,2}[\.|\\/|-]\d{1,4})(\s*(?:0?[1-9]:[0-5]|1(?=[012])\d:[0-5])\d\s*[ap]m)?$/;
			var retValue = dateFormat.test(value);
			if(!retValue)
			{
				value = this.__formatDateString(value);
				var parsedDate = Date.parse(value);
				if (isNaN(value) && !isNaN(parsedDate)) 
				{
					retValue = true;
				}
			}
			return retValue;
		};
		
		this.__convertToDate = function(value) 
		{
			var retValue = null;
			if(!this.util.isUndefinedOrNull(value))
		    {
				value = this.__formatDateString(value);
				retValue = new Date(value);
		    }
		    return retValue;
		};
		
		this.__formatDateString = function(value)
		{
			if(this.util.isString(value))
		    {
				//For conditions where date comes like (from sqlserver convert(varchar,date,100)) "May 16 2016  2:25PM" 
				//then new Date returns nan.It should be like "May 16 2016  2:25 PM"
				var ampm = null;
				ampm = ((value.indexOf("AM") > -1) ? "AM" : ((value.indexOf("PM") > -1) ? "PM" : null));
				if(ampm)
				{
					var index = value.indexOf(ampm);
					if(value.charAt(index-1) != " ")
					{
						value = value.substring(0,index) + " " + ampm;
					}
				}
		    }
			return value;
		};
		/******************************Create Sort Components*******************************/
		this.__addAscendingIndicator = function(target,columnDetail)
		{
		     if(target)
		     {
		    	 this.__setSortIcons(target,true,false,columnDetail);
		         this.util.addStyleClass(target,this.__CLASS_SORTING_ASC);
		     }
		};
	
		this.__removeAscendingIndicator= function(target,columnDetail)
		{
		     if(target)
		     {
		          this.util.removeStyleClass(target,this.__CLASS_SORTING_ASC);
		          this.__setSortIcons(target,false,false,columnDetail);
		     }
		};
	
		this.__addDescendingIndicator= function(target,columnDetail)
		{
		    if(target)
		    {
		    	this.__setSortIcons(target,false,true,columnDetail);
		        this.util.addStyleClass(target,this.__CLASS_SORTING_DESC);
		    }
		};
	
		this.__removeDescendingIndicators= function(target,columnDetail)
		{
		     if(target)
		     {
		    	 this.util.removeStyleClass(target,this.__CLASS_SORTING_DESC);
		    	 this.__setSortIcons(target,false,false,columnDetail);
		     }
		};
	
		this.__resetIndicators= function(target,columnDetail)
		{
		     if(target)
		     {
		          this.__removeAscendingIndicator(target,columnDetail);
		          this.__removeDescendingIndicators(target,columnDetail);
		          this.__setSortIcons(target,true,true,columnDetail);
		     }
		};
	
		this.__resetColumnHeaders= function(isInternal)
		{
		     var headerBodyRow = this.__nsGrid.__getHeaderBodyRow(this.__nsGrid.__tblCenterHeader);
		     if (!headerBodyRow)
		     {
		          return;
		     }
		     var headers = headerBodyRow.cells;
		     for (var colCount = 0; colCount < headers.length; colCount++)
		     {
		          this.__resetIndicators(headers[colCount]);
		     }
		     if(isInternal)
		     {
		    	 for (var colCount = 0; colCount < this.__nsGrid.__columns.length; colCount++)
			     {
			    	 this.__nsGrid.__columns[colCount][this.__nsGrid.__fieldColSortedAsc] = null;
			     }
		     }
		};
	
		this.__setSortIcons= function(target,isAscVisible,isDescVisible,columnDetail)
		{
			if(target)
			{
				if(!columnDetail)
				{
					var columnIndex = parseInt(target.getAttribute("currentColumnIndex"));
					columnDetail = this.__nsGrid.__getColumnObject(columnIndex);
				}
				if(columnDetail && this.__nsGrid.__isSortingIconCustom(columnDetail))
				{
					var divSorting = target.querySelector(".nsGridSortContainer");
					if(divSorting)
					{
						divSorting.innerHTML = "";
						if(isAscVisible)
						{
							divSorting.innerHTML += this.__nsGrid.__getColumnCustomIcon(columnDetail,"sortAscending");
						}
						if(isDescVisible)
						{
							divSorting.innerHTML += this.__nsGrid.__getColumnCustomIcon(columnDetail,"sortDescending");
						}
					}
				}
				else
				{
					if(isAscVisible != null)
					{
						 var divSortAsc = document.getElementById(target.getAttribute("id") + "SortAsc");
						 if(divSortAsc)
						 {
							 divSortAsc.style.display = isAscVisible ? "" : "none";
						 }
					}
					if(isDescVisible != null)
					{
						 var divSortDesc = document.getElementById(target.getAttribute("id") + "SortDesc");
						 if(divSortDesc)
						 {
							 divSortDesc.style.display = isDescVisible ? "" : "none";
						 }
					}
				}
			}
		};
		/******************************End of Create Sort Components*******************************/
	};
	return NSGridSort;
})();
nsModuleExport(this,"NSGridSort",NSGridSort);

var NSGridColumnResize = (function()
{
	var NSGridColumnResize = function(nsGrid)
	{
		this.__nsGrid = nsGrid;
		this.util = this.__nsGrid.util;
		
		//cell which is being resized
		this.__resizingHeader = null;
		this.__resizingHeaderCell = null;
		this.__resizingBodyCell = null;
		this.__resizeHandler = null;
		this.__resizeIndicatorMouseDownInterval = -1;
		this.__resizeIndicatorMouseDownCount = 0;
		
		this.__doResizeRef = null;
		this.__endResizeRef = null;
		
		this.autoResize = function(index)
		{
			if(index > -1)
			{
				var objColumn = this.__nsGrid.__getColumnObject(index);
				if(objColumn)
				{
					if(objColumn["autoSize"]) 
					{
						var preferredWidth = this.__getPreferredWidthForColumn(objColumn);
						if(preferredWidth > 0)
						{
							var cellIndex = objColumn[this.__nsGrid.__fieldColIndex];
							var resizingHeaderCell = this.__getHeaderTopCell(null,cellIndex);
							var resizingBodyCell = this.__getBodyTopCell(null,cellIndex);
							this.__resize(this.__nsGrid.__tblCenterHeader,resizingHeaderCell,preferredWidth,objColumn);
							this.__resize(this.__nsGrid.__tblCenterBody,resizingBodyCell,preferredWidth,objColumn);
							this.__handleColumnResize();
							this.__nsGrid.__dispatchEvent(NSGrid.COLUMN_RESIZED,objColumn,objColumn);
						}
					}
					else 
					{
						this.util.warning("NSGrid","This column with dataField " + objColumn.dataField + " is not autosizable.");
					}
				}
				else {
					this.util.warning("NSGrid","This column details was not found.");
				}
			}
		};
		
		this.addResizeIndicator = function(row,cell,divCellContainer,objColumn,colID)
		{
			 if(objColumn["resizable"])
			 {
				var divResize = this.util.createDiv(null,"nsColumnResizeIndicator");
				this.util.addStyleClass(divResize,"nsColumnResizeIndicatorTheme");
				divResize.title = "Drag to resize the column " + objColumn.headerText;
				//divResize.style.height = this.__nsGrid.__getViewportHeight() + "px";
				//divResize.style.borderRight = '2px solid #0000ff';
				var resizeEventHandler = this.__resizeEventHandler.bind(this);
				//this.util.addEvent(divResize,"mouseover",resizeEventHandler);
				//this.util.addEvent(divResize,"mouseout",resizeEventHandler);
				this.util.addEvent(divResize,"mousedown",resizeEventHandler);
				this.util.addEvent(divResize,"click",resizeEventHandler);
				this.util.addEvent(divResize,"dblclick",resizeEventHandler);
				divCellContainer.appendChild(divResize);
				this.__nsGrid.__addTouchEvent(divResize);
			 }
		};
		
		this.startResize = function(event,target)
		{
			/*if(!this.__nsGrid.__onGridLine)
			{
				return;
			}*/
			this.__nsGrid.__isColumnResizing = true;
			this.util.removeEvent(target,"click",this.__nsGrid.__headerClickRef);
			this.__nsGrid.__headerClickRef = null;
		    this.util.removeEvent(target,"mouseover",this.__nsGrid.__headerMouseOverRef);
		    this.__nsGrid.__headerMouseOverRef = null;
		    this.util.removeEvent(target,"mouseout",this.__nsGrid.__headerMouseOutRef);
		    this.__nsGrid.__headerMouseOutRef = null;
		    this.__nsGrid.__removeTouchEvent(target);
			
			this.__resizingHeader = target;
			this.__resizingHeaderCell = this.__getHeaderTopCell(target);
			this.__resizingBodyCell = this.__getBodyTopCell(target);
			var objColumn = this.__nsGrid.__getColumnObject(this.__resizingHeader.getAttribute("currentColumnIndex"));
			this.__nsGrid.__dispatchEvent(NSGrid.COLUMN_RESIZING,objColumn,objColumn);
			this.__createResizeHandler(event);
			
			this.__doResizeRef = this.__doResize.bind(this);
			this.__endResizeRef = this.__endResize.bind(this);
			this.util.addEvent(document,"mousemove",this.__doResizeRef);
			this.util.addEvent(document,"mouseup",this.__endResizeRef);
			
			event.stopImmediatePropagation();
		};
		
		this.__resize = function(table,cell,desirableWidth,objColumn)
		{
			var cellPaddingLeft = this.util.getDimensionAsNumber(cell,cell.style.paddingLeft);
			var cellPaddingRight = this.util.getDimensionAsNumber(cell,cell.style.paddingRight);
			var pad = parseInt(cellPaddingLeft,10) + parseInt(cellPaddingRight,10);
			if(!objColumn && this.__resizingHeader)
			{
				objColumn = this.__nsGrid.__getColumnObject(this.__resizingHeader.getAttribute("currentColumnIndex"));
			}
			var minWidth = this.__nsGrid.__columnMinWidth;
			if(objColumn)
			{
				minWidth = objColumn["minWidth"];
			}
			var setWidth = Math.max((desirableWidth - pad), minWidth);
			if(objColumn)
			{
				objColumn["width"] = setWidth + "px";
			}
			cell.style.width = setWidth + "px";
		};
	
		this.__doResize = function(event)
		{
			//putting this check as somehow the document evenlistener is not getting detached
			if(!this.__resizingHeader)
			{
				return;
			}
			this.util.makeBodyUnselectable();
			event = this.util.getEvent(event);
			this.__resizeHandler.style.left = this.__getResizeLeftPos(event) + "px";
			
			return false;
		};
	
		this.__endResize = function(event)
		{
			//putting this check as somehow the document evenlistener is not getting detached
			if(!this.__resizingHeader)
			{
				return;
			}
			this.util.removeEvent(document,"mousemove",this.__doResizeRef);
			this.__doResizeRef = null;
			this.util.removeEvent(document,"mouseup",this.__endResizeRef);
			this.__endResizeRef = null;
			this.util.removeEvent(selectedHeader,"mouseout",this.__nsGrid.__headerMouseOutRef);
			this.__nsGrid.__headerMouseOutRef = null;
			this.util.removeEvent(selectedHeader,"click",this.__nsGrid.__headerClickRef);
			this.__nsGrid.__headerClickRef = null;
			this.__nsGrid.__removeTouchEvent(selectedHeader);
			this.util.makeBodySelectable();
			event = this.util.getEvent(event);
			var selectedHeader = this.__resizingHeader;
			var tableHeader = this.__nsGrid.__tblCenterHeader;
			var tableBody = this.__nsGrid.__tblCenterBody;
			var posEvent = this.util.getEventPosition(event,this.__nsGrid.__divCenterTableBodyContainer);
			var desiredWidth = posEvent.left - this.util.getCumulativeOffset(selectedHeader).x;
			this.__resize(tableHeader,this.__resizingHeaderCell,desiredWidth);
			this.__resize(tableBody,this.__resizingBodyCell,desiredWidth);
			if(this.__resizeHandler)
			{
				this.__nsGrid.__divOuterContainer.removeChild(this.__resizeHandler);
			}
			var column = this.__resizingHeader;
			this.__resizingHeader = null;
			this.__resizingHeaderCell = null;
			this.__resizingBodyCell = null;
			this.__resizeHandler = null;
			event.stopImmediatePropagation();
			this.__handleColumnResize();
			var objColumn = this.__nsGrid.__getColumnObject(column.getAttribute("currentColumnIndex"));
			this.__nsGrid.__dispatchEvent(NSGrid.COLUMN_RESIZED,objColumn,objColumn);
			this.__nsGrid.__isColumnResizing = false;
		};
		
		this.__resizeEventHandler = function(event)
		{
			var stopEventPropogation = function()
			{
				event.stopPropagation();
				event.preventDefault();
				event.stopImmediatePropagation();
			};
			event = this.util.getEvent(event);
			var target = this.util.getTarget(event);
			var resizeIndicator = target;
		    target = this.util.findParent(target,"TD");
		    var colIndex = parseInt(target.getAttribute("currentColumnIndex"));
		    //var objColumn = this.__nsGrid.__getColumnObject(colIndex);
			switch(event.type)
			{
				/*case "mouseover":
					if(this.util.hasStyleClass(resizeIndicator,"nsColumnResizeIndicator"))
					{
						var height = this.__nsGrid.__getViewportHeight();
						if(height != resizeIndicator.offsetHeight)
						{
							resizeIndicator.style.height = height + "px";
						}
						resizeIndicator.style.borderRight = '2px solid #0000ff';
					}
				break;
				case "mouseout":
					if(this.util.hasStyleClass(resizeIndicator,"nsColumnResizeIndicator"))
					{
						resizeIndicator.style.borderRight = '';
					}
				break;*/
				case "mousedown":
					var self = this;
					this.__resizeIndicatorMouseDownCount++;
					if (this.__resizeIndicatorMouseDownInterval != -1)
					{
						clearTimeout(this.__resizeIndicatorMouseDownInterval);
						this.__resizeIndicatorMouseDownInterval = -1;
					}
					this.__resizeIndicatorMouseDownInterval = setTimeout(
						function()
						{
							if(self.__resizeIndicatorMouseDownCount > 1)
							{
								self.autoResize(colIndex);
							}
							else
							{
								self.startResize(event,target);
								/*var headerRect = headerCell.getBoundingClientRect();
								var headerHeight = headerCell.offsetHeight;
								var startOffset = headerRect.left - 6;
							    var startWidth = parseInt(headerRect.width, 10);
							    this.__resizeIndicatorHandler.style.top = headerRect.top + "px";
							    this.__resizeIndicatorHandler.style.left = (startOffset + startWidth) + "px";
							    this.__resizeIndicatorHandler.style.height = headerHeight + "px";
								this.__lastHeaderCell = headerCell;*/
							}
							self.__resizeIndicatorMouseDownCount = 0;
						},500);
					stopEventPropogation();
				break;
				case "mouseleave":
				break;
				case "click":
					stopEventPropogation();
				break;
				case "dblclick":
					stopEventPropogation();
				break;
			}
		};
		
		this.__createResizeHandler = function(event)
		{
			this.__resizeHandler = this.util.createDiv(null,"nsResizeHandle");
			this.util.addStyleClass(this.__resizeHandler,"nsResizeHandle" + this.__nsGrid.__theme);
			this.__resizeHandler.style.top = this.util.getCumulativeOffset(this.__resizingHeader,this.__nsGrid.__divTableWrapper).y + "px";
			this.__resizeHandler.style.left = this.__getResizeLeftPos(event) + "px";
			var scrollBarWidth = this.util.getScrollBarWidth(this.__nsGrid.__divCenterTableBodyContainer);
			this.__resizeHandler.style.height = (this.__nsGrid.__divCenterTableHeaderContainer.offsetHeight + this.__nsGrid.__divCenterTableBodyContainer.offsetHeight - scrollBarWidth) + "px";
			var maxZIndex = this.util.getMaxZIndex(this.__resizingHeader); 
			if(maxZIndex > 0)
			{
				this.__resizeHandler.style.zIndex = maxZIndex + 1;
			}
			this.__nsGrid.__divOuterContainer.appendChild(this.__resizeHandler);
		};
		
		this.__getResizeLeftPos = function(event)
		{
			event = this.util.getEvent(event);
			var left = 0;
			var scrollContainer = this.__nsGrid.__getHorizontalScrollableContainer();
			var hasHorizontalScrollbar = scrollContainer.scrollWidth > scrollContainer.clientWidth;
			if(hasHorizontalScrollbar)
			{
				var containerLeft = this.util.getOffSetByRect(this.__nsGrid.__divOuterContainer).left;
			    left = (event.pageX - containerLeft + scrollContainer.scrollLeft);
			}
			else
			{
				var posEvent = this.util.getEventPosition(event);
				left = posEvent.left;
			}
		    return left;
		};
	
		this.__getHeaderTopCell = function(cell,cellIndex)
		{
			if(cell || !this.util.isUndefinedOrNull(cellIndex))
			{
				var index = cell ? cell.cellIndex : cellIndex;
				var headerRow = this.__nsGrid.__getHeaderHeaderRow(this.__nsGrid.__tblCenterHeader);
				if(headerRow && headerRow.cells.length > 0)
				{
					var headerCells = headerRow.cells;
					return headerCells[index];
				}
			}
			return null;
		};
	
		this.__getBodyTopCell = function(cell,cellIndex)
		{
			if(cell || !this.util.isUndefinedOrNull(cellIndex))
			{
				var index = cell ? cell.cellIndex : cellIndex;
				var bodyRow = this.__nsGrid.__getBodyHeaderRow(this.__nsGrid.__tblCenterBody);
				if(bodyRow && bodyRow.cells.length > 0)
				{
					var bodyCells = bodyRow.cells;
					return bodyCells[index];
				}
			}
			return null;
		};
		
		this.__handleColumnResize = function()
		{
			this.__nsGrid.__alignTables(false);
			if(this.__nsGrid.__enableVirtualScroll)
			{
				//this.__nsGrid.__setVirtualVariables(false,false,false,false);
			}
			//this.__nsGrid.__setFixedCellsPosition();
			this.__nsGrid.__addStyleForFixedColumns();
		};
		
		this.__getPreferredWidthForColumn = function(objColumn)
		{
			if(objColumn)
			{
				var self = this;
				var addRows = function(sourceTable)
				{
					var arrRows = sourceTable.tBodies[0].rows;
					for(var count = 0;count < arrRows.length;count++)
					{
						var sourceRow = arrRows[count];
						//Ignore Filter Row
						if(sourceRow && !self.util.hasStyleClass(sourceRow,"nsGridFilterRow") && sourceRow.cells && sourceRow.cells.length)
						{
							var row = document.createElement("TR");
							var cell = row.insertCell(-1);
							cell.innerHTML = sourceRow.cells[objColumn[self.__nsGrid.__fieldColIndex]].innerHTML;
							cell.style.whiteSpace = "nowrap";
							cell.style.width = "";
							var arrChildren = cell.querySelectorAll(".nsTruncateToFit");
							for(var childCount = 0;childCount < arrChildren.length;childCount++)
							{
								var child = arrChildren[childCount];
								self.util.removeStyleClass(child,"nsTruncateToFit");
							}
							body.appendChild(row);
						}
					}
				};
				var dummyTable = this.__nsGrid.__tblCenterBody.cloneNode(false);
				dummyTable.setAttribute("id","nsDummyTable");
				dummyTable.style.width = "auto";
				var body = document.createElement("tbody");
				dummyTable.appendChild(body);
				addRows(this.__nsGrid.__tblCenterHeader);
				addRows(this.__nsGrid.__tblCenterBody);
				//this.__nsGrid.__divCenterTableBodyContainer.appendChild(dummyTable);
				document.body.appendChild(dummyTable);
				var preferredWidth = dummyTable.getBoundingClientRect().width;
				//this.__nsGrid.__divCenterTableBodyContainer.removeChild(dummyTable);
				document.body.removeChild(dummyTable);
				//+1 so that headers doesnot wordwrap
				return preferredWidth + 5;
			}
			return 0;
		};
	};
	return NSGridColumnResize;
})();
nsModuleExport(this,"NSGridColumnResize",NSGridColumnResize);

var NSGridColumnMove = (function()
{
	var NSGridColumnMove = function(nsGrid)
	{
		this.__MIN_DRAG_OFFSET = 100;
		
		this.__nsGrid = nsGrid;
		this.util = nsGrid.util;
		
		this.__objColumnDrag = null;
		this.__lastDragEvent = null;
		this.__lastDragInfo = null;
		this.__isColumnDragged = false;
		this.__scrollLeft = false;
	    this.__scrollRight = false;
		this.__dragColumnMoveRef = null;
		this.__dragColumnEndRef = null;
		this.__scrollInterval = null;
		this.__animationSteps = null;
		this.__moveAttempts = 0;
		this.__scrollableContainer = null;
		this.__maxZIndex = 0;
		
		this.handle = function(event,target)
		{
			this.__maxZIndex = this.util.getMaxZIndex(target);
			this.__scrollableContainer = this.__nsGrid.__getHorizontalScrollableContainer();
			this.__startColumnMove(event,target);
		};
		
		this.__startColumnMove = function(event,target)
		{
			//should be merging __onGridLine and __isColumnResizing
			if(this.__nsGrid.__isColumnResizing || this.__nsGrid.__onGridLine)
			{
				return;
			}
			var objColumn = this.__nsGrid.__getColumnObject(target.getAttribute("currentColumnIndex"));
			var columnIndex = this.__nsGrid.__getColumnIndexByObject(objColumn);
			if(columnIndex > -1)
			{
				this.__nsGrid.__dispatchEvent(NSGrid.COLUMN_MOVING,objColumn,{columnDetail:objColumn,columnIndex:columnIndex});
				this.__lastDragEvent = event;
				this.__isColumnDragged = true;
				this.__objColumnDrag = {};
				this.__objColumnDrag.source = target;
				this.__objColumnDrag.objColumn = objColumn;
				this.__objColumnDrag.columnIndex = columnIndex;
				var position = this.util.getEventPosition(event,this.__nsGrid.__divCenterTableHeaderContainer);
				this.__objColumnDrag.dragElement = this.__createCopyItem(target,position);
				this.__objColumnDrag.dragElementAdded = false;
				this.__objColumnDrag.position = position;
				this.__dragColumnMoveRef = this.__dragColumnMoveHandler.bind(this);
				this.__dragColumnEndRef = this.__dragColumnEndHandler.bind(this);
				this.util.addEvent(document,"mousemove",this.__dragColumnMoveRef);
				this.util.addEvent(document,"mouseup",this.__dragColumnEndRef);
			}
			event.preventDefault();
		};
	
		this.__dragColumnMoveHandler = function(event)
		{
			event = this.util.getEvent(event);
			var direction = this.__getDragDirection(event);
			this.__lastDragEvent = event;
			
			var position = this.util.getEventPosition(event);
			var leftOffset = this.__objColumnDrag.position.left - position.left;
		    var topOffset = this.__objColumnDrag.position.top - position.top;
		    var dragRadius = (leftOffset * leftOffset) + (topOffset * topOffset);
		    if(!this.__objColumnDrag.dragElementAdded && dragRadius > this.__MIN_DRAG_OFFSET)
		    {
		    	document.body.appendChild(this.__objColumnDrag.dragElement);
		    	this.__objColumnDrag.dragElementAdded = true;
		    }
		    this.__positionDragElement(event);
		    /*var posEvent = this.util.getEventPosition(event);
		    this.__objColumnDrag.dragElement.style.left = posEvent.left + "px";
	        this.__objColumnDrag.dragElement.style.top = posEvent.top + "px";*/
		    if(this.__objColumnDrag.lastDropTarget)
		    {
		    	this.util.removeStyleClass(this.__objColumnDrag.lastDropTarget,"nsDottedCell"); 
		    	this.__objColumnDrag.lastDropTarget = null;
		    }
		    var target = this.util.getTarget(event);
		    var element = this.util.findParentBySelector(target,"." + this.__nsGrid.__CLASS_TABLE_HEADER_DROPPABLE_CELL);
		    if(element != this.__objColumnDrag.source)
		    {
		    	this.util.addStyleClass(element,"nsDottedCell");   
		    	this.__objColumnDrag.lastDropTarget = element;
		    }
		    var objDrag = this.__getDragInfoObject(event,direction);
		    this.__handleScrollMovement(objDrag);
		    event.preventDefault();
		};
	
		this.__dragColumnEndHandler = function(event)
		{
			this.__lastDragEvent = null;
			this.__isColumnDragged = false;
			this.__stopScrollAnimation();
			if(this.__objColumnDrag.lastDropTarget)
		    {
		    	this.util.removeStyleClass(this.__objColumnDrag.lastDropTarget,"nsDottedCell"); 
		    	this.__objColumnDrag.lastDropTarget = null;
		    }
			this.util.removeEvent(document,"mousemove",this.__dragColumnMoveRef);
			this.__dragColumnMoveRef = null;
			this.util.removeEvent(document,"mouseup",this.__dragColumnEndRef);
			this.__dragColumnEndRef = null;
			if(this.__objColumnDrag.dragElementAdded)
			{
				var position = this.util.getEventPosition(event);
				position.top = position.top + this.__nsGrid.__divCenterTableHeaderContainer.scrollTop;
				position.left = position.left + this.__nsGrid.__divCenterTableHeaderContainer.scrollLeft;
				var tablePosition = this.util.getOffSet(this.__nsGrid.__tblCenterHeader);
				if (position.top < tablePosition.top || position.top > (tablePosition.top + this.__nsGrid.__tblCenterHeader.offsetHeight)) 
				{
					this.util.addStyleClass(this.__objColumnDrag.dragElement,"nsGhostHeader");
					var transitionEndCallback = function()
					{
						this.__removeDragElement();
					};
					var transition = new this.util.transition(this.__objColumnDrag.dragElement,transitionEndCallback.bind(this));
					this.__objColumnDrag.dragElement.style.left = (this.__objColumnDrag.position.left - this.__nsGrid.__divCenterTableHeaderContainer.scrollLeft) + "px"; //position.left + "px";
					this.__objColumnDrag.dragElement.style.top = (this.__objColumnDrag.position.top ) + "px";
				    return;
				}
				var targetIndex = this.__getHeaderColumnByPosition(position);
			    if (targetIndex > -1 && targetIndex != this.__objColumnDrag.columnIndex) 
			    {
			    	this.__nsGrid.moveColumn(this.__objColumnDrag.columnIndex,targetIndex);
			    }
			    this.__removeDragElement();
			}
			this.__nsGrid.__dispatchEvent(NSGrid.COLUMN_MOVED,this.__objColumnDrag.objColumn,{columnDetail:this.__objColumnDrag.objColumn,columnIndex:this.__objColumnDrag.columnIndex});
		};
		
		this.__createCopyItem = function(target,position)
		{
			var divDrag = null;
			if(target && position)
			{
				divDrag = this.util.createDiv(this.__nsGrid.getID() + "Drag",this.__nsGrid.__CLASS_TABLE_HEADER_CELL);
				this.util.addStyleClass(divDrag , "nsDataGridHeaderDrag");
				this.util.addStyleClass(divDrag , "nsDataGridHeaderDrag" + this.__nsGrid.__theme);
				divDrag.innerHTML = target.innerHTML;
				divDrag.style.left = (position.left) + "px";
				divDrag.style.top = (position.top) + "px";
				//giving 50px padding to the width if width is very less
				divDrag.style.width = (target.offsetWidth + 50) + "px";
				divDrag.style.height = target.offsetHeight + "px";
				if(this.__maxZIndex > 0)
				{
					divDrag.style.zIndex = this.__maxZIndex + 1;
				}
			}
			return divDrag;
		};
		
		this.__positionDragElement = function(event)
		{
			var posEvent = this.util.getEventPosition(event);
			var rectDragElement = this.__objColumnDrag.dragElement.getBoundingClientRect();
	        var objDimension = this.util.getDocumentDimension();
	        var browserWidth = objDimension.width - 2;
	        var browserHeight = objDimension.height - 2;
	        // put DragElement vertically in middle of cursor
	        var yPos = posEvent.top - (rectDragElement.height / 2);
	        var xPos = posEvent.left;
	        if (browserWidth > 0) 
	        {
	            if ((xPos + this.__objColumnDrag.dragElement.clientWidth) > browserWidth) 
	            {
	            	xPos = browserWidth - this.__objColumnDrag.dragElement.clientWidth;
	            }
	        }
	        if (browserHeight > 0) 
	        {
	            if ((yPos + this.__objColumnDrag.dragElement.clientHeight) > browserHeight) 
	            {
	            	yPos = browserHeight - this.__objColumnDrag.dragElement.clientHeight;
	            }
	        }
	        xPos = Math.max(0,xPos);
	        yPos = Math.max(0,yPos);
	        this.__objColumnDrag.dragElement.style.left = xPos + "px";
	        this.__objColumnDrag.dragElement.style.top = yPos + "px";
		};
		
		this.__removeDragElement = function()
		{
			if(this.__objColumnDrag && this.__objColumnDrag.dragElement)
			{
				document.body.removeChild(this.__objColumnDrag.dragElement);
				this.__objColumnDrag.dragElement = null;
			}
		};
	
		this.__getHeaderColumnByPosition = function(position) 
		{
			var headerBodyRow = this.__nsGrid.__getHeaderBodyRow(this.__nsGrid.__tblCenterHeader);
			if(headerBodyRow)
			{
				var headerBodyRowCells = headerBodyRow.cells;
			    for (var count = 0; count < headerBodyRowCells.length; count++) 
			    {
			    	var cell = headerBodyRowCells[count];
			    	if(this.util.hasStyleClass(cell,this.__nsGrid.__CLASS_TABLE_HEADER_DROPPABLE_CELL))
			    	{
			    		var rowPosition = this.util.getOffSet(cell);
				    	if (rowPosition.left <= position.left && position.left <= rowPosition.left + headerBodyRowCells[count].offsetWidth) 
				    	{
				    		return count;
				    	}
			    	}
			    }
			    return -1;
			}
		};
		
		/*Horizontal Scroll Logic for Edge cases */
		this.__getDragDirection = function(event) 
		{
		    var direction = null;
		    if (this.__lastDragEvent.clientX > event.clientX) 
		    {
		        direction = "left";
		    }
		    else if (this.__lastDragEvent.clientX < event.clientX) 
		    {
		        direction = "right";
		    }
		    return direction;
		};
	
		this.__getDragInfoObject = function(event,direction) 
		{
		    // localise x and y to the target component
		    var rect = this.__nsGrid.__divCenterTableHeaderContainer.getBoundingClientRect();
		    var x = event.clientX - rect.left;
		    var y = event.clientY - rect.top;
		    var objDragInfo = 
		    {
		        event: event,
		        x: x,
		        y: y,
		        direction: direction
		    };
		    return objDragInfo;
		};
	
		this.__handleScrollMovement = function(objDragInfo) 
		{
			this.__lastDragInfo = objDragInfo;
		    if (!objDragInfo || !objDragInfo.direction) 
		    {
		        return;
		    }
		    var adjustedScrollPos = this.__getAdjustedScrollPosition(objDragInfo);
		    this.__setScrollVariables(adjustedScrollPos);
		};
	
		this.__getAdjustedScrollPosition = function(objDragInfo) 
		{
			return objDragInfo.x + this.__scrollableContainer.scrollLeft;
		};
	
		this.__setScrollVariables = function (adjustedScrollPos) 
		{
		    if (this.__scrollableContainer) 
		    {
		        //below logic checks if the scroll should move right or left
		        var xPosLeft = this.__scrollableContainer.scrollLeft;
		        var xPosRight = xPosLeft + this.__scrollableContainer.clientWidth;
		        this.__scrollLeft = adjustedScrollPos < (xPosLeft + 50);
		        this.__scrollRight = adjustedScrollPos > (xPosRight - 100);
		        if(this.__scrollLeft || this.__scrollRight) 
		        {
		            this.__startScrollAnimation();
		        }
		        else 
		        {
		            this.__stopScrollAnimation();
		        }
		    }
		};
	
		this.__startScrollAnimation = function() 
		{
		    if (!this.__scrollInterval) 
		    {
		        this.__animationSteps = 0;
		        this.__moveAttempts = 0;
		        this.__scrollInterval = setInterval(this.__scrollBody.bind(this), 100);
		        if (this.__scrollLeft) 
		        {
		        	this.__setIcon("left",true);
		            //this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_LEFT, true);
		        }
		        else 
		        {
		        	this.__setIcon("right",true);
		            //this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_RIGHT, true);
		        }
		    }
		};
		
		this.__stopScrollAnimation = function () 
		{
		    if (this.__scrollInterval) 
		    {
		        clearInterval(this.__scrollInterval);
		        this.__scrollInterval = null;
		        this.__setIcon("move",false);
		        //this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_MOVE);
		    }
		};
	
		this.__scrollBody = function() 
		{
		    var pixelsToMove;
		    this.__animationSteps++;
		    pixelsToMove = 10 + (this.__animationSteps * 5);
		    if (pixelsToMove > 100) 
		    {
		        pixelsToMove = 100;
		    }
		    var pixelsMoved = 0;
		    if (this.__scrollLeft) 
		    {
		        pixelsMoved = this.__scrollBodyHorizontally(-pixelsToMove);
		    }
		    else if (this.__scrollRight) 
		    {
		        pixelsMoved = this.__scrollBodyHorizontally(pixelsToMove);
		    }
		    if (pixelsMoved !== 0) 
		    {
		        this.__handleScrollMovement(this.__lastDragInfo);
		        this.__moveAttempts = 0;
		    }
		    else 
		    {
		        this.__moveAttempts++;
		        if (this.__moveAttempts > 7) 
		        {
		            if (this.__scrollLeft) 
		            {
		                //this.columnController.setColumnPinned(this.__lastDragInfo.dragItem, column_1.Column.PINNED_LEFT);
		            }
		            else 
		            {
		                //this.columnController.setColumnPinned(this.__lastDragInfo.dragItem, column_1.Column.PINNED_RIGHT);
		            }
		            this.__pushScroll();
		        }
		    }
		};
	
		this.__scrollBodyHorizontally = function(pixels) 
		{
		    var oldScrollPosition = this.__scrollableContainer.scrollLeft;
		    this.__scrollableContainer.scrollLeft = oldScrollPosition + pixels;
		    var newScrollPosition = this.__scrollableContainer.scrollLeft;
		    return newScrollPosition - oldScrollPosition;
		};
	
		this.__pushScroll = function() 
		{
		    if (this.__isColumnDragged) 
		    {
		        this.__handleScrollMovement(this.__lastDragEvent);
		    }
		};
		
		this.__setIcon = function(iconName,animate)
		{
			if(iconName)
			{
				var divDrag = this.__objColumnDrag.dragElement;
				var divMove = divDrag.querySelector(".nsHeaderMove");
				var objSVG = new NSSvg();
				var iconID = null;
				switch(iconName) 
				{
			         case "left":
			        	 iconID = new NSSvgShapes().__MOVE_ICON_ID;
			             break;
			         case "right":
			        	 iconID = new NSSvgShapes().__RIGHT_ICON_ID;
			             break;
			         case "move":
			        	 iconID = new NSSvgShapes().__LEFT_ICON_ID;
			             break;
			         default:
			        	 iconID = null;
			             break;
				}
				if(divMove)
				{
					this.util.removeAllChildren(divMove);
					if(iconID)
					{
						var containerID = divMove.getAttribute("id");
						if(!containerID)
						{
							containerID = this.util.getUniqueId();
						}
						var svg = objSVG.addSVG(divMove,containerID + iconID + "svg","nsMoveIcon",null,null,null,null,null,null,false);
						this.util.addStyleClass(svg,"nsMoveIconTheme");
						objSVG.addUse(svg,containerID + "use",null,"#" + iconID);
					}
					animate ? this.util.addStyleClass(divMove,"nsAnimateLeftToRight") : this.util.removeStyleClass(divMove,"nsAnimateLeftToRight");
				}
			}
		};
		/*End of Horizontal Scroll Logic for Edge cases */
	};
	return NSGridColumnMove;
})();
nsModuleExport(this,"NSGridColumnMove",NSGridColumnMove);

var NSGridFilter = (function()
{
	var NSGridFilter = function(nsGrid)
	{
		this.SEARCH_INTERVAL = 500;
		this.__nsGrid = nsGrid;
		this.__enableApply = true;
		this.__isOrFilter = false;
		
		this.util = nsGrid.util;
		this.isFiltered = false;
		this.__interval = null;
		this.__objControl = {};
		this.__filteredColumn = [];
		this.__objAdvancedFilterSetting = {};
		this.__nsPopUp = null;
		this.__maxZIndex = -1;
		this.__documentClickRef = null;
		this.__documentKeyUpRef = null;
		
		this.processColumnObject = function(objColumn)
		{
			if(this.__nsGrid.__enableFilter)
			{
				if(objColumn.hasOwnProperty("enableFilter"))
				{
					objColumn.enableFilter = Boolean.parse(objColumn["enableFilter"]);
				}
				else
				{
					objColumn.enableFilter = true;
				}
				if(objColumn.enableFilter)
				{
					var objFilter = objColumn["filter"];
					if(objFilter)
					{
						if(objFilter.hasOwnProperty("filterRenderer"))
						{
							var filterRenderer = objFilter["filterRenderer"];
							if (typeof filterRenderer === "string" || filterRenderer instanceof String)
							{
								if(this.util.isFunction(filterRenderer))
								{
									objFilter.filterRenderer = this.__nsGrid.__context[filterRenderer];
								}
							}
						}
						else if(objFilter.hasOwnProperty("filterTemplate") && objFilter["filterTemplate"])
						{
							objFilter.filterTemplate = this.util.getTemplate(objFilter["filterTemplate"]);
						}
						else if(objFilter.hasOwnProperty("type") && objFilter["type"] == NSGrid.FILTER_TYPE_DATE)
						{
							this.__setDefaultDatePicker();
							objFilter.filterDateComponent = new this.__nsGrid.__components["datePicker"]();
						}
						else 
						{
							objFilter.filterRenderer = this.__defaultRenderer.bind(this);
						}
						if(this.__nsGrid.__enableAdvancedFilter)
						{
							if(objFilter.hasOwnProperty("enableAdvancedFilter"))
							{
								objFilter.enableAdvancedFilter = Boolean.parse(objFilter["enableAdvancedFilter"]);
							}
							else
							{
								objFilter.enableAdvancedFilter = true;
							}
							objFilter["advancedFilterType"] = objFilter["advancedFilterType"] ? objFilter["advancedFilterType"] : NSGrid.ADVANCED_FILTER_TEXT;
							if(objFilter.hasOwnProperty("advancedFilterHandler"))
							{
								var advancedFilterHandler = objFilter["advancedFilterHandler"];
								if (typeof advancedFilterHandler === "string" || advancedFilterHandler instanceof String)
								{
									if(this.util.isFunction(advancedFilterHandler))
									{
										objFilter.advancedFilterHandler = this.__nsGrid.__context[advancedFilterHandler];
									}
								}
							}
						}
						else
						{
							objFilter.enableAdvancedFilter = false;
						}
					}
					else
					{
						objColumn["filter"] = {filterRenderer:this.__defaultRenderer.bind(this),enableAdvancedFilter:this.__nsGrid.__enableAdvancedFilter,advancedFilterType:NSGrid.ADVANCED_FILTER_TEXT};
					}
				}
			}
		};
		
		this.addFilterRenderer = function(rendererRow,rendererCell,colItem,colIndex,colID)
		{
			if(this.__nsGrid.__enableFilter && colItem && colItem["enableFilter"])
			{
				var objFilter = colItem["filter"];
				if(objFilter)
				{
					var divHeaderRendererContainer = this.util.createDiv(colID + "rendererContainer","nsFilterParentContainer"); 
					rendererCell.appendChild(divHeaderRendererContainer);
					var dataField = colItem["dataField"];
					var type = objFilter["type"];
					var templateRenderer = objFilter["filterTemplate"];
					var itemRenderer = objFilter["filterRenderer"];
					var dateComponent = objFilter["filterDateComponent"];
					if(dateComponent && type == NSGrid.FILTER_TYPE_DATE)
					{
						var config = objFilter["config"] || {};
						this.dateRenderer(dateComponent,dataField,divHeaderRendererContainer,config,objFilter,this.dateSelectedHandler.bind(this,objFilter));
						this.__objControl[dataField] = {control:dateComponent,config:config,type:"date"};
					}
					else if(itemRenderer)
					{
						var objRenderer = itemRenderer(colItem,colIndex,rendererCell,rendererRow);
						if(objRenderer)
						{
							if(this.util.isString(objRenderer))
							{
								var compSpan = document.createElement("span");
								compSpan.innerHTML = objRenderer;
								divHeaderRendererContainer.appendChild(compSpan);
							}
							else
							{
								divHeaderRendererContainer.appendChild(objRenderer);
							}
						}
					}
					else if(templateRenderer)
					{
						divHeaderRendererContainer.appendChild(templateRenderer.cloneNode(true));
					}
					if(objFilter && objFilter["enableAdvancedFilter"])
					{
						var rendererID = this.__getRendererID(dataField);
						var divFilterIconContainer = this.util.createDiv(rendererID + "FilterIconContainer","nsFilterIconContainer");
						divFilterIconContainer.setAttribute("field",dataField);
						this.util.addEvent(divFilterIconContainer,"click",this.__filterIconClickHandler.bind(this));
						if(this.__nsGrid.__getColumnCustomIcon(colItem,"filter"))
						{
							divFilterIconContainer.innerHTML = this.__nsGrid.__getColumnCustomIcon(colItem,"filter");
						}
						else
						{
							var objSVG = new NSSvg();
							var filterID = new NSSvgShapes().__FILTER_ICON_ID;
							var svg = objSVG.addSVG(divFilterIconContainer,rendererID + "filtersvg","nsFilterIconSVG",null,null,null,null,null,null,true);
							objSVG.addUse(svg,rendererID + "use",null,"#" + filterID);
						}
						this.util.addStyleClass(divHeaderRendererContainer,"nsAdvancedFilterParentContainer");
						divHeaderRendererContainer.appendChild(divFilterIconContainer);
					}
				}
			}
		};
		
		this.dateRenderer = function(dateComponent,dataField,parent,config,objFilter,dateSelectedHandler)
		{
			config.dateSelectedHandler = this.dateSelectedHandler.bind(this,objFilter,config);//dateSelectedHandler;
			dateComponent.init(config);
			var element = dateComponent.getElement();
			if(element)
			{
				element.setAttribute("field",dataField);
				parent.appendChild(element);
				dateComponent.elementAdded();
			}
			else
			{
				this.util.warning("NSGrid","Date Component UI is null.");
			}
		};
		
		this.dateSelectedHandler = function(objFilter,config,isTyping)
		{
			var dateComponent = objFilter["filterDateComponent"];
			if(dateComponent)
			{
				var date = dateComponent.getDate();
				var target = this.util.getTarget(event);
				//clear advanced Filter object if coming from normal filter
				if(!this.__nsPopUp)
				{
					var dataField = target.getAttribute("field");
					if(dataField)
					{
						this.__objAdvancedFilterSetting[dataField] = null;
					}
				}
				if(isTyping)
				{
					clearTimeout(this.__interval);
					var base = this;
					this.__interval = setTimeout(function(){
							base.__filterGrid.bind(base)();
					}, this.SEARCH_INTERVAL);
				}
				else
				{
					this.__filterGrid.bind(this)();
				}
			}
		};
		
		this.setFiltersInControls = function(filter)
		{
			if(this.__nsGrid.__enableFilter && this.__objControl && filter)
			{
				 for(var field in this.__objControl)
				 {
					 if(filter[field])
				     {
						 var control = this.__objControl[field];
						 if(control && control.control)
						 {
							 if(control.type == "date")
							 {
								 control.control.setDate(filter[field]);
							 }
							 else if(control.type == "text")
							 {
								 control.control.value = filter[field];
							 }
						 }
				     }
				 }
			}
		};
		
		this.resetFilters = function()
		{
			if(this.__nsGrid.__enableFilter && this.__objControl)
			{
				 for(var field in this.__objControl)
				 {
					 var control = this.__objControl[field];
					 if(control && control.control)
					 {
						 if(control.type == "date" && control.control.getDate())
						 {
							 control.control.setDate(null);
						 }
						 else if(control.type == "text" && control.control.value)
						 {
							 control.control.value = "";
						 }
					 }
				 }
				 this.__resetFiltering();
			}
		};
		
		this.remove = function()
		{
			if(this.__documentClickRef)
			{
				this.util.removeEvent(document,"click", this.__documentClickRef, false);
				this.__documentClickRef = null;
			}
			if(this.__documentKeyUpRef)
			{
				this.util.removeEvent(document,"keyup", this.__documentKeyUpRef, false);
				this.__documentKeyUpRef = null;
			}
		};
		
		this.clearFilters = function() 
		{
			 for(var field in this.__objControl)
			 {
				 var control = this.__objControl[field];
				 if(control && control.control)
				 {
					 if(control.type == "date" && control.control.getDate())
					 {
						 control.control.setDate(null);
					 }
					 else if(control.type == "text" && control.control.value)
					 {
						 control.control.value = "";
					 }
				 }
			 }
			 this.__objAdvancedFilterSetting = {};
		};
		
		this.resetVariables = function() 
		{
			this.__filteredColumn = [];
			this.__objAdvancedFilterSetting = [];
		};
		
		this.__initialize = function()
		{
			if(!this.__documentClickRef)
			{
				this.__documentClickRef = this.__documentClickHandler.bind(this);
				this.util.addEvent(document,"click", this.__documentClickRef);
			}
			if(!this.__documentKeyUpRef)
			{
				this.__documentKeyUpRef = this.__documentKeyUpHandler.bind(this);
				this.util.addEvent(document,"keyup", this.__documentKeyUpRef);
			}
			this.__maxZIndex = this.util.getMaxZIndex();
			this.__injectInNSGrid();
		};
		
		this.__defaultRenderer = function(colItem,colIndex,cell,row)
		{
			if(colItem)
			{
				var objFilter = colItem["filter"];
				var dataField = colItem["dataField"];
				var headerText = colItem["headerText"];
				var rendererID = this.__getRendererID(dataField);
				var divRenderer = this.util.createDiv(rendererID,"nsFilterContainer");
				var txtFilter = this.util.createElement("input","txt" + rendererID,"nsFilter");
				//this.util.addStyleClass(txtFilter,"nsSearchInlineTextBox");
				txtFilter.setAttribute("type","search");
				txtFilter.setAttribute("autocomplete","off");
				txtFilter.setAttribute("field",dataField);
				//txtFilter.setAttribute("placeholder","Search " + headerText);
				this.util.addEvent(txtFilter,"input",this.__txtInputChangeHandler.bind(this));
				//this.util.addEvent(txtFilter,"search",this.__txtInputChangeHandler.bind(this));
				//var divSearch = this.util.getSearchTextBox(txtFilter);
				//txtFilter.style.width = (cell.offsetWidth / 2) + "px";
				divRenderer.appendChild(txtFilter);
				this.__objControl[dataField] = {control:txtFilter,type:"text"};
				return divRenderer;
			}
			return null;
		};
		
		this.__txtInputChangeHandler = function(event)
		{
			var target = this.util.getTarget(event);
			var dataField = target.getAttribute("field");
			if(dataField)
			{
				this.__objAdvancedFilterSetting[dataField] = null;
			}
			clearTimeout(this.__interval);
			var base = this;
			this.__interval = setTimeout(function(){
					base.__filterGrid.bind(base)();
				}, this.SEARCH_INTERVAL);
		};
		
		this.__filterIconClickHandler = function(event)
		{
			var target = this.util.getTarget(event);
			target = this.util.getWebComponentElement(target);
			if(target && !this.util.hasStyleClass(target,"nsFilterIconContainer"))
			{
				target = this.util.findParentBySelector(target,".nsFilterIconContainer");
			}
			var dataField = target.getAttribute("field");
			var objColumn = this.__nsGrid.__getColumnObjectByDataField(dataField);
			var objFilter = objColumn["filter"];
			if(this.__nsPopUp)
			{
				this.__removePopUp();
			}
			var control = this.__objControl[dataField];
			if(control && control.control)
			{
				(control.type == "date") ? control.control.setDate(null) : control.control.value = "";
			}
			var colID = this.__getRendererID(dataField);
			var popUpPos = objFilter["advancedFilterPopUpPos"];
			if(!popUpPos)
			{
				popUpPos = this.util.POS_BOTTOMLEFT;
				if(objColumn[this.__nsGrid.__fieldColIndex] === 0 || (this.__nsGrid.__enableGrouping && objColumn[this.__nsGrid.__fieldColIndex] === 1))
				{
					popUpPos = this.util.POS_BOTTOMRIGHT; 
				}
			}
			var popUpSetting = {id:colID + "detailFilterContainer",type:"div",width:275,position:popUpPos,closeOnOutsideClick:true};
			this.__nsPopUp = new this.util.nsPopUp(popUpSetting);
			this.__nsPopUp.create();
			var popUp = this.__nsPopUp.getPopUp();
			if(this.__maxZIndex > 0)
			{
				popUp.style.zIndex = this.__maxZIndex + 1;
			}
			this.util.addEvent(popUp,"click",this.__detailFilterClickHandler.bind(this));
			var advancedFilterType = objFilter["advancedFilterType"];
			if(objFilter.advancedFilterHandler)
			{
				objFilter.advancedFilterHandler(dataField,this.__nsPopUp,this.__objAdvancedFilterSetting,this.__getRendererID(dataField),this.__enableApply,
						this.__createApplySection.bind(this),this.__advanceFilterGrid.bind(this),this.__removePopUp.bind(this));
			}
			else if(advancedFilterType === NSGrid.ADVANCED_FILTER_TEXT)
			{
				this.__getTextDetailFilter(dataField,objFilter);
			}
			else if(advancedFilterType === NSGrid.ADVANCED_FILTER_NUMBER)
			{
				this.__getNumberDetailFilter(dataField,objFilter);
			}
			else if(advancedFilterType === NSGrid.ADVANCED_FILTER_LIST)
			{
				this.__getListDetailFilter(dataField,objFilter);
			}
			else if(advancedFilterType === NSGrid.ADVANCED_FILTER_DATE)
			{
				this.__getDateDetailFilter(dataField,objFilter);
			}
			this.__nsPopUp.show();
			this.__nsPopUp.placePopUp(event);
			//event.stopImmediatePropagation();
			event.stopPropagation();
		};
		
		this.__filterGrid = function()
		{
			 var conditionFilter = null;
			 if(this.__isOrFilter)
			 {
				 var filter = [];
				 var setting = {};
				 for(var field in this.__objControl)
				 {
					 var control = this.__objControl[field];
					 if(control && control.control)
					 {
						 if(control.type == "date" && control.control.getDate())
						 {
							 var item = {};
							 item[field] = control.control.getDate();
							 var config = control.config || {};
							 setting[field] = {matchType:"equals",type:"date"};
							 for(var key in config)
							 {
								 if(this.util.isUndefined(setting[field][key]))
								 {
									 setting[field][key] = config[key];
								 }
							 }
							 filter.push(item);
						 }
						 else if(control.type == "text" && control.control.value)
						 {
							 var item = {};
							 item[field] = control.control.value;
							 setting[field] = {caseSensitive:false,multiline:false,matchType:new NSFilter().CONTAINS};
							 filter.push(item);
						 }
					 }
				 }
				 conditionFilter = filter;
			 }
			 else
			 {
				 var filter = {};
				 var setting = {};
				 for(var field in this.__objControl)
				 {
					 var control = this.__objControl[field];
					 if(control && control.control)
					 {
						 if(control.type == "date" && control.control.getDate())
						 {
							 filter[field] = control.control.getDate();
							 var config = control.config || {};
							 setting[field] = {matchType:"equals",type:"date"};
							 for(var key in config)
							 {
								 if(this.util.isUndefined(setting[field][key]))
								 {
									 setting[field][key] = config[key];
								 }
							 }
						 }
						 else if(control.type == "text" && control.control.value)
						 {
							 filter[field] = control.control.value;
							 setting[field] = {caseSensitive:false,multiline:false,matchType:new NSFilter().CONTAINS};
						 }
					 }
				 }
				 conditionFilter = Object.keys(filter);
			 }
			 var isReset = false;
			 if(filter && conditionFilter && conditionFilter.length > 0)
			 {
				 this.__handleFiltering(filter,setting);
			 }
			 else
			 {
				 this.__resetFiltering();
				 isReset = true;
			 }
			 this.__nsGrid.__callFunctionInsideGridType("afterFiltering",isReset);
		};
		
		this.__advanceFilterGrid = function()
		{
			 var fieldSetting = null;
			 var field = null;
			 var conditionFilter = null;
			 if(this.__isOrFilter)
			 {
				 var filter = [];
				 var setting = {};
				 var item = null;
				 for(field in this.__objAdvancedFilterSetting)
				 {
					 fieldSetting = this.__objAdvancedFilterSetting[field];
					 if(fieldSetting)
					 {
						 if(fieldSetting.type == NSGrid.ADVANCED_FILTER_DATE)
						 {
							 item = {};
							 item[field] = new Date();
							 filter.push(item);
							 var config = fieldSetting.config || {};
							 setting[field] = {matchType1:fieldSetting.firstSelectValue,firstDate:fieldSetting.firstDate,operation:fieldSetting.operationSelectValue,
									 matchType2:fieldSetting.secondSelectValue,secondDate:fieldSetting.secondDate,
									 type:NSGrid.ADVANCED_FILTER_DATE};
							 for(var key in config)
							 {
								 if(this.util.isUndefined(setting[field][key]))
								 {
									 setting[field][key] = config[key];
								 }
							 }
							
						 }
						 else if(fieldSetting["arrText"] && fieldSetting["arrTextField"])
						 {
							 var arrTextField = fieldSetting["arrTextField"];
							 var arrText = fieldSetting["arrText"];
							 var length = arrText.length;
							 filter[field] = [];
							 for(var count = 0;count < length;count++)
							 {
								 item = {};
								 item[field] = arrText[count][arrTextField];
								 filter.push(item);
							 }
							 setting[field] = {caseSensitive:fieldSetting.caseSensitive,multiline:false,matchType:fieldSetting.matchType};
						 }
						 else
						 {
							 item = {};
							 item[field] = fieldSetting.text;
							 filter.push(item);
							 setting[field] = {caseSensitive:fieldSetting.caseSensitive,multiline:false,matchType:fieldSetting.matchType};
						 }
					 }
				 }
				 conditionFilter = filter;
			 }
			 else
			 {
				 var filter = {};
				 var setting = {};
				 for(field in this.__objAdvancedFilterSetting)
				 {
					 fieldSetting = this.__objAdvancedFilterSetting[field];
					 if(fieldSetting)
					 {
						 if(fieldSetting.type == NSGrid.ADVANCED_FILTER_DATE)
						 {
							 filter[field] = new Date();
							 var config = fieldSetting.config || {};
							 setting[field] = {matchType1:fieldSetting.firstSelectValue,firstDate:fieldSetting.firstDate,operation:fieldSetting.operationSelectValue,
									 matchType2:fieldSetting.secondSelectValue,secondDate:fieldSetting.secondDate,
									 type:NSGrid.ADVANCED_FILTER_DATE};
							 for(var key in config)
							 {
								 if(this.util.isUndefined(setting[field][key]))
								 {
									 setting[field][key] = config[key];
								 }
							 }
						 }
						 else if(fieldSetting["arrText"] && fieldSetting["arrTextField"])
						 {
							 var arrTextField = fieldSetting["arrTextField"];
							 var arrText = fieldSetting["arrText"];
							 var length = arrText.length;
							 filter[field] = [];
							 for(var count = 0;count < length;count++)
							 {
								 filter[field].push(arrText[count][arrTextField]);
							 }
							 setting[field] = {caseSensitive:fieldSetting.caseSensitive,multiline:false,matchType:fieldSetting.matchType};
						 }
						 else
						 {
							 filter[field] = fieldSetting.text;
							 setting[field] = {caseSensitive:fieldSetting.caseSensitive,multiline:false,matchType:fieldSetting.matchType};
						 }
					 }
				 }
				 conditionFilter = Object.keys(filter);
			 }
			 var isReset = false;
			 if(filter && conditionFilter && conditionFilter.length > 0)
			 {
				 this.__handleFiltering(filter,setting);
			 }
			 else
			 {
				 this.__resetFiltering();
				 isReset = true;
			 }
			 this.__nsGrid.__callFunctionInsideGridType("afterFiltering",isReset);
		};
		
		this.__handleFiltering = function(filter,setting,enableHighlighting,recordLimit)
		{
			if(this.__nsGrid.__enableFilter)
			{
				var eventParam = {filter:filter,setting:setting,recordLimit:recordLimit};
				this.__nsGrid.__dispatchEvent(NSGrid.FILTER_CHANGING,eventParam,eventParam);
				this.__filteredColumn = [];
				if(filter)
			    {
					 if(this.util.isUndefinedOrNull(enableHighlighting))
					 {
						enableHighlighting = true;
					 }
					 var isHierarchical = false;
					 var source = this.__nsGrid.__arrWrapper;
					 if(this.__nsGrid.__enableHierarchical || this.__nsGrid.__enableGrouping || this.__nsGrid.__enableMasterDetail)
					 {
						 isHierarchical = true;
					 }
				   	 var nsFilter = new NSFilter(source,filter,setting,recordLimit,isHierarchical,this.__nsGrid.__childField,
				   			 this.__nsGrid.__filterFunction,this.__nsGrid.__hierarchyFilterChildrenFunction,
				   			 (this.__nsGrid.__objGrid.__ignoreFieldsForDeepCopy && this.__nsGrid.__objGrid.__ignoreFieldsForDeepCopy())
				   	 );
				   	 this.__nsGrid.__arrInternalSource = nsFilter.execute();
				   	 this.__nsGrid.__arrFilteredGroupedSource =  this.__nsGrid.__arrInternalSource.slice(0);
				   	 if(enableHighlighting)
				   	 {
					   	 if(filter instanceof Array) 
				  	     {
					   		 for (var count = 0; count < filter.length; count++) 
					         {
					 	   		var item = filter[count];
					 	   		var key = Object.keys(item)[0];
					 	   		var colItem = this.__nsGrid.__getColumnObjectByDataField(key);
					 	   		this.__filteredColumn.push({field:key,text:item[key],item:colItem});
					         }
				  	     }
				  		 else if(typeof(filter) === "object") 
				  	     {
				  	        for(var key in filter) 
				  	        {
				  	        	var colItem = this.__nsGrid.__getColumnObjectByDataField(key);
				  	        	this.__filteredColumn.push({field:key,text:filter[key],item:colItem});
				  	        }
				  	     }
				   	 }
				   	 if(isHierarchical)
				   	 {
				   		this.__nsGrid.__objGrid.__setWrapperSource(this.__nsGrid.__arrInternalSource,0,-1,0,false);
				   		this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrFlatHierarchicalSource.slice(0); 
				   	 }
				   	 this.__nsGrid.__updateTotalRecords();
				   	 this.__nsGrid.__updateVisibleIndexByRow(this.__nsGrid.__arrInternalSource);
				   	 this.__nsGrid.__renderBody(false,true);
				   	 this.isFiltered = true;
				   	 this.__nsGrid.__dispatchEvent(NSGrid.FILTER_CHANGED,eventParam,eventParam);
			    }
			}
		};
	
		this.__resetFiltering = function()
		{
			if(this.__nsGrid.__enableFilter)
			{
				if(this.__nsGrid.__dataSource)
				{
					this.__nsGrid.__dispatchEvent(NSGrid.FILTER_CHANGING,null,null);
					this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrWrapper.slice(0);
					this.__nsGrid.__arrFilteredGroupedSource =  this.__nsGrid.__arrInternalSource.slice(0);
					this.__filteredColumn = [];
					if(this.__nsGrid.__enableHierarchical || this.__nsGrid.__enableGrouping || this.__nsGrid.__enableMasterDetail)
					{
						this.__nsGrid.__objGrid.__setWrapperSource(this.__nsGrid.__arrInternalSource,0,-1,0,false);
						this.__nsGrid.__arrInternalSource = this.__nsGrid.__arrFlatHierarchicalSource.slice(0); 
					}
					this.__nsGrid.__updateTotalRecords();
					this.__nsGrid.__updateVisibleIndexByRow(this.__nsGrid.__arrInternalSource);
					this.__nsGrid.__renderBody(false,true);
					this.isFiltered = false;
					this.__nsGrid.__dispatchEvent(NSGrid.FILTER_CHANGED,null,null);
					this.__nsGrid.__dispatchEvent(NSGrid.FILTER_RESETTED,null,null);
					//this.unHighlightText();
				}
			}
		};
	
		this.__highlightDiv = function(divText,colIndex)
		{
			var length = this.__filteredColumn.length;
			for (var count = 0; count < length; count++) 
		    {
				var item = this.__filteredColumn[count].item;
				if(item)
				{
					var type = (item.filter && item.filter.type) ? item.filter.type : "text";
					if(type == "text" && item[this.__nsGrid.__fieldColIndex] === colIndex)
					{
						var text = this.__filteredColumn[count].text;
						this.util.highlightText(divText,text,"nsTextHighlight");
					}
				}
		    }
		};
		
		this.__documentClickHandler = function(event) 
		{
			event = this.util.getEvent(event);
			this.__removePopUp();
			this.__nsGrid.__dispatchEvent(NSGrid.ADVANCED_FILTER_CLOSING);
			/*var target = this.util.getTarget(event);
			if(!(target && target.getAttribute("id") && target.getAttribute("id").endsWith("FilterIconContainer")))
			{
				this.__removePopUp();
				this.util.preventDefault(event);
			}*/
		};
	
	
		this.__documentKeyUpHandler = function(event) 
		{
			event = this.util.getEvent(event);
			if(event.keyCode === this.util.KEYCODE.ESC) 
			{
				this.__removePopUp();
				this.__nsGrid.__dispatchEvent(NSGrid.ADVANCED_FILTER_CLOSING);
			}
		};
		
		this.__detailFilterClickHandler = function(event)
		{
			event = this.util.getEvent(event);
			event.stopImmediatePropagation();
		};
		
		this.__removePopUp = function()
		{
			if(this.__nsPopUp)
			{
				this.__nsPopUp.remove();
				this.__nsPopUp = null;
			}
		};
		
		this.__getTextDetailFilter = function(dataField,objFilter)
		{
			var self = this;
			var txtInputChangeHandler = function()
			{
				clearTimeout(self.__interval);
				self.__interval = setTimeout(function(){
						handleTextFilter();
					}, self.SEARCH_INTERVAL);
			};
			var handleTextFilter = function()
			{
				var item = null;
				var text = null;
				if(txtFilter.value && txtFilter.value !== "")
				{
					text = txtFilter.value;
					item = {text:text,caseSensitive:chkSensitive.checked,matchType:arrOptions[cmbFilter.selectedIndex].value,sensitiveChecked:chkSensitive.checked,
							optionIndex:cmbFilter.selectedIndex,textInputText:txtFilter.value,type:NSGrid.ADVANCED_FILTER_TEXT};
				}
				self.__objAdvancedFilterSetting[dataField] = item;
				self.__advanceFilterGrid.bind(self)();
				if(self.__enableApply)
				{
					self.__removePopUp();
				}
			};
			var resetTextFilter = function()
			{
				self.__objAdvancedFilterSetting[dataField] = null;
				self.__advanceFilterGrid.bind(self)();
				self.__removePopUp();
			};
			var createSelect = function(arrSource,strID,prevField)
			{
				var divSelect = self.util.createElement("span",colID + strID + "detailFilterSelectContainer");
				var cmbFilter = self.util.createElement("select",colID + strID + "detailFilterSelect","nsFilterSelect");
				cmbFilter.style.height = "25px";
				var option = null;
				var item = null;
				var label = null;
				for(var count = 0;count < arrSource.length;count++)
				{
					item = arrSource[count];
					option = document.createElement("option");
					label = document.createTextNode(item["label"]);
					option.appendChild(label);
					option.setAttribute("value", item["id"]);
					cmbFilter.appendChild(option);
				}
				if(objPrev && objPrev[prevField])
				{
					cmbFilter.selectedIndex = objPrev[prevField];
				}
				divSelect.style.display = "inline-block";
				divSelect.style.width = "40%";
				divSelect.appendChild(cmbFilter);
				divUpperContainer.appendChild(divSelect);
				return cmbFilter;
			};
			var createCheckbox = function(text,strID,prevField)
			{
				var divCheckbox = self.util.createElement("span",colID + strID + "detailFilterCheckboxContainer");
				var label = self.util.createElement("label",colID + strID + "detailFilterLabel",null);
				var checkbox = self.util.createElement("input",colID + strID + "detailFilterCheckbox",null);
				checkbox.setAttribute("type","checkbox");
				label.appendChild(checkbox);
				if(text)
				{
					label.appendChild(document.createTextNode(text));
				}
				if(objPrev && objPrev[prevField])
				{
					checkbox.setAttribute("checked",true);
				}
				label.style.fontWeight = "400";
				label.style.cursor = "pointer";
				checkbox.style.marginRight = "5px";
				divCheckbox.style.paddingTop = "5px";
				divCheckbox.style.display = "inline-block";
				divCheckbox.appendChild(label);
				divLowerContainer.appendChild(divCheckbox);
				return checkbox;
			};
			var nsFilter = new NSFilter();
			var arrOptions = [{id:1,label:"Contains",value:nsFilter.CONTAINS},
			                  {id:2,label:"Exact",value:nsFilter.EXACT},
			                  {id:3,label:"Starts With",value:nsFilter.STARTS_WITH},
			                  {id:4,label:"Ends With",value:nsFilter.ENDS_WITH}];
			var objPrev = this.__objAdvancedFilterSetting[dataField];
			var colID = this.__getRendererID(dataField);
			var divDetailFilterContainer = this.__nsPopUp.getPopUp();
			//divDetailFilterContainer.style.width = "275px";
			divDetailFilterContainer.style.padding = "10px";
			var divUpperContainer = this.util.createDiv(colID + "detailFilterUpperContainer");
			divUpperContainer.style.paddingBottom = "8px";
			var divLowerContainer = this.util.createDiv(colID + "detailFilterLowerContainer");
			var cmbFilter = createSelect(arrOptions,"options","optionIndex");
			var divTextInput = this.util.createElement("span",colID + "detailFilterTextInputContainer");
			divTextInput.style.float = "right";
			divTextInput.style.width = "60%";
			var txtFilter = this.util.createElement("input",colID + "detailFilterTextInput","nsFilterTextInput");
			txtFilter.setAttribute("placeholder", "Enter Value here");
			txtFilter.style.width = "100%";
			if(objPrev && objPrev["textInputText"])
			{
				txtFilter.value = objPrev["textInputText"];
			}
			//var divSearch = this.util.getSearchTextBox(txtFilter);
			//this.util.addStyleClass(divSearch,"nsFilterSearchTextBox");
			divTextInput.appendChild(txtFilter);
			divUpperContainer.appendChild(divTextInput);
			var chkSensitive = createCheckbox("Case Sensitive","sensitive","sensitiveChecked");
			if(this.__enableApply)
			{
				this.__createApplySection.bind(this)(colID,divLowerContainer,handleTextFilter,resetTextFilter);
			}
			else
			{
				this.util.addEvent(chkSensitive,"click",handleTextFilter);
				this.util.addEvent(cmbFilter,"change",handleTextFilter);
				this.util.addEvent(txtFilter,"keyup",txtInputChangeHandler);
			}
			divDetailFilterContainer.appendChild(divUpperContainer);
			divDetailFilterContainer.appendChild(divLowerContainer);
		};
		
		this.__getNumberDetailFilter = function(dataField,objFilter)
		{
			var self = this;
			var txtInputChangeHandler = function()
			{
				clearTimeout(self.__interval);
				self.__interval = setTimeout(function(){
						handleNumberFilter();
					}, self.SEARCH_INTERVAL);
			};
			var handleNumberFilter = function()
			{
				var item = null;
				var text = null;
				if(txtFilter.value && txtFilter.value !== "")
				{
					text = arrOptions[cmbFilter.selectedIndex].sign + txtFilter.value;
					item = {text:text,caseSensitive:false,matchType:new NSFilter().CONTAINS,index:cmbFilter.selectedIndex,textInputText:txtFilter.value,type:NSGrid.ADVANCED_FILTER_NUMBER};
				}
				self.__objAdvancedFilterSetting[dataField] = item;
				self.__advanceFilterGrid.bind(self)();
				if(self.__enableApply)
				{
					self.__removePopUp();
				}
			};
			var resetNumberFilter = function()
			{
				self.__objAdvancedFilterSetting[dataField] = null;
				self.__advanceFilterGrid.bind(self)();
				self.__removePopUp();
			};
			
			var arrOptions = [{id:1,label:"<=",toolTip:"Less than Equals To",sign:"<="},
			                  {id:2,label:">=",toolTip:"Greater than Equals To",sign:">="},
			                  {id:3,label:"<",toolTip:"Less than",sign:"<"},
			                  {id:4,label:">",toolTip:"Greater than",sign:">"},
			                  {id:5,label:"=",toolTip:"Equals",sign:""}];
			var objPrev = this.__objAdvancedFilterSetting[dataField];
			var colID = this.__getRendererID(dataField);
			var divDetailFilterContainer = this.__nsPopUp.getPopUp();
			//divDetailFilterContainer.style.width = "225px";
			divDetailFilterContainer.style.padding = "10px";
			var divUpperContainer = this.util.createDiv(colID + "detailFilterUpperContainer");
			divUpperContainer.style.paddingBottom = "8px";
			var divLowerContainer = this.util.createDiv(colID + "detailFilterLowerContainer");
			var divSelect = this.util.createElement("span",colID + "detailFilterSelectContainer");
			var cmbFilter = this.util.createElement("select",colID + "detailFilterSelect","nsFilterSelect");
			cmbFilter.style.height = "25px";
			divSelect.style.display = "inline-block";
			divSelect.style.width = "20%";
			var option = null;
			var item = null;
			var label = null;
			for(var count = 0;count < arrOptions.length;count++)
			{
				item = arrOptions[count];
				option = document.createElement("option");
				label = document.createTextNode(item["label"]);
				option.appendChild(label);
				//option.setAttribute("text", item["label"]);
				option.setAttribute("value", item["id"]);
				cmbFilter.appendChild(option);
			}
			if(objPrev && objPrev["index"])
			{
				cmbFilter.selectedIndex = objPrev["index"];
			}
			divSelect.appendChild(cmbFilter);
			divUpperContainer.appendChild(divSelect);
			var divTextInput = this.util.createElement("span",colID + "detailFilterTextInputContainer");
			var txtFilter = this.util.createElement("input",colID + "detailFilterTextInput","nsFilterTextInput");
			txtFilter.setAttribute("placeholder", "Enter Value here");
			if(objPrev && objPrev["textInputText"])
			{
				txtFilter.value = objPrev["textInputText"];
			}
			divTextInput.style.float = "right";
			divTextInput.style.width = "80%";
			txtFilter.style.width = "100%";
			divTextInput.appendChild(txtFilter);
			divUpperContainer.appendChild(divTextInput);
			if(this.__enableApply)
			{
				this.__createApplySection.bind(this)(colID,divLowerContainer,handleNumberFilter,resetNumberFilter);
			}
			else
			{
				this.util.addEvent(cmbFilter,"change",handleNumberFilter);
				this.util.addEvent(txtFilter,"keyup",txtInputChangeHandler);
			}
			divDetailFilterContainer.appendChild(divUpperContainer);
			divDetailFilterContainer.appendChild(divLowerContainer);
		};
		
		this.__getListDetailFilter = function(dataField,objFilter)
		{
			var self = this;
			var itemRenderer = function(item,labelField,fieldIndex,isDisabled,listItem)
			{
				if(item)
				{
					var divRenderer = self.util.createElement("span",colID + "filterListContainer" + item["id"] ,"nsFilterListRenderer");
					var label = self.util.createElement("label");
					var checkBox = self.util.createElement("input",null,"nsFilterListRendererCheckBox");
					checkBox.setAttribute("type","checkbox");
					checkBox.checked = Boolean.parse(item["selected"]);
					this.util.addEvent(checkBox,"click",checkBoxClickHandler);
					label.style.fontWeight = "400";
					label.style.cursor = "pointer";
					checkBox.style.marginRight = "5px";
					label.appendChild(checkBox);
					label.appendChild(document.createTextNode(item[labelField]));
					divRenderer.appendChild(label);
					return divRenderer;
				}
				return null;
			};
			var txtInputChangeHandler = function()
			{
				clearTimeout(self.__interval);
				self.__interval = setTimeout(function(){
						handleListFilter(true);
					}, self.SEARCH_INTERVAL);
			};
			var handleListFilter = function(isReset)
			{
				var item = null;
				var text = null;
				var text = txtFilter.value;
				if(text === "")
				{
					objNSList.resetFilter();
				}
				else
				{
					var setting = {caseSensitive:false,multiline:false,matchType:new NSFilter().CONTAINS};
					objNSList.filter(text,setting,true);
				}
				if(isReset)
				{
					arrSelected = objNSList.__arrInternalSource;
				}
			};
			var checkBoxClickHandler = function(event)
			{
				var target = self.util.getTarget(event);
				var checked = target.checked;
				target = self.util.findParent(target,"li");
				var source = objNSList.__arrInternalSource;
				var index = objNSList.__getIndexFromTarget(target);
				if(index > -1)
				{
					tempItem = objNSList.__getItemByIndex(index);
					if(tempItem)
					{
						var selectedIndex = source.findIndex(findIndexfromSelectedArray);
						if(checked && selectedIndex > -1)
						{
							arrSelected.push(tempItem);
						}
						else if(!checked && selectedIndex > -1)
						{
							for(var count = 0;count < arrSelected.length;count++)
							{
								if(arrSelected[count].id == selectedIndex)
								{
									arrSelected.splice(count,1);
									break;
								}
							}
						}
						tempItem["selected"] = checked;
					}
					setSelectAllCheckBox();
				}
			};
			
			var chkSelectAllClickHandler = function(event)
			{
				if(arrSource)
				{
					var length = arrSource.length;
					var checked = chkSelectAll.checked;
					var source = objNSList.__arrInternalSource;
					var item = null;
					for(var count = 0;count < length;count++)
					{
						item = arrSource[count];
						item["selected"] = checked;
					}
					if(source)
					{
						for(var count = 0;count < source.length;count++)
						{
							item = source[count];
							item["selected"] = checked;
						}
					}
					if(checked)
					{
						arrSelected = self.util.cloneObject(arrSource);
					}
					else
					{
						arrSelected = [];
					}
					objNSList.__renderBody(false);
				}
			};
			
			var setSelectAllCheckBox = function()
			{
				var isAllSelected = isSelectedAll();
				var isNoneSelected = isUnselectedAll();
				if(isAllSelected)
				{
					chkSelectAll.indeterminate = false;
					chkSelectAll.checked = true;
				}
				else if(isNoneSelected)
				{
					chkSelectAll.indeterminate = false;
					chkSelectAll.checked = false;
				}
				else
				{
					chkSelectAll.indeterminate = true;
				}
			};
			
			var findIndexfromSelectedArray = function(element,index,array)
			{
				return (element["id"] === tempItem["id"]);
			};
			
			var isSelectedAll = function()
			{
				if(arrSource && arrSelected)
				{
					return (arrSource.length === arrSelected.length);
				}
				return false;
			};
			
			var isUnselectedAll = function()
			{
				if(arrSelected)
				{
					return (arrSelected.length === 0);
				}
				return true;
			};
			
			var handleMainFilter = function()
			{
				var arrTemp = [];
				if(arrSelected && arrSelected.length > 0)
				{
					for(var count = 0;count < arrSelected.length;count++)
					{
						if(arrSelected[count]["selected"])
						{
							arrTemp.push(arrSelected[count]);
						}
					}
				}
				var item = {arrText:arrTemp,arrTextField:"label",caseSensitive:true,matchType:new NSFilter().EXACT,arrSelected:arrSelected,textInputText:txtFilter.value,type:NSGrid.ADVANCED_FILTER_LIST};
				self.__objAdvancedFilterSetting[dataField] = item;
				self.__advanceFilterGrid.bind(self)();
				if(self.__enableApply)
				{
					self.__removePopUp();
				}
			};
			var resetMainFilter = function()
			{
				self.__objAdvancedFilterSetting[dataField] = null;
				self.__advanceFilterGrid.bind(self)();
				self.__removePopUp();
			};
			
			var tempItem = null;
			var objPrev = this.__objAdvancedFilterSetting[dataField];
			if(!objPrev)
			{
				objPrev = {};
			}
			var arrSelected = objPrev["arrSelected"];
			var arrSource = this.__getUniqueValues(this.__nsGrid.__objGrid.__getFlatSource(),dataField,arrSelected);
			if(!arrSelected)
			{
				arrSelected = this.util.cloneObject(arrSource);
			}
			var colID = this.__getRendererID(dataField);
			var divDetailFilterContainer = this.__nsPopUp.getPopUp();
			//divDetailFilterContainer.style.width = "240px";
			divDetailFilterContainer.style.padding = "10px";
			var divUpperContainer = this.util.createDiv(colID + "detailFilterUpperContainer");
			divUpperContainer.style.paddingBottom = "8px";
			var divLowerContainer = this.util.createDiv(colID + "detailFilterLowerContainer");
			var divTextInput = this.util.createDiv(colID + "detailFilterTextInputContainer","nsFilterLineContainer");
			this.util.addStyleClass(divTextInput,"nsFilterLineContainerTheme");
			divTextInput.setAttribute("style","height:29px;");
			var txtFilter = this.util.createElement("input",colID + "detailFilterTextInput","nsFilterTextInput");
			txtFilter.setAttribute("placeholder", "Enter Value here");
			txtFilter.style.width = "100%";
			if(objPrev["textInputText"])
			{
				txtFilter.value = objPrev["textInputText"];
			}
			this.util.addEvent(txtFilter,"keyup",txtInputChangeHandler);
			divTextInput.appendChild(txtFilter);
			divUpperContainer.appendChild(divTextInput);
			divDetailFilterContainer.appendChild(divUpperContainer);
			divDetailFilterContainer.appendChild(divLowerContainer);
			var divList = this.util.createDiv(colID + "detailFilterListContainer");
			var lstFilter = this.util.createElement("div",colID + "detailFilterList","nsFilterList");
			lstFilter.style.height = "300px";
			divList.appendChild(lstFilter);
			divUpperContainer.appendChild(divList);
			var setting = {labelField:"label",enableVirtualScroll:false,enableDragDrop:false,enableDragByHandle:false,enableMultipleSelection:true,enableKeyboardNavigation:false,
						   customScrollerRequired:false,enableMouseHover:true,enableMouseHoverAnimation:false,itemRenderer:itemRenderer.bind(this)};
			setting["dataSource"] = arrSource;
			var objNSList = new NSList(lstFilter,setting);
			
			var divSelectAll = this.util.createElement("span",colID + "detailFilterSelectAllContainer","nsFilterLineContainer");
			this.util.addStyleClass(divSelectAll,"nsFilterLineContainerTheme");
			var label = self.util.createElement("label");
			var chkSelectAll = self.util.createElement("input",null,"nsFilterListRendererCheckBox");
			chkSelectAll.setAttribute("type","checkbox");
			this.util.addEvent(chkSelectAll,"click",chkSelectAllClickHandler);
			label.appendChild(chkSelectAll);
			label.appendChild(document.createTextNode("Select All"));
			label.style.fontWeight = "400";
			label.style.cursor = "pointer";
			chkSelectAll.style.marginRight = "5px";
			divSelectAll.style.paddingTop = "5px";
			divSelectAll.style.display = "inline-block";
			divSelectAll.appendChild(label);
			divLowerContainer.appendChild(divSelectAll);
			if(this.__enableApply)
			{
				this.__createApplySection.bind(this)(colID,divLowerContainer,handleMainFilter,resetMainFilter);
			}
			handleListFilter(false);
			setSelectAllCheckBox();
		};
		
		this.__getDateDetailFilter = function(dataField,objFilter)
		{
			var self = this;
			this.__setDefaultDatePicker();
			var arrOptions = [{text:"Equals",value:"equals"},
			                  {text:"Greater than",value:"greaterThan"},
			                  {text:"Less than",value:"lessThan"},
			                  {text:"Not equal",value:"notEqual"}];
			var arrOptOption = [{text:"And",value:"and"},
			                  {text:"OR",value:"or"}];
			var createSelect = function(id,css)
			{
				var select =  self.util.createElement("select",id,css);
				for(var count = 0;count < arrOptions.length;count++)
				{
					var item = arrOptions[count];
					var option = self.util.createElement("option");
					option.setAttribute("value", item.value);
					var text = document.createTextNode(item.text);
					option.appendChild(text);
					select.appendChild(option);
				}
				return select;
			};
			var handleMainFilter = function()
			{
				var item = {type:NSGrid.ADVANCED_FILTER_DATE,selectFirst:selectFirst,firstSelectIndex:selectFirst.selectedIndex,firstSelectValue:selectFirst.options[selectFirst.selectedIndex].value,
							compFirstDate:compFirstDate,firstDate:compFirstDate.getDate(),
							operationSelect:select,operationSelectedIndex:select.selectedIndex,operationSelectValue:select.options[select.selectedIndex].value,
							selectSecond:selectSecond,secondSelectIndex:selectSecond.selectedIndex,secondSelectValue:selectSecond.options[selectSecond.selectedIndex].value,
							compSecondDate:compSecondDate,secondDate:compSecondDate.getDate(),config:dateConfig,
							divUpperContainer:divUpperContainer,divLowerContainer:divLowerContainer
						};
				self.__objAdvancedFilterSetting[dataField] = item;
				self.__advanceFilterGrid.bind(self)();
				if(self.__enableApply)
				{
					self.__removePopUp();
				}
			};
			var resetMainFilter = function()
			{
				self.__objAdvancedFilterSetting[dataField] = null;
				self.__advanceFilterGrid.bind(self)();
				self.__removePopUp();
			};
			var divDetailFilterContainer = this.__nsPopUp.getPopUp();
			divDetailFilterContainer.style.padding = "10px";
			var dateConfig = objFilter["advancedFilterConfig"] || {};
			var filterConfig = objFilter["config"] || {};
			for(var key in filterConfig)
			{
				if(this.util.isUndefined(dateConfig[key]))
				{
					dateConfig[key] = filterConfig[key];
				}
			}
			dateConfig["filterManually"] = this.__enableApply;
			var objPrev = this.__objAdvancedFilterSetting[dataField];
			if(objPrev)
			{
				var divUpperContainer = objPrev.divUpperContainer;
				var divLowerContainer = objPrev.divLowerContainer;
				var selectFirst = objPrev.selectFirst;
				selectFirst.selectedIndex = objPrev.firstSelectIndex;
				var compFirstDate = objPrev.compFirstDate;
				compFirstDate.setDate(objPrev.firstDate);
				var select = objPrev.operationSelect;
				select.selectedIndex = objPrev.operationSelectedIndex;
				var selectSecond = objPrev.selectSecond;
				selectSecond.selectedIndex = objPrev.secondSelectIndex;
				var compSecondDate = objPrev.compSecondDate;
				compSecondDate.setDate(objPrev.secondDate);
				divDetailFilterContainer.appendChild(divUpperContainer);
				divDetailFilterContainer.appendChild(divLowerContainer);
			}
			else
			{
				/*if(!objPrev)
				{
					objPrev = {};
				}*/
				var colID = this.__getRendererID(dataField);
				var divUpperContainer = this.util.createDiv(colID + "detailFilterUpperContainer");
				divUpperContainer.style.paddingBottom = "8px";
				var divLowerContainer = this.util.createDiv(colID + "detailFilterLowerContainer");
				var divFirstSelect = this.util.createDiv(colID + "detailFirstSelectContainer","nsGridFilterFirstSelectContainer");
				this.util.addStyleClass(divFirstSelect,"nsGridFilterFirstSelectContainerTheme");
				//divFirstSelect.setAttribute("style","height:29px;");
				var selectFirst =  createSelect(colID + "detailFirstSelect","nsGridFilterFirstSelect");
				divFirstSelect.appendChild(selectFirst);
				divUpperContainer.appendChild(divFirstSelect);
				//selectFirst.selectedIndex = this.util.isUndefinedOrNull(objPrev.firstSelectIndex) ? 0 : objPrev.firstSelectIndex;
				
				var divFirstDate = this.util.createDiv(colID + "detailFirstDateContainer","nsGridFilterFirstDateContainer");
				this.util.addStyleClass(divFirstDate,"nsGridFilterFirstDateContainerTheme");
				divUpperContainer.appendChild(divFirstDate);
				var compFirstDate = new this.__nsGrid.__components["datePicker"]();
				this.dateRenderer(compFirstDate,dataField,divFirstDate,dateConfig,objFilter);
				
				var divOption = this.util.createDiv(colID + "detailOptionContainer","nsGridFilterOptionContainer");
				this.util.addStyleClass(divOption,"nsGridFilterOptionContainerTheme");
				var select =  this.util.createElement("select",null,"nsGridFilterOptOption");
				for(var count = 0;count < arrOptOption.length;count++)
				{
					var item = arrOptOption[count];
					var option = this.util.createElement("option");
					option.setAttribute("value", item.value);
					var text = document.createTextNode(item.text);
					option.appendChild(text);
					select.appendChild(option);
				}
				divOption.appendChild(select);
				divUpperContainer.appendChild(divOption);
				//select.selectedIndex = this.util.isUndefinedOrNull(objPrev.operationSelectedIndex) ? 0 : objPrev.operationSelectedIndex;
				
				
				var divSecondSelect = this.util.createDiv(colID + "detailSecondSelectContainer","nsGridFilterSecondSelectContainer");
				this.util.addStyleClass(divSecondSelect,"nsGridFilterSecondSelectContainerTheme");
				//divSecondSelect.setAttribute("style","height:29px;");
				var selectSecond =  createSelect(colID + "detailSecondSelect","nsGridFilterSecondSelect");
				divSecondSelect.appendChild(selectSecond);
				divUpperContainer.appendChild(divSecondSelect);
				//selectSecond.selectedIndex = this.util.isUndefinedOrNull(objPrev.secondSelectIndex) ? 0 : objPrev.secondSelectIndex;
				
				var divSecondDate = this.util.createDiv(colID + "detailSecondDateContainer","nsGridFilterSecondDateContainer");
				this.util.addStyleClass(divSecondDate,"nsGridFilterSecondDateContainerTheme");
				divUpperContainer.appendChild(divSecondDate);
				var compSecondDate = new this.__nsGrid.__components["datePicker"]();
				this.dateRenderer(compSecondDate,dataField,divSecondDate,dateConfig,objFilter);
				divDetailFilterContainer.appendChild(divUpperContainer);
				divDetailFilterContainer.appendChild(divLowerContainer);
				if(this.__enableApply)
				{
					this.__createApplySection.bind(this)(colID,divLowerContainer,handleMainFilter,resetMainFilter);
				}
			}
		};
		
		this.__createApplySection = function(colID,parent,applyClickHandler,resetClickHandler)
		{
			var divApplyButton = this.util.createDiv(colID + "detailFilterApplyButtonContainer","nsFilterButtonDiv");
			this.util.addStyleClass(divApplyButton,"nsFilterButtonDivTheme");
			var btnFilter = this.util.createElement("button",colID + "detailFilterApply","nsFilterButton");
			this.util.addStyleClass(btnFilter,"nsButton");
			this.util.addStyleClass(btnFilter,"nsButtonGreen");
			this.util.addStyleClass(btnFilter,"nsButtonShadow");
			this.util.addStyleClass(btnFilter,"nsButtonFont12");
			btnFilter.innerHTML = "Filter";
			divApplyButton.appendChild(btnFilter);
			var btnCancel = this.util.createElement("button",colID + "detailFilterReset","nsFilterButton");
			this.util.addStyleClass(btnCancel,"nsButton");
			this.util.addStyleClass(btnCancel,"nsButtonGrey");
			this.util.addStyleClass(btnCancel,"nsButtonShadow");
			this.util.addStyleClass(btnCancel,"nsButtonFont12");
			btnCancel.innerHTML = "Cancel";
			divApplyButton.appendChild(btnCancel);
			divApplyButton.style.float = "right";
			parent.appendChild(divApplyButton);
			this.util.addEvent(btnFilter,"click",applyClickHandler);
			this.util.addEvent(btnCancel,"click",resetClickHandler);
		};
		
		this.__getRendererID = function(dataField)
		{
			return (this.__nsGrid.getID() + "col" + dataField + "renderer");
		};
		
		this.__getUniqueValues = function(arrSource,dataField,arrSelected)
		{
			var findItem = function(element, index, array) 
			{
				return (item["value"] === element["value"]);
			};
			var arrReturn = null;
			var item = {};
			if(arrSource && arrSource.length > 0 && dataField)
			{
				var objMap = {};
				var value = "";
				var length = arrSource.length;
				var count = 0;
				var arrTemp = [];
				var itemPrev = {};
				arrReturn = [];
			    for(count = 0; count < length;count++)
			    {
			    	value = arrSource[count][dataField];
			    	if(value)
			    	{
			    		objMap[value] = value;
			    	}
			    }
			    arrTemp = Object.keys(objMap);
			    length = arrTemp.length;
			    if(length > 0)
			    {
			    	for(count = 0; count < length;count++)
				    {
				    	value = arrTemp[count];
				    	item = {id:count,label:value,value:value,selected:true};
				    	//if arrSelected is present and then item is not found then it is unselected
				    	//if arrSelected is not present then all Items are selected
				    	if(arrSelected)
				    	{
				    		itemPrev = arrSelected.find(findItem);
				    		if(itemPrev)
				    		{
				    			item["selected"] = itemPrev["selected"];
				    		}
				    		else
				    		{
				    			item["selected"] = false;
				    		}
				    	}
				    	arrReturn.push(item);
				    }
			    }
			}
			return arrReturn;
		};
		
		this.__setDefaultDatePicker = function()
		{
			if(!this.__nsGrid.__components)
			{
				this.__nsGrid.__components = {};
			}
			if(!this.__nsGrid.__components["datePicker"])
			{
				var dateComp = function()
				{
					var setting = null;
					var div = null;
					var objDate = null;
				    var self = this;
				    var util = new NSUtil();
				    
				    var init = function(config) 
				    {
						setting = getParam(config);
						if(!setting)
						{
							setting = {};
						}
						setting.dateOutputFormat = setting.dateOutputFormat ? setting.dateOutputFormat : "MM/dd/yyyy";
						//setting.placeHolder = setting.placeHolder ? setting.placeHolder : setting.dateOutputFormat;
						div = util.createDiv(null,"nsGridDatePicker"); 
						//div.style.width = "90%";
						div.style.display = "inline-block";
				    };
				    
				    var getElement = function()
				    {
				    	return div;
				    };
				    
				    var elementAdded = function()
				    {
				    	objDate = new NSDatePicker(div,setting);
						util.addEvent(div,NSDatePicker.DATE_SELECTED,function(event)
						{
							dateSelected(event.detail,false);
						});
						util.addEvent(div,NSDatePicker.INPUT_CHANGE,function(event)
						{
							dateSelected(event.detail,true);
						});
				    };
				    
				    var dateSelected = function(date,isType)
				    {
				    	if(util.isUndefinedOrNull(setting.filterManually) || !setting.filterManually)
				    	{
				    		setting.dateSelectedHandler(isType);
				    	}
				    };
				    
				    var getDate = function()
				    {
				    	return objDate.getSelectedDate();
				    };
				    
				    var setDate = function(date,fireEvent)
				    {
				    	objDate.setSelectedDate(date,null,false);
				    };
				    
				    var getParam = function(param)
				    {
				    	if(!param)
				    	{
				    		param = {};
				    	}
				    	/*param = {
				    		cssClass: param.cssClass || null,
				    	};*/
				    	return param;
				    };
				    
				    self.init = init;
				    self.getElement = getElement;
				    self.elementAdded = elementAdded;
				    self.getDate = getDate;
				    self.setDate = setDate;
				};
				
				this.__nsGrid.__components["datePicker"] = dateComp;
			}
		};
		
		this.__injectInNSGrid = function()
		{
			NSGrid.FILTER_TYPE_DATE = "date";
			NSGrid.ADVANCED_FILTER_TEXT = "text";
			NSGrid.ADVANCED_FILTER_NUMBER = "number";
			NSGrid.ADVANCED_FILTER_LIST = "list";
			NSGrid.ADVANCED_FILTER_DATE = "date";
		};
		this.__initialize();
	};
	return NSGridFilter;
})();
nsModuleExport(this,"NSGridFilter",NSGridFilter);var NSList = (function()
{
	function NSList(component,setting) 
	{
		//this.base.call(this);
		this.ITEM_SELECTED = "itemSelected";
		this.ITEM_UNSELECTED = "itemUnselected";
		this.ITEM_NAVIGATED = "itemNavigated";
		this.NAVIGATION_UP = "up";
		this.NAVIGATION_DOWN = "down";
		this.ITEM_DROPPING = "itemDropping";
		this.ITEM_DROPPED = "itemDropped";
		this.DRAG_STARTED = "dragStarted";
		this.DRAGGING = "dragging";
		this.DRAG_END = "dragEnd";
		
		this.__setting = setting;
		this.__dataSource = null;
		this.__labelField = "label";
		this.__itemRenderer = null;
		this.__templateID = null;
		this.__setData = null;
		this.__labelFunction = null;
		this.__enableHierarchical = false;
		this.__enableMouseHover = false;
		this.__enableMouseHoverAnimation = false;
		this.__disableHoverField = null;
		this.__disableHoverFunction = null;
		this.__enableKeyboardNavigation = false;
		this.__enableMultipleSelection = false;
		this.__enableCustomScrollBar = false;
		this.__enableVirtualScroll = false;
		this.__isDraggable = true;
		this.__isDroppable = true;
		this.__enableDragByHandle = false;
		this.__dragHandlerClass = null;
		this.__enableDragAfterHold = false;
		this.__holdTime = 500;
		this.__enableCloneMode = false;
		this.__rowHeight = -1;
		this.__noDataMessage = "No matching records found";
		this.__enableContextMenu = false;
		this.__enableVariableRowHeight = false;
		this.__contextMenuProvider = null;
		this.__contextMenuSetting = null;
		this.__enableTruncateToFit = false;
		this.__toolTipField = null;
		this.__enableToolTipForTruncateText = false;
		this.__toolTipRenderer = null;
		
		this.__arrWrapper = null;
		this.__arrInternalSource = null;
		this.__arrFlatHierarchicalSource = [];
		
		this.__divOuterContainer = null;
		this.__divParentContainer = null;
		this.__listContainer = null;
		this.__scroller = null;
		this.__scrollerSetting = {};
		this.__customScrollBarSetting = {};
		this.__customScrollBarTooltip = null;
		
		this.__template = null;
		this.__currentIndex = -1;
		this.__selectedIndex = -1;
		this.__navigationIndex = -1;
		this.__selectedItem = null;
		this.__selectedItems = [];	
		this.__selectedIndexes = [];
		this.__lastNavigationDirection = null;
		this.__orignalItemKey = [];
		//for keyboard navigation
		this.__pageSize = 0;
		this.__scrollTarget = null;
		this.__startArrayElement = -1;
		this.__listItemHeight = 0;
		//for Virtual Scroll
		this.__virtualScrollSetting = {};
		this.__nsVirtualScroll = null; 
		this.__virtualRowHeight = 0;
		
		this.__childField = "children";
		this.__CLASS_GROUP_CELL = "nsListGroupCell";
		this.__CLASS_CELL_CHILD = "nsListCellChild";
		
		//removing this.getID() as prefix as move functionality from one list to another would have different fields.
		this.__fieldPrefix = "ns_field";
		this.__fieldIndex =  this.__fieldPrefix + "_item_index";
		this.__fieldVisibleIndex = this.__fieldPrefix + "_item_visible_index";
		this.__fieldItem = this.__fieldPrefix + "_item";
		this.__fieldDisableHover = this.__fieldPrefix + "_disableHover";
		this.__fieldSelected = this.__fieldPrefix + "_selected";
		this.__fieldHover = this.__fieldPrefix + "_hover";
		
		this.__fieldItemLevel = this.__fieldPrefix + "_item_level";
		this.__fieldItemVisible = this.__fieldPrefix + "_item_visible";
		this.__fieldParentIndex = this.__fieldPrefix + "_parent_index";
		this.__fieldHasChild = this.__fieldPrefix + "_item_hasChild";
		this.__fieldHasParent = this.__fieldPrefix + "_item_hasParent";
		this.__fieldIsCollapsed = this.__fieldPrefix + "_item_isCollapsed";
		this.__fieldItemArrow = this.__fieldPrefix + "_item_arrow";
		
		this.__isShiftPressed = false;
		this.__isCtrlPressed = false;
		
		this.__objGrid = null;
		this.__nsListFilter = null;
		this.__nsListDragDrop = null;
		this.__nsToolTipInElement = null;
		
		this.__keyDownRef = null;
		this.__keyUpRef = null;
		this.base.__setBaseComponent.call(this,component);
	};
	nsExtendPrototype(NSContainerBase,NSList);
	NSList.prototype.constructor = NSList;
	
	NSList.prototype.initializeComponent = function() 
	{
		this.base.initializeComponent.call(this);
		this.__setSetting();
		this.__initializePluggins();
	};
	
	NSList.prototype.setComponentProperties = function() 
	{
		this.base.setComponentProperties.call(this);
		this.__objGrid.__addSVGInPage();
		this.__setTemplate();
		this.__objGrid.__initialize();
		this.__addListenerForBody();
		if(this.__dataSource)
		{
			this.dataSource(this.__dataSource);
		}
		if(!window["nsListMap"])
		{
			window["nsListMap"] = {};
		}
		window["nsListMap"][this.getID()] = this;
	};
	
	NSList.prototype.propertyChange = function(attrName, oldVal, newVal, setProperty)
	{
		var attributeName = attrName.toLowerCase();
		this.base.propertyChange.call(this,attrName, oldVal, newVal, setProperty);
	};
	
	NSList.prototype.removeComponent = function() 
	{
		if(this.__keyDownRef)
		{
			this.util.removeEvent(document,"keydown",this.__keyDownRef);
			this.__keyDownRef = null;
		}
		if(this.__keyUpRef)
		{
			this.util.removeEvent(document,"keyup",this.__keyUpRef);
			this.__keyUpRef = null;
		}
		if(this.__scroller)
		{
			this.__scroller.__destroyElements();
			this.__scroller = null;
		}
		this.base.removeComponent.call(this);
	};
	
	NSList.prototype.componentResized = function(event) 
	{
		this.base.componentResized.call(this,event);
	};
	
	NSList.prototype.expandAll = function()
	{
		if(this.__enableHierarchical)
		{
			this.__expandCollapseAll(false);
		}
	};
	
	NSList.prototype.collapseAll = function()
	{
		if(this.__enableHierarchical)
		{
			this.__expandCollapseAll(true);
		}
	};
	
	NSList.prototype.setContextMenuSetting = function(contextMenuSetting)
	{
		this.__contextMenuSetting = contextMenuSetting;
	};
	
	NSList.prototype.__setSetting = function()
	{
		var setting = this.__setting;
		if(setting)
		{
			if(setting.hasOwnProperty("enableHierarchical"))
			{
				this.__enableHierarchical = Boolean.parse(setting["enableHierarchical"]);
			}
			if(setting.hasOwnProperty("enableVirtualScroll"))
			{
				this.__enableVirtualScroll = Boolean.parse(setting["enableVirtualScroll"]);
			}
			if(setting.hasOwnProperty("enableDragDrop"))
			{
				if(!this.__enableVirtualScroll)
				{
					this.__enableDragDrop = Boolean.parse(setting["enableDragDrop"]);
				}
			}
			if(setting.hasOwnProperty("isDraggable"))
			{
				this.__isDraggable = Boolean.parse(setting["isDraggable"]);
			}
			if(setting.hasOwnProperty("isDroppable"))
			{
				this.__isDroppable = Boolean.parse(setting["isDroppable"]);
			}
			if(setting.hasOwnProperty("enableDragByHandle"))
			{
				this.__enableDragByHandle = Boolean.parse(setting["enableDragByHandle"]);
			}
			if(setting.hasOwnProperty("dragHandlerClass"))
			{
				this.__dragHandlerClass = setting["dragHandlerClass"];
			}
			if(setting.hasOwnProperty("enableDragAfterHold"))
			{
				this.__enableDragAfterHold = Boolean.parse(setting["enableDragAfterHold"]);
			}
			if(setting.hasOwnProperty("holdTime"))
			{
				this.__holdTime = parseInt(setting["holdTime"]);
			}
			if(setting.hasOwnProperty("enableCloneMode"))
			{
				this.__enableCloneMode = Boolean.parse(setting["enableCloneMode"]);
			}
			if(setting.hasOwnProperty("labelField"))
			{
				this.__labelField = setting["labelField"];
			}
			if(setting.hasOwnProperty("itemRenderer"))
			{
				this.__itemRenderer = setting["itemRenderer"];
				this.__itemRenderer = this.util.getFunction(this.__itemRenderer);
			}
			if(setting.hasOwnProperty("template"))
			{
				this.__templateID = setting["template"];
			}
			if(setting.hasOwnProperty("setData"))
			{
				this.__setData = setting["setData"];
			}
			if(setting.hasOwnProperty("labelFunction"))
			{
				this.__labelFunction = setting["labelFunction"];
				this.__labelFunction = this.util.getFunction(this.__labelFunction);
			}
			if(setting.hasOwnProperty("enableMultipleSelection"))
			{
				this.__enableMultipleSelection =  Boolean.parse(setting["enableMultipleSelection"]);
			}
			if(setting.hasOwnProperty("enableCustomScrollBar"))
			{
				this.__enableCustomScrollBar =  Boolean.parse(setting["enableCustomScrollBar"]);
			}
			if(setting.hasOwnProperty("enableKeyboardNavigation"))
			{
				this.__enableKeyboardNavigation =  Boolean.parse(setting["enableKeyboardNavigation"]);
			}
			if(setting.hasOwnProperty("enableMouseHover"))
			{
				this.__enableMouseHover =  Boolean.parse(setting["enableMouseHover"]);
			}
			if(setting.hasOwnProperty("enableMouseHoverAnimation"))
			{
				this.__enableMouseHoverAnimation =  Boolean.parse(setting["enableMouseHoverAnimation"]);
			}
			if(setting.hasOwnProperty("disableHoverField"))
			{
				this.__disableHoverField = setting["disableHoverField"];
			}
			if(setting.hasOwnProperty("disableHoverFunction"))
			{
				this.__disableHoverFunction = setting["disableHoverFunction"];
				this.__disableHoverFunction = this.util.getFunction(this.__disableHoverFunction);
			}
			if(setting.hasOwnProperty("rowHeight"))
			{
				this.__rowHeight =  parseInt(setting["rowHeight"]);
			}
			if(setting.hasOwnProperty("noDataMessage"))
			{
				this.__noDataMessage = setting["noDataMessage"];
			}
			if(setting.hasOwnProperty("dataSource"))
			{
				this.__dataSource = setting["dataSource"];
			}
			if(setting.hasOwnProperty("childField"))
			{
				this.__childField = setting["childField"];
			}
			if(setting.hasOwnProperty("enableContextMenu"))
			{
				this.__enableContextMenu = Boolean.parse(setting["enableContextMenu"]);
			}
			if(setting.hasOwnProperty("contextMenuProvider"))
			{
				this.__contextMenuProvider =  setting["contextMenuProvider"];
				this.__contextMenuProvider = this.util.getFunction(this.__contextMenuProvider);
			}
			if(setting.hasOwnProperty("enableVariableRowHeight"))
			{
				this.__enableVariableRowHeight =  Boolean.parse(setting["enableVariableRowHeight"]);
			}
			if(setting.hasOwnProperty("customScrollBarSetting"))
			{
				this.__customScrollBarSetting =  setting["customScrollBarSetting"];
			}
			else
			{
				this.__customScrollBarSetting = {enableTooltip: false,toolTipLabelFunction: null,verticalScrollButtons: {enable: false},horizontalScrollButtons:{enable: false}};
			}
			if(setting.hasOwnProperty("virtualScrollSetting"))
			{
				this.__virtualScrollSetting = setting["virtualScrollSetting"];
			}
			else
			{
				this.__virtualScrollSetting = {pageSize: null,pagesRendered: null,enableScrollDelay: false,scrollInterval: null,resizeInterval: null,enableLoader: false,getLoaderComponent: null};
			}
		}
	};
	
	NSList.prototype.dataSource = function(source)
	{
		this.__dataSource = source;
		if(this.__listContainer)
		{
			this.util.removeAllChildren(this.__listContainer);
		}
		else
		{
			this.__createStructure();
		}
		if(this.__dataSource && this.__dataSource.length > 0)
		{
			this.__orignalItemKey = Object.keys(this.__dataSource[0]);
			this.__objGrid.dataSource();
		}
		else
		{
			this.__arrWrapper = [];
			this.__arrInternalSource = [];
			this.__updateTotalRecords(0);
		}
		this.__renderBody();
	};
	
	NSList.prototype.getOrignalItem = function(item)
	{
		if(item && this.__orignalItemKey && this.__orignalItemKey.length > 0)
		{
			var retItem = {};
			var key = null;
			for(var count = 0;count < this.__orignalItemKey.length;count++)
			{
				key = this.__orignalItemKey[count];
				retItem[key] = item[key];
			}
			return retItem;
		}
		return item;
	};
	
	NSList.prototype.addItems = function(arrItem)
	{
		this.__addItem(arrItem);
	};
	
	NSList.prototype.addItemsAsChildren = function(item,arrChildren)
	{
		this.__objGrid.addItemsAsChildren(item,arrChildren);
	};
	
	NSList.prototype.removeItems = function(arrObject)
	{
		if(arrObject && arrObject.length > 0)
		{
			var arrIndex = [];
			if(this.util.isNumber(arrObject[0]))
			{
				arrIndex = arrObject;
			}
			else
			{
				for (var count = 0;count < arrObject.length;count++)
			    {
					var item = arrObject[count];
					if(item && item[this.__fieldIndex])
					{
						arrIndex.push(item[this.__fieldIndex]);
					}
			    }
			}
			arrIndex.sort();
	   	 	for (var rowIndex = arrIndex.length - 1; rowIndex >= 0; rowIndex--)
		    {
	   	 		var index = arrIndex[rowIndex];
	   	 		if(index > 0 && index < this.__arrInternalSource.length)
	   	 		{
		   	 		//if virtual scroll or Pagination of type Page is enabled then do not remove rows
		   	 		if(!this.__enableVirtualScroll)
		   	 		{
		   	 			this.__listContainer.removeChild(this.__listContainer.childNodes[index]);
		   	 		}
		   	 		this.__arrInternalSource.splice(index, 1);
		   	 		this.__arrWrapper.splice(index, 1);
	   	 		}
		    }
		 	this.__updateTotalRecords();
		}
	};
	
	NSList.prototype.scrollToIndex = function(selectedIndex,animationRequired)
	{
		selectedIndex = parseInt(selectedIndex);
		var source = this.__objGrid.__getFlatSource();
		if(selectedIndex > -1 && source && selectedIndex < source.length)
		{
			var item = this.__getItemByIndex(selectedIndex);
			if(item)
			{
				if(this.__enableVirtualScroll)
				{
					if(this.__enableCustomScrollBar)
					{
						var targetDimension = this.__virtualRowHeight * (selectedIndex - 1);
						this.__setVirtualScroll_ScrollTop(targetDimension);
					}
					else
					{
						//var item = this.__getVisibleItemByIndex(this.__arrInternalSource,selectedIndex);
						if(this.__nsVirtualScroll)
						{
							//because in list index is index+1
							this.__nsVirtualScroll.scrollToIndex(selectedIndex - 1,animationRequired);
						}
					}
				}
				else
				{
					if(item[this.__fieldItem])
					{
						var targetDimension = item[this.__fieldItem].offsetTop;
						var scrollTarget = this.__divOuterContainer;
						if(animationRequired)
						{
							var animation = new this.util.animation(scrollTarget,[
				       	  	    {
				       	  	      time: 500,
				       	  	      property:"scrollTop",
				       	  	      target: targetDimension,
				       	  	    }
				       	  	]);
				   	  	  	animation.animate();
						}
						else
						{
							scrollTarget.scrollTop = targetDimension;
						}
					}
				}
			}
		}
	};
	
	NSList.prototype.setSelectedItems = function(arrItems)
	{
		if(arrItems && arrItems.length > 0)
		{
			var source = this.__objGrid.__getFlatSource();
			if(source)
			{
				this.__clearAllRowSelection(false);
				var length = arrItems.length;
				var item = null;
				var index = -1;
				for(var count = 0;count < length;count++)
				{
					item = arrItems[count];
					index = this.__getIndexByItem(item);
					if(index > -1 && source && index < source.length)
					{
						this.__setIndex(index,true);
					}
				}
			}
		}
	};
	
	NSList.prototype.setSelectedItem = function(arrItems)
	{
		this.setSelectedItems([arrItems]);
	};
	
	NSList.prototype.setSelectedIndexes = function(arrSelectedIndex)
	{
		if(arrSelectedIndex && arrSelectedIndex.length > 0)
		{
			var source = this.__objGrid.__getFlatSource();
			if(source)
			{
				var length = arrSelectedIndex.length;
				var index = -1;
				for(var count = 0;count < length;count++)
				{
					index = arrSelectedIndex[count];
					if(index > -1 && source && index < source.length)
					{
						this.__setIndex(index,true);
					}
				}
			}
		}
	};
	
	NSList.prototype.setSelectedIndex = function(selectedIndex)
	{
		this.setSelectedIndexes([selectedIndex]);
	};
	
	NSList.prototype.unSelectItems = function(arrItems)
	{
		
	};
	
	NSList.prototype.unSelectItem = function(arrItems)
	{
		this.unSelectItems([arrItems]);
	};
	
	NSList.prototype.unSelectIndexes = function(arrSelectedIndex)
	{
		
	};
	
	NSList.prototype.unSelectIndex = function(selectedIndex)
	{
		this.unSelectIndexes([selectedIndex]);
	};
	
	NSList.prototype.getSelectedIndex = function()
	{
		return this.__selectedIndex;
	};
	
	NSList.prototype.getSelectedItem = function()
	{
		return this.__selectedItem;
	};
	
	NSList.prototype.getSelectedIndexes = function()
	{
		return this.__selectedIndexes;
	};
	
	NSList.prototype.getSelectedItems = function()
	{
		return this.__selectedItems;
	};
	
	NSList.prototype.deselectAll = function()
	{
		this.__clearAllRowSelection(true);
	};
	
	NSList.prototype.filter = function(strData,setting,enableHighlighting,recordLimit)
	{
		this.__nsListFilter.filter(strData,setting,enableHighlighting,recordLimit);
	};
	
	NSList.prototype.resetFilter = function()
	{
		this.__nsListFilter.reset();
	};
	
	NSList.prototype.updateListItemByIndex = function(index)
	{
		var item = this.__getItemByIndex(index);
		if(item)
		{
			var listItem = this.__getListItemFromItem(item);
			if(listItem)
			{
				var index = this.__getIndexByItem(item);
				this.__updateListItemText(listItem,item,index);
			}
		}
	};
	
	NSList.prototype.__highlightDiv = function(divText)
	{
		this.__nsListFilter.__highlightDiv(divText);
	};
	
	NSList.prototype.__initializePluggins = function()
	{
		if(!this.__objGrid)
		{
			if(this.__enableHierarchical)
			{
				this.__objGrid = new NSHierarchicalList(this);
			}
			else
			{
				this.__objGrid = new NSFlatList(this);
			}
		}
		if(!this.__nsListFilter)
		{
			this.__nsListFilter = new NSListFilter(this);
			if(this.__enableDragDrop)
			{
				this.__nsListDragDrop = new NSListDragDrop(this);
			}
		}
		this.__nsToolTipInElement = new this.util.nsToolTipInElement();
	};
	
	NSList.prototype.__createStructure = function()
	{
		if(!this.__divOuterContainer)
		{
			this.__divOuterContainer = this.util.createDiv(this.getID() + "container","nsListOuterContainer");
			if(this.__enableHierarchical)
			{
				this.util.addStyleClass(this.__divOuterContainer,"nsListOuterContainerHierarchical")
			}
			this.__divOuterContainer.style.width = this.util.getStyleValue(this.__baseComponent,"width");
			//this.__divOuterContainer.style.height = this.util.getStyleValue(this.__baseComponent,"height");
			this.addChild(this.__divOuterContainer);
			this.__divParentContainer = this.util.createDiv(this.getID() + "parentContainer","nsListParentContainer");
			this.__divOuterContainer.appendChild(this.__divParentContainer);
			this.__listContainer = this.util.createElement("ul",this.getID() + "list","nsListContainer");
			this.__listContainer.style.minHeight = (this.__divOuterContainer.clientHeight - 10) + "px";
			this.__divParentContainer.appendChild(this.__listContainer);
			if(this.__enableVirtualScroll)
			{
				this.util.addStyleClass(this.__divParentContainer,"nsListBodyContainerVirtual");
			}
			this.__createCustomScroller();
		}
	};

	NSList.prototype.__renderBody = function()
	{
		this.__navigationIndex = -1;
		if(this.__enableContextMenu)
		{
			this.__initializeContextMenu();
		}
		if(this.__enableVirtualScroll)
		{
			this.__setNSVirtualScroll(this.__arrInternalSource);
		}
		else
		{
			this.util.removeAllChildren(this.__listContainer);
			this.__createList(this.__arrInternalSource,0,this.__arrInternalSource.length);
			//5 is offset for number of rows
			var listItem = this.__getListItemByIndex(0);
			if(listItem)
			{
				this.__listItemHeight = listItem.clientHeight;
			}
			this.__pageSize = (this.__divOuterContainer.clientHeight/this.__listItemHeight) - 5;
			this.__startArrayElement = 0;
		}
		//this.__listContainer.scrollTop = 0;
		if(this.__nsListDragDrop)
		{
			this.__nsListDragDrop.initialize();
		}
	};
	
	NSList.prototype.__setNSVirtualScroll = function(source)
	{
		var length = 0;
		if(source && source.length)
		{
			for(var count = 0;count < source.length;count++)
			{
				if(source[count][this.__fieldItemVisible])
				{
					length++;
				}
			}
		}
		if(this.__nsVirtualScroll)
		{
			this.__nsVirtualScroll.dataSource(length);
		}
		else
		{
			if(length > 0)
			{
				if(this.__rowHeight > 0)
				{
					this.__virtualRowHeight = this.__rowHeight;
				}
				else
				{
					this.__createList(this.__arrInternalSource,0,1);
					var item = this.__arrInternalSource[0];
					var listItem = item[this.__fieldItem];
				    this.__virtualRowHeight = listItem.offsetHeight;
				    listItem.parentNode.removeChild(listItem);
				}
				var setting = {scrollElement: this.__divOuterContainer,contentElement: this.__listContainer,itemTag: "li",totalLength: length,getItemComponent:this.__getItemComponentForVirtual.call(this),getEmptyItemComponent:this.__getEmptyItemComponentForVirtual.call(this)};
				var virtualScrollSetting = this.__virtualScrollSetting;
				var arrCopyFields = ["pageSize","pagesRendered","enableScrollDelay","scrollInterval","resizeInterval","enableLoader","getLoaderComponent"];
				var field = null;
				for(var count = 0;count < arrCopyFields.length;count++)
				{
					field = arrCopyFields[count];
					if(!this.util.isUndefinedOrNull(virtualScrollSetting[field]))
					{
						setting[field] = virtualScrollSetting[field];
					}
				}
				this.__nsVirtualScroll = new NSVirtualScroll(setting);
			}
		}
	};
	
	NSList.prototype.__getItemComponentForVirtual = function()
	{
		var list = this;
		var CreateListItem = function(index)
		{
			this.__index = index;
			this.__list =  list;
			this.__item = null;
			this.__listItem = null;
		};
		CreateListItem.prototype.getElement = function()
		{
			if(!this.__listItem)
			{
				if(this.__list.__enableHierarchical)
				{
					this.__item = this.__list.__getVisibleItemByIndex(null,this.__index);
				}
				else
				{
					this.__item = this.__list.__arrInternalSource[this.__index];
				}
				this.__listItem = this.__list.__createListItem(this.__item,false);
			}
			return this.__listItem;
		};
		return CreateListItem;
	};
	
	NSList.prototype.__getEmptyItemComponentForVirtual = function()
	{
		var list = this;
		var CreateEmptyListItem = function()
		{
			this.__list =  list;
			this.__listItem = null;
		};
		CreateEmptyListItem.prototype.getElement = function()
		{
			if(!this.__listItem)
			{
				this.__listItem = this.__list.__createNoDataRow.call(this.__list);
			}
			return this.__listItem;
		};
		return CreateEmptyListItem;
	};
	
	NSList.prototype.__createCustomScroller = function()
	{
		if(this.__enableCustomScrollBar && !this.__scroller)
		{
			var setting = {element: this.__divOuterContainer,enableCustomHandler: true,verticalScrollButtons:this.__customScrollBarSetting.verticalScrollButtons,horizontalScrollButtons:this.__customScrollBarSetting.horizontalScrollButtons};
			for (var key in setting) 
			{ 
				this.__scrollerSetting[key] = setting[key]; 
			}
			this.__scroller = new NSScroller(this.__scrollerSetting);
			this.util.addEvent(this.__scrollerSetting.element,NSScroller.SCROLLING,this.__customScrollHandler.bind(this));
			this.util.addEvent(this.__scrollerSetting.element,NSScroller.SCROLL_END,this.__customScrollEndHandler.bind(this));
		}
	};
	
	NSList.prototype.__customScrollHandler = function(event)
	{
		var self = this;
		var virtualVerHandler = function()
		{
			//todo Virtual Scroll impl for Custom Scroll Bar
		};
		var dataRefreshVerHandler = function()
		{
			
		};
		var asyncLoadVerHandler = function()
		{
			
		};
		var paginationVerHandler = function()
		{
			
		};
		var normalVerHandler = function()
		{
			self.__divOuterContainer.scrollTop = scrollPos;
			
			var first,last;
			var arrRows = self.__listContainer.querySelectorAll("li");
			for(var count = 0;count < arrRows.length;count++)
			{
				var li = arrRows[count];
				if(isInViewport(li))
				{
					first = li;
					break;
				}
			}
			for(;count < arrRows.length;count++)
			{
				var li = arrRows[count];
				if(!isInViewport(li))
				{
					break;
				}
				last = li;
			}
			console.log(first,last);
		};
		var normalHorHandler = function()
		{
			self.__divOuterContainer.scrollLeft = scrollPos;
		};
		var isInViewport = function (elem) 
		{
			if(elem)
			{
				/*var distance = elem.getBoundingClientRect();
				return (
					distance.top >= 0 &&
					distance.left >= 0 &&
					distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
					distance.right <= (window.innerWidth || document.documentElement.clientWidth)
				);*/
				const rect = elem.getBoundingClientRect();
			    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
			    const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

			    const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
			    const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

			    return (vertInView && horInView);
			}
			return false;
		};
		var objCondition = {virtualScroll:{eligible:this.__enableVirtualScroll,verHandler:virtualVerHandler,horHandler:normalHorHandler},
							dataRefreshOnEnd:{eligible:this.__enableDataRefreshOnScrollEnd,verHandler:dataRefreshVerHandler,horHandler:normalHorHandler},
							asyncLoad:{eligible:this.__enableAsyncLoadPagination,verHandler:asyncLoadVerHandler,horHandler:normalHorHandler},
							pagination:{eligible:(this.__enablePagination && this.__isPaginationTypeScroll),verHandler:paginationVerHandler,horHandler:normalHorHandler},
							normal:{eligible:true,verHandler:normalVerHandler,horHandler:normalHorHandler}
						   };
		var eventItem = event;
		var direction = eventItem.direction;
		var scrollPos = eventItem.scrollPos;
		var oldScrollPos = eventItem.oldScrollPos;
		var orignalEvent = eventItem.orignalEvent;
		var scrollBar = eventItem.scrollBar;
		var position = eventItem.absoluteScrollBarPos;
		for(var key in objCondition)
		{
			var item = objCondition[key];
			if(item.eligible)
			{
				if(direction == "vertical")
				{
					if(item.verHandler)
					{
						if(this.__customScrollBarSetting["enableTooltip"] && !this.__customScrollBarTooltip)
						{
							this.__customScrollBarTooltip = this.util.createElement("span",null,"tooltiptext tooltip-left");
							document.body.appendChild(this.__customScrollBarTooltip);
						}
						item.verHandler();
					}
				}
				else
				{
					if(item.horHandler)
					{
						item.horHandler();
					}
				}
				break;
			}
		}
	};
	
	NSList.prototype.__customScrollEndHandler = function(event)
	{
		if(this.__customScrollBarTooltip)
		{
			document.body.removeChild(this.__customScrollBarTooltip);
			this.__customScrollBarTooltip = null;
		}
	};
	
	NSList.prototype.__customScrollTooltipPos = function(scrollbar,position,itemFrom,itemTo)
	{
		if(this.__customScrollBarTooltip)
		{
			var toolTip = this.__customScrollBarTooltip;
			var css = {};
			//5 for the triangle
			css.left = (position.x - toolTip.offsetWidth - 5) + "px";
			css.top = position.y + "px";
			this.util.css(toolTip,css);
			if(this.__customScrollBarSetting.toolTipLabelFunction)
			{
				toolTip.innerHTML = this.__customScrollBarSetting.toolTipLabelFunction(itemFrom,itemTo);
			}
			else
			{
				toolTip.innerHTML = "Showing Record from index " + itemFrom + " to " +  itemTo;
			}
		}
		
	};
	
	NSList.prototype.__virtualRowSelection = function()
	{
		if(this.__listContainer.children && this.__listContainer.children.length > 0 && this.__arrInternalSource)
		{
			var listItem = null;
			var index = null;
			var item = null;
			for(var count = 0; count < this.__listContainer.children.length; count++) 
			{
				listItem = this.__listContainer.children[count];
				index = this.__getIndexFromTarget(listItem);
				item = this.__getItemByIndex(index);
				if(item && this.__isMouseHoverAllowed(index))
				{
					if(item[this.__fieldSelected])
					{
						//DONOT REPLACE WITH __markRowSelected
						this.util.addStyleClass(listItem,"nsListItemSelected"); 
					}
					else
					{
						//DONOT REPLACE WITH __markRowUnselected
						this.util.removeStyleClass(listItem,"nsListItemSelected");
					}
				}
			}
		}
	};
	
	NSList.prototype.__virtualRowHover = function()
	{
		if(this.__listContainer.children && this.__listContainer.children.length > 0 && this.__arrInternalSource)
		{
			var listItem = null;
			var index = null;
			var item = null;
			for(var count = 0; count < this.__listContainer.children.length; count++) 
			{
				listItem = this.__listContainer.children[count];
				index = this.__getIndexFromTarget(listItem);
				item = this.__getItemByIndex(index);
				(item && item[this.__fieldHover]) ? this.util.addStyleClass(listItem,"nsListItemHover") : this.util.removeStyleClass(listItem,"nsListItemHover");
			}
		}
	};
	
	NSList.prototype.__setVirtualRowHoverField = function(indexToSet)
	{
		if(this.util.isUndefinedOrNull(indexToSet))
		{
			indexToSet = -1;
		}
		var source = this.__objGrid.__getFlatSource();
		if(source)
		{
			var item = null;
			for(var count = 0; count < source.length; count++) 
			{
				var item = source[count];
				if(item)
				{
					item[this.__fieldHover] = (item[this.__fieldIndex] === indexToSet); 
				}
			}
		}
	};
	
	NSList.prototype.__setVirtualRowHover = function(indexToSet)
	{
		if(this.__enableVirtualScroll)
		{
			if(this.util.isUndefinedOrNull(indexToSet))
			{
				indexToSet = 0;
			}
			var item = this.__getVisibleItemByIndex(null,indexToSet);
			if(item)
			{
				this.__navigationIndex = indexToSet;
				var index = item[this.__fieldIndex];
				this.__setVirtualRowHoverField(index);
				this.__virtualRowHover();
			}
			
		}
	};
	
	NSList.prototype.__setRowHover = function(indexToSet)
	{
		if(this.util.isUndefinedOrNull(indexToSet))
		{
			indexToSet = 0;
		}
		if(this.__enableVirtualScroll)
		{
			this.__setVirtualRowHover(indexToSet);
		}
		else
		{
			if(this.util.isUndefinedOrNull(indexToSet))
			{
				indexToSet = 0;
			}
			this.__navigationIndex = indexToSet;
			var listItem = this.__getListItemFromContainer(this.__navigationIndex);
			this.util.addStyleClass(listItem,"nsListItemHover");
		}
	};
	
	NSList.prototype.__createNoDataRow = function()
	{
		var listItem = this.util.createElement("li",null,"nsListNoRecordsFound");
		listItem.setAttribute("nsNoData","true");
		var textNode = document.createTextNode(this.__noDataMessage);
		listItem.appendChild(textNode);
		return listItem;
	};
	
	NSList.prototype.__addListenerForBody = function()
	{
		if(!this.__keyDownRef)
		{
			this.__keyDownRef = this.__keyDownHandler.bind(this);
			this.util.addEvent(document,"keydown",this.__keyDownRef);
		}
		if(!this.__keyUpRef)
		{
			this.__keyUpRef = this.__keyUpHandler.bind(this);
			this.util.addEvent(document,"keyup",this.__keyUpRef);
		}
	};
	
	NSList.prototype.__createList = function(dataSet,startIndex,endIndex)
	{
		if(dataSet && dataSet.length > 0)
	    {
			this.__objGrid.__createList(dataSet,startIndex,endIndex);
	    }
		else
		{
			this.__listContainer.appendChild(this.__createNoDataRow());
		}
	};
	
	NSList.prototype.__createListAt = function(item,index,isResetIndex)
	{
		if(item && index > -1)
	    {
			this.__updateItem(item,index,true,isResetIndex);
			var listItem = this.__createListItem(item,false);
			this.__listContainer.insertBefore(listItem, this.__listContainer.childNodes[index]);
			return listItem;
	    }
		return null;
	};
	
	NSList.prototype.__updateItem = function(item,index,isReset,isResetIndex)
	{
		if(item)
		{
			if(isResetIndex || !item.hasOwnProperty(this.__fieldIndex))
			{
				item[this.__fieldIndex] = index;
			}
			if(isReset || !item.hasOwnProperty(this.__fieldDisableHover))
			{
				item[this.__fieldDisableHover] = this.__isHoverDisabled(item);
			}
			if(isReset || !item.hasOwnProperty(this.__fieldSelected))
			{
				item[this.__fieldSelected] = false;
			}
		}
	};
	
	NSList.prototype.__createListItem = function(item,isAdd)
	{
		if(item)
		{
			 if(this.util.isUndefined(isAdd) || isAdd === null)
			 {
				 isAdd = true;
			 }
			 var listItem = this.util.createElement("li",null,"nsListItem");
			 this.__objGrid.__createListItem(listItem,item);
			 if(this.__enableMouseHover)
			 {
				 this.util.addEvent(listItem,"mouseover",this.__itemMouseOverHandler.bind(this));
				 this.util.addEvent(listItem,"mouseout",this.__itemMouseOutHandler.bind(this));
				 if(this.__enableMouseHoverAnimation)
				 {
					 this.util.addStyleClass(listItem,"nsListItemAnimated");
				 }
				 else
				 {
					 this.util.addStyleClass(listItem,"nsListItemNormal");
				 }
			 }
			 this.util.addEvent(listItem,"click",this.__itemClickHandler.bind(this));
			 this.__setListItemProperties(listItem,item);
			 if(isAdd)
			 {
				 this.__listContainer.appendChild(listItem);
			 }
			 return listItem;
		}
		return null;
	};
	
	NSList.prototype.__setListItemProperties = function(listItem,item)
	{
		this.__objGrid.__setListItemProperties(listItem,item);
	};
	
	NSList.prototype.__addCellText = function(listItem,item,div)
	{
		var toolTipText = null;
		if(listItem && item && div)
		{
			if(this.__itemRenderer)
			{
				var objRenderer = this.__itemRenderer(item,this.__labelField,item[this.__fieldIndex],item[this.__fieldDisableHover],listItem);
				if(objRenderer)
				{
					if(this.util.isString(objRenderer))
					{
						var compBodySpan = document.createElement("span");
						compBodySpan.innerHTML = objRenderer;
						div.appendChild(compBodySpan);
					}
					else
					{
						div.appendChild(objRenderer);
					}
				}
			}
			else if(this.__template)
			{
				div.appendChild(this.__template.cloneNode(true));
				this.__setDataInTemplateRenderer(div,item,listItem);
			}
			else if(this.__labelFunction)
			{
				var text = this.__labelFunction(item,this.__labelField);
				div.appendChild(document.createTextNode(text));
			}
			else if(item.hasOwnProperty(this.__labelField) && !this.util.isUndefined(item[this.__labelField]) && item[this.__labelField] != null)
		    {
				var text = item[this.__labelField];
				div.appendChild(document.createTextNode(text));
		    }
			this.__highlightDiv(div);
			if(this.__toolTipField)
			{
				toolTipText = item[this.__toolTipField];
			}
			else if(this.__toolTipRenderer)
			{
				toolTipText = this.__toolTipRenderer(item,this.__labelField,item[this.__fieldIndex],item[this.__fieldDisableHover],listItem);
			}
			if(this.__enableTruncateToFit)
			{
				this.util.addStyleClass(div,"nsListTruncateToFit");
				//This condition is above so that toolTip and title are not set togeather
				if(!toolTipText || toolTipText === "")
				{
					if(this.__enableToolTipForTruncateText)
					{
						toolTipText = div.textContent;
					}
					else
					{
						div.setAttribute("title",div.textContent);
					}
				}
			}
			if(toolTipText && toolTipText !== "")
			{
				this.__nsToolTipInElement.addToolTip(div,toolTipText);
			}
		}
	};
	
	NSList.prototype.__setDataInTemplateRenderer = function(cellItem,data,listItem)
	{
		if(cellItem && this.__setData)
		{
			this.__setRendererProperties(cellItem);
			this.__setRendererInData(cellItem,data,listItem);
			//IE bug
			cellItem.data = data;
			if(this.util.isFunction(this.__setData))
		    {
				var strParam = "(cellItem,data,dataField,isDisabled,listItem)"; 
		    	if(this.util.isString(this.__setData))
		    	{
		    		var base = this;
		    		this.util.callFunctionFromString(this.__setData + strParam,function(paramValue){
						if(paramValue === "cellItem")
						{
							return cellItem;
						}
						if(paramValue === "data")
						{
							return data;
						}
						if(paramValue === "dataField")
						{
							return base.__labelField;
						}
						if(paramValue === "isDisabled")
						{
							return data[base.__fieldDisableHover];
						}
						if(paramValue === "listItem")
						{
							return listItem;
						}
						return paramValue;
					});
		    	}
		    	else
		    	{
		    		this.__setData(cellItem,data,this.__labelField,data[this.__fieldDisableHover],listItem);
		    	}
		    }
		}
	};
	
	NSList.prototype.__setRendererInData = function(cellItem,data,listItem)
	{
		if(cellItem)
		{
			var compChild = null;
			for(var count = 0; count < cellItem.children.length; count++) 
			{
				compChild = cellItem.children[count];
				if(compChild)
				{
					compChild.data = data;
					compChild.listItem = listItem;
				}
				//IE 9 Bug,you got to assign it back
				//listItem.children[count] = compChild;
				this.__setRendererInData(compChild,data,listItem);
			}
		}
	};
	
	NSList.prototype.__setRendererProperties = function(cellItem)
	{
		if(cellItem)
		{
			var compChild = null;
			for(var count = 0; count < cellItem.children.length; count++) 
			{
				compChild = cellItem.children[count];
				var grid = this;
				Array.prototype.slice.call(compChild.attributes).forEach(function(attribute) 
				{
			        if(grid.util.isFunction(attribute.value))
			        {
			        	var newValue = attribute.value + "(this)";
			        	compChild.removeAttribute(attribute.name);
						compChild.setAttribute(attribute.name,newValue);
			        }
				});
				if(compChild)
				{
					if(compChild.hasAttribute("accessor-name"))
					{
						cellItem[compChild.getAttribute("accessor-name")] = compChild;
					}
				}
				this.__setRendererProperties(compChild);
			}
		}
	};
	
	NSList.prototype.__setTemplate = function()
	{
		if(this.__templateID)
		{
			this.__template = this.util.getTemplate(this.__templateID);
		}
	};
	
	NSList.prototype.__isHoverDisabled = function(item)
	{
		if(this.__disableHoverField)
		{
			return Boolean.parse(item[this.__disableHoverField]);
		}
		if(this.__disableHoverFunction)
		{
			return Boolean.parse(this.__disableHoverFunction(item,this.__fieldIndex));
		}
		return false;
	};
	
	NSList.prototype.__itemClickHandler = function(event)
	{
		event = this.util.getEvent(event);
	    var target = this.util.getTarget(event);
	    target = this.util.findParent(target,"li");
	    var index = this.__getIndexFromTarget(target);
	    this.__setIndex(index,false);
	    this.__lastNavigationDirection = null;
	};
	
	NSList.prototype.__setIndex = function(index,isMultiSelect)
	{
		if(index > -1)
		{
			isMultiSelect = Boolean.parse(isMultiSelect);
			if (this.__isShiftPressed && this.__enableMultipleSelection)
		    {
		    	this.__multiSectionHandler(index);
		    }
		    else if(isMultiSelect || (this.__isCtrlPressed && this.__enableMultipleSelection))
		    {
		    	if(this.__isRowSelected(index))
		    	{
		    		this.__markRowUnselected(index);
		    	}
		    	else
		    	{
		    		this.__markRowSelected(index);
		    	}
		    }
		    else
		    {
		    	this.__clearAllRowSelection(false);
		    	this.__markRowSelected(index);
		    } 
		}
	};
	
	NSList.prototype.__itemMouseOverHandler = function(event)
	{
		 var target = this.util.getTarget(event);
	     target = this.util.findParent(target,"li");
	     var index = this.__getIndexFromTarget(target);
	     var item = this.__getItemByIndex(index);
	     if(target && index > -1 && this.__isMouseHoverAllowed(index))
	     {
	    	 this.util.addStyleClass(target,"nsListItemHover");
	    	 this.__navigationIndex = index;
	    	 this.util.dispatchEvent(this.__baseComponent,this.ITEM_NAVIGATED,item,{index:this.__navigationIndex});
	     }
	};
	
	NSList.prototype.__itemMouseOutHandler = function(event)
	{
		 var target = this.util.getTarget(event);
	     target = this.util.findParent(target,"li");
	     if(target)
	     {
	    	 this.util.removeStyleClass(target,"nsListItemHover");
	     }
	};
	
	NSList.prototype.__keyDownHandler = function(event)
	{
		event = this.util.getEvent(event);
		if(this.hasFocus())
		{
			this.__isShiftPressed = event.shiftKey;
			this.__isCtrlPressed = event.ctrlKey;
			var isShiftCtrlPressed = this.__isShiftPressed || this.__isCtrlPressed;
			var keyCode = this.util.getKeyUnicode(event);
			if(this.__enableKeyboardNavigation)
			{
				var source = this.__objGrid.__getFlatSource();
				//key Up
				if(keyCode === this.util.KEYCODE.UP && isShiftCtrlPressed && this.__enableMultipleSelection)
				{
					if(this.__lastNavigationDirection && this.__lastNavigationDirection === this.NAVIGATION_DOWN)
					{
						return this.__keyBoardSelectionHandler(event,this.NAVIGATION_UP);
					}
					if(this.__selectedIndex != 0)
					{
						this.__selectedIndex--;
						this.__navigationIndex--;
						while(!this.__isMouseHoverAllowed(this.__selectedIndex))
						{
							this.__selectedIndex--;
							this.__navigationIndex--;
						}
						return this.__keyBoardSelectionHandler(event,this.NAVIGATION_UP);
					}
				}
				//key down
				else if(keyCode === this.util.KEYCODE.DOWN && isShiftCtrlPressed && this.__enableMultipleSelection)
				{
					if(this.__lastNavigationDirection && this.__lastNavigationDirection === this.NAVIGATION_UP)
					{
						return this.__keyBoardSelectionHandler(event,this.NAVIGATION_DOWN);
					}
					if(source && this.__selectedIndex != source.length - 1)
					{
						this.__selectedIndex++;
						this.__navigationIndex++;
						while(!this.__isMouseHoverAllowed(this.__selectedIndex))
						{
							this.__selectedIndex++;
							this.__navigationIndex++;
						}
						return this.__keyBoardSelectionHandler(event,this.NAVIGATION_DOWN);
					}
				}
				else if(keyCode === this.util.KEYCODE.UP)
				{
					if(source && this.__navigationIndex === -1)
					{
						this.__navigationIndex = source.length - 1;
					}
					if(this.__navigationIndex > 0)
					{
						return this.__keyBoardNavigationHandler(event,this.NAVIGATION_UP);
					}
				}
				else if(keyCode === this.util.KEYCODE.DOWN)
				{
					/*if(this.__navigationIndex === -1)
					{
						this.__navigationIndex = 0;
					}*/
					if(source)//&& this.__navigationIndex < source.length
					{
						return this.__keyBoardNavigationHandler(event,this.NAVIGATION_DOWN);
					}
				}
				else if(keyCode === this.util.KEYCODE.ENTER)
				{
					this.__clearAllRowSelection(false);
					var listItem = this.__getkeyboardNavigationListItem();
					if(listItem)
					{
						this.__markRowSelected(this.__getIndexFromTarget(listItem));
					}
				}
			}
			if(keyCode === this.util.KEYCODE.SHIFT)
			{
				this.util.makeBodyUnselectable();
			}
		}
	};
	
	NSList.prototype.__keyUpHandler = function(event)
	{
		if(this.util.getKeyUnicode(event) === this.util.KEYCODE.CTRL)
		{
			this.__isCtrlPressed = false;
		}
		if(this.util.getKeyUnicode(event) === this.util.KEYCODE.SHIFT)
		{
			this.__isShiftPressed = false;
			this.util.makeBodySelectable();
		}
	};
	
	NSList.prototype.__keyBoardNavigationHandler = function(event,direction)
	{
		var self = this;
		var lastIndex = this.__navigationIndex;
		var currentIndex = this.__navigationIndex;
		(direction === this.NAVIGATION_UP) ? currentIndex--:currentIndex++;
		while(!this.__isMouseHoverAllowed(currentIndex))
		{
			(direction === this.NAVIGATION_UP) ? currentIndex--:currentIndex++;
		}
		var endHandler = function()
		{
			self.__navigationIndex = currentIndex;
			var listItem = self.__getkeyboardNavigationListItem();
			var index = -1;
			var item = null;
			if(listItem)
			{
				var source = self.__objGrid.__getFlatSource();
				index = self.__getIndexFromTarget(listItem);
				item = self.__getItemByIndex(index, source);
			}
			self.util.dispatchEvent(self.__baseComponent,self.ITEM_NAVIGATED,item,{index:index});
			self.__lastNavigationDirection = null;
		};
		if(this.__enableVirtualScroll)
		{
			
			var virtualHandler = function()
			{
				//self.__setVirtualRowHover.call(self,index);
				var item = self.__getVisibleItemByIndex.call(self,null,currentIndex);
				if(item)
				{
					var index = item[self.__fieldIndex];
					self.__setVirtualRowHoverField.call(self,index);
					self.__virtualRowHover.call(self);
					endHandler();
				}
			};
			this.scrollToIndex(currentIndex,false);
			
			setTimeout(function()
			{ 
				virtualHandler();
			},0);
			//this.__setVirtualRowHover(currentIndex);
		}
		else
		{
			var listItem = this.__getListItemFromContainer(lastIndex - this.__startArrayElement);
			var currentListItem = this.__getListItemFromContainer(currentIndex - this.__startArrayElement);
			//var listItem = this.__getListItemByIndex(lastIndex - this.__startArrayElement);
			//var currentListItem = this.__getListItemByIndex(currentIndex - this.__startArrayElement);
			if(currentListItem)
			{
				this.util.removeStyleClass(listItem,"nsListItemHover");
				this.util.addStyleClass(currentListItem,"nsListItemHover");
				this.__refreshScrollPosition(currentListItem,direction);
				endHandler();
			}
		}
		
		event.preventDefault();
		return false;
	};
	
	NSList.prototype.__keyBoardSelectionHandler = function(event,direction)
	{
		if(this.__isRowSelected(this.__selectedIndex))
		{
			this.__markRowUnselected(this.__selectedIndex);
		}
		else
		{
			this.__markRowSelected(this.__selectedIndex);
		}
		if(direction === this.NAVIGATION_DOWN)
		{
			if(this.__enableVirtualScroll)
			{
				this.scrollToIndex(this.__selectedIndex,false);
			}
			else if(Math.floor(this.__selectedIndex % this.__pageSize) === 0)
			{
				var listItem = this.__getListItemByIndex(this.__selectedIndex);
				this.__refreshScrollPosition(listItem,this.NAVIGATION_DOWN);
			}
		}
		else if(direction === this.NAVIGATION_UP)
		{
			if(this.__enableVirtualScroll)
			{
				this.scrollToIndex(this.__selectedIndex,false);
			}
			else
			{
				var listItem = this.__getListItemByIndex(this.__selectedIndex);
				this.__refreshScrollPosition(listItem,this.NAVIGATION_UP);
			}
		}
		this.__lastNavigationDirection = direction;
		event.preventDefault();
		return false;
	};
	
	NSList.prototype.__refreshScrollPosition = function(listItem,direction)
	{
		if(!this.__isElementInView(listItem))
		{
			this.__scrollToListItem(listItem);
		}
	};
	
	NSList.prototype.__isElementInView = function(listItem)
	{
		var cellBottom = 0;
	    var parentBottom = 0;
	    var cellTop = 0;
	    var parentTop = 0;
		if(listItem)
		{
			var scrollParent = this.__divOuterContainer;
			var listChild = listItem.querySelector(".nsListChild");
			if(scrollParent && listChild)
			{
				var cellRect = listChild.getBoundingClientRect();
	            parentTop = 0;
	            var rectScrollParent = scrollParent.getBoundingClientRect();
	            parentBottom = rectScrollParent.height;
	            cellTop =  cellRect.top - rectScrollParent.top;
	            cellBottom = cellTop + cellRect.height;
			}
		}
		return cellBottom <= parentBottom && cellTop >= parentTop;
	};
	
	NSList.prototype.__scrollToListItem = function(listItem)
	{
		if(listItem)
		{
			var rectCell = listItem.getBoundingClientRect();
			var rectParentContainer = this.__divParentContainer.getBoundingClientRect();
	        var scrollTop = rectCell.top - rectParentContainer.top;
	        this.__divOuterContainer.scrollTop = scrollTop;
		}
	};
	
	NSList.prototype.__getkeyboardNavigationListItem = function()
	{
		var listItem = null;
		if(this.__enableVirtualScroll)
		{
			listItem = this.__listContainer.querySelector(".nsListItemHover");
		}
		else
		{
			listItem = this.__getListItemFromContainer(this.__navigationIndex);
		}
		return listItem;
	};
	
	NSList.prototype.__isMouseHoverAllowed = function(index)
	{
		var item = this.__getItemByIndex(index);
		if(item)
		{
			return !item[this.__fieldDisableHover];
		}
		return true;
	};
	
	NSList.prototype.__markRowSelected= function(index)
	{
		if(index > -1)
	    {
	        if(!this.__isRowSelected(index))
	        {
	        	this.__setMultiSelectedVars(index,true);
	            this.__setValuesForSelectedRow(index);
	        	if(this.__enableVirtualScroll)
	        	{
	        		this.__virtualRowSelection();
	        	}
	        	else
	        	{
	        		var listItem = this.__getListItemByIndex(index);
	            	this.util.addStyleClass(listItem,"nsListItemSelected"); 
	        	}
	        }
	    }
	};
	
	NSList.prototype.__markRowUnselected = function(index)
	{
	    if(this.__isRowSelected(index) && this.__isMouseHoverAllowed(index))
	    {
	    	var isUnselected = this.__setMultiSelectedVars(index,false);
	        if(isUnselected)
	        {
	        	this.__setValuesForUnselectedRow(index);
	        }
	        if(this.__enableVirtualScroll)
	    	{
	    		this.__virtualRowSelection();
	    	}
	    	else
	    	{
	    		var listItem = this.__getListItemByIndex(index);
	    		this.util.removeStyleClass(listItem,"nsListItemSelected");
	    	}
	    }
	};
	
	NSList.prototype.__setValuesForSelectedRow = function(index)
	{
		if(index > -1 && this.__isMouseHoverAllowed(index))
		{
			var item = this.__getItemByIndex(index);
			if(item)
			{
				item[this.__fieldSelected] = true;
			    this.__selectedIndex = index;
			    this.__navigationIndex = index;
			    this.util.dispatchEvent(this.__baseComponent,this.ITEM_SELECTED,item,{index:index});
			}
		}
	};
	
	NSList.prototype.__setValuesForUnselectedRow = function(index)
	{
		if(index > -1 && this.__isMouseHoverAllowed(index))
		{
			var item = this.__getItemByIndex(index);
			if(item)
			{
				item[this.__fieldSelected] = false;
		    	this.util.dispatchEvent(this.__baseComponent,this.ITEM_UNSELECTED,item,{index:index});
			}
		}
	};
	
	NSList.prototype.__clearAllRowSelection = function(setIndexVariables)
	{
		var size = this.__selectedIndexes.length;
	    for (var count = size - 1; count >= 0 ; count--)
	    {
	    	var index = this.__selectedIndexes[count];
	        this.__markRowUnselected(index);
	    }
	    this.__setMultiSelectedVars(-1,true);
	    if(setIndexVariables)
	    {
	    	this.__selectedIndex = -1;
	        this.__navigationIndex = -1;
	    }
	};
	
	NSList.prototype.__multiSectionHandler = function(lastIndex)
	{
		 if(lastIndex < 0)
		 {
			 return;
		 }
		 if (this.__selectedIndexes.length === 0)
		 {
			 this.__isRowSelected(lastIndex);
		     return;
		 }
		 var firstIndex = this.__selectedIndexes[this.__selectedIndexes.length - 1];
		 if(lastIndex === firstIndex)
		 {
			 this.__markRowUnselected(lastIndex);
			 return;
		 }
		 var isDown = lastIndex > firstIndex;
		 var isSelection = !this.__isRowSelected(lastIndex);
		 var counter = firstIndex;
		 do
		 {
			  counter = isDown ? (counter + 1) : (counter - 1);
			  if (isSelection)
			  {
				  this.__markRowSelected(counter);
			  }
			  else
			  {
				  this.__markRowUnselected(counter);
			  }
		 }
		 while(counter != lastIndex);	 
	};
	
	NSList.prototype.__setMultiSelectedVars = function(index,add)
	{
		if(index === -1)
		{
			this.__selectedItems = [];	
			this.__selectedIndexes = [];	
		}
		else if(add)
		{
			var data = this.__getItemByIndex(index);
			this.__selectedItems.push(data);
			this.__selectedIndexes.push(index);
		}
		else
		{
			var isUnselected = false;
			for (var count= 0; count < this.__selectedIndexes.length ; count++)
	        {
	            if (this.__selectedIndexes[count] === index)
	            {
	                this.__selectedItems.splice(count,1);
	                this.__selectedIndexes.splice(count,1);
	                isUnselected = true;
	                break;
	            }
	        }
			return isUnselected;
		}
		
		return true;
	};
	
	NSList.prototype.__isRowSelected= function(index)
	{
	    if(index > -1)
	    {
	    	var item = this.__getItemByIndex(index);
	    	if(item)
	    	{
	    		return item[this.__fieldSelected];
	    	}
	    }   
	    return false;
	};
	
	/******************************************************Start of Context Menu*************************************************************/
	NSList.prototype.__initializeContextMenu = function()
	{
		//if(!this.__contextMenu)
		//{
			var contextMenuSetting = {parent:this.__listContainer,isContextMenu:true,createRunTime:true,sourceProvider:this.__getContextMenuDataProvider.bind(this),targetType:"LI"};
			if(this.__contextMenuSetting)
			{
				for(var key in this.__contextMenuSetting)
				{
					//grid setting should not be overriden by the users
					if(!contextMenuSetting[key])
					{
						contextMenuSetting[key] = this.__contextMenuSetting[key];
					}
				}
			}
			this.__contextMenu = new NSMenu(contextMenuSetting);
		//}
	};
	
	NSList.prototype.__getContextMenuDataProvider = function(listItem)
	{
		if(listItem)
		{
			listItem = this.util.findParent(listItem,"LI");
			if(listItem)
			{
				var index = this.__getIndexFromTarget(listItem);
				var item = this.__getItemByIndex(index);
				if(item && this.__contextMenuProvider) 
				{
					return this.__contextMenuProvider(item,index);
				}
			}
		}
		return null;
	};
	/******************************************************End of Context Menu*************************************************************/
	/******************************Custom Function *************************************/
	NSList.prototype.__getIndexFromTarget = function(target)
	{
		if(target)
		{
			return parseInt(target.getAttribute("ns-index"));
		}
		return -1;
	};
	
	NSList.prototype.__getListItemFromItem = function(item)
	{
		var listItem = null;
		if(item)
		{
			listItem = item[this.__fieldItem];
			var index = item[this.__fieldIndex];
			//below case is true if row reference has been removed due to virtual scroll 
			var listItemRawIndex = this.__getListItemRawIndex(listItem); 
			if(!listItem || listItemRawIndex === -1)
			{
				var arrListItem = this.__listContainer.querySelectorAll('[ns-index="' + index + '"]');
				if(arrListItem && arrListItem.length > 0)
				{
					listItem = arrListItem[0];
				}
			}
		}
		return listItem;
	};
	
	NSList.prototype.__getListItemByIndex = function(index)
	{
		if(index > -1)
	    {
	    	var item = this.__getItemByIndex(index);
	    	if(item)
	    	{
	    		return item[this.__fieldItem];
	    	}
	    }   
		return null;
	};
	
	NSList.prototype.__getListItemFromContainer = function(index)
	{
		if(this.__listContainer.children.length > index)
		{
			return this.__listContainer.children[index];
		}
		return null;
	};
	
	NSList.prototype.__getItemByIndex = function(indexToFind,source)
	{
		if(!source)
		{
			source = this.__objGrid.__getFlatSource();
		}
		if(source && source.length > 0)
		{
			for(var count = 0;count < source.length;count++)
			{
				var item = source[count];
				if(item && item[this.__fieldIndex] === indexToFind)
				{
					return item;
				}
			}
		}
		return null;
	};
	
	NSList.prototype.__getIndexByItem = function(itemToFind,source)
	{
		if(!source)
		{
			source = this.__objGrid.__getFlatSource();
		}
		if(itemToFind && source && source.length > 0)
		{
			for(var count = 0;count < source.length;count++)
			{
				var item = source[count];
				if(item && item[this.__fieldIndex] === itemToFind[this.__fieldIndex])
				{
					return item[this.__fieldIndex];
				}
			}
		}
		return -1;
	};
	
	NSList.prototype.__addItem = function(arrItem,atIndex)
	{
		var flatSource = this.__objGrid.__getFlatSource();
		if(this.util.isUndefined(atIndex) || atIndex === null)
		{
			atIndex = flatSource.length;
		}
		if(arrItem && arrItem.length > 0)
		{
			if(this.__listContainer && this.__listContainer.children && this.__listContainer.children.length > 0 && this.__listContainer.children.length < 3)
			{
				for(var count = 0;count < this.__listContainer.children.length;count++)
				{
					var listItem = this.__listContainer.children[count];
					if(listItem.hasAttribute("nsNoData"))
					{
						this.__listContainer.removeChild(listItem);
						break;
					}
				}
			}
			if(!this.__addRemoveRowCallInternal)
	   	 	{
				this.__objGrid.__setWrapperSource(arrItem,atIndex,-1,0,true);
	   	 	};
			var item = null;
			var length = arrItem.length;
			var index = -1;
			for(var count = 0;count < length;count++)
			{
				item = arrItem[count];
				index = atIndex + count;
				if(item)
				{
					this.__dataSource.splice(index, 0, item);
					this.__arrWrapper.splice(index, 0, item);
					this.__arrInternalSource.splice(index, 0, item);
				}
			}
			/*flatSource = this.__objGrid.__getFlatSource();
			this.__updateSourceIndex(flatSource);*/
			for(var count = 0;count < length;count++)
			{
				item = arrItem[count];
				if(this.__enableVirtualScroll)
				{
					
				}
				else
				{
					this.__createListAt(item,item[this.__fieldIndex]);
				}
			}
		}
	};
	
	NSList.prototype.__moveItem = function(arrItem,toIndex)
	{
		if(arrItem && arrItem.length > 0 && !this.util.isUndefined(toIndex) && toIndex !== null)
		{
			var item = null;
			var length = arrItem.length;
			var index = -1;
			var fromIndex = -1;
			var listContainer = this.__listContainer;
			var listItem = null;
			for(var count = length - 1;count >= 0;count--)
			{
				item = arrItem[count];
				index = toIndex + count;
				if(item)
				{
					fromIndex = item[this.__fieldIndex];
					this.util.moveArrayItem(this.__dataSource,fromIndex,index);
					this.util.moveArrayItem(this.__arrWrapper,fromIndex,index);
					this.util.moveArrayItem(this.__arrInternalSource,fromIndex,index);
					if(this.__enableVirtualScroll)
					{
						
					}
					else
					{
						// donot use item[this.__fieldItem] for getting listItem as after de-serialization the reference get lost 
						// hence getting the item back from dataSource
						item = this.__getItemByIndex(fromIndex);
						listItem = item[this.__fieldItem];
						if(listItem)
						{
							if(listItem.parentNode === listContainer)
							{
								listContainer.removeChild(listItem);
							}
							index = (index === 0) ? index : (index - 1);
							listContainer.insertBefore(listItem, listContainer.children[index]);
						}
					}
				}
			}
		}
	};
	
	NSList.prototype.__updateSourceIndex = function(source)
	{
		if(!source)
		{
			source = this.__getAllItems();
		}
		var item = null;
		var listItem = null;
		var length = source.length;
		for(var count = 0;count < length;count++)
		{
			item = source[count];
			var index = this.__enableHierarchical ? (count + 1) : count;
			item[this.__fieldIndex] = index;
			listItem = item[this.__fieldItem];
			if(listItem && this.util.isElementOfType(listItem,"li"))
			{
				listItem.setAttribute("ns-index",index);
				var compArrow = listItem.querySelector(".nsListArrow");
				if(compArrow)
				{
					compArrow.setAttribute("ns-parent-row-count",index);
					var arrowID = this.getID() + "compArrow" + index;
					compArrow.setAttribute("id",arrowID);
					var compSvg = compArrow.querySelector("svg");
					if(compSvg)
					{
						var svgID = arrowID + "svg";
						compSvg.setAttribute("id",svgID);
					}
					var compUse = compArrow.querySelector("use");
					if(compUse)
					{
						var useID = arrowID + "use";
						compUse.setAttribute("id",useID);
					}
				}
			}
		}
	};
	
	NSList.prototype.__createArrow = function(item,parentRowCount,parentElement,isCollapsed)
	{
		 if(parentElement)
		 {
			 var cellArrowParent = this.util.createDiv(null,"nsListArrowParent");
			 var arrowID = this.getID() + "compArrow" + parentRowCount;
			 var compArrow = this.util.createDiv(arrowID,"nsListArrow");
			 compArrow.style.paddingTop = "3px";
			 compArrow.setAttribute("ns-parent-row-count",parentRowCount);
			 
			 var objSVG = new NSSvg();
			 this.__objGrid.__createArrow(compArrow,objSVG,arrowID,isCollapsed);
			 this.util.addEvent(compArrow,"click",this.__arrowClickHandler.bind(this));
			 cellArrowParent.appendChild(compArrow);
			 parentElement.appendChild(cellArrowParent);
			 item[this.__fieldItemArrow] = compArrow;
			 return compArrow;
		 }
		 return null;
	};
	
	NSList.prototype.__setArrowDirection = function(compArrow,isCollapsed)
	{
		if(compArrow)
		{
			var objSVG = new NSSvg();
			var useID = compArrow.getAttribute("id") + "use";
			this.__objGrid.__setArrowDirection(objSVG,useID,isCollapsed);
		}
	};
	
	NSList.prototype.__isArrowCollapsed = function(compArrow)
	{
		if(compArrow && compArrow.hasAttribute("ns-parent-row-count"))
		{
			var rowIndex = parseInt(compArrow.getAttribute("ns-parent-row-count"));
			var item = this.__getItemByIndex(rowIndex);
			if(item)
			{
				return item[this.__fieldIsCollapsed];
			}
		}
		return false;
	};
	
	NSList.prototype.__arrowClickHandler = function(event)
	{
		event = this.util.getEvent(event);
		var target = this.util.getTarget(event);
		target = this.util.findParent(target,"DIV");
		if(target && target.hasAttribute("ns-parent-row-count"))
		{
			var rowIndex = target.getAttribute("ns-parent-row-count");
			var isCollapse = this.__isArrowCollapsed(target);
			rowIndex = parseInt(rowIndex);
			if(rowIndex > -1)
			{
				var item = this.__getItemByIndex(rowIndex);
				if(item[this.__childField]  && item[this.__childField].length > 0)
		        {
					this.__showHideRow(rowIndex,target,!isCollapse);
		        }
				else 
				{
					this.__objGrid.__handleOnDemandClick(item,event);
				}
			}
		}
		event.stopImmediatePropagation();
	};
	
	NSList.prototype.__expandCollapseAll = function(isCollapse)
	{
		if(!this.__enableVirtualScroll && this.__getTotalListItems() < this.__totalRecords)
		{
			this.util.warning("nsList","Please let all the items to render.");
			return;
		}
		var dataSource = this.__arrInternalSource;
		if(dataSource && dataSource.length > 0)
		{
			if(this.__enableVirtualScroll)
			{
				this.__expandCollapseAllVirtual(dataSource,isCollapse);
			}
			else
			{
				this.__expandCollapseAllNormal(dataSource,isCollapse);
			}
		}
	};
	
	NSList.prototype.__expandCollapseAllNormal = function(dataSource,isCollapse)
	{
		for(var count = 0;count < dataSource.length;count++)
		{
			var item = dataSource[count];
			//setting __fieldIsCollapsed here assuming that __showHideAllArrows() will be called after this function
			item[this.__fieldIsCollapsed] = isCollapse;
			if(parseInt(item[this.__fieldItemLevel]) > 0)
			{
				var row = item[this.__fieldItem];
				if(isCollapse)
				{
					row.style.display = "none";
					item[this.__fieldItemVisible] = false;
				}
				else
				{
					row.style.display = "";
					item[this.__fieldItemVisible] = true;
				}
			}
		}
		this.__showHideAllArrows(isCollapse);
	};
	
	NSList.prototype.__expandCollapseAllVirtual = function(dataSource,isCollapse)
	{
		for(var count = 0;count < dataSource.length;count++)
		{
			var item = dataSource[count];
			//setting __fieldIsCollapsed here assuming that __showHideAllArrows() will be called after this function
			item[this.__fieldIsCollapsed] = isCollapse;
			if(parseInt(item[this.__fieldItemLevel]) > 0)
			{
				if(isCollapse)
				{
					item[this.__fieldItemVisible] = false;
				}
				else
				{
					item[this.__fieldItemVisible] = true;
				}
			}
		}
		this.__showHideAllArrows(isCollapse);
		this.__updateVisibleIndex(null,0);
		this.__setNSVirtualScroll(this.__arrInternalSource);
	};
	
	NSList.prototype.__showHideRow = function(rowIndex,compArrow,isCollapse)
	{
		if(rowIndex > -1)
		{
			var item = this.__getItemByIndex(rowIndex);
			if(!compArrow)
			{
				compArrow = this.__getArrow(item[this.__fieldIndex]);
			}
			var rowLevel = parseInt(item[this.__fieldItemLevel]);
			var arrChildItems = [];
			if(item && item[this.__fieldHasChild])
			{
				var startIndex = 0;
				if(isCollapse)
				{
					arrChildItems = this.__arrInternalSource;
					startIndex = rowIndex;
				}
				else
				{
					arrChildItems = this.__getImmediateChildItems(arrChildItems, item);
				}
				if(this.__enableVirtualScroll)
				{
					this.__showHideRowVirtual(item,arrChildItems,startIndex,rowLevel,isCollapse);
					item[this.__fieldIsCollapsed] = isCollapse;
					//this.__updateItemInSource(item);
					this.__setNSVirtualScroll(this.__arrInternalSource);
				}
				else
				{
					this.__showHideRowNormal(item,arrChildItems,startIndex,rowLevel,isCollapse);
					this.__setArrowDirection(compArrow,isCollapse);
					item[this.__fieldIsCollapsed] = isCollapse;
				}
			}
		}
	};
	
	NSList.prototype.__showHideRowNormal = function(item,arrChildItems,startIndex,rowLevel,isCollapse)
	{
		if(arrChildItems && arrChildItems.length > 0)
		{
			if(isCollapse)
			{
				var retIndex = this.__getActualIndex(arrChildItems,startIndex);
				if(retIndex !== startIndex)
				{
					startIndex = (retIndex + 1);
				}
			}
			var rowItem = null;
			for(var count = startIndex;count < arrChildItems.length;count++)
			{
				rowItem = arrChildItems[count];
				var row = rowItem[this.__fieldItem];
				if(!row)
				{
					row = this.__createListAt(rowItem,rowItem[this.__fieldIndex] - 1,false);
					rowItem[this.__fieldItem] = row;
					this.__updateSourceIndex();
				}
				if(isCollapse)
				{
					if(rowLevel >= parseInt(rowItem[this.__fieldItemLevel]))
					{
						break;
					}
					row.style.display = "none";
					rowItem[this.__fieldItemVisible] = false;
					if(rowItem[this.__fieldHasChild])
					{
						rowItem[this.__fieldIsCollapsed] = true;
						if(rowItem[this.__fieldItemArrow])
						{
							var divArrow = rowItem[this.__fieldItemArrow];
							if(divArrow)
							{
								this.__setArrowDirection(divArrow,true);
							}
						}
					}
				}
				else
				{
					row.style.display = "";
					rowItem[this.__fieldItemVisible] = true;
				}
			}
		}
	};
	
	NSList.prototype.__showHideRowVirtual = function(item,arrChildItems,startIndex,rowLevel,isCollapse)
	{
		if(arrChildItems && arrChildItems.length > 0)
		{
			if(isCollapse)
			{
				var retIndex = this.__getActualIndex(arrChildItems,startIndex);
				if(retIndex !== startIndex)
				{
					startIndex = (retIndex + 1);
				}
			}
			for(var count = startIndex;count < arrChildItems.length;count++)
			{
				var rowItem = arrChildItems[count];
				if(isCollapse)
				{
					if(rowLevel >= parseInt(rowItem[this.__fieldItemLevel]))
					{
						break;
					}
					rowItem[this.__fieldItemVisible] = false;
					if(rowItem[this.__fieldHasChild])
					{
						rowItem[this.__fieldIsCollapsed] = true;
					}
				}
				else
				{
					rowItem[this.__fieldItemVisible] = true;
				}
			}
			var index = item[this.__fieldIndex];
			this.__updateVisibleIndex(null,index - 1);
		}
	};
	
	NSList.prototype.__showHideAllArrows = function(isCollapse)
	{
		var arrDivs = this.__getAllArrows();
		if(arrDivs && arrDivs.length > 0)
		{
			for(var count = 0;count < arrDivs.length;count++)
			{
				var div = arrDivs[count];
				if(div && div.hasAttribute("ns-parent-row-count"))
				{
					this.__setArrowDirection(div,isCollapse);
				}
			}
		}
	};
	
	NSList.prototype.__getAllItems = function()
	{
		return this.__objGrid.__getFlatSource();
	};
	
	NSList.prototype.__updateListItemText = function(listItem,item,index)
	{
		return this.__objGrid.__updateListItemText(listItem,item,index);
	};
	
	NSList.prototype.__getImmediateChildItems = function(arrItems,item)
	{
		if(!arrItems)
		{
			arrItems = [];
		}
		if(item && item[this.__fieldHasChild])
		{
			var arrChild = this.__arrInternalSource;
			var rowLevel = parseInt(item[this.__fieldItemLevel]);
			var startIndex = item[this.__fieldIndex];
			var retIndex = this.__getActualIndex(arrChild,startIndex);
			if(retIndex !== startIndex)
			{
				startIndex = (retIndex + 1);
			}
			var length = arrChild.length;
			for(var count = startIndex;count < length;count++)
			{
				var itemChild = arrChild[count];
				var childRowLevel = parseInt(itemChild[this.__fieldItemLevel]);
				if(rowLevel >= childRowLevel)
				{
					break;
				}
				if((rowLevel + 1) === childRowLevel)
				{
					arrItems.push(itemChild);
				}
			}
		}
		return arrItems;
	};
	
	//generally used for Filter condition
	NSList.prototype.__getActualIndex = function(arrChild,startIndex,addCompareOne)
	{
		//(startIndex + 1) as __fieldIndex starts from 1
		if(arrChild && arrChild.length < startIndex || arrChild[startIndex][this.__fieldIndex] !== (startIndex + 1))
		{
			var compareIndex = startIndex;
			if(addCompareOne)
			{
				compareIndex += 1;
			}
			var rowItem = null;
			for(var count = 0;count < arrChild.length;count++)
			{
				rowItem = arrChild[count];
				if(rowItem[this.__fieldIndex] === compareIndex)
				{
					return count;
				}
			}
		}
		return startIndex;
	};
	
	
	NSList.prototype.__getAllChildItems = function(arrItems,item)
	{
		if(!arrItems)
		{
			arrItems = [];
		}
		if(item && item[this.__fieldHasChild])
		{
			var arrChild = this.__arrInternalSource;
			var rowLevel = parseInt(item[this.__fieldItemLevel]);
			var startIndex = item[this.__fieldIndex];
			var length = arrChild.length;
			for(var count = startIndex;count < length;count++)
			{
				var itemChild = arrChild[count];
				if(rowLevel >= parseInt(itemChild[this.__fieldItemLevel]))
				{
					break;
				}
				arrItems.push(itemChild);
			}
		}
		return arrItems;
	};
	
	NSList.prototype.__getAllVisibleItems = function()
	{
		var totalRecords = 0;
		var arrItems = this.__getAllItems();
		if(arrItems && arrItems.length > 0)
		{
			for(var count = 0;count < arrItems.length;count++)
			{
				var item = arrItems[count];
				if(item && item[this.__fieldItemVisible])
				{
					totalRecords += 1;
				}
			}
		}
		return totalRecords;
	};
	
	NSList.prototype.__getFirstVisibleItemBeforeIndex = function(itemIndex)
	{
		var arrItems = this.__getAllItems();
		if(arrItems && arrItems.length > 0)
		{
			var retIndex = this.__getActualIndex(arrItems,itemIndex);
			if(retIndex !== itemIndex)
			{
				itemIndex = (retIndex + 1);
			}
			for(var count = itemIndex;count >= 0;count--)
			{
				var item = arrItems[count];
				if(item && item[this.__fieldItemVisible] && item[this.__fieldVisibleIndex] > -1)
				{
					return item;
				}
			}
		}
		return null;
	};
	
	NSList.prototype.__getVisibleItemByIndex = function(source,index)
	{
		var arrItems = source;
		if(!arrItems)
		{
			arrItems = this.__getAllItems();
		}
		if(arrItems && arrItems.length > 0)
		{
			var self = this; 
			var findItem = function(itemCompare)
			{
				 return (itemCompare[self.__fieldVisibleIndex] === (index + 1));
			};
			return arrItems.find(findItem);
		}
		return null;
	};
	
	NSList.prototype.__updateVisibleIndex = function(source,fromIndex)
	{
		var arrItems = source;
		if(!arrItems)
		{
			arrItems = this.__getAllItems();
		}
		if(this.util.isUndefinedOrNull(fromIndex))
		{
			fromIndex = 0;
		}
		if(arrItems && arrItems.length > 0)
		{
			var visibleRowIndex = 1;
			if(fromIndex > 0)
			{
				var visibleItem = this.__getFirstVisibleItemBeforeIndex(fromIndex);
				if(visibleItem)
				{
					visibleRowIndex = visibleItem[this.__fieldVisibleIndex];
					fromIndex = visibleItem[this.__fieldIndex] - 1;
					var retIndex = this.__getActualIndex(arrItems,fromIndex,true);
					if(retIndex !== fromIndex)
					{
						fromIndex = retIndex;
					}
				}
			}
			var length = arrItems.length;
			var item = null;
			for(var count = fromIndex; count < length; count++)
			{
				item = arrItems[count];
				if(item)
				{
					if(item[this.__fieldItemVisible])
					{
						item[this.__fieldVisibleIndex] = visibleRowIndex;
						visibleRowIndex++;
					}
					else
					{
						item[this.__fieldVisibleIndex] = -1;
					}
				}
			}
		}
	};
	
	NSList.prototype.__updateVisibleIndexByListItem = function(source,arrAllItems)
	{
		if(source)
		{
			var arrItems = arrAllItems;
			if(!arrItems)
			{
				arrItems = this.__getAllItems();
			}
			var length = source.length;
			var item = null;
			var objVisibleIndex = {};
			for(var count = 0; count < length; count++)
			{
				item = source[count];
				if(item)
				{
					var index = item[this.__fieldIndex];
					objVisibleIndex[index] = "NSList";
				}
			}
			if(arrItems && arrItems.length > 0)
			{
				length = arrItems.length;
				item = null;
				var visibleRowIndex = 1;
				for(var count = 0; count < length; count++)
				{
					item = arrItems[count];
					var index = item[this.__fieldIndex];
					if(this.util.isUndefinedOrNull(objVisibleIndex[index]))
					{
						item[this.__fieldVisibleIndex] = -1;
						item[this.__fieldItemVisible] = false;
					}
					else
					{
						item[this.__fieldVisibleIndex] = visibleRowIndex;
						item[this.__fieldItemVisible] = true;
						visibleRowIndex++;
					}
				}
			}
			
		}
	};
	
	NSList.prototype.__updateIndexForAllItems = function(source)
	{
		if(!source)
		{
			source = this.__getAllItems();
		}
		var length = source.length;
		var item = null;
		for(var count = 0; count < length; count++)
		{
			item = source[count];
			if(item)
			{
				item[this.__fieldIndex] = count;
			}
		}
	};
	
	NSList.prototype.__getArrow = function(rowCount)
	{
		var arrDivs = this.__getAllArrows();
		if(arrDivs && arrDivs.length > 0)
		{
			for(var count = 0;count < arrDivs.length;count++)
			{
				var div = arrDivs[count];
				if(div && div.hasAttribute("ns-parent-row-count"))
				{
					var rowParentCount = div.getAttribute("ns-parent-row-count");
					if(rowParentCount && rowParentCount == rowCount)
					{
						return div;
					}
				}
			}
		}
		return null;
	};
	
	NSList.prototype.__getAllArrows = function(divParent)
	{
		if(!divParent)
		{
			divParent = this.__listContainer;
		}
		return divParent.querySelectorAll(".nsListArrow");
	};
	
	NSList.prototype.__getTotalListItems = function()
	{
		if(this.__listContainer && this.__listContainer.children)
		{
			return this.__listContainer.children.length;
		}
		return 0;
	};
	
	NSList.prototype.__updateTotalRecords = function(totalCount)
	{
		if(this.util.isUndefined(totalCount) || totalCount === null)
		{
			totalCount = this.__arrInternalSource.length; 
		}
		this.__totalRecords = totalCount;
	};
	
	NSList.prototype.__getListItemRawIndex = function(listItem)
	{
		if(listItem && listItem.parentNode)
		{
			var index = [].slice.call(listItem.parentNode.children).indexOf(listItem);
			return index;
		}
		return -1;
	};
	
	NSList.prototype.__checkForVirtualMode = function()
	{
		if(this.__enableVirtualScroll)
		{
			if(this.__enablePagination)
			{
				this.__enableVirtualScroll = false;
			}
		}
	};
	
	NSList.prototype.__setVirtualScroll_ScrollTop = function(scrollTop)
	{
		if(this.__enableCustomScrollBar)
		{
			if(this.__scroller)
			{
				this.__scroller.setScrollTop(scrollTop);
			}
		}
	};
	
	var NSFlatList = function(nsList)
	{
		this.__nsList = nsList;
		this.util = nsList.util;
		/********************************Common Functions for Grid ****************************************/
		this.__initialize = function()
		{
		};
		
		this.dataSource = function(source)
		{
			this.__nsList.__arrWrapper = this.__nsList.__dataSource.slice(0);
			this.__setWrapperSource(this.__nsList.__arrWrapper,0,-1,0,true);
			this.__nsList.__arrInternalSource = this.__nsList.__arrWrapper.slice(0);
			this.__nsList.__updateTotalRecords();
		};
		
		this.addItemsAsChildren = function(item,arrChildren)
		{
		};
		
		this.__setWrapperSource = function(source,offset,parentIndex,level,setFieldIndex)
		{
			if(source)
			{
				if(!offset)
				{
					offset = 0;
				}
				var length = source.length;
				var count = 0;
				var item = null;
				var index = -1; 
				for (count = 0; count < length; count++) 
				{
					item = source[count];
					index = offset + count;
					this.__setItemProperty(item,index,setFieldIndex);
				}
			}
		};
	
		this.__createList= function(dataSet,startIndex,endIndex)
		{
			var item = null;
			var index = -1;
		    for(var count = startIndex; count < endIndex; count++)
		     {
	    		item = dataSet[count];
	    		index =  item[this.__nsList.__fieldIndex];
	    		this.__nsList.__updateItem(item,index);
	    		this.__nsList.__createListItem(item);
		     }
		};
		
		this.__createListItem = function(listItem,item)
		{
		};
	
		this.__addSVGInPage = function()
		{
		};
	
		this.__setListItemProperties = function(listItem,item)
		{
			if(listItem && item)
			{
				var index = item[this.__nsList.__fieldIndex];
				listItem.setAttribute("ns-index",index);
				item[this.__nsList.__fieldItem] = listItem;
				this.util.removeAllChildren(listItem);
				var divCell = this.util.createDiv(null,"nsListChild");
				this.util.addStyleClass(divCell,this.__nsList.__CLASS_CELL_CHILD);
				listItem.appendChild(divCell);
				this.__nsList.__addCellText(listItem,item,divCell);
			}
		};
		
		this.__updateListItemText = function(listItem,item,index)
		{
			if(listItem && item)
			{
				this.util.removeAllChildren(listItem);
				this.__setListItemProperties(listItem,item);
			}
		};
	
		this.__getFlatSource= function()
		{
			return this.__nsList.__arrWrapper;
		};
		/********************************Common Functions for Grid ****************************************/
		this.__setItemProperty = function(item,rowIndex,setFieldIndex)
		{
			if(item)
			{
				if(setFieldIndex)
				{
					item[this.__nsList.__fieldIndex] = rowIndex;
				}
				item[this.__nsList.__fieldVisibleIndex] = rowIndex + 1;
			}
		};
	
		this.__resetListItem = function(listItem,index,item)
		{
			listItem.style.display = "";
			listItem.setAttribute("ns-index",index);
			this.util.removeStyleClass(listItem,"nsListItemSelected");
			this.__nsList.__updateItem(item,index);
			this.__setListItemProperties(listItem,item);
		};
	};
	
	var NSHierarchicalList = function(nsList)
	{
		this.__nsList = nsList;
		this.util = nsList.util;
		this.__ARROW_COLLAPSE_PATH = "M 0 9.99994L 6.10352e-005 -3.05176e-005L 5 5.00006L 0 9.99994 Z";
		this.__ARROW_EXPANDED_PATH = "M 0 3.05176e-005L 9.99994 9.15527e-005L 4.99988 5.00003L 0 3.05176e-005 Z";
		this.__CLASS_ARROW = "nsListArrowFill";
		this.__rowCounter = -1;
		this.__enableOnDemandHierarchy = false;
		this.__onDemandChildDetectionField = "hasChildren";
		this.__onDemandChildFetchCallback = null;
		/********************************Common Functions for Grid ****************************************/
		this.__initialize = function()
		{
			var setting = this.__nsList.__setting;
			if(setting.hasOwnProperty("enableOnDemandHierarchy"))
			{
				this.__enableOnDemandHierarchy = Boolean.parse(setting["enableOnDemandHierarchy"]);
			}
			if(this.__enableOnDemandHierarchy)
			{
				if(setting.hasOwnProperty("onDemandChildDetectionField"))
				{
					this.__onDemandChildDetectionField = setting["onDemandChildDetectionField"];
				}
				if(setting.hasOwnProperty("onDemandChildFetchCallback"))
				{
					this.__onDemandChildFetchCallback = setting["onDemandChildFetchCallback"];
					this.__onDemandChildFetchCallback = this.util.getFunction(this.__onDemandChildFetchCallback);
				}
				if(!this.__onDemandChildDetectionField)
				{
					this.util.throwNSError("NSList","Value for onDemandChildDetectionField is not valid");
				}
				if(!this.__onDemandChildFetchCallback)
				{
					this.util.throwNSError("NSList","Value for onDemandChildFetchCallback is not valid");
				}
				if(this.__enableVirtualScroll)
				{
					this.util.warning("NSList","As enableVirtualScroll is true so OnDemandHierarchy will have no impact.");
				}
			}
		};
		
		this.dataSource = function(source)
		{
			this.__nsList.__arrWrapper = this.__nsList.__dataSource.slice(0);
			this.__setWrapperSource(this.__nsList.__arrWrapper,0,-1,0,true,true,true);
			this.__nsList.__updateTotalRecords(this.__rowCounter);
			this.__nsList.__arrInternalSource = this.__nsList.__arrFlatHierarchicalSource.slice(0);
		};
		
		this.addItemsAsChildren = function(item,arrChildren)
		{
			if(item && arrChildren && arrChildren.length > 0)
			{
				if(!item[this.__nsList.__childField])
				{
					item[this.__nsList.__childField] = [];
				}
				item[this.__nsList.__childField].push.apply(item[this.__nsList.__childField], arrChildren);
				this.__setWrapperSource(this.__nsList.__arrWrapper,0,-1,0,true,false,false);
				this.__nsList.__updateTotalRecords(this.__rowCounter);
				this.__nsList.__arrInternalSource = this.__nsList.__arrFlatHierarchicalSource.slice(0);
				item[this.__nsList.__fieldItemVisible] = true;
				item[this.__nsList.__fieldIsCollapsed] = false;
		   		var listItem = this.__nsList.__getListItemFromItem(item);
		   		var rowIndex = this.__nsList.__getIndexByItem(item);
		   		this.__nsList.__showHideRow(rowIndex,null,false);
		   		console.log(this.__nsList.__arrFlatHierarchicalSource);
			}
		};
		
		this.__setWrapperSource = function(source,offset,parentIndex,level,setFieldIndex,setIsCollapsed,setItemVisible)
		{
			if(source)
			{
				if(level === 0)
				{
					if(!offset)
					{
						offset = 0;
					}
					this.__nsList.__arrFlatHierarchicalSource = [];
					this.__rowCounter = offset;
				}
				var length = source.length;
				var count = 0;
				var item = null;
				for (count = 0; count < length; count++) 
				{
					item = source[count];
					this.__rowCounter++;
					this.__nsList.__arrFlatHierarchicalSource.push(item);
					this.__setItemProperty(item,parentIndex,level,setFieldIndex,setIsCollapsed,setItemVisible);
				}
			}
		};
	
		this.__createList= function(dataSet,startIndex,endIndex)
		{
			var item = null;
			var index = -1;
		    for(var count = startIndex; count < endIndex; count++)
		    {
	    		item = dataSet[count];
	    		if(item)
	    		{
	    			index =  item[this.__nsList.__fieldIndex];
	        		this.__nsList.__updateItem(item,index);
	        		this.__nsList.__createListItem(item);
	    		}
		    }
		};
		
		this.__createListItem = function(listItem,item)
		{
		};
	
		this.__addSVGInPage = function()
		{
			var objSVG = new NSSvg();
			objSVG.addPath("svgListArrowDown",this.__ARROW_EXPANDED_PATH,"0 0 16 16");
			objSVG.addPath("svgListArrowRight",this.__ARROW_COLLAPSE_PATH,"0 0 16 16");
		};
	
		this.__setListItemProperties = function(listItem,item)
		{
			if(listItem && item)
			{
				var index = item[this.__nsList.__fieldIndex];
				var level = item[this.__nsList.__fieldItemLevel];
				var parentIndex = item[this.__nsList.__fieldParentIndex];
				listItem.setAttribute("ns-index",index);
				listItem.setAttribute("ns-level",level);
				if(item[this.__nsList.__fieldHasParent])
			    {
					listItem.setAttribute("ns-parent-index",parentIndex);
			    }
				item[this.__nsList.__fieldItem] = listItem;
				this.util.removeAllChildren(listItem);
				var divCell = this.util.createDiv(null,"nsListChild");
				listItem.appendChild(divCell);
				
				var hierarchicalPadding = 0;
				var divText = null;
				if(item && item.hasOwnProperty(this.__nsList.__labelField) && item[this.__nsList.__labelField])
				{
			        if((item[this.__nsList.__childField]  && item[this.__nsList.__childField].length > 0) || (this.__isOnDemandHasChildren(item)))
			        {
			        	this.util.addStyleClass(divCell,this.__nsList.__CLASS_GROUP_CELL);
			        	this.__nsList.__createArrow(item,index,divCell,item[this.__nsList.__fieldIsCollapsed]);
			        	var cellText = this.util.createDiv(null,this.__nsList.__CLASS_CELL_CHILD);
			        	this.util.addStyleClass(cellText,"nsListGroupCellText");
			        	cellText.style.verticalAlign = "top";
			        	divText = cellText;
			        	divCell.appendChild(cellText);
			        }
			        else
			        {
			        	this.util.addStyleClass(divCell,this.__nsList.__CLASS_CELL_CHILD);
			        	divText = divCell;
			        	//24 = 16(Arrow Width) + 6(Arrow Parent Padding) + 2(divCell horizontalGap between elements shown in debugger)
			        	hierarchicalPadding = 24;
			        }
			        this.__nsList.__addCellText(listItem,item,divText);
		        	if(level === 0)
		        	{
		        		listItem.style.paddingLeft = "1px";
		        	}
		        	else
		        	{
		        		var paddingLeft = (10 * level) + hierarchicalPadding;
		        		listItem.style.paddingLeft = paddingLeft + "px";
		        	}
				}
			}
		};
		
		this.__updateListItemText = function(listItem,item,index)
		{
			if(listItem && item)
			{
				this.util.removeAllChildren(listItem);
				this.__setListItemProperties(listItem,item);
			}
		};
	
		this.__getFlatSource= function()
		{
			return this.__nsList.__arrFlatHierarchicalSource;
		};
		
		this.__handleOnDemandClick = function(item,event)
		{
			if(item && this.__isOnDemandHasChildren(item))
			{
				if(this.__onDemandChildFetchCallback)
				{
					event = this.util.getEvent(event);
					var rowLevel = item[this.__nsList.__fieldItemLevel];
					var rowIndex = this.__nsList.__getIndexByItem(item);
					this.__onDemandChildFetchCallback(item,rowIndex,rowLevel,event);
				}
			}
		};
		/********************************Common Functions for Grid ****************************************/
		this.__setItemProperty = function(item,parentIndex,level,setFieldIndex,setIsCollapsed,setItemVisible)
		{
			if(item)
			{
				if(this.util.isUndefinedOrNull(setIsCollapsed))
				{
					setIsCollapsed = true;
				}
				if(this.util.isUndefinedOrNull(setItemVisible))
				{
					setItemVisible = true;
				}
				var totalRowCount = this.__rowCounter;
				if(setFieldIndex || this.util.isUndefinedOrNull(item[this.__nsList.__fieldIndex]))
				{
					item[this.__nsList.__fieldIndex] = totalRowCount;
				}
				item[this.__nsList.__fieldVisibleIndex] = totalRowCount;
				item[this.__nsList.__fieldItemLevel] = level;
				var hasChild = false;
				if(item.hasOwnProperty(this.__nsList.__childField) && item[this.__nsList.__childField] && item[this.__nsList.__childField].length > 0)
			    {
			    	hasChild = true;
			    	this.__setWrapperSource(item[this.__nsList.__childField],0,totalRowCount,level + 1,setFieldIndex,setIsCollapsed,setItemVisible);
			    }
				item[this.__nsList.__fieldParentIndex] = parentIndex;
				if(parentIndex > -1)
			    {
					item[this.__nsList.__fieldHasParent] = true;
			    }
				else
				{
					item[this.__nsList.__fieldHasParent] = false;
				}
				item[this.__nsList.__fieldHasChild] = hasChild;
				if(setItemVisible || this.util.isUndefinedOrNull(item[this.__nsList.__fieldItemVisible]))
				{
					item[this.__nsList.__fieldItemVisible] = true;
				}
				if(setIsCollapsed || this.util.isUndefinedOrNull(item[this.__nsList.__fieldIsCollapsed]))
				{
					item[this.__nsList.__fieldIsCollapsed] = this.__isOnDemandHasChildren(item);
				}
			}
		};
		
		this.__createArrow = function(compArrow,objSVG,arrowID,isCollapsed)
		{
			 var svg = objSVG.addSVG(compArrow,arrowID + "svg",this.__CLASS_ARROW,null,null,null,null,null,null,true);
			 if(isCollapsed)
			 {
				 objSVG.addUse(svg,arrowID + "use",null,"#svgListArrowRight");
			 }
			 else
			 {
				 objSVG.addUse(svg,arrowID + "use",null,"#svgListArrowDown");
			 }
		};
	
		this.__setArrowDirection = function(objSVG,useID,isCollapsed)
		{
			if(isCollapsed)
			{
				objSVG.changeUseHref(useID,"#svgListArrowRight");
			}
			else
			{
				objSVG.changeUseHref(useID,"#svgListArrowDown");
			}
		};
	
		this.__resetListItem = function(listItem,index,item)
		{
			listItem.style.display = "";
			listItem.setAttribute("ns-index",index);
			this.util.removeStyleClass(listItem,"nsListItemSelected");
			this.__nsList.__updateItem(item,index);
			this.__setListItemProperties(listItem,item);
		};
		
		this.__isOnDemandHasChildren = function(item)
		{
			return (this.__enableOnDemandHierarchy && item[this.__onDemandChildDetectionField]);
		};
	};
	
	var NSListFilter = function(nsList)
	{
		this.__nsList = nsList;
		
		this.util = nsList.util;
		this.__filteredColumn = [];
		this.__config = {};
		this.__nsDragDrop = null;
		
		this.__initialize = function()
		{
			
		};
		
		this.filter = function(strData,filterSetting,enableHighlighting,recordLimit)
		{
			if(!filterSetting)
			{
				filterSetting = {};
			}
			if(this.util.isUndefinedOrNull(enableHighlighting))
			{
				enableHighlighting = true;
			}
			var config = {
					caseSensitive: this.util.isUndefinedOrNull(filterSetting["caseSensitive"]) ? false : Boolean.parse(filterSetting["caseSensitive"]),
					multiline: this.util.isUndefinedOrNull(filterSetting["multiline"]) ? false : Boolean.parse(filterSetting["multiline"]),
					matchType: filterSetting["matchType"] || new NSFilter().CONTAINS
			};
			var filter = {};
			var setting = {};
			var field = this.__nsList.__labelField;
			filter[field] = strData;
			setting[field] = {caseSensitive:config["caseSensitive"],multiline:config["multiline"],matchType:config["matchType"]};
			if(filter && Object.keys(filter).length > 0)
			{
				this.__handleFiltering(filter,setting,enableHighlighting,recordLimit);
			}
			else
			{
				this.__resetFiltering();
			}
		};
		
		this.reset = function()
		{
			this.__resetFiltering();
		};
		
		this.__handleFiltering = function(filter,setting,enableHighlighting,recordLimit)
		{
			this.__filteredColumn = [];
			if(filter)
		    {
				 var field = this.__nsList.__labelField;
				 var source = this.__nsList.__arrWrapper;
				 var isHierarchical = false;
				 if(this.__nsList.__enableHierarchical)
				 {
					 isHierarchical = true;
				 }
			   	 var nsFilter = new NSFilter(source,filter,setting,recordLimit,isHierarchical,this.__nsList.__childField);
			   	 this.__nsList.__arrInternalSource = nsFilter.execute();
			   	 if(enableHighlighting)
			   	 {
			   		for(var key in filter) 
		  	        {
		  	        	this.__filteredColumn.push({field:key,text:filter[key]});
		  	        }
			   	 }
			   	 if(isHierarchical)
			   	 {
			   		this.__nsList.__objGrid.__setWrapperSource(this.__nsList.__arrInternalSource,0,-1,0,false);
			   		this.__nsList.__arrInternalSource = this.__nsList.__arrFlatHierarchicalSource.slice(0); 
			   	 }
			   	 this.__nsList.__updateTotalRecords();
			   	 this.__nsList.__renderBody();
			   	 this.__nsList.__updateVisibleIndexByListItem(this.__nsList.__arrInternalSource);
		    }
		};
	
		this.__resetFiltering = function()
		{
			if(this.__nsList.__dataSource)
			{
				this.__nsList.__arrInternalSource = this.__nsList.__arrWrapper.slice(0);
				this.__filteredColumn = [];
				if(this.__nsList.__enableHierarchical)
				{
					this.__nsList.__objGrid.__setWrapperSource(this.__nsList.__arrInternalSource,0,-1,0,false);
					this.__nsList.__arrInternalSource = this.__nsList.__arrFlatHierarchicalSource.slice(0); 
				}
				this.__nsList.__updateTotalRecords();
				this.__nsList.__renderBody();
				this.__nsList.__updateVisibleIndexByListItem(this.__nsList.__arrInternalSource);
			}
		};
	
		this.__highlightDiv = function(divText)
		{
			var length = this.__filteredColumn.length;
			for (var count = 0; count < length; count++) 
		    {
				var text = this.__filteredColumn[count].text;
				this.util.highlightText(divText,text,"nsTextHighlight");
		    }
		};
		
		this.__initialize();
	};
	
	var NSListDragDrop = function(nsList)
	{
		this.__nsList = nsList;
		this.util = nsList.util;
		
		this.__disableDraggableFunction = null;
		this.__disableDropableFunction = null;
		
		this.initialize = function()
		{
			var container = this.__nsList.__listContainer;
			var setting = {container:container,childNodeType:"LI",isContainerDraggable:this.__nsList.__isDraggable,isContainerDroppable:this.__nsList.__isDroppable,
						   enableDragByHandle:this.__nsList.__enableDragByHandle,dragHandlerClass:this.__nsList.__dragHandlerClass,
						   enableDragAfterHold:this.__nsList.__enableDragAfterHold,enableCloneMode:this.__nsList.__enableCloneMode,holdTime:this.__nsList.__holdTime,createCloneCallback:this.__createClone.bind(this),
						   createPlaceholderCallback:this.__createPlaceholder.bind(this),nodeDroppableCallback:this.__isListItemDroppable.bind(this),
						   nodeDraggableCallback:this.__isListItemDraggable.bind(this),insertNodeCallback:this.__insertListItemHandler.bind(this),
						   moveNodeCallback:this.__moveListItemHandler.bind(this),removeNodeCallback:this.__removeListItemHandler.bind(this)};
			this.__nsDragDrop = new NSDragDrop(setting);
			this.util.addEvent(container,this.__nsDragDrop.ITEM_DROPPING,this.__itemDroppingHandler.bind(this));
			this.util.addEvent(container,this.__nsDragDrop.ITEM_DROPPED,this.__itemDroppedHandler.bind(this));
			this.util.addEvent(container,this.__nsDragDrop.DRAG_STARTING,this.__dragStartingHandler.bind(this));
			this.util.addEvent(container,this.__nsDragDrop.DRAG_STARTED,this.__dragStartHandler.bind(this));
			this.util.addEvent(container,this.__nsDragDrop.DRAGGING,this.__draggingHandler.bind(this));
			this.util.addEvent(container,this.__nsDragDrop.DRAG_END,this.__dragEndHandler.bind(this));
		};
		
		this.__initialize = function()
		{
			var setting = this.__nsList.__setting;
			if(setting.hasOwnProperty("disableDraggableFunction"))
			{
				this.__disableDraggableFunction = setting["disableDraggableFunction"];
				this.__disableDraggableFunction = this.util.getFunction(this.__disableDraggableFunction);
			}
			if(setting.hasOwnProperty("disableDropableFunction"))
			{
				this.__disableDropableFunction = setting["disableDropableFunction"];
				this.__disableDropableFunction = this.util.getFunction(this.__disableDropableFunction);
			}
		};
		
		this.__dragStartingHandler = function(event)
		{
			var listItem = event.node;
			var arrItems = this.__getSelectedItems(listItem);
			var data = {parentID:this.__nsList.__listContainer.getAttribute("id"),arrItems:arrItems};
			this.__nsDragDrop.setDragData(data);
		};
		
		this.__dragStartHandler = function(event)
		{
			var listItem = event.node;
			var data = this.__nsDragDrop.getDragData();
			var arrItems = data.arrItems;
			this.util.dispatchEvent(this.__nsList.__baseComponent,this.__nsList.DRAG_STARTED,arrItems,{items:arrItems});
		};
		
		this.__draggingHandler = function(event)
		{
			var listData = event.item;
			var data = this.__nsDragDrop.getDragData();
			var arrItems = data.arrItems;
			listData.arrItems = arrItems;
	 	    this.util.dispatchEvent(this.__nsList.__baseComponent,this.__nsList.DRAGGING,listData,{item:listData});
		};
		
		this.__dragEndHandler = function(event)
		{
			var data = this.__nsDragDrop.getDragData();
			var arrItems = data.arrItems;
	 	    this.util.dispatchEvent(this.__nsList.__baseComponent,this.__nsList.DRAG_END,arrItems,{items:arrItems});
		};
		
		this.__itemDroppingHandler = function(event)
		{
			var cancelled = this.util.dispatchEvent(this.__nsList.__baseComponent,this.__nsList.ITEM_DROPPING,event.item,{item:event.item},true,true);
			if(cancelled)
			{
				event.preventDefault();
			}
		};
		
		this.__itemDroppedHandler = function(event)
		{
			this.util.dispatchEvent(this.__nsList.__baseComponent,this.__nsList.ITEM_DROPPED,event.item,{item:event.item},true,false);
		};
		
		this.__createClone = function(listItem,containerConfiguration)
		{
			var listContainer = this.__nsList.__listContainer.cloneNode(false);
			var data = this.__nsDragDrop.getDragData();
			var arrItems = data.arrItems;
			var clonedNode = null;
			//make a clone only when clone Mode is ON or the list is not droppable
			if(this.__nsList.__enableCloneMode || !this.__nsList.__isDroppable)
			{
				for(var count = 0;count < arrItems.length;count++)
				{
					clonedNode = arrItems[count][this.__nsList.__fieldItem].cloneNode(true);
					clonedNode.setAttribute("id","comp" + listContainer.id + "ClonedNode" + count);
					listContainer.appendChild(clonedNode);
				}
			}
			else
			{
				for(var count = 0;count < arrItems.length;count++)
				{
					clonedNode = arrItems[count][this.__nsList.__fieldItem];
					listContainer.appendChild(clonedNode);
				}
			}
			listContainer.style.width = containerConfiguration.width + "px";
			return listContainer;
		};
		
		this.__createPlaceholder = function(listItem)
		{
			var listItem = this.util.createElement("li",null,"nsListEmptyItem");
			listItem.innerHTML = "<div class='nsListEmptyChild'>&nbsp;</div>";
			return listItem;
		};
		
		this.__isListItemDroppable = function(listItem)
		{
			var item = this.__getItemFromTarget(listItem);
			return this.__isItemDroppable(listItem,item);
		};
		
		this.__isListItemDraggable = function(listItem)
		{
			var item = this.__getItemFromTarget(listItem);
			return this.__isItemDraggable(listItem,item);
		};
		
		this.__insertListItemHandler = function(container,newListItem,index,currentListItem,data)
		{
			var arrItems = data.arrItems;
			this.__nsList.__addItem(arrItems,index);
		};
		
		this.__moveListItemHandler = function(container,newListItem,index,currentListItem,data)
		{
			var arrItems = data.arrItems;
			this.__nsList.__moveItem(arrItems,index);
		};
		
		this.__removeListItemHandler = function(container,listItem,data)
		{
			
		};
		
		this.__getSelectedItems = function(target)
		{
			var list = this.__nsList;
			var listContainer = list.__listContainer;
			var index = parseInt(list.__getIndexFromTarget(target));
			var item = list.__getItemByIndex(index);
			var arrItems = [];
			var arrSelectedItems = list.getSelectedItems();
			var itemSelected = false; 
			if(arrSelectedItems && arrSelectedItems.length > 0)
			{
				var tempItem = null;
				for(var count = 0;count < arrSelectedItems.length;count++)
				{
					tempItem = this.__cloneItem(arrSelectedItems[count]);
					if(tempItem[list.__fieldIndex] === item[list.__fieldIndex])
					{
						itemSelected = true;
					}
					arrItems.push(tempItem);
				}
			}
			if(!itemSelected || !arrItems || arrItems.length === 0 || !arrItems[0])
			{
				var tempItem = this.__cloneItem(item);
				arrItems = [tempItem];
			}
			return arrItems;
		};
		
		this.__cloneItem = function(item)
		{
			var list = this.__nsList;
			var tempItem = null;
			if(item)
			{
				tempItem = this.util.cloneObject(item);
				if(list.__enableHierarchical && tempItem[list.__childField] && tempItem[list.__childField].length > 0)
				{
					var arrChild = tempItem[list.__childField];
					var length = arrChild.length;
					var childItem = null;
					var tempChildItem = null;
					for(var count = 0;count < length;count++)
					{
						childItem = arrChild[count];
						tempChildItem = this.__cloneItem(childItem);
						if(tempChildItem)
						{
							tempItem[list.__childField][count] = tempChildItem;
						}
					}
				}
			}
			return tempItem;
		};
		
		this.__getItemFromTarget = function(listItem)
		{
			var itemIndex = this.__nsList.__getIndexFromTarget(listItem);
			return this.__nsList.__getItemByIndex(itemIndex);
		};
		
		this.__isItemDraggable = function(listItem,item) 
	    {
			var retValue = true;
			if(this.__disableDraggableFunction)
			{
				retValue = this.__disableDraggableFunction(item,this.__nsList.__labelField,item[this.__nsList.__fieldIndex],item[this.__nsList.__fieldDisableHover],listItem);
				retValue = !retValue;
			}
	    	return retValue;
		};
		
		this.__isItemDroppable = function(event) 
	    {
			var retValue = true;
			if(this.__disableDropableFunction)
			{
				var target = this.util.getTarget(event);
				target = this.util.findParent(target,"li");
				var index = this.__nsList.__getIndexFromTarget(target);
				var item = this.__nsList.__getItemByIndex(index);
				if(item)
				{
					retValue = this.__disableDropableFunction(item,this.__nsList.__labelField,item[this.__nsList.__fieldIndex],item[this.__nsList.__fieldDisableHover],target);
					retValue = !retValue;
				}
			}
	    	return retValue;
		};
		
		this.__initialize();
	};
	return NSList;
})();
nsModuleExport(this,"NSList",NSList);
"use strict";
var NSGrid = (function()
{
	function NSGrid(component,setting) 
	{
		//this.base.call(this);
		this.GRID_TYPE_HIERARCHICAL = "hierarchical";
		this.GRID_TYPE_GROUP = "group";
		this.GRID_TYPE_NORMAL = "normal";
		this.GRID_TYPE_MASTER_DETAIL = "masterdetail";
		this.PAGINATION_TYPE_SCROLL = "scroll";
		this.PAGINATION_TYPE_PAGES = "pages";
		this.PAGINATION_MODE_AUTO = "auto";
		this.PAGINATION_MODE_MANUAL = "manual";
		this.RESPONSIVE_MODE_STACK = "stack";
		this.RESPONSIVE_MODE_COLUMN_TOGGLE = "columnToggle";
		this.MULTICOLUMN_KEY_SHIFT = "shift";
		this.MULTICOLUMN_KEY_CTRL = "ctrl";
		this.MULTICOLUMN_KEY_ALT = "alt";
		
		this.NAVIGATION_UP = "up";
		this.NAVIGATION_DOWN = "down";
		
		//this.initializeDOM(ns.NSDATAGRID_CSS);
		
		this.__OUTER_CONTAINER_ID = "divDataSet";
		this.__TITLE_CONTAINER_ID = "divTitleBar";
		this.__TABLE_HEADER_CONTAINER_WRAPPER_ID = "divHeaderContainerWrapper";
		this.__TABLE_BODY_CONTAINER_WRAPPER_ID = "divBodyContainerWrapper";
		this.__TABLE_FOOTER_CONTAINER_WRAPPER_ID = "divFooterContainerWrapper";
		this.__TABLE_LEFT_HEADER_CONTAINER_ID = "divLeftHeaderContainer";
		this.__TABLE_LEFT_HEADER_ID = "tblLeftHeader";
		this.__TABLE_LEFT_BODY_CONTAINER_ID = "divLeftBodyContainer";
		this.__TABLE_LEFT_BODY_ID = "tblLeftBody";
		this.__TABLE_LEFT_FOOTER_CONTAINER_ID = "divLeftFooterContainer";
		this.__TABLE_LEFT_FOOTER_ID = "tblLeftFooter";
		this.__TABLE_CENTER_HEADER_CONTAINER_ID = "divCenterHeaderContainer";
		this.__TABLE_CENTER_HEADER_ID = "tblCenterHeader";
		this.__TABLE_CENTER_BODY_CONTAINER_ID = "divCenterBodyContainer";
		this.__TABLE_CENTER_BODY_ID = "tblCenterBody";
		this.__TABLE_CENTER_FOOTER_CONTAINER_ID = "divCenterFooterContainer";
		this.__TABLE_CENTER_FOOTER_ID = "tblCenterFooter";
		this.__TABLE_RIGHT_HEADER_CONTAINER_ID = "divRightHeaderContainer";
		this.__TABLE_RIGHT_HEADER_ID = "tblRightHeader";
		this.__TABLE_RIGHT_BODY_CONTAINER_ID = "divRightBodyContainer";
		this.__TABLE_RIGHT_BODY_ID = "tblRightBody";
		this.__TABLE_RIGHT_FOOTER_CONTAINER_ID = "divRightFooterContainer";
		this.__TABLE_RIGHT_FOOTER_ID = "tblRightFooter";
		this.__PAGINATION_CONTROL_ID = "divPagination";
		
		this.__CLASS_TABLE = "nsDataGridTable";
		this.__CLASS_TITLEBAR = "nsDataGridTitleBar";
		this.__CLASS_TABLE_HEADER_CELL = "nsDataGridHeader";
		this.__CLASS_TABLE_HEADER_DROPPABLE_CELL = "nsDataGridDroppableHeader";
		this.__CLASS_BODY_CONTAINER = "nsDataGridBodyContainer";
		this.__CLASS_ODD_ROW = "nsDataGridOddRow";
		this.__CLASS_EVEN_ROW = "nsDataGridEvenRow";
		this.__CLASS_SELECTED_ROW = "nsDataGridSelection";
		this.__CLASS_GROUP_CELL = "nsGroupCell";
		this.__CLASS_CELL_CHILD = "nsCellChild";
		
		this.__DEFAULT_COLUMN_WIDTH = 100;
		this.__INFINITE_SCROLL_PADDING = 40;
		this.__INFINITE_SCROLL_INITIAL_LOAD = 250;
		
		this.__columns = [];
		this.__orignalColumns = [];
		this.__orignalItemKey = [];
		this.__navigationIndex = -1;
		this.__selectedIndex = -1;
		this.__selectedItem = null;
		this.__selectedIndexes = [];
		this.__selectedItems = [];
		this.__lastNavigationDirection = null;
	
		this.__title = null;
		this.__type = this.GRID_TYPE_NORMAL;
		this.__dataSource = null;
		this.__arrColumns = null;
		this.__context = window;
		this.__enableHierarchical = false;
		this.__enableGrouping = false;
		this.__enableMasterDetail = false;
		this.__enableMouseHover = false;
		this.__mouseHoverColor = "#CCCCCC";
		this.__enableColumnMouseHover = false;
		this.__enableMultipleSelection = false;
		this.__enableKeyboardNavigation = false;
		this.__enableCustomScrollBar = false;
		this.__columnResizable = false;
		this.__columnDraggable = false;
		this.__columnSortable = true;
		this.__columnAutoSize = false;
		this.__enableContextMenu = false;
		this.__enableVariableRowHeight = false;
		this.__enableFilter = false;
		this.__filterFunction = null;
		this.__hierarchyFilterChildrenFunction = null;
		this.__enableAdvancedFilter = false;
		this.__enableToolTipForTruncateText = false;
		this.__childField = "children";
		this.__rowKeyField = null;
		this.__isParentRowField = "ns-isParentRow";
		this.__groupByField = null;
		this.__columnMinWidth = 50;
		this.__pageSize = 50;
		this.__rowHeight = -1;
		this.__noDataMessage = "No matching records found";
		//stores initial Column Count 
		this.__initialColumnCount = 0;
		this.__initialTableWidth = 0;
		this.__enablePagination = false;
		this.__enableVirtualScroll = false;
		this.__enableDataRefreshOnScrollEnd = false;
		this.__enableServerCall = false;
		this.__enableExport = false;
		this.__enableResponsive = false;
		this.__enableColumnSetting = false;
		this.__enableRowSelection = true;
		this.__enableCellSelection = false;
		this.__enableMultiCellSelection = false;
		this.__enableMultiSort = false;
		this.__enableEditable = false;
		this.__showExpandCollapseIcon = true;
		this.__isPopUp = false; 
		this.__isPaginationTypeScroll = true;
		this.__isPaginationModeAuto = true;
		
		this.__isResponsiveModeStack = true;
		this.__isResponsiveModeColumnToggle = false;
		this.__totalRecords = 0;
		this.__contextMenuProvider = null;
		this.__contextMenuSetting = null;
		this.__responsiveMode = this.RESPONSIVE_MODE_STACK;
		this.__paginationFetchRecordCallBack = null;
		this.__eventDispatcher = null;
		this.__heightOffset = null;
		this.__editorSetting = null;
		//for Virtual Scroll
		this.__virtualScrollSetting = {};
		this.__nsVirtualScroll = null; 
		this.__virtualRowHeight = 0;
		//for DataRefreshOnScrollEnd
		this.__dataRefreshfireDelay = 100;
		
		this.__scrollOffsetPosition = 0;
		this.__componentResizingInterval = -1;
		this.__divPagination = null;
		
		this.__divOuterContainer = null;
		this.__divTableWrapper = null;
		this.__divTableHeaderContainerWrapper = null;
		this.__divTableBodyContainerWrapper = null;
		this.__divTableFooterContainerWrapper = null;
		this.__divCenterTableHeaderContainer = null;
		this.__tblCenterHeader = null;
		this.__tblCenterHeaderBody = null;
		this.__divCenterTableBodyContainer = null;
		this.__tblCenterBody = null;
		this.__tblCenterBodyBody = null;
		this.__divCenterTableFooterContainer = null;
		this.__tblCenterFooter = null;
		this.__tblCenterFooterBody = null;
		//stores whether mouse is on GridLine
		this.__onGridLine = false;
		this.__addRemoveRowCallInternal = false;
		this.__lastBodyCellFocus = null;
		this.__isColumnResizing = false;
		
		this.__bodyScrollPos = 0;
		//for Page type Pagination
		this.__nsPagination = null;
		//for Infinite Scroll Pagination
		this.__bottomPercentageForAddRows = 15;
		this.__processArrayAsync = null;
		this.__rowsRendered = false;
		this.__stopScroll = false;
		this.__lastScrollPos = [0,0];
		//for Fixed Column 
		this.__leftFixedColumn = 0;
		this.__rightFixedColumn = 0;
		this.__enableFixedColumnAnimation = false;
		this.__arrFixedLeftCells = [];
		this.__arrFixedRightCells = [];
		this.__fixedTimerTimeout = -1;
		this.__enableFooter = false;
		this.__tableRectFixedColumn = null;
		//for Row Mover
		this.__enableRowMove = false;
		this.__isSameTableMove = false;
		this.__rowMoverDropEndHandler = null;
		//flag to figure out that text of cell is cached or not
		//generally for IE this should be true to improve performance except when we are using Virtual scrolling
		this.__renderInCachedMode = false;
		this.__customClass = {};
		//for Multicolumn Sort
		this.__multiColumnKey = this.MULTICOLUMN_KEY_SHIFT;
		this.__isMultiColumnKeyPressed = false;
		this.__dateComponent = null;
		
		this.__headerExtraRowCount = 0;
		
		this.__loader = null;
		this.__scroller = null;
		this.__scrollerSetting = {};
		this.__groupCollection = null;
		this.__groupSource = null;
		this.__contextMenu = null;
		this.__exportMenu = null;
		this.__exportFileName = null;
		this.__exportMenuDataSource = [{id: 0,title: 'XLS',iconHTML: '<i class="fa fa-file-excel-o fa-lg"></i>'},
		                               {id: 1,title: 'CSV',iconHTML: '<i class="fa fa-file-excel-o fa-lg"></i>',separatorBelow:true},
		                               {id: 2,title: 'DOC',iconHTML: '<i class="fa fa-file-word-o fa-lg"></i>'},
		                               {id: 3,title: 'TEXT',iconHTML: '<i class="fa fa-file-text-o fa-lg"></i>',separatorBelow:true},
		                               {id: 4,title: 'XML',iconHTML: '<i class="fa fa-file-code-o fa-lg"></i>'},
		                               {id: 5,title: 'JSON',iconHTML: '<i class="fa fa-file-o" fa-lg></i>',separatorBelow:true},
		                               {id: 6,title: 'PDF',iconHTML: '<i class="fa fa-file-pdf-o fa-lg"></i>'},
		                               {id: 7,title: 'IMAGE',iconHTML: '<i class="fa fa-file-picture-o fa-lg"></i>',separatorBelow:true},
		                               {id: 8,title: 'XLSX',iconHTML: '<i class="fa fa-file-excel-o fa-lg"></i>'},
		                               {id: 9,title: 'DOCX',iconHTML: '<i class="fa fa-file-word-o fa-lg"></i>'}];
		this.__imgUtil = null;
		this.__arrWrapper = null;
		this.__arrInternalSource = null;
		this.__arrFlatHierarchicalSource = [];
		this.__arrFilteredGroupedSource = [];
		// This flag stops componentResized code to be called first time 
		this.__isComponentResizedCallCorrect = false;
		this.__customScrollBarSetting = {};
		//Custom Scrollbar Tooltip
		this.__enableScrollBarTip = false;
		this.__scrollBarTipLabelFunction = null;
		this.__divScrollTipContainer = null;
		this.__divScrollTipText = null;
		this.__scrollTipInterval = null;
		 //queue up the functions not called as Creation Complete called later
		this.__queueFunc = [];
		//if columns total width is less than parent still Table will fill all the width if this flag is true 
		this.__fillParentWidth = true;
		this.__enableAutoResize = false;
		
		this.__fieldPrefix = "ns_field";
		this.__fieldIndex = this.__fieldPrefix + "_row_index";
		this.__fieldVisibleIndex = this.__fieldPrefix + "_row_visible_index";
		this.__fieldRow = this.__fieldPrefix + "_row";
		this.__fieldRowHtml = this.__fieldPrefix + "_row";
		this.__fieldRowLevel = this.__fieldPrefix + "_row_level";
		this.__fieldRowVisible = this.__fieldPrefix + "_row_visible";
		this.__fieldRowHover = this.__fieldPrefix + "_row_hover";
		this.__fieldParentIndex = this.__fieldPrefix + "_parent_index";
		this.__fieldHasChild = this.__fieldPrefix + "_row_hasChild";
		this.__fieldHasParent = this.__fieldPrefix + "_row_hasParent";
		this.__fieldIsCollapsed = this.__fieldPrefix + "_row_isCollapsed";
		this.__fieldRowArrow = this.__fieldPrefix + "row_arrow";
		this.__fieldCellText = this.__fieldPrefix + "cell_text";
		this.__fieldSelected = this.__fieldPrefix + "_selected";
		this.__fieldColIndex = this.__fieldPrefix + "_col_index";
		this.__fieldColSortedAsc = this.__fieldPrefix + "_col_sorted_asc";
		this.__fieldColVisible = this.__fieldPrefix + "_col_visible";
		
		this.__isShiftPressed = false;
		this.__isCtrlPressed = false;
		
		this.__synchronizeTablesRef = null;
		this.__divCenterTableBodyMouseUpRef = null;
		this.__bodyScrollRef = null;
		this.__keyDownRef = null;
		this.__keyUpRef = null;
		this.__tableCellNavigatorEventRef = null;
		this.__tableCellSelectionEventRef = null;
		
		//mobile touch events
		this.__enableTouchEvents = true;
		this.__objTouchEvents = new Map();
		
		this.__objGrid = null;
		this.__nsGridColumnMove = null;
		this.__nsGridColumnResize = null;
		this.__nsGridSort = null;
		this.__nsGridFilter = null;
		this.__nsGridKeyboard = null;
		this.__nsToolTipInElement = null;
		this.__nsTableCellNavigator = null;
		this.__nsCellSelection = null;
		this.__multiCellSelectionSetting = null;
		this.__icons = {menu:null,filter:null,sortAscending:null,sortDescending:null,columnMove:null,exportButton:null,columnSetting:null,rowExpanded:null,rowCollapsed:null};
		this.__nsGridEditor = null;
		this.__nsPopUpColumnSetting = null;
		this.__setting = setting;
		this.base.__setBaseComponent.call(this,component,true);
	};
	nsExtendPrototype(NSContainerBase,NSGrid);
	NSGrid.prototype.constructor = NSGrid;
	
	NSGrid.prototype.initializeComponent = function() 
	{
		this.base.initializeComponent.call(this);
		this.__setFields();
		this.__setSetting();
	};
	
	NSGrid.prototype.setComponentProperties = function() 
	{
		this.base.setComponentProperties.call(this);
		this.__initializePluggins();
		this.__setGridType();
		this.__objGrid.__initialize();
		this.__addListenerForBody();
		this.__setPaginationType();
		this.__setPaginationMode();
		this.__setResponsiveMode();
		this.__checkForVirtualMode();
		this.__addSVGInPage();
		this.__addStyleInDOM();
		if(this.__arrColumns)
		{
			this.setColumn(this.__arrColumns);
		}
		if(this.__dataSource)
		{
			this.dataSource(this.__dataSource);
		}
		if(this.__queueFunc && this.__queueFunc.length > 0)
		{
			for(var count = this.__queueFunc.length - 1;count > -1;count--)
			{
				this.__queueFunc[count]();
				this.__queueFunc.splice(count, 1);
			}
		}
	};
	
	NSGrid.prototype.propertyChange = function(attrName, oldVal, newVal, setProperty)
	{
		if(setProperty)
		{
			this.__setting[attrName] = newVal;
			this.__objGrid.propertyChange(attrName, oldVal, newVal, setProperty);
		}
		this.base.propertyChange.call(this,attrName, oldVal, newVal, setProperty);
	};
	
	NSGrid.prototype.blurHandler = function(event)
	{
		this.base.blurHandler.call(this);
		this.__dispatchInternalEvent("blur");
	};
	
	NSGrid.prototype.componentResized = function(event,force) 
	{
		//console.log("In Grid componentResized");
		if(this.__enableAutoResize || force)
		{
			if(this.__isComponentResizedCallCorrect || this.__isPopUp)
			{
				var baseMeasurement = this.__baseComponent.getBoundingClientRect();
				if(!this.__lastBaseMeasurement || this.__lastBaseMeasurement.height !== baseMeasurement.height || this.__lastBaseMeasurement.width !== baseMeasurement.width)
				{
					//if (this.__componentResizingInterval != -1)
					//{
						clearTimeout(this.__componentResizingInterval);
						this.__componentResizingInterval = -1;
					//}
					var self = this;
					if(this.util.hasStyleClass(this.__baseComponent,"nsMobileStackGrid"))
					{
						this.__componentResizingInterval = setTimeout(
						function()
						{ 
							self.__componentResizingInterval = -1;
							if(self.__divOuterContainer)
							{
								console.log("In Resize" + self.__tblCenterBody.style.width);
								self.__setComponentHeight.bind(self)();
								self.__setOuterContainerMeasurement.bind(self)();
								var scrollBarWidth = self.util.getScrollBarWidth(self.__getVerticalScrollableContainer());
								var width = self.__divOuterContainer.getBoundingClientRect().width - scrollBarWidth;
								self.__setTableWidth.call(self,width);
								self.__setBodyMeasurement();
								self.__lastBaseMeasurement = self.__baseComponent.getBoundingClientRect();
							}
						},500);
					}
					else
					{
						this.__componentResizingInterval = setTimeout(
						function()
						{ 
							self.__componentResizingInterval = -1;
							self.reRender.call(self);
							self.base.componentResized.call(self,event);
						},500);
					}
				}
			}
			this.__isComponentResizedCallCorrect = true;
		}
	};
	
	NSGrid.prototype.setHeightOffset = function(offset)
	{
		this.__heightOffset = offset;
		this.__setComponentHeight();
		this.reRender();
	};
	
	NSGrid.prototype.__setSetting = function()
	{
		var setting = this.__setting;
		if(setting)
		{
			if(this.hasAttribute("nsTitle"))
			{
				this.__title = this.getAttribute("nsTitle");
			}
			if(this.hasAttribute("type"))
			{
				this.__type = this.getAttribute("type");
				if(!this.__type)
				{
					this.__type = this.GRID_TYPE_NORMAL;
				}
			}
			if(this.hasAttribute("context"))
			{
				this.__context = this.getAttribute("context");
			}
			if(this.hasAttribute("enableMouseHover"))
			{
				this.__enableMouseHover = Boolean.parse(this.getAttribute("enableMouseHover"));
			}
			if(this.hasAttribute("mouseHoverColor") && this.getAttribute("mouseHoverColor"))
			{
				this.__mouseHoverColor = this.getAttribute("mouseHoverColor");
			}
			if(this.hasAttribute("enableMultipleSelection"))
			{
				this.__enableMultipleSelection = Boolean.parse(this.getAttribute("enableMultipleSelection"));
			}
			if(this.hasAttribute("enableKeyboardNavigation"))
			{
				this.__enableKeyboardNavigation =  Boolean.parse(this.getAttribute("enableKeyboardNavigation"));
			}
			if(this.hasAttribute("enableColumnMouseHover"))
			{
				this.__enableColumnMouseHover =  Boolean.parse(this.getAttribute("enableColumnMouseHover"));
			}
			if(this.hasAttribute("childField"))
			{
				this.__childField = this.getAttribute("childField");
			}
			if(this.hasAttribute("rowKeyField"))
			{
				this.__rowKeyField = this.getAttribute("rowKeyField");
			}
			else
			{
				this.__rowKeyField = this.__fieldIndex;
			}
			if(this.hasAttribute("groupByField"))
			{
				this.__groupByField = this.getAttribute("groupByField");
			}
			if(this.hasAttribute("columnMinWidth"))
			{
				this.__columnMinWidth = this.getAttribute("columnMinWidth");
			}
			if(this.hasAttribute("enableCustomScrollBar"))
			{
				this.__enableCustomScrollBar =  Boolean.parse(this.getAttribute("enableCustomScrollBar"));
			}
			if(this.hasAttribute("customScrollBarSetting"))
			{
				this.__scrollerSetting = this.getAttribute("customScrollBarSetting");
			}
			if(this.hasAttribute("columnResizable"))
			{
				this.__columnResizable =  Boolean.parse(this.getAttribute("columnResizable"));
			}
			if(this.hasAttribute("columnDraggable"))
			{
				this.__columnDraggable = Boolean.parse(this.getAttribute("columnDraggable"));
			}
			if(this.hasAttribute("columnAutoSize"))
			{
				this.__columnAutoSize = Boolean.parse(this.getAttribute("columnAutoSize"));
			}
			if(this.hasAttribute("columnSortable"))
			{
				this.__columnSortable = Boolean.parse(this.getAttribute("columnSortable"));
			}
			if(this.hasAttribute("enablePagination"))
			{
				this.__enablePagination = Boolean.parse(this.getAttribute("enablePagination"));
			}
			if(this.hasAttribute("paginationType"))
			{
				this.__paginationType = this.getAttribute("paginationType");
			}
			if(this.hasAttribute("paginationMode"))
			{
				this.__paginationMode =  this.getAttribute("paginationMode");
			}
			if(this.hasAttribute("enableAsyncLoadPagination"))
			{
				this.__enableAsyncLoadPagination = Boolean.parse(this.getAttribute("enableAsyncLoadPagination"));
			}
			if(this.hasAttribute("pageSize"))
			{
				this.__pageSize = parseInt(this.getAttribute("pageSize"));
			}
			if(this.hasAttribute("totalRecords"))
			{
				this.__totalRecords =  parseInt(this.getAttribute("totalRecords"));
			}
			if(this.hasAttribute("paginationFetchRecordCallBack"))
			{
				this.__paginationFetchRecordCallBack =  this.getAttribute("paginationFetchRecordCallBack");
				this.__paginationFetchRecordCallBack = this.util.getFunction(this.__paginationFetchRecordCallBack);
			}
			if(this.hasAttribute("enableContextMenu"))
			{
				this.__enableContextMenu = Boolean.parse(this.getAttribute("enableContextMenu"));
			}
			if(this.hasAttribute("contextMenuProvider"))
			{
				this.__contextMenuProvider =  this.getAttribute("contextMenuProvider");
				this.__contextMenuProvider = this.util.getFunction(this.__contextMenuProvider);
			}
			if(this.hasAttribute("enableFilter"))
			{
				this.__enableFilter = Boolean.parse(this.getAttribute("enableFilter"));
			}
			if(this.hasAttribute("filterFunction"))
			{
				this.__filterFunction = this.getAttribute("filterFunction");
				this.__filterFunction = this.util.getFunction(this.__filterFunction);
			}
			if(this.hasAttribute("hierarchyFilterChildrenFunction"))
			{
				this.__hierarchyFilterChildrenFunction = this.getAttribute("hierarchyFilterChildrenFunction");
				this.__hierarchyFilterChildrenFunction = this.util.getFunction(this.__hierarchyFilterChildrenFunction);
			}
			if(this.hasAttribute("enableAdvancedFilter"))
			{
				this.__enableAdvancedFilter = Boolean.parse(this.getAttribute("enableAdvancedFilter"));
			}
			if(this.hasAttribute("enableVirtualScroll"))
			{
				this.__enableVirtualScroll = Boolean.parse(this.getAttribute("enableVirtualScroll"));
			}
			if(this.hasAttribute("enableDataRefreshOnScrollEnd"))
			{
				this.__enableDataRefreshOnScrollEnd = Boolean.parse(this.getAttribute("enableDataRefreshOnScrollEnd"));
			}
			if(this.hasAttribute("dataRefreshfireDelay") && parseInt(this.getAttribute("dataRefreshfireDelay")) > -1)
			{
				this.__dataRefreshfireDelay = parseInt(this.getAttribute("dataRefreshfireDelay"));
			}
			if(this.hasAttribute("bottomPercentageForAddRows") && parseInt(this.getAttribute("bottomPercentageForAddRows") > 0))
			{
				this.__bottomPercentageForAddRows = parseInt(this.getAttribute("bottomPercentageForAddRows"));
			}
			if(this.hasAttribute("enableServerCall"))
			{
				this.__enableServerCall = Boolean.parse(this.getAttribute("enableServerCall"));
			}
			if(this.hasAttribute("rowHeight"))
			{
				this.__rowHeight =  parseInt(this.getAttribute("rowHeight"));
			}
			if(this.hasAttribute("enableColumnSetting"))
			{
				this.__enableColumnSetting =  Boolean.parse(this.getAttribute("enableColumnSetting"));
			}
			if(this.hasAttribute("enableExport"))
			{
				this.__enableExport =  Boolean.parse(this.getAttribute("enableExport"));
			}
			if(this.hasAttribute("exportFileName"))
			{
				this.__exportFileName = this.getAttribute("exportFileName");
			}
			if(this.hasAttribute("enableResponsive"))
			{
				this.__enableResponsive =  Boolean.parse(this.getAttribute("enableResponsive"));
			}
			if(this.hasAttribute("enableRowSelection"))
			{
				this.__enableRowSelection =  Boolean.parse(this.getAttribute("enableRowSelection"));
			}
			if(this.hasAttribute("enableCellSelection"))
			{
				this.__enableCellSelection =  Boolean.parse(this.getAttribute("enableCellSelection"));
			}
			if(this.hasAttribute("enableMultiCellSelection"))
			{
				this.__enableMultiCellSelection =  Boolean.parse(this.getAttribute("enableMultiCellSelection"));
			}
			if(this.hasAttribute("responsiveMode"))
			{
				this.__responsiveMode = this.getAttribute("responsiveMode");
			}
			if(this.hasAttribute("noDataMessage"))
			{
				this.__noDataMessage = this.getAttribute("noDataMessage");
			}
			if(this.hasAttribute("leftFixedColumn"))
			{
				this.__leftFixedColumn =  parseInt(this.getAttribute("leftFixedColumn"));
			}
			if(this.hasAttribute("rightFixedColumn"))
			{
				this.__rightFixedColumn =  parseInt(this.getAttribute("rightFixedColumn"));
			}
			if(this.hasAttribute("enableFixedColumnAnimation"))
			{
				this.__enableFixedColumnAnimation =  Boolean.parse(this.getAttribute("enableFixedColumnAnimation"));
			}
			if(this.hasAttribute("enableRowMove"))
			{
				this.__enableRowMove =  Boolean.parse(this.getAttribute("enableRowMove"));
			}
			if(this.hasAttribute("isSameTableMove"))
			{
				this.__isSameTableMove =  Boolean.parse(this.getAttribute("isSameTableMove"));
			}
			if(this.hasAttribute("rowMoverDropEndHandler"))
			{
				this.__rowMoverDropEndHandler = this.getAttribute("rowMoverDropEndHandler");
				this.__rowMoverDropEndHandler = this.util.getFunction(this.__rowMoverDropEndHandler);
			}
			if(this.hasAttribute("renderInCachedMode"))
			{
				this.__renderInCachedMode =  Boolean.parse(this.getAttribute("renderInCachedMode"));
			}
			if(this.hasAttribute("enableVariableRowHeight"))
			{
				this.__enableVariableRowHeight =  Boolean.parse(this.getAttribute("enableVariableRowHeight"));
			}
			if(this.hasAttribute("enableToolTipForTruncateText"))
			{
				this.__enableToolTipForTruncateText =  Boolean.parse(this.getAttribute("enableToolTipForTruncateText"));
			}
			if(this.hasAttribute("heightOffset"))
			{
				this.__heightOffset =  this.getAttribute("heightOffset");
			}
			if(this.hasAttribute("enableMultiSort"))
			{
				this.__enableMultiSort =  Boolean.parse(this.getAttribute("enableMultiSort"));
			}
			if(this.hasAttribute("enableEditable"))
			{
				this.__enableEditable =  Boolean.parse(this.getAttribute("enableEditable"));
			}
			if(this.hasAttribute("editorSetting"))
			{
				this.__editorSetting =  this.getAttribute("editorSetting");
			}
			if(this.hasAttribute("multiColumnKey") && this.getAttribute("multiColumnKey"))
			{
				this.__multiColumnKey =  this.getAttribute("multiColumnKey");
			}
			if(this.hasAttribute("enableFooter"))
			{
				this.__enableFooter =  Boolean.parse(this.getAttribute("enableFooter"));
			}
			if(this.hasAttribute("dataSource"))
			{
				this.__dataSource = this.getAttribute("dataSource");
			}
			if(this.hasAttribute("columns"))
			{
				this.__arrColumns = this.getAttribute("columns");
			}
			if(this.hasAttribute("headerExtraRowCount"))
			{
				this.__headerExtraRowCount = parseInt(this.getAttribute("headerExtraRowCount"));
			}
			if(this.hasAttribute("customClass"))
			{
				this.__customClass = this.getAttribute("customClass");
				if(!this.__customClass)
				{
					this.__customClass = {};
				}
			}
			if(this.hasAttribute("theme") && this.getAttribute("theme"))
			{
				this.__theme = this.getAttribute("theme");
			}
			if(this.hasAttribute("showExpandCollapseIcon"))
			{
				this.__showExpandCollapseIcon = this.util.isUndefinedOrNull(this.getAttribute("showExpandCollapseIcon")) ? true : Boolean.parse(this.getAttribute("showExpandCollapseIcon"));
			}
			if(this.hasAttribute("dateComponent") && this.getAttribute("dateComponent"))
			{
				this.__dateComponent = this.getAttribute("dateComponent");
			}
			//isPopUp should be true if the grid is used in cases like autocomplete so that componentResized is called multiple times so that width is adjusted properly
			if(this.hasAttribute("isPopUp"))
			{
				this.__isPopUp =  Boolean.parse(this.getAttribute("isPopUp"));
			}
			//eventDispatcher to support different frameworks 
			if(this.hasAttribute("eventDispatcher"))
			{
				this.__eventDispatcher =  this.getAttribute("eventDispatcher");
				this.__eventDispatcher = this.util.getFunction(this.__eventDispatcher);
			}
			if(this.hasAttribute("multiCellSelectionSetting"))
			{
				this.__multiCellSelectionSetting = this.getAttribute("multiCellSelectionSetting");
			}
			else
			{
				this.__multiCellSelectionSetting = {scrollableElement:null,enableFillHandle:false,enableKeyboardNavigation:true,enableCopy:true,enablePaste:true,cellClass:null,areaClass:null,areaClassLeft:null,areaClassRight:null,areaClassTop:null,areaClassBottom:null};
			}
			if(this.hasAttribute("icons"))
			{
				this.__icons =  this.getAttribute("icons");
			}
			if(this.hasAttribute("enableTouchEvents"))
			{
				this.__enableTouchEvents = Boolean.parse(this.getAttribute("enableTouchEvents"));
			}
			if(this.hasAttribute("enableAutoResize"))
			{
				this.__enableAutoResize = Boolean.parse(this.getAttribute("enableAutoResize"));
			}
			if(this.hasAttribute("fillParentWidth"))
			{
				this.__fillParentWidth = Boolean.parse(this.getAttribute("fillParentWidth"));
			}
			if(this.hasAttribute("customScrollBarSetting"))
			{
				this.__customScrollBarSetting = this.getAttribute("customScrollBarSetting");
			}
			else
			{
				this.__customScrollBarSetting = {verticalScrollButtons: {enable: true},horizontalScrollButtons:{enable: true}};
			}
			if(this.hasAttribute("virtualScrollSetting"))
			{
				this.__virtualScrollSetting = this.getAttribute("virtualScrollSetting");
			}
			else
			{
				this.__virtualScrollSetting = {pageSize: null,pagesRendered: null,enableScrollDelay: false,scrollInterval: null,resizeInterval: null,enableLoader: false,getLoaderComponent: null};
			}
			if(this.hasAttribute("components"))
			{
				this.__components = this.getAttribute("components");
			}
			else
			{
				this.__components = {datePicker: null};
			}
			if(this.__enableVirtualScroll)
			{
				if(this.hasAttribute("enableScrollBarTip"))
				{
					this.__enableScrollBarTip =  Boolean.parse(this.getAttribute("enableScrollBarTip"));
				}
				if(this.hasAttribute("scrollBarTipLabelFunction"))
				{
					this.__scrollBarTipLabelFunction = this.getAttribute("scrollBarTipLabelFunction");
					this.__scrollBarTipLabelFunction = this.util.getFunction(this.__scrollBarTipLabelFunction);
				}
			}
		}
	};
	
	NSGrid.prototype.hasAttribute = function(attributeName)
	{
		return (this.__setting.hasOwnProperty(attributeName) || this.__setting.hasOwnProperty(attributeName.toLowerCase()));
	};
	
	NSGrid.prototype.getAttribute = function(attributeName)
	{
		var value = this.__setting[attributeName];
		if(this.util.isUndefined(value))
		{
			value = this.__setting[attributeName.toLowerCase()];
		}
		return value;
	};
	
	NSGrid.prototype.deviceViewChanged = function(conditionTrue,queryIndex,query) 
	{
		queryIndex = parseInt(queryIndex);
		var self = this;
		var refresh = function()
		{
			if(self.__nsVirtualScroll)
			{
				self.__nsVirtualScroll.refresh(true);
				self.__divCenterTableBodyContainer.scrollTop = 0;
			}
		};
		if(this.__isResponsiveModeStack)
		{
			if(conditionTrue)
			{
				this.util.addStyleClass(this.__baseComponent,"nsMobileStackGrid");
				refresh();
			}
			else
			{
				this.util.removeStyleClass(this.__baseComponent,"nsMobileStackGrid");
				refresh();
			}
			this.componentResized(null,true);
		}
		else if(this.__isResponsiveModeColumnToggle)
		{
			var className = "nsMobileColumnToggleGrid";
			var postFix = "";
			switch(queryIndex)
			{
				case 0:
					postFix = ">960";
					break;
				case 1:
					postFix = "960";
					break;
				case 2:
					postFix = "800";
					break;
				case 3:
					postFix = "640";
					break;
				case 4:
					postFix = "480";
					break;
				case 5:
					postFix = "320";
					break;
			}
			var reset = function()
			{
				self.util.removeStyleClass(self.__baseComponent,"nsMobileColumnToggleGrid960");
				self.util.removeStyleClass(self.__baseComponent,"nsMobileColumnToggleGrid800");
				self.util.removeStyleClass(self.__baseComponent,"nsMobileColumnToggleGrid640");
				self.util.removeStyleClass(self.__baseComponent,"nsMobileColumnToggleGrid480");
				self.util.removeStyleClass(self.__baseComponent,"nsMobileColumnToggleGrid320");
			};
			if(postFix)
			{
				reset();
				if(postFix != ">960" && conditionTrue)
				{
					this.util.addStyleClass(this.__baseComponent,className + postFix);
				}
				refresh();
			}
		}
		this.base.deviceViewChanged.call(this,conditionTrue,query);
	};
	
	//call this function when outer container width or height changes and enableAutoResize is false
	NSGrid.prototype.reRender = function()
	{
		if(this.__divOuterContainer)
		{
			this.__setComponentHeight();
			this.__setOuterContainerMeasurement();
			//done the below so that if the width of cell is in % then it will take its corresponding value after resize
			this.__setTableWidth(null);
			this.__renderBody(false);
			this.__lastBaseMeasurement = this.__baseComponent.getBoundingClientRect();
		}
	};
	
	NSGrid.prototype.getGridState = function()
	{
		var data = {};
		data.columns = this.__columns;
		return data;
	};
	
	//setState name conflicts with react setState method
	NSGrid.prototype.setGridState = function(data)
	{
		if(data)
		{
			if(data["columns"] && data["columns"].length > 0)
			{
				this.__createColumnProvider(data["columns"]);
			}
		}
	};
	
	NSGrid.prototype.setColumn = function(arrColumns)
	{
		//moving __initializePluggins here to ensure that the Pluggins are downloaded and then they are initialized
		this.__initializePluggins();
		if(arrColumns && arrColumns.length > 0)
		{
			this.__orignalColumns = arrColumns;
			this.__objGrid.__checkForAdditionalColumns();
			this.__processPinnedColumn();
			for(var count = 0;count < this.__orignalColumns.length;count++)
			{
				var item = this.__orignalColumns[count];
				//reset column visibility initially
				this.__setColumnVisibility(count,true,item);
				this.__processColumnObject(item,count);
			}
		}
		else
		{
			this.__orignalColumns = [];
		}
		this.__columns = this.__orignalColumns.slice(0);
	};
	
	NSGrid.prototype.setContextMenuSetting = function(contextMenuSetting)
	{
		this.__contextMenuSetting = contextMenuSetting;
	};
	
	NSGrid.prototype.dataSource = function(source,isReset)
	{
		if(!this.util.isUndefined(source))
		{
			//var start = new Date().getTime();
			if(this.util.isUndefinedOrNull(isReset))
			{
				isReset = true;
			}
			this.__dataSource = source;
			if(this.__isCreationCompleted)
			{
				this.__rowsRendered = false;
				if(isReset)
				{
					this.__setComponentHeight();
				}
				this.__resetPluggins();
				this.__createStructure();
				this.__callPlugginsInitialize();
				this.__addColumnPseudoStyle();
				if(this.__dataSource && this.__dataSource.length > 0 && this.__dataSource[0])
				{
					this.__orignalItemKey = Object.keys(this.__dataSource[0]);
					this.__objGrid.dataSource();
				}
				else
				{
					this.__arrWrapper = [];
					this.__arrInternalSource = [];
					this.__updateTotalRecords(0);
				}
				this.__setMeasurement();
				if(isReset)
				{
					this.__nsGridSort.reset();
				}
				this.__setHeaderSortFunction();
				if(isReset || !this.__processDefaultSort())
				{
					this.__renderBody(false);
				}
				this.__handleHiddenColumn();
				this.__addRowHeightInDOM();
				//setTimeout(function(){ self.__dispatchEvent(NSGrid.GRID_RENDERED); }, 700);
				if(this.__enableAutoResize)
				{
					this.attachResizeListener();
				}
				this.__objGrid.afterGridRendered();
				this.__dispatchEvent(NSGrid.GRID_RENDERED);
				
				/*var end = new Date().getTime();
				var time = end - start;
				console.debug('Execution time: ' + (time / 1000.0));*/
			}
			else
			{
				//always add as the first item so that when execute we can start from end and remove the elements
				this.__queueFunc.splice(0, 0, this.dataSource.bind(this,source,isReset));
			}
		}
		return this.__dataSource;
	};
	
	NSGrid.prototype.getOrignalItem = function(item)
	{
		if(item && this.__orignalItemKey && this.__orignalItemKey.length > 0)
		{
			var retItem = {};
			var key = null;
			for(var count = 0;count < this.__orignalItemKey.length;count++)
			{
				key = this.__orignalItemKey[count];
				if(!this.util.startsWith(key,this.__fieldPrefix))
				{
					retItem[key] = item[key];
				}
			}
			return retItem;
		}
		return item;
	};
	
	NSGrid.prototype.addRows = function(source)
	{
		this.__stopScroll = true;
		if(source && source.length > 0)
		{
			var startIndex = this.__arrInternalSource.length;
			if(!this.__addRemoveRowCallInternal)
	   	 	{
				this.__objGrid.__setWrapperSource(source,startIndex,-1,0,true);
	   	 	}
			//this logic might be wrong for filtered result or sorted list
			this.__arrInternalSource = this.__arrInternalSource.concat(source);
			this.__createBodyBody(this.__arrInternalSource,startIndex,this.__arrInternalSource.length);
	   	 	if(!this.__addRemoveRowCallInternal)
	   	 	{
	   	 		this.__arrWrapper = this.__arrWrapper.concat(source);
	   	 		this.__updateTotalRecords();
	   	 	}
	   	 	this.__addRemoveRowCallInternal = false;
		}
		this.__stopScroll = false;
	};
	
	NSGrid.prototype.removeRows = function(arrIndex)
	{
		if(!this.__enableHierarchical && !this.__enableGrouping && !this.__enableMasterDetail && arrIndex && arrIndex.length > 0)
		{
			arrIndex.sort();
	   	 	for (var rowIndex = arrIndex.length - 1; rowIndex >= 0; rowIndex--)
		    {
	   	 		var index = arrIndex[rowIndex];
	   	 		if(index > 0 && index < this.__arrInternalSource.length)
	   	 		{
		   	 		//if virtual scroll or Pagination of type Page is enabled then do not remove rows
		   	 		if(!(this.__enableVirtualScroll || (this.__enablePagination && !this.__isPaginationTypeScroll)))
		   	 		{
		   	 			this.__tblCenterBodyBody.deleteRow(index);
		   	 		}
		   	 		this.__arrInternalSource.splice(index, 1);
		   	 		this.__arrWrapper.splice(index, 1);
	   	 		}
		    }
	   	 	if(!this.__addRemoveRowCallInternal)
		 	{
		 		this.__updateTotalRecords();
		 	}
		 	this.__addRemoveRowCallInternal = false;
		}
	};
	
	NSGrid.prototype.groupBy = function(groupByField)
	{
		if(this.__enableGrouping && groupByField && groupByField.length > 0)
		{
			if(this.__setting)
			{
				this.__setting["groupByField"] = groupByField;
			}
			this.propertyChange("groupByField",this.__groupByField,groupByField,true);
		}
	};
	
	NSGrid.prototype.expandAll = function()
	{
		if(this.__enableHierarchical || this.__enableGrouping || this.__enableMasterDetail)
		{
			this.__expandCollapseAll(false);
		}
	};
	
	NSGrid.prototype.collapseAll = function()
	{
		if(this.__enableHierarchical || this.__enableGrouping || this.__enableMasterDetail)
		{
			this.__expandCollapseAll(true);
		}
	};
	
	NSGrid.prototype.expandByRow = function(element,rowIndex)
	{
		this.expandCollapseByRow(element,rowIndex,false);
	};
	
	NSGrid.prototype.collapseByRow = function(element,rowIndex)
	{
		this.expandCollapseByRow(element,rowIndex,true);
	};
	
	NSGrid.prototype.expandByKeyField = function(keyFieldValue) 
	{
		this.expandCollapseByKeyField(keyFieldValue,false);
	};
	
	NSGrid.prototype.collapseByKeyField = function(keyFieldValue) 
	{
		this.expandCollapseByKeyField(keyFieldValue,true);
	};
	
	NSGrid.prototype.expandCollapseByKeyField = function(keyFieldValue,isCollapse)
	{
		if(!this.util.isUndefinedOrNull(keyFieldValue))
		{
			var item = this.__getItemBykeyField(keyFieldValue);
			if(item)
			{
				var index = this.__getIndexByItem(item);
				this.expandCollapseByRow(null,index,isCollapse);
			}
		}
	};
	
	NSGrid.prototype.expandCollapseByRow = function(element,rowIndex,isCollapse)
	{
		if(element)
		{
			element = this.util.findParent(element,"TR");
			if(element)
			{
				rowIndex = parseInt(element.getAttribute("ns-index"));
			}
		}
		if(rowIndex > 0)
		{
			if(this.util.isUndefinedOrNull(isCollapse)) {
				isCollapse = this.__isRowCollapsed(null,rowIndex);
				isCollapse = !isCollapse;
			}
			rowIndex = parseInt(rowIndex);
			this.__showHideRow(rowIndex,element,isCollapse);
			var item = this.__getItemByIndex(rowIndex);
			this.__objGrid.arrowClickHandler(item,isCollapse);
		}
		else 
		{
			this.util.warning("NSGrid","Row Index starts with index 1.");
		}
	};
	
	NSGrid.prototype.getRowInfo = function(row)
	{
		if(row)
		{
			var objInfo = {};
			objInfo.rowIndex = parseInt(row.getAttribute("ns-index"));
			objInfo.rowLevel = parseInt(row.getAttribute("ns-level"));
			objInfo.rowParentIndex = parseInt(row.getAttribute("ns-parent-index"));
			objInfo.item = this.__getItemByIndex(objInfo.rowIndex);
			objInfo.rowOrignalIndex = objInfo.item[this.__fieldVisibleIndex];
			return objInfo;
		}
		return null;
	};
	
	NSGrid.prototype.getCellInfo = function(cell)
	{
		if(cell)
		{
			var objInfo = {};
			var row = this.util.findParent(cell,"TR");
			if(row)
			{
				objInfo = this.getRowInfo(row);
				objInfo.row = row;
				objInfo.cellIndex = cell.cellIndex;
				return objInfo;
			}
		}
		return null;
	};
	
	NSGrid.prototype.getItemInfo = function(objItem)
	{
		var objReturn = null;
		if(!this.util.isUndefinedOrNull(objItem))
		{
			var target = null;
			var event = this.util.getEvent(objItem);
			if(event)
			{
				target = this.util.getTarget(event);
			}
			else
			{
				target = objItem;
			}
			if(target && this.util.isElement(target))
			{
				if(this.util.isElementOfType(target,"TR"))
				{
					objReturn = this.getRowInfo(target);
				}
				else if(this.util.isElementOfType("TD"))
				{
					objReturn = this.getCellInfo(target);
				}
				else
				{
					target = this.util.findParent(target,"TD");
					objReturn = this.getCellInfo(target);
				}
			}
			else if(this.util.isNumber(objItem))
			{
				var index = parseInt(objItem);
				var item = this.__getItemByIndex(index);
				if(item)
				{
					/*if(item[this.__fieldRow])
					{
						objReturn = this.getRowInfo(item[this.__fieldRow]);
					}
					else
					{*/
						objReturn = {};
						objReturn.rowIndex = item[this.__fieldIndex];
						objReturn.rowOrignalIndex = item[this.__fieldVisibleIndex];
						objReturn.rowLevel = item[this.__fieldRowLevel];
						objReturn.rowParentIndex = item[this.__fieldParentIndex];
						objReturn.parentItem = this.__getItemByIndex(objReturn.rowParentIndex);
						objReturn.item = item;
					//}
				}
			}
			else if (this.util.isObject(objItem) && objItem.hasOwnProperty(this.__fieldIndex)) 
			{
            	var objReturn = {};
                objReturn.rowIndex = objItem[this.__fieldIndex];
                objReturn.rowOrignalIndex = objItem[this.__fieldVisibleIndex];
                objReturn.rowLevel = objItem[this.__fieldRowLevel];
                objReturn.rowParentIndex = objItem[this.__fieldParentIndex];
                objReturn.item = objItem;
            }
		}
		return objReturn;
	};
	
	NSGrid.prototype.getItemInfoByKeyField = function(keyFieldValue)
	{
		var objReturn = null;
		if(!this.util.isUndefinedOrNull(keyFieldValue))
		{
			var item = this.__getItemBykeyField(keyFieldValue);
			if(item)
			{
				objReturn = this.getItemInfo(item);
			}
		}
		return objReturn;
	};
	
	NSGrid.prototype.cascadeValues = function(event,callBack)
	{
		if(this.__enableGrouping)
		{
			var control = this.util.getTarget(event);
			var cell = this.util.findParent(control,"TD");
			var objCellInfo = this.getCellInfo(cell);
			var row = objCellInfo.row;
			var cellIndex = objCellInfo.cellIndex;
			var colItem = this.__columns[cellIndex];
			var dataField = colItem.dataField;
			var cascadeValue = this.util.getControlValue(control);
			var flatSource = this.__objGrid.__getFlatSource();
			var rowIndex = objCellInfo.rowIndex;
			var retIndex = this.__getActualIndex(flatSource,rowIndex);
			if(retIndex !== rowIndex)
			{
				rowIndex = (retIndex + 1);
			}
			var groupItem = objCellInfo["item"];//flatSource[rowIndex];
			if(groupItem)
			{
				groupItem[dataField] = cascadeValue;
			}
			for(var count = rowIndex;count < flatSource.length;count ++)
			{
				var item = flatSource[count];
				var childRow = item[this.__fieldRow];
				if(item[this.__fieldRowLevel] !== objCellInfo.rowLevel)
				{
					var isSetValue = false;
	                var setValue = null;
	                if(childRow && item[this.__fieldRowVisible])
	                {
	                   var childCell = childRow.cells[cellIndex];
	                   if(childCell.getElementsByTagName(control.tagName).length > 0)
	                   {
	                      var childControl = childCell.getElementsByTagName(control.tagName)[0];
	                      if(childControl)
	                      {
	                             if(callBack)
	                             {
	                                callBack(control,childControl,item,dataField,cellIndex,colItem,childCell,row);
	                                isSetValue = false;
	                             }
	                             else
	                             {
	                                setValue = this.util.setControlValue(childControl,cascadeValue);
	                                isSetValue = true;
	                             }
	                      }
	                   }
	                   else if(callBack)
		               {
		                  callBack(control,null,item,dataField,cellIndex,colItem,null,row);
		                  isSetValue = false;
		               }
		               else
		               {
		            	  setValue = cascadeValue;
		                  isSetValue = true;
		               }
	                }
	                else if(callBack)
	                {
	                    callBack(control,null,item,dataField,cellIndex,colItem,null,row);
	                    isSetValue = false;
	                }
	                else
	                {
	                   setValue = cascadeValue;
	                   isSetValue = true;
	                }
	                if(isSetValue)
	                {
	                   item[dataField] = setValue;
	                }
	                this.updateItemInDataSource(item);
				}
				else
				{
					break;
				}
			}
		}
	};
	
	NSGrid.prototype.setFontSize = function(fontSize)
	{
		if(this.__tblCenterHeader)
		{
			this.__tblCenterHeader.style.fontSize = fontSize;
		}
		if(this.__tblCenterBody)
		{
			this.__tblCenterBody.style.fontSize = fontSize;
		}
	};
	
	//assuming column is added at last
	//if reposition then use swapColumn
	NSGrid.prototype.addColumn = function(objColumn)
	{
		if(objColumn)
		{
			this.__processColumnObject(objColumn,this.__columns.length);
			if(!this.__isColumnExist(objColumn["dataField"]))
			{
				this.__editColumnArray("add",objColumn);
				var headerRow = this.__getHeaderHeaderRow(this.__tblCenterHeader);
				if(headerRow)
				{
					var headerBodyRow = this.__getHeaderBodyRow(this.__tblCenterHeader);
					var rendererRow = this.__getHeaderFilterRow(this.__tblCenterHeader);
					if(headerBodyRow)
					{
						this.__createHeaderColGroup(objColumn);
						this.__createHeaderHeaderCell(objColumn,headerRow);
					    this.__createHeaderBodyCell(objColumn,headerBodyRow,rendererRow,this.__columns.length - 1);
					}
				}
				var bodyRow = this.__getBodyHeaderRow(this.__tblCenterBody);
		    	if(bodyRow)
				{
		    		var arrRows = this.__getBodyBodyRow(this.__tblCenterBody);
		    		if(arrRows && arrRows.length > 0)
		    		{
		    			var arrItems = this.__arrInternalSource;
			    		this.__createBodyColGroup(objColumn);
			    		this.__createBodyHeaderCell(objColumn,bodyRow);
			    		var row = null;
			    		var item = null;
			    		for (var rowCount = 0; rowCount < arrRows.length; rowCount++) 
			    		{
			    			row = arrRows[rowCount];
			    			item = arrItems[rowCount];
			    			var colIndex = this.__columns.length - 1;
			    			var cell = this.__createBodyRowCell(row,colIndex,true);
			    			this.__setBodyCellProperty(row,cell,item,objColumn,colIndex,-1,0,true);
			    	    }
		    		}
				}
				this.__alignTables(false);
				this.__setHeaderSortFunctionForItem(objColumn);
				this.__addColumnPseudoStyle();
			}
			else
			{
				this.showColumn(objColumn["dataField"]);
			}
			return true;
		}
		this.util.warning("NSGrid","Please pass valid Column object to be added.");
		return false;
	};
	
	//programmatic method to call deviceViewChanged
	NSGrid.prototype.changeDeviceView = function(conditionTrue)
	{
		this.deviceViewChanged(conditionTrue);
	};
	
	NSGrid.prototype.hideColumn = function(column)
	{
		var index = this.__getColumnIndexForSwapOrRemove(column);
		if(index > -1)
		{
			if(this.__isColumnValidForSwapOrRemove(index,"hidden"))
			{
				//this.__removeHeaderCell(index);
				//this.__removeBodyColumn(index);
				//this.__removeFooterColumn(index);
				this.__editColumnArray("hide",index);
				this.__setColumnVisibility(index,false);
				this.__alignTables(false);
				this.__addColumnPseudoStyle();
				return true;
			}
		}
		return false;
	};
	
	NSGrid.prototype.showColumn = function(column)
	{
		var index = this.__getColumnIndexForSwapOrRemove(column);
		if(index > -1)
		{
			this.__editColumnArray("show",index);
			this.__setColumnVisibility(index,true,column);
			return true;
		}
		return false;
	};
	
	NSGrid.prototype.swapColumns = function(sourceColumn,destinationColumn)
	{
		var sourceIndex = this.__getColumnIndexForSwapOrRemove(sourceColumn);
		var destinationIndex = this.__getColumnIndexForSwapOrRemove(destinationColumn);
		if(sourceIndex > -1 && destinationIndex > -1)
		{
			var sourceValid = this.__isColumnValidForSwapOrRemove(sourceIndex,"swapped");
			var destinationValid = this.__isColumnValidForSwapOrRemove(destinationIndex,"swapped");
			if(sourceValid && destinationValid)
			{
				this.__swapOrMoveHeaderCell("swap",sourceIndex,destinationIndex);
				this.__swapOrMoveBodyCell("swap",sourceIndex,destinationIndex);
				this.__swapOrMoveFooterCell("swap",sourceIndex,destinationIndex);
				this.__alignTables(false);
				this.__columns[sourceIndex][this.__fieldColIndex] = destinationIndex;
				this.__columns[destinationIndex][this.__fieldColIndex] = sourceIndex;
				this.util.swapArrayItems(this.__columns,sourceIndex,destinationIndex);
				this.__addColumnPseudoStyle();
				return true;
			}
		}
		return false;
	};
	
	NSGrid.prototype.moveColumn = function(column,toIndex)
	{
		var sourceIndex = this.__getColumnIndexForSwapOrRemove(column);
		toIndex = this.__getColumnIndexForSwapOrRemove(toIndex);
		if(sourceIndex > -1 && toIndex > -1 && sourceIndex !== toIndex)
		{
			var sourceValid = this.__isColumnValidForSwapOrRemove(sourceIndex,"moved");
			var destinationValid = this.__isColumnValidForSwapOrRemove(toIndex,"moved");
			if(sourceValid && destinationValid)
			{
				this.__swapOrMoveHeaderCell("move",sourceIndex,toIndex);
				this.__swapOrMoveBodyCell("move",sourceIndex,toIndex);
				this.__swapOrMoveFooterCell("move",sourceIndex,toIndex);
				var currentColumn = this.__columns[toIndex];
				var direction = "no";
				if((currentColumn && currentColumn.pinned) || this.__columns[sourceIndex].pinned)
				{
					this.__columns[sourceIndex].pinned = null;
					if(currentColumn.pinned)
					{
						direction = currentColumn.pinned;
						this.__columns[sourceIndex].pinned = currentColumn.pinned;
					}
					this.__updateFixedColCounts();
					this.__createFixedRows();
				}
				this.__alignTables(false);
				//this.__setFixedCellsPosition();
				this.__columns[sourceIndex][this.__fieldColIndex] = toIndex;
				this.util.moveArrayItem(this.__columns,sourceIndex,toIndex);
				var smallIndex = Math.min(sourceIndex,toIndex);
				for(var count = smallIndex;count < this.__columns.length;count++)
				{
					this.__columns[count][this.__fieldColIndex] = count;
				}
				this.__addColumnPseudoStyle();
				this.__updateColumnClassForFixedColumns(toIndex,direction);
				this.__addStyleForFixedColumns();
				return true;
			}
		}
		return false;
	};
	
	NSGrid.prototype.sortBy = function(column,isAscending)
	{
		var index = this.__getColumnIndexForSwapOrRemove(column);
		var headerBodyRow = this.__getHeaderBodyRow(this.__tblCenterHeader);
		if(index > -1 && headerBodyRow)
		{
			var arrHeaderCells = headerBodyRow.cells;
			var cell = arrHeaderCells[index];
		    var columnDetail = this.__getColumnObject(cell.getAttribute("currentColumnIndex"));
		    this.__nsGridSort.handle(cell,columnDetail,false,isAscending);
		}
	};
	
	NSGrid.prototype.autoResizeColumn = function(column)
	{
		var index = this.__getColumnIndexForSwapOrRemove(column);
		this.__nsGridColumnResize.autoResize(index);
	};
	
	NSGrid.prototype.pinColumn = function(column,direction)
	{
		var index = this.__getColumnIndexForSwapOrRemove(column);
		var columnDetail = this.__getColumnObject(index);
		if(columnDetail)
		{
			if(columnDetail.pinned != direction)
			{
				var toIndex = -1;
				switch(direction)
				{
					case "left":
						for(var count = 0;count < this.__columns.length;count++)
						{
							if(this.__columns[count].pinned != "left")
							{
								toIndex = count;
								break;
							}
						}
					break;
					case "right":
						//this.__columns = this.__orignalColumns.slice(0);
						for(var count = this.__columns.length - 1;count > -1;count--)
						{
							if(this.__columns[count].pinned != "right")
							{
								toIndex = count;
								break;
							}
						}
					break;
					
				}
				var update = false;
				if(toIndex > -1)
				{
					if(this.moveColumn(index,toIndex)) {
						update = true;
					}
				}
				else {
					update = true;
					toIndex = index;
				}
				if(update) {
					columnDetail.pinned = direction;
					this.__updateFixedColCounts();
					this.__createFixedRows();
					//this.__setFixedCellsPosition();
					this.__updateColumnClassForFixedColumns(toIndex,direction);
					this.__addStyleForFixedColumns();
				}
			}
		}
	};
	
	NSGrid.prototype.updateRowByIndex = function(index)
	{
		var item = this.__getItemByIndex(index);
		if(item)
		{
			var row = this.__getRowFromItem(item);
			if(row)
			{
				var cells = row.cells;
				for (var colIndex = 0; colIndex < this.__columns.length; colIndex++)
		        {
					var cell = cells[colIndex];
		        	var colItem = this.__columns[colIndex];
		        	this.__updateCellText(row,cell,item,colItem,index,colIndex);
		        }
			}
		}
	};
	
	NSGrid.prototype.updateRowByKeyField = function(keyFieldValue)
	{
		var item = this.__getItemBykeyField(keyFieldValue);
		if(item)
		{
			var row = this.__getRowFromItem(item);
			if(row && parseInt(row.getAttribute("ns-index")) === item[this.__fieldIndex])
			{
				var cells = row.cells;
				for (var colIndex = 0; colIndex < this.__columns.length; colIndex++)
		        {
					var cell = cells[colIndex];
		        	var colItem = this.__columns[colIndex];
		        	this.__updateCellText(row,cell,item,colItem,item[this.__fieldIndex],colIndex);
		        }
			}
		}
	};
	
	NSGrid.prototype.updateCellByIndex = function(index,dataField)
	{
		var item = this.__getItemByIndex(index);
		var colItem = this.__getColumnObjectByDataField(dataField);
		if(item && colItem)
		{
			var colIndex = colItem[this.__fieldColIndex];
			var row = this.__getRowFromItem(item);
			if(row)
			{
				var cells = row.cells;
				var cell = cells[colIndex];
				this.__updateCellText(row,cell,item,colItem,index,colIndex);
			}
		}
	};
	
	NSGrid.prototype.updateCellByKeyField = function(keyFieldValue,dataField)
	{
		var item = this.__getItemBykeyField(keyFieldValue);
		var colItem = this.__getColumnObjectByDataField(dataField);
		if(item && colItem)
		{
			var colIndex = colItem[this.__fieldColIndex];
			var row = this.__getRowFromItem(item);
			if(row)
			{
				var cells = row.cells;
				var cell = cells[colIndex];
				this.__updateCellText(row,cell,item,colItem,item[this.__fieldIndex],colIndex);
			}
		}
	};
	
	NSGrid.prototype.updateItemInDataSource = function(item)
	{
		this.__updateItemInSource(item);
	};
	
	NSGrid.prototype.getGroupedSource = function()
	{
		return this.__arrFilteredGroupedSource;
	};
	
	NSGrid.prototype.setSelectedItems = function(arrItems)
	{
		if(arrItems && arrItems.length > 0)
		{
			var source = this.__getAllItems();
			if(source)
			{
				this.__clearAllRowSelection(true);
				var length = arrItems.length;
				var item = null;
				var index = -1;
				for(var count = 0;count < length;count++)
				{
					item = arrItems[count];
					index = this.__getIndexByItem(item);
					if(index > -1 && source && index < source.length)
					{
						this.__setIndex(index,true);
					}
				}
			}
		}
	};
	
	NSGrid.prototype.addSelectedItems = function(arrItems)
	{
		if(arrItems && arrItems.length > 0)
		{
			var source = this.__getAllItems();
			if(source)
			{
				var length = arrItems.length;
				var item = null;
				var index = -1;
				for(var count = 0;count < length;count++)
				{
					item = arrItems[count];
					index = this.__getIndexByItem(item);
					if(index > -1 && source)// && index < source.length
					{
						this.__setIndex(index,true);
					}
				}
			}
		}
	};
	
	NSGrid.prototype.removeSelectedItems = function(arrItems)
	{
		if(arrItems && arrItems.length > 0)
		{
			var source = this.__getAllItems();
			if(source)
			{
				var length = arrItems.length;
				var item = null;
				var index = -1;
				for(var count = 0;count < length;count++)
				{
					item = arrItems[count];
					index = this.__getIndexByItem(item);
					if(index > -1 && source)// && index < source.length
					{
						this.__markRowUnselected(index);
					}
				}
			}
		}
	};
	
	NSGrid.prototype.setSelectedItem = function(item)
	{
		this.setSelectedItems([item]);
	};
	
	NSGrid.prototype.setSelectedIndexes = function(arrSelectedIndex)
	{
		if(arrSelectedIndex && arrSelectedIndex.length > 0)
		{
			var source = this.__getAllItems();
			if(source)
			{
				var length = arrSelectedIndex.length;
				var index = -1;
				for(var count = 0;count < length;count++)
				{
					index = arrSelectedIndex[count];
					if(index > -1 && source && index < source.length)
					{
						this.__setIndex(index,true);
					}
				}
			}
		}
	};
	
	NSGrid.prototype.setSelectedIndex = function(selectedIndex)
	{
		this.setSelectedIndexes([selectedIndex]);
	};
	
	NSGrid.prototype.unSelectItems = function(arrItems)
	{
		this.removeSelectedItems(arrItems);
	};
	
	NSGrid.prototype.unSelectItem = function(arrItems)
	{
		this.unSelectItems([arrItems]);
	};
	
	NSGrid.prototype.unSelectIndexes = function(arrSelectedIndex)
	{
		
	};
	
	NSGrid.prototype.unSelectIndex = function(selectedIndex)
	{
		this.unSelectIndexes([selectedIndex]);
	};
	
	NSGrid.prototype.getSelectedIndex = function()
	{
		return this.__selectedIndex;
	};
	
	NSGrid.prototype.getSelectedItem = function()
	{
		return this.__selectedItem;
	};
	
	NSGrid.prototype.getSelectedIndexes = function()
	{
		return this.__selectedIndexes;
	};
	
	NSGrid.prototype.getSelectedItems = function()
	{
		return this.__selectedItems;
	};
	
	NSGrid.prototype.deselectAll = function()
	{
		this.__clearAllRowSelection(true);
	};
	
	NSGrid.prototype.filter = function(filter,setting,enableHighlighting,recordLimit)
	{
		this.__nsGridFilter.__handleFiltering(filter,setting,enableHighlighting,recordLimit);
		this.__nsGridFilter.setFiltersInControls(filter);
	};
	
	NSGrid.prototype.resetFilters = function()
	{
		this.__nsGridFilter.clearFilters();
		this.__nsGridFilter.resetFilters();
	};
	
	NSGrid.prototype.getFilteredData = function()
	{
		return this.__arrInternalSource;
	};
	
	NSGrid.prototype.highlightText = function(dataField,text)
	{
		var colItem = this.__getColumnObjectByDataField(dataField);
		if(colItem)
		{
			var index = colItem[this.__fieldColIndex];
			var arrRows = this.__tblCenterBodyBody.rows;
			var length = arrRows.length;
			for(var rowIndex = 0; rowIndex < length; rowIndex++)
		    {
				var cell = arrRows[rowIndex].cells[index];
				if(cell)
				{
					var divText = cell.querySelector("." + this.__CLASS_CELL_CHILD);
					if(divText)
					{
						this.util.unHighlightText(divText,"nsTextHighlight");
						this.util.highlightText(divText,text,"nsTextHighlight");
					}
				}
		    }
		}
	};
	
	NSGrid.prototype.unHighlightText = function()
	{
		var arrRows = this.__tblCenterBodyBody.rows;
		var length = arrRows.length;
		for(var rowIndex = 0; rowIndex < length; rowIndex++)
	    {
			var colLength = this.__columns.length;
			for(var colIndex = 0; colIndex < colLength; colIndex++)
		    {
				var cell = arrRows[rowIndex].cells[colIndex];
				if(cell)
				{
					var divText = cell.querySelector("." + this.__CLASS_CELL_CHILD);
					if(divText)
					{
						this.util.unHighlightText(divText,"nsTextHighlight");
					}
				}
		    }
	    }
	};
	
	//call this function if the Grid has Fixed Columns and the header calculation is not perfect due to external elements
	//call this function after all the elements are rendered by javascript
	NSGrid.prototype.fixFixedHeader = function()
	{
		this.__renderBody(false);
	};
	
	NSGrid.prototype.setSelectedRows = function(arrIndex)
	{
		/*if(arrIndex && arrIndex.length > 0)
		{
			arrIndex.sort();
	   	 	for (var rowIndex = arrIndex.length - 1; rowIndex >= 0; rowIndex--)
		    {
	   	 		var index = arrIndex[rowIndex];
	   	 		if(index > 0 && index < this.__arrInternalSource.length)
	   	 		{
		   	 		//if virtual scroll or Pagination of type Page is enabled then do not remove rows
		   	 		if(!(this.__enableVirtualScroll || (this.__enablePagination && !this.__isPaginationTypeScroll)))
		   	 		{
		   	 			this.__tblCenterBodyBody.deleteRow(index);
		   	 		}
		   	 		this.__arrInternalSource.splice(index, 1);
		   	 		this.__arrWrapper.splice(index, 1);
	   	 		}
		    }
	   	 	if(!this.__addRemoveRowCallInternal)
		 	{
		 		this.__updateTotalRecords();
		 	}
		 	this.__addRemoveRowCallInternal = false;
		}*/
	};
	
	NSGrid.prototype.scrollToIndex = function(selectedIndex,animationRequired)
	{
		selectedIndex = parseInt(selectedIndex);
		var source = this.__objGrid.__getFlatSource();
		if(selectedIndex > -1 && source && selectedIndex < source.length)
		{
			var item = this.__getItemByIndex(selectedIndex);
			if(item)
			{
				if(this.__enableVirtualScroll)
				{
					if(this.__enableCustomScrollBar)
					{
						var targetDimension = this.__virtualRowHeight * selectedIndex;
						this.__setCustomScrollBarScrollTop(targetDimension);
					}
					else
					{
						if(this.__nsVirtualScroll)
						{
							//because in list index is index+1
							this.__nsVirtualScroll.scrollToIndex(selectedIndex,animationRequired);
						}
					}
				}
				else
				{
					var targetDimension = -1;
					if(item[this.__fieldRowHtml])
					{
						targetDimension = (item[this.__fieldRowHtml].offsetTop);
					}
					var scrollTarget = this.__divCenterTableBodyContainer;
					if(animationRequired)
					{
						var animation = new this.util.animation(scrollTarget,[
			       	  	    {
			       	  	      time: 500,
			       	  	      property:"scrollTop",
			       	  	      target: targetDimension,
			       	  	    }
			       	  	]);
			   	  	  	animation.animate();
					}
					else
					{
						scrollTarget.scrollTop = targetDimension;
					}
				}
			}
		}
	};
	
	NSGrid.prototype.setNoDataMessage = function(message)
	{
		if(message && message.length > 0)
		{
			this.__noDataMessage = message;
		}
	};
	
	NSGrid.prototype.renderHeaderExtraRows = function()
	{
		this.__createHeaderExtraRows();
	};
	
	//Editor related public functions
	
	/*
	 * for editType = cell 
	 * combination can be this.editByIndex(cellIndex,rowIndex),this.editByIndex(rowIndex,dataField)
	 * 
	 * for editType = row 
	 * combination can be this.editByIndex(rowIndex)
	 * 
	 */
	NSGrid.prototype.editByIndex = function(index,dataField)
	{
		if(this.util.isUndefinedOrNull(dataField))
		{
			this.__nsGridEditor.edit(index);
		}
		else
		{
			this.__nsGridEditor.edit(dataField,index);
		}
	};
	
	/*
	 * for editType = cell 
	 * combination can be this.editByKeyField(keyFieldValue,dataField)
	 * 
	 * for editType = row 
	 * combination can be this.editByKeyField(keyFieldValue)
	 * 
	 */
	NSGrid.prototype.editByKeyField = function(keyFieldValue,dataField)
	{
		var item = this.__getItemBykeyField(keyFieldValue);
		var rowIndex = this.__getIndexByItem(item);
		this.editByIndex(rowIndex,dataField);
	};
	
	/*
	 * for editType = cell 
	 * combination can be this.editByItem(item,dataField)
	 * 
	 * for editType = row 
	 * combination can be this.editByItem(item)
	 * 
	 */
	NSGrid.prototype.editByItem = function(item,dataField)
	{
		var rowIndex = this.__getIndexByItem(item);
		this.editByIndex(rowIndex,dataField);
	};
	
	/*
	 * for editType = cell 
	 * combination can be this.editStopByIndex(cellIndex,rowIndex,isCancel),this.editStopByIndex(rowIndex,dataField,isCancel)
	 * 
	 * for editType = row 
	 * combination can be this.editStopByIndex(rowIndex,null,isCancel)
	 * 
	 */
	NSGrid.prototype.editStopByIndex = function(index,dataField,isCancel)
	{
		var self = this;
		isCancel = Boolean.parse(isCancel);
		var callLater = function(param1,param2)
		{
			if(isCancel)
			{
				self.__nsGridEditor.cancelEdit(param1,param2);
			}
			else
			{
				self.__nsGridEditor.saveEdit(param1,param2);
			}
		};
		if(this.util.isUndefinedOrNull(dataField))
		{
			callLater(index);
		}
		else
		{
			callLater(dataField,index);
		}
	};
	
	/*
	 * for editType = cell 
	 * combination can be this.editStopByKeyField(keyFieldValue,dataField,isCancel)
	 * 
	 * for editType = row 
	 * combination can be this.editStopByKeyField(keyFieldValue,null,isCancel)
	 * 
	 */
	NSGrid.prototype.editStopByKeyField = function(keyFieldValue,dataField,isCancel)
	{
		var item = this.__getItemBykeyField(keyFieldValue);
		var rowIndex = this.__getIndexByItem(item);
		this.editStopByIndex(rowIndex,dataField,isCancel);
	};
	
	/*
	 * for editType = cell 
	 * combination can be this.editStopByItem(item,dataField,isCancel)
	 * 
	 * for editType = row 
	 * combination can be this.editStopByItem(item,null,isCancel)
	 * 
	 */
	NSGrid.prototype.editStopByItem = function(item,dataField,isCancel)
	{
		var rowIndex = this.__getIndexByItem(item);
		this.editStopByIndex(rowIndex,dataField,isCancel);
	};
	
	NSGrid.prototype.getEditorInstances = function(element,dataField)
	{
		if(this.__nsGridEditor)
		{
			if(this.util.isUndefinedOrNull(dataField))
			{
				return this.__nsGridEditor.getEditorInstances(element);
			}
			else
			{
				this.__nsGridEditor.getEditorInstances(dataField,element);
			}
		}
		return null;
	};
	
	NSGrid.prototype.addItemsAsChildren = function(item,arrChildren)
	{
		this.__objGrid.addItemsAsChildren(item,arrChildren);
	};
	//end of editor related public functions
	
	NSGrid.prototype.removeComponent = function()
	{
		if(this.__scroller)
		{
			this.__scroller.remove();
			this.__scroller = null;
		}
		if(this.__contextMenu)
		{
			this.__contextMenu.remove();
			this.__contextMenu = null;
		}
		if(this.__exportMenu)
		{
			this.__exportMenu.remove();
			this.__exportMenu = null;
		}
		if(this.__bodyScrollRef)
		{
			this.util.removeEvent(this.__getVerticalScrollableContainer(),"scroll",this.__bodyScrollRef);
			this.__bodyScrollRef = null;
		}
		if(this.__synchronizeTablesRef)
		{
			this.util.removeEvent(this.__getHorizontalScrollableContainer(),"scroll",this.__synchronizeTablesRef);
			this.__synchronizeTablesRef = null;
		}
		if(this.__divCenterTableBodyMouseUpRef)
		{
			this.util.removeEvent(document,"mouseup",this.__divCenterTableBodyMouseUpRef);
			this.__divCenterTableBodyMouseUpRef = null;
		}
		if(this.__keyDownRef)
		{
			this.util.removeEvent(document.body,"keydown",this.__keyDownRef);
			this.__keyDownRef = null;
		}
		if(this.__keyUpRef)
		{
			this.util.removeEvent(document.body,"keyup",this.__keyUpRef);
			this.__keyUpRef = null;
		}
		if(this.__nsGridFilter)
		{
			this.__nsGridFilter.remove();
		}
		if(this.__nsPopUpColumnSetting)
		{
			this.__nsPopUpColumnSetting.remove();
			this.__nsPopUpColumnSetting = null;
		}
		if(this.__nsVirtualScroll)
		{
			this.__nsVirtualScroll.destroy();
			this.__nsVirtualScroll = null;
		}
		if(this.__divOuterContainer && this.__divOuterContainer.parentElement) {
			this.__divOuterContainer.parentElement.removeChild(this.__divOuterContainer);
		}
		this.base.removeComponent.call(this);
	};
	
	NSGrid.prototype.__setFields = function()
	{
		var id = this.getID();
		this.__fieldPrefix = "ns_field";
		this.__fieldIndex = this.__fieldPrefix + "_row_index" + id;
		this.__fieldVisibleIndex = this.__fieldPrefix + "_row_visible_index" + id;
		this.__fieldRow = this.__fieldPrefix + "_row" + id;
		this.__fieldRowHtml = this.__fieldPrefix + "_row" + id;
		this.__fieldRowLevel = this.__fieldPrefix + "_row_level" + id;
		this.__fieldRowVisible = this.__fieldPrefix + "_row_visible" + id;
		this.__fieldRowHover = this.__fieldPrefix + "_row_hover" + id;
		this.__fieldParentIndex = this.__fieldPrefix + "_parent_index" + id;
		this.__fieldHasChild = this.__fieldPrefix + "_row_hasChild" + id;
		this.__fieldHasParent = this.__fieldPrefix + "_row_hasParent" + id;
		this.__fieldIsCollapsed = this.__fieldPrefix + "_row_isCollapsed" + id;
		this.__fieldRowArrow = this.__fieldPrefix + "row_arrow" + id;
		this.__fieldCellText = this.__fieldPrefix + "cell_text" + id;
		this.__fieldSelected = this.__fieldPrefix + "_selected" + id;
		this.__fieldColIndex = this.__fieldPrefix + "_col_index" + id;
		this.__fieldColSortedAsc = this.__fieldPrefix + "_col_sorted_asc" + id;
		this.__fieldColVisible = this.__fieldPrefix + "_col_visible" + id;
	};
	
	NSGrid.prototype.__processColumnObject = function(objColumn,index)
	{
		if(objColumn)
		{
			objColumn[this.__fieldColIndex] = index;
			if(objColumn.hasOwnProperty("width"))
			{
				var widthUnit = this.util.getDimensionUnit(objColumn["width"]);
				if(widthUnit === 0)
				{
					objColumn["width"] = objColumn["width"] + "px";
				}
			}
			if(this.__columnSortable)
			{
				objColumn["sortable"] = this.util.isUndefinedOrNull(objColumn["sortable"]) ? true : Boolean.parse(objColumn["sortable"]);
			}
			objColumn["sortDescending"] = Boolean.parse(objColumn["sortDescending"]);
			objColumn["truncateToFit"] = Boolean.parse(objColumn["truncateToFit"]);
			objColumn["headerTruncateToFit"] = Boolean.parse(objColumn["headerTruncateToFit"]);
			objColumn["sortField"] = objColumn["sortField"] ? objColumn["sortField"] :  objColumn["dataField"];
			if(this.__columnResizable)
			{
				if(objColumn.hasOwnProperty("resizable"))
				{
					objColumn["resizable"] = Boolean.parse(objColumn["resizable"]);
				}
				else
				{
					objColumn["resizable"] = true;
				}
			}
			else
			{
				objColumn["resizable"] = false;
			}
			if(this.__columnDraggable)
			{
				if(objColumn.hasOwnProperty("draggable"))
				{
					objColumn["draggable"] = Boolean.parse(objColumn["draggable"]);
				}
				else
				{
					objColumn["draggable"] = true;
				}
			}
			else
			{
				objColumn["draggable"] = false;
			}
			if(this.__columnAutoSize && objColumn["resizable"])
			{
				if(objColumn.hasOwnProperty("autoSize"))
				{
					objColumn["autoSize"] = Boolean.parse(objColumn["autoSize"]);
				}
				else
				{
					objColumn["autoSize"] = true;
				}
			}
			else
			{
				objColumn["autoSize"] = false;
			}
			if(objColumn.hasOwnProperty("showMenu"))
			{
				objColumn["showMenu"] = Boolean.parse(objColumn["showMenu"]);
			}
			else
			{
				objColumn["showMenu"] = false;
			}
			if(objColumn.hasOwnProperty("minWidth"))
			{
				objColumn["minWidth"] = this.util.getDimensionAsNumber(null,objColumn["minWidth"]);
			}
			else
			{
				objColumn["minWidth"] = this.__columnMinWidth;
			}
			if(objColumn.hasOwnProperty("groupRenderer"))
			{
				objColumn["groupRenderer"] = this.util.getFunction(objColumn["groupRenderer"]);
			}
			//itemRendrer property gets precedence over template
			if(objColumn.hasOwnProperty("itemRenderer"))
			{
				objColumn["itemRenderer"] = this.util.getFunction(objColumn["itemRenderer"]);
			}
			else if(objColumn.hasOwnProperty("template") && objColumn["template"])
			{
				//setData should be before template for checking
				if(objColumn.hasOwnProperty("setData"))
				{
					objColumn["setData"] = this.util.getFunction(objColumn["setData"]);
				}
				objColumn.templateRenderer = this.util.getTemplate(objColumn["template"]);
			}
			else if(objColumn.hasOwnProperty("labelFunction"))
			{
				objColumn["labelFunction"] = this.util.getFunction(objColumn["labelFunction"]);
			}
			if(objColumn.hasOwnProperty("headerRenderer"))
			{
				objColumn["headerRenderer"] = this.util.getFunction(objColumn["headerRenderer"]);
			}
			else if(objColumn.hasOwnProperty("headerTemplate") && objColumn["headerTemplate"])
			{
				objColumn.headerTemplate = this.util.getTemplate(objColumn["headerTemplate"]);
			}
			if(!objColumn.hasOwnProperty("toolTipField") && objColumn.hasOwnProperty("toolTipRenderer"))
			{
				objColumn["toolTipRenderer"] = this.util.getFunction(objColumn["toolTipRenderer"]);
			}
			if(objColumn.hasOwnProperty("extraRowHeaderRenderer"))
			{
				objColumn["extraRowHeaderRenderer"] = this.util.getFunction(objColumn["extraRowHeaderRenderer"]);
			}
			if(objColumn.hasOwnProperty("footerRenderer"))
			{
				objColumn["footerRenderer"] = this.util.getFunction(objColumn["footerRenderer"]);
			}
			if(objColumn.hasOwnProperty("exportGetBodyTextFunction"))
			{
				objColumn["exportGetBodyTextFunction"] = this.util.getFunction(objColumn["exportGetBodyTextFunction"]);
			}
			if(objColumn.hasOwnProperty("exportGetFooterTextFunction"))
			{
				objColumn["exportGetFooterTextFunction"] = this.util.getFunction(objColumn["exportGetFooterTextFunction"]);
			}
			if(objColumn.hasOwnProperty("excelStyleHeaderFunction"))
			{
				objColumn["excelStyleHeaderFunction"] = this.util.getFunction(objColumn["excelStyleHeaderFunction"]);
			}
			if(objColumn.hasOwnProperty("excelStyleBodyFunction"))
			{
				objColumn["excelStyleBodyFunction"] = this.util.getFunction(objColumn["excelStyleBodyFunction"]);
			}
			if(objColumn.hasOwnProperty("excelStyleFooterFunction"))
			{
				objColumn["excelStyleFooterFunction"] = this.util.getFunction(objColumn["excelStyleFooterFunction"]);
			}
			if(this.__isResponsiveModeColumnToggle)
			{
				if(!objColumn.hasOwnProperty("priority"))
				{
					objColumn.priority = 6;
				}
				objColumn.priority = parseInt(objColumn.priority);
			}
			var isColumnFixed = this.__isColumnFixed(index);
			if(!isColumnFixed)
			{
				if(objColumn.hasOwnProperty("hideable"))
				{
					objColumn["hideable"] = Boolean.parse(objColumn["hideable"]);
				}
				else
				{
					objColumn["hideable"] = true;
				}
			}
			else
			{
				objColumn["hideable"] = false;
			}
			this.__processIconsInColumn(objColumn);
			this.__nsGridFilter.processColumnObject(objColumn);
			this.__nsGridEditor.processColumnObject(objColumn);
		}
		return objColumn;
	};
	
	NSGrid.prototype.__processPinnedColumn = function()
	{
		if(this.__orignalColumns && this.__orignalColumns.length > 0)
		{
			for(var count = 0;count < this.__leftFixedColumn;count++)
			{
				this.__orignalColumns[count].pinned = "left";
			}
			for(var count = this.__orignalColumns.length - 1,colCount = 0;count > -1 && colCount < this.__rightFixedColumn;count--,colCount++)
			{
				this.__orignalColumns[count].pinned = "right";
			}
			var arrLeft = [];
			var arrCenter = [];
			var arrRight = [];
			for(var count = 0;count < this.__orignalColumns.length;count++)
			{
				if(this.__orignalColumns[count].pinned)
				{
					if(this.__orignalColumns[count].pinned == "left")
					{
						arrLeft.push(this.__orignalColumns[count]);
					}
					else if(this.__orignalColumns[count].pinned == "right")
					{
						arrRight.push(this.__orignalColumns[count]);
					}
					else
					{
						arrCenter.push(this.__orignalColumns[count]);
					}
				}
				else
				{
					arrCenter.push(this.__orignalColumns[count]);
				}
			}
			this.__orignalColumns = arrLeft.concat(arrCenter).concat(arrRight); 
		}
	};
	
	NSGrid.prototype.__updateFixedColCounts = function()
	{
		this.__leftFixedColumn = 0;
		this.__rightFixedColumn = 0;
		for(var count = 0;count < this.__columns.length;count++)
		{
			if(this.__columns[count].pinned)
			{
				if(this.__columns[count].pinned == "left")
				{
					this.__leftFixedColumn++;
				}
				else if(this.__columns[count].pinned == "right")
				{
					this.__rightFixedColumn++;
				}
			}
		}
	};
	
	NSGrid.prototype.__processIconsInColumn = function(objColumn)
	{
		if(objColumn)
		{
			var itemIcons = objColumn["icons"];
			var icons = null;
			if(itemIcons)
			{
				icons = {};
				icons.menu = itemIcons["menu"] || this.__icons["menu"];
				icons.filter = itemIcons["filter"] || this.__icons["filter"];
				icons.sortAscending = itemIcons["sortAscending"] || this.__icons["sortAscending"];
				icons.sortDescending = itemIcons["sortDescending"] || this.__icons["sortDescending"];
				icons.columnMove = itemIcons["columnMove"] || this.__icons["columnMove"];
			}
			else if(this.__icons)
			{
				icons = this.util.cloneObject(this.__icons,true);
				delete icons.exportButton;
				delete icons.rowExpanded;
				delete icons.rowCollapsed;
			}
			if(icons)
			{
				objColumn.icons = icons;
			}
		}
	};
	
	NSGrid.prototype.__isColumnExist = function(dataField)
	{
		if(dataField && this.__columns && this.__columns.length > 0)
		{
			for(var count = 0; count < this.__columns.length;count++)
			{
				var objColumn = this.__columns[count];
				if(objColumn["dataField"] == dataField)
				{
					return true;
				}
			}
		}
		return false;
	};
	
	NSGrid.prototype.__createStructure = function()
	{
		var divOuterContainer = this.__createOuterContainer();
		var divTitleBar = this.__createTitleBar(divOuterContainer);
		this.__createTableStructure(divOuterContainer);
		if(divTitleBar && this.__title && this.__title.length > 0)
		{
			var spanTitle = divTitleBar.firstChild;
			var body = document.body || document.getElementsByTagName('body')[0];
			var bodyPaddingLeft = this.util.getDimensionAsNumber(body,this.util.getStyleValue(body,"padding-left"));
			var bodyPaddingTop = this.util.getDimensionAsNumber(body,this.util.getStyleValue(body,"padding-top"));
			var bodyMarginLeft = this.util.getDimensionAsNumber(body,this.util.getStyleValue(body,"margin-left"));
			var bodyMarginTop = this.util.getDimensionAsNumber(body,this.util.getStyleValue(body,"margin-top"));
			var paddingLeft = this.util.getDimensionAsNumber(this.__baseComponent,this.util.getStyleValue(this.__baseComponent,"padding-left"));
			var paddingTop = this.util.getDimensionAsNumber(this.__baseComponent,this.util.getStyleValue(this.__baseComponent,"padding-top"));
			var marginLeft = this.util.getDimensionAsNumber(this.__baseComponent,this.util.getStyleValue(this.__baseComponent,"margin-left"));
			var marginTop = this.util.getDimensionAsNumber(this.__baseComponent,this.util.getStyleValue(this.__baseComponent,"margin-top"));
			var setting = {offsetX:(-1 * (bodyPaddingLeft + bodyMarginLeft + paddingLeft + marginLeft)),offsetY:(-1 * (bodyPaddingTop + bodyMarginTop + paddingTop + marginTop))};
			this.util.addAnimatedLineOnHover(spanTitle,setting);
		}
		this.__createCustomScroller();
		this.__createScrollTip();
	};
	
	NSGrid.prototype.__createOuterContainer = function()
	{
		if(this.__divOuterContainer)
		{
			this.removeComponent();
			this.__divOuterContainer = null;
		}
		this.__divOuterContainer = this.util.createDiv(this.getID() + this.__OUTER_CONTAINER_ID,"nsDataGridContainer");
		this.__applyTheme(this.__divOuterContainer,"nsDataGridContainer");
		this.__applyCustomClass(this.__divOuterContainer,"outerContainer");
		this.__setOuterContainerMeasurement();
		this.addChild(this.__divOuterContainer);
		return this.__divOuterContainer;
	};
	
	NSGrid.prototype.__setOuterContainerMeasurement = function()
	{
		if(this.__divOuterContainer)
		{
			var width = this.util.getStyleValue(this.__baseComponent,"width");
			var height = this.util.getStyleValue(this.__baseComponent,"height");
			var rectBase = this.__baseComponent.getBoundingClientRect();
			if(rectBase.width > 0)
			{
				width = rectBase.width + "px";
			}
			if(rectBase.height > 0)
			{
				height = rectBase.height + "px";
			}
			this.__divOuterContainer.style.width = width;
			this.__divOuterContainer.style.height = height;
		}
	};
	
	NSGrid.prototype.__createTitleBar= function(parentElement)
	{
		if(parentElement && ((this.__title && this.__title.length > 0) || this.__enableExport || this.__enableColumnSetting))
		{
			var divTitleBar = this.util.createDiv(this.getID() + this.__TITLE_CONTAINER_ID,this.__CLASS_TITLEBAR);
			this.util.addStyleClass(divTitleBar,"nsDataGridTitleBarTheme");
			this.__applyCustomClass(divTitleBar,"titleBar");
			if(this.__title && this.__title.length > 0)
			{
				var spanTitle = document.createElement("span");
				var titleText = document.createTextNode(this.__title);
				spanTitle.appendChild(titleText);
				divTitleBar.appendChild(spanTitle);
			}
			var spanRight = document.createElement("span");
			spanRight.style.float = "right";
			divTitleBar.appendChild(spanRight);
			if(this.__enableColumnSetting)
			{
				var spanExport = document.createElement("span");
				spanExport.style.cursor = "pointer";
				if(this.__icons.columnSetting)
				{
					spanExport.innerHTML = this.__icons.columnSetting;
				}
				else
				{
					var objSVG = new NSSvg();
					var exportID = new NSSvgShapes().__COLUMNSETTING_ICON_ID;
					var svg = objSVG.addSVG(spanExport,exportID + "exportsvg","nsColumnSetting");
					this.util.addStyleClass(svg,"nsColumnSettingTheme");
					objSVG.addUse(svg,exportID + "use",null,"#" + exportID);
				}
				spanRight.appendChild(spanExport);
				var self = this;
				this.util.addEvent(spanExport,"click",function(event){
					self.__createColumnSettingUI.call(self,spanExport,event);
				});
			}
			if(this.__enableExport)
			{
				var spanExport = document.createElement("span");
				spanExport.style.paddingLeft = "5px";
				spanExport.style.cursor = "pointer";
				if(this.__icons.exportButton)
				{
					spanExport.innerHTML = this.__icons.exportButton;
				}
				else
				{
					var objSVG = new NSSvg();
					var exportID = new NSSvgShapes().__EXPORT_ICON_ID;
					var svg = objSVG.addSVG(spanExport,exportID + "exportsvg","nsExportIcon");
					this.util.addStyleClass(svg,"nsExportIconTheme");
					objSVG.addUse(svg,exportID + "use",null,"#" + exportID);
				}
				spanRight.appendChild(spanExport);
				if(!this.__exportMenu)
				{
					var exportMenuSetting = {parent:spanExport,dataSource:this.__exportMenuDataSource,isContextMenu:false,createRunTime:false,eventType:"click",defaultHandler:this.__exportHandler.bind(this),
							position:this.util.POS_BOTTOMLEFT};
					this.__exportMenu = new NSMenu(exportMenuSetting);
				}
			}
			parentElement.appendChild(divTitleBar);
			return divTitleBar;
		}
		return null;
	};
	
	NSGrid.prototype.__createColumnSettingUI = function(parentElement,event)
	{
		if(!this.__nsPopUpColumnSetting)
		{
			var self = this;
			var itemRenderer = function(item,labelField,fieldIndex,isDisabled,listItem)
			{
				if(item)
				{
					var divRenderer = self.util.createElement("span",null,"nsFilterListRenderer");
					var label = self.util.createElement("label");
					var checkBox = self.util.createElement("input",null,"nsFilterListRendererCheckBox");
					checkBox.setAttribute("type","checkbox");
					var visible = item[this.__fieldColVisible];
					if(self.util.isUndefinedOrNull(visible))
					{
						visible = true;
					}
					checkBox.checked = visible;
					this.util.addEvent(checkBox,"click",checkBoxClickHandler.bind(self,item));
					label.style.fontWeight = "400";
					label.style.cursor = "pointer";
					checkBox.style.marginRight = "5px";
					label.appendChild(checkBox);
					label.appendChild(document.createTextNode(item["headerText"] || item["dataField"]));
					divRenderer.appendChild(label);
					return divRenderer;
				}
				return null;
			};
			
			var checkBoxClickHandler = function(item,event)
			{
				var target = self.util.getTarget(event);
				var checked = target.checked;
				var index = this.__getColumnIndexByObject(item);
				var counter = 0;
				for(var count = 0;count < arrSource.length;count++)
				{
					if(self.util.isUndefinedOrNull(arrSource[count][this.__fieldColVisible]) || arrSource[count][this.__fieldColVisible])
					{
						counter++;
					}
				}
				var strMsg = "Atleast 1 Column should be selected in Column Configuration";
				if(counter == 1 && !checked)
				{
					target.checked = !checked;
					console.log(strMsg);
					return;
				}
				item[this.__fieldColVisible] = checked;
				this.__setColumnVisibility(index,checked,item);
				//if(checked)
				//{
					self.__alignTables(true);
					self.__addStyleForFixedColumns();
					//self.__setFixedCellsPosition();
				//}
			};
			var popUpSetting = {id:this.getID() + "columnSettingContainer",type:"div",width:275,position:this.util.POS_BOTTOMLEFT,closeOnOutsideClick:true,hideOrRemoveOnOutsideClick:"hide",closeRequired:true};
			this.__nsPopUpColumnSetting = new this.util.nsPopUp(popUpSetting);
			this.__nsPopUpColumnSetting.create();
			var popUp = this.__nsPopUpColumnSetting.getPopUp();
			var self = this;
			this.util.addEvent(popUp,"click",function(event){
				event = self.util.getEvent(event);
				event.stopImmediatePropagation();
			});
			var divList = this.util.createDiv();
			var lstColumn = this.util.createElement("div",null,"nsFilterList");
			lstColumn.style.height = "300px";
			divList.appendChild(lstColumn);
			popUp.appendChild(divList);
			var arrSource = this.__getColumnSettingSource();
			var setting = {labelField:"label",enableVirtualScroll:false,enableDragDrop:false,enableDragByHandle:false,enableMultipleSelection:true,enableKeyboardNavigation:false,
					   customScrollerRequired:false,enableMouseHover:true,enableMouseHoverAnimation:false,itemRenderer:itemRenderer.bind(this)};
			setting["dataSource"] = arrSource;
			var objNSList = new NSList(lstColumn,setting);
		}
		this.__nsPopUpColumnSetting.show();
		this.__nsPopUpColumnSetting.placePopUp(event);
		event.stopPropagation();
	};
	
	NSGrid.prototype.__getColumnSettingSource = function()
	{
		var arrSource = [];
		for(var count = 0;count < this.__columns.length;count++)
		{
			var objColumn = this.__columns[count];
			if(objColumn["hideable"])
			{
				arrSource.push(objColumn);
			}
		}
		return arrSource;
	};
	
	NSGrid.prototype.__createTableStructure= function(parentElement)
	{
		if(parentElement)
		{
			this.__divTableWrapper = this.util.createDiv(this.getID() + "TableWrapper","nsTableWrapper");
			parentElement.appendChild(this.__divTableWrapper);
			this.__divTableHeaderContainerWrapper = this.util.createDiv(this.getID() + this.__TABLE_HEADER_CONTAINER_WRAPPER_ID,"nsGridHeaderContainer");
			this.__divTableWrapper.appendChild(this.__divTableHeaderContainerWrapper);
			this.__divTableBodyContainerWrapper = this.util.createDiv(this.getID() + this.__TABLE_BODY_CONTAINER_WRAPPER_ID,"nsGridBodyContainer");
			this.__divTableWrapper.appendChild(this.__divTableBodyContainerWrapper);
			this.__divTableFooterContainerWrapper = this.util.createDiv(this.getID() + this.__TABLE_FOOTER_CONTAINER_WRAPPER_ID,"nsGridFooterContainer");
			this.__divTableWrapper.appendChild(this.__divTableFooterContainerWrapper);
			this.__createHeader();
			this.__createBody();
			this.__createFooter();
		}
	};
	
	NSGrid.prototype.__createPaginationControl= function(parentElement)
	{
		if(parentElement)
		{
			if(this.__divPagination)
			{
				this.util.removeAllChildren(this.__divPagination);
				this.__divPagination.parentElement.removeChild(this.__divPagination);
				this.__divPagination = null;
			}
			this.__divPagination = this.util.createDiv(this.getID() + this.__PAGINATION_CONTROL_ID,"nsGridPagination");
			parentElement.appendChild(this.__divPagination);
			var setting = {
					parent:this.__divPagination,
					totalRecords : this.__totalRecords,
					pageSize : this.__pageSize,
					//containerStyle:"pagination",
					//activeStyle:"active",
					//disabledStyle:"disabled",
					textFirst:"Home",
					textLast:"Last",
					textPrev:"Prev",
					textNext:"Next",
					showFirstLast:true
			};
			this.__nsPagination = new NSPagination(setting);
			this.__nsPagination.util.addEvent(this.__divPagination,this.__nsPagination.PAGE_CHANGE,this.__pageChangeHandler.bind(this));
		}
	};
	
	NSGrid.prototype.__pageChangeHandler= function(event)
	{
		if(!event)
		{
			event = {oldIndex:0,newIndex:1,fromRecord:0,toRecord:this.__pageSize - 1};
		}
		console.log("OldPage::" + event.oldIndex + ",NewPage::" + event.newIndex);
		if(this.__paginationFetchRecordCallBack && this.__totalRecords > event.fromRecord)
		{
			this.__paginationFetchRecordCallBack(event.fromRecord,event.toRecord,this.__pageSize);
		}
	};
	
	/******************************Header Creation *************************************/
	NSGrid.prototype.__createHeader = function()
	{
		this.__divCenterTableHeaderContainer = this.__createHeaderContainer(this.__divTableHeaderContainerWrapper,this.__divCenterTableHeaderContainer,this.getID() + this.__TABLE_CENTER_HEADER_CONTAINER_ID,this.getID() + this.__TABLE_CENTER_HEADER_ID);
		this.__tblCenterHeader = this.__divCenterTableHeaderContainer.firstChild;
		var divHeaderCorner = this.util.createDiv(null,"nsHeaderBarCorner");
		this.__divTableHeaderContainerWrapper.appendChild(divHeaderCorner);
		this.__createHeaderRows();
	};
	
	NSGrid.prototype.__createHeaderContainer= function(tableContainer,headerContainer,containerID,tableID)
	{
		if(headerContainer)
		{
			headerContainer.parentNode.removeChild(headerContainer);
		}
		headerContainer = this.__createTableAndParent(containerID,"nsDataGridHeaderContainer",tableID);
		tableContainer.appendChild(headerContainer);
		return headerContainer;
	};
	
	NSGrid.prototype.__createHeaderRows= function()
	{
		if(this.__tblCenterHeader && this.__columns && this.__columns.length > 0)
		{
			var header = this.__tblCenterHeader.createTHead();
			var headerRow = header.insertRow(-1);
		    headerRow.style.height = "auto";
		    this.__tblCenterHeaderBody = document.createElement("tbody");
			this.__tblCenterHeader.appendChild(this.__tblCenterHeaderBody);
		    var bodyRow = this.__tblCenterHeaderBody.insertRow(-1);
		    this.util.addStyleClass(bodyRow,"nsGridHeaderRow");
			this.__applyCustomClass(bodyRow,"headerRow");
		    var rendererRow = this.__tblCenterHeaderBody.insertRow(-1);
		    this.util.addStyleClass(rendererRow,"nsGridFilterRow");
			this.__applyCustomClass(rendererRow,"filterRow");
		    for (var colIndex = 0; colIndex < this.__columns.length; colIndex++)
		    {
		    	var colItem = this.__columns[colIndex];
		    	this.__createHeaderColGroup(colItem);
		        this.__createHeaderHeaderCell(colItem,headerRow);
		        this.__createHeaderBodyCell(colItem,bodyRow,rendererRow,colIndex);
		    }
		}
	};
	
	NSGrid.prototype.__createHeaderExtraRows = function()
	{
		var headerBodyRow = this.__getHeaderBodyRow(this.__tblCenterHeader);
		if(this.__headerExtraRowCount > 0 && headerBodyRow)
		{
			var arrExtraRow = this.__getHeaderExtraRow(this.__tblCenterHeader);
			if(arrExtraRow && arrExtraRow.length > 0)
			{
				for (var rowIndex = arrExtraRow.length - 1; rowIndex > -1; rowIndex--)
			    {
					this.__tblCenterHeader.deleteRow(arrExtraRow[rowIndex].rowIndex);
			    }
			}
			for (var rowIndex = 0; rowIndex < this.__headerExtraRowCount; rowIndex++)
		    {
				var extraRow = this.__tblCenterHeaderBody.insertRow(-1);
				this.util.addStyleClass(extraRow,"nsHeaderExtraRow");
				this.__applyCustomClass(extraRow,"extraHeaderRow");
				this.__applyCustomClass(extraRow,"extraHeaderRow" + rowIndex);
				for (var colIndex = 0; colIndex < this.__columns.length; colIndex++)
			    {
					this.__createHeaderExtraCell(this.__columns[colIndex],extraRow,rowIndex,colIndex);
			    }
		    }
		}
	};
	
	NSGrid.prototype.__createHeaderColGroup = function(colItem)
	{
		if(colItem)
		{
			var colgroup = document.createElement("colgroup");
			colgroup.setAttribute("id",this.getID() + "HeaderColGroup" + colItem.dataField);
			this.util.addStyleClass(colgroup,"nsGridColGroup");
			this.util.addStyleClass(colgroup,"nsGridColGroupHeader");
			this.__tblCenterHeader.appendChild(colgroup);
		}
	};
	
	NSGrid.prototype.__createHeaderHeaderCell = function(colItem,headerRow)
	{
		if(colItem && headerRow)
		{
			var headerCell = headerRow.insertCell(-1);
			this.util.addStyleClass(headerCell,"nsGridCell");
			headerCell.style.padding = "0px"; 
			headerCell.style.width = colItem["width"]; 
			this.__addPriorityClassInCell(headerCell,colItem);
		}
	};
	
	NSGrid.prototype.__createHeaderExtraCell = function(colItem,extraHeaderRow,rowIndex,colIndex)
	{
		if(colItem && extraHeaderRow)
		{
			var extraHeaderCell = extraHeaderRow.insertCell(-1);
			var colID = this.getID() + "colExtra" + colItem["dataField"] + rowIndex + colIndex;
			extraHeaderCell.setAttribute("id",colID);
			this.util.addStyleClass(extraHeaderCell,"nsGridCell");
			this.util.addStyleClass(extraHeaderCell,"nsDataGridHeaderRenderer");
			this.util.addStyleClass(extraHeaderCell,"nsDataGridHeaderRendererTheme");
			this.__addStyleForFixedCell(extraHeaderCell,colIndex);
			//this.__nsGridFilter.addFilterRenderer(rendererRow,rendererCell,colItem,index,colID);
			this.__addPriorityClassInCell(extraHeaderCell,colItem);
			var divHeaderRendererContainer = this.util.createDiv(null); 
			extraHeaderCell.appendChild(divHeaderRendererContainer);
			var itemRenderer = colItem["extraRowHeaderRenderer"];
			if(itemRenderer)
			{
				var objRenderer = itemRenderer(colItem["dataField"],colItem,this.__arrFilteredGroupedSource,rowIndex,colIndex,extraHeaderCell,extraHeaderRow);
				var callback = function(objRenderer)
				{
					if(objRenderer)
					{
						if(this.util.isString(objRenderer))
						{
							var compSpan = document.createElement("span");
							compSpan.innerHTML = objRenderer;
							divHeaderRendererContainer.appendChild(compSpan);
						}
						else
						{
							divHeaderRendererContainer.appendChild(objRenderer);
						}
					}
				};
				this.util.resolveFunctionOrPromise(objRenderer,callback.bind(this));
			}
		}
	};
	
	NSGrid.prototype.__createHeaderBodyCell = function(colItem,bodyRow,rendererRow,index)
	{
		if(colItem && bodyRow && rendererRow)
		{
			var bodyCell = bodyRow.insertCell(-1);
			var colID = this.getID() + "ColHeader" + colItem["dataField"];
			bodyCell.setAttribute("id",colID);
			this.util.addStyleClass(bodyCell , "nsGridCell");
			this.util.addStyleClass(bodyCell , this.__CLASS_TABLE_HEADER_CELL);
			this.util.addStyleClass(bodyCell , "nsDataGridHeaderTheme");
			this.__addStyleForFixedCell(bodyCell,index);
			this.__applyCustomClass(bodyCell,"headerCell");
			bodyCell.setAttribute("orignalColumnIndex",index);
		    bodyCell.setAttribute("currentColumnIndex",index);
		    
	        this.util.addEvent(bodyCell,"click",this.__headerClickHandler.bind(this));
	        this.util.addEvent(bodyCell,"mouseover",this.__headerMouseOverHandler.bind(this));
	        this.util.addEvent(bodyCell,"mouseout",this.__headerMouseOutHandler.bind(this));
	        this.util.addEvent(bodyCell,"mousedown",this.__headerMouseDownHandler.bind(this));
	        
	        var divCell = this.util.createDiv(colID + "container","nsDataGridHeaderCellContainer"); 
	        bodyCell.appendChild(divCell);
	        if(colItem["draggable"])
			{
	        	var objSVG = new NSSvg();
				this.util.addStyleClass(bodyCell , this.__CLASS_TABLE_HEADER_DROPPABLE_CELL);
				var divMove = this.util.createDiv(colID + "move","nsHeaderMove");
				if(this.__getColumnCustomIcon(colItem,"columnMove"))
				{
					divMove.innerHTML = this.__getColumnCustomIcon(colItem,"columnMove");
				}
				else
				{
					var iconID = new NSSvgShapes().__MOVE_ICON_ID;
					var svg = objSVG.addSVG(divMove,divMove.id + iconID + "svg","nsMoveIcon",null,null,null,null,null,null,false);
					objSVG.addUse(svg,divMove.id + "use",null,"#" + iconID);
				}
				divCell.appendChild(divMove);
			}
			var divText = this.util.createDiv(colID + "text");
			divCell.appendChild(divText);
			this.__addHeaderRenderer(divText,colItem,index);
			if(colItem.hasOwnProperty("sortable") && colItem["sortable"])
			{
				var divSorting = this.util.createDiv(colID + "SortContainer","nsGridSortContainer");
				divCell.appendChild(divSorting);
				if(!this.__isSortingIconCustom(colItem))
				{
					var divSortAsc = this.util.createDiv(colID + "SortAsc","nsSortAsc"); 
					divSorting.appendChild(divSortAsc);
					var divSortSpacer = this.util.createDiv(colID + "SortSpacer","nsSortSpacer"); 
					divSorting.appendChild(divSortSpacer);
					var divSortDesc = this.util.createDiv(colID + "SortDesc","nsSortDesc"); 
					divSorting.appendChild(divSortDesc);
				}
			}
			if(colItem["showMenu"])
			{
				var objSVG = new NSSvg();
				var arrMenu = this.__getHeaderMenuDataProvider(bodyCell);
				if(arrMenu && arrMenu.length > 0)
				{
					var divMenuContainer = this.util.createDiv(colID + "MenuContainer");
					if(this.__getColumnCustomIcon(colItem,"menu"))
					{
						divMenuContainer.innerHTML = this.__getColumnCustomIcon(colItem,"menu");
					}
					else
					{
						var svg = objSVG.addSVG(divMenuContainer,colID + "menusvg","nsMenuArrowSVG",null,null,null,null,null,null,true);
						objSVG.addUse(svg,colID + "use","nsMenuUse","#svgCircleDownArrow");
					}
					divCell.appendChild(divMenuContainer);
					var menuSetting = {parent:divMenuContainer,isContextMenu:false,createRunTime:false,dataSource:arrMenu,targetType:"TD"
									,defaultHandler:this.__headerMenuHandler.bind(this),eventHandler:this.__headerMenuClickHandler.bind(this)
									,position:this.util.POS_BOTTOMRIGHT};
					//place the menu for 2nd last and last column to bottom right
					if(index === this.__columns.length - 1 || index === this.__columns.length - 2)
					{
						menuSetting.position = this.util.POS_BOTTOMLEFT;
					}
					var headerMenu = new NSMenu(menuSetting);
				}
			}
			this.__nsGridColumnResize.addResizeIndicator(bodyRow,bodyCell,divCell,colItem,colID);
			var rendererCell = rendererRow.insertCell(-1);
			this.util.addStyleClass(rendererCell,"nsGridCell");
			this.util.addStyleClass(rendererCell,"nsDataGridHeaderRenderer");
			this.util.addStyleClass(rendererCell,"nsDataGridHeaderRendererTheme");
			this.__addStyleForFixedCell(rendererCell,index);
			this.__applyCustomClass(rendererCell,"filterCell");
			this.__nsGridFilter.addFilterRenderer(rendererRow,rendererCell,colItem,index,colID);
			this.__addPriorityClassInCell(bodyCell,colItem);
			this.__addPriorityClassInCell(rendererCell,colItem);
		}
	};
	
	NSGrid.prototype.__addHeaderRenderer = function(div,colItem,colIndex)
	{
		if(colItem)
		{
			var templateRenderer = colItem["headerTemplate"];
			var itemRenderer = colItem["headerRenderer"];
			if(itemRenderer)
			{
				var objRenderer = itemRenderer(colItem,colIndex);
				var callback = function(objRenderer)
				{
					if(objRenderer)
					{
						if(this.util.isString(objRenderer))
						{
							var compSpan = document.createElement("span");
							compSpan.innerHTML = objRenderer;
							div.appendChild(compSpan);
						}
						else
						{
							div.appendChild(objRenderer);
						}
					}
				};
				this.util.resolveFunctionOrPromise(objRenderer,callback.bind(this));
			}
			else if(templateRenderer)
			{
				div.appendChild(templateRenderer.cloneNode(true));
			}
			else
			{
				this.util.addStyleClass(div,"nsHeaderText");
				this.util.addStyleClass(div,"nsHeaderTextTheme");
				var headerText = " ";
				if(colItem.hasOwnProperty("headerText") && colItem["headerText"])
		        {
		        	headerText = colItem["headerText"];
		        }
				var headerTextNode = document.createTextNode(headerText);
				div.appendChild(headerTextNode);
			}
			if(colItem["headerTruncateToFit"])
			{
				this.util.addStyleClass(div,"nsTruncateToFit");
				if(this.__enableToolTipForTruncateText)
				{
					this.__nsToolTipInElement.addToolTip(div,div.textContent);
				}
				else
				{
					div.setAttribute("title",div.textContent);
				}
			}
		}
	};
	
	NSGrid.prototype.__setHeaderSortFunction = function()
	{
		if(this.__arrWrapper && this.__arrWrapper.length > 0)
	    {
			if(this.__columns && this.__columns.length > 0)
			{
				var dataSource = this.__getAllItems();
		        for(var colIndex = 0; colIndex < this.__columns.length; colIndex++)
		        {
		        	var colItem = this.__columns[colIndex];
		        	this.__setHeaderSortFunctionForItem(colItem,dataSource);
		        }
			}
	    } 
	};
	
	NSGrid.prototype.__setHeaderSortFunctionForItem = function(colItem,dataSource)
	{
		if(colItem)
		{
			if(colItem.hasOwnProperty("sortField") && colItem["sortField"] && colItem.hasOwnProperty("sortable") && colItem["sortable"] === true)
	    	{
				//In case of addColumn() dataSource will be null 
				if(!dataSource)
				{
					dataSource = this.__getAllItems();
				}
	    		var item = null;
	    		for(var count = 0; count < dataSource.length; count++)
	            {
	                 item = dataSource[count][colItem["sortField"]];
	                 if(!this.util.isUndefined(item) && item != null && item != "")
	                 {
	                	 break;
	                 }
	            }
	    		if(!this.util.isUndefined(item) && item != null && item != "")
	            {
	            	colItem.sortFunction = this.__nsGridSort.determineSortFunction(item,colItem);
	            }
	            else
	            {
	            	colItem.sortFunction = "__sortCaseInsensitive";
	            }
	    	}
		}
	};
	
	NSGrid.prototype.__removeHeaderCell = function(colIndex)
	{
		if(colIndex > -1 && colIndex < this.__columns.length)
		{
			var headerRow = this.__getHeaderHeaderRow(this.__tblCenterHeader);
			if(headerRow)
			{
				headerRow.deleteCell(colIndex);
				var headerBodyRow = this.__getHeaderBodyRow(this.__tblCenterHeader);
				var rendererRow = this.__getHeaderFilterRow(this.__tblCenterHeader);
				headerBodyRow ? headerBodyRow.deleteCell(colIndex) : null;
				rendererRow ? rendererRow.deleteCell(colIndex) : null;
			}
			return true;
		}
		return false;
	};
	
	NSGrid.prototype.__swapOrMoveHeaderCell = function(functionality,sourceIndex,destinationIndex)
	{
		if(this.__isColumnIndexValid(sourceIndex) && this.__isColumnIndexValid(destinationIndex))
		{
			var headerRow = this.__getHeaderHeaderRow(this.__tblCenterHeader);
			if(headerRow)
			{
				var arrRows = this.__getBodyBodyRow(this.__tblCenterHeader);
	    		if(arrRows && arrRows.length > 0)
	    		{
					var arrHeaderCells = headerRow.cells;
					this.__swapCell(arrHeaderCells[sourceIndex],arrHeaderCells[destinationIndex]);
					for (var rowIndex = 0; rowIndex < arrRows.length; rowIndex++)
				    {
						var arrCells = arrRows[rowIndex].cells;
						if(rowIndex === 0)
						{
							arrCells[sourceIndex].setAttribute("currentColumnIndex",destinationIndex);
							arrCells[destinationIndex].setAttribute("currentColumnIndex",sourceIndex);
						}
						if(functionality === "swap")
						{
							this.__swapCell(arrCells[sourceIndex],arrCells[destinationIndex]);
						}
						else 
						{
							this.__moveCell(arrCells[sourceIndex],destinationIndex);
							if(rowIndex === 0)
							{
								var smallIndex = Math.min(sourceIndex,destinationIndex);
								for(var count = smallIndex;count < arrCells.length;count++)
								{
									arrCells[count].setAttribute("currentColumnIndex",count);
								}
							}
						}
				    }
				}
				return true;
			}
		}
		return false;
	};
	
	NSGrid.prototype.__removeHeader = function()
	{
		if(this.__tblCenterHeader && this.__tblCenterHeader.tHead)
		{
			this.__tblCenterHeader.deleteTHead();
		}
		if(this.__tblCenterHeader.tBodies && this.__tblCenterHeader.tBodies.length > 0)
	    {
	    	this.__tblCenterHeader.removeChild(this.__tblCenterHeader.tBodies[0]);
	    }
	};
	/******************************End of Header Creation *************************************/
	/******************************Footer Creation **********************************************/
	NSGrid.prototype.__createFooter = function()
	{
		if(this.__enableFooter)
		{
			this.__divCenterTableFooterContainer = this.__createFooterContainer(this.__divTableFooterContainerWrapper,this.__divCenterTableFooterContainer,this.getID() + this.__TABLE_CENTER_FOOTER_CONTAINER_ID,this.getID() + this.__TABLE_CENTER_FOOTER_ID);
			this.__tblCenterFooter = this.__divCenterTableFooterContainer.firstChild;
			var divFooterCorner = this.util.createDiv(null,"nsFooterBarCorner");
			this.__divCenterTableFooterContainer.appendChild(divFooterCorner);
		}
	};
	
	NSGrid.prototype.__createFooterContainer= function(tableContainer,footerContainer,containerID,tableID)
	{
		if(footerContainer)
		{
			footerContainer.parentNode.removeChild(footerContainer);
		}
		footerContainer = this.__createTableAndParent(containerID,"nsDataGridFooterContainer",tableID);
		tableContainer.appendChild(footerContainer);
		return footerContainer;
	};
	
	NSGrid.prototype.__createFooterRows = function()
	{
		if(this.__enableFooter && this.__tblCenterFooter && this.__columns && this.__columns.length > 0)
		{
			this.util.removeAllChildren(this.__tblCenterFooter);
			var footer = this.__tblCenterFooter.createTHead();
			var footerRow = footer.insertRow(-1);
		    footerRow.style.height = "auto";
		    this.__tblCenterFooterBody = document.createElement("tbody");
			this.__tblCenterFooter.appendChild(this.__tblCenterFooterBody);
		    var bodyRow = this.__tblCenterFooterBody.insertRow(-1);
		    this.util.addStyleClass(bodyRow,"nsGridFooterRow");
			this.__applyCustomClass(bodyRow,"footerRow");
		    for (var colIndex = 0; colIndex < this.__columns.length; colIndex++)
		    {
		    	var colItem = this.__columns[colIndex];
		    	this.__createFooterColGroup(colItem);
		        this.__createFooterHeaderCell(colItem,footerRow);
		        this.__createFooterBodyCell(colItem,bodyRow,0,colIndex);
		    }
		    this.__createFixedFooterRow(footerRow);
		    var arrRows = this.__tblCenterFooterBody.rows;
		    for (var rowIndex = 0; rowIndex < arrRows.length; rowIndex++)
		    {
		    	 this.__createFixedFooterRow(arrRows[rowIndex]);
		    }
		    if(this.__enableCustomScrollBar && this.__scroller)
			{
		    	this.__divTableFooterContainerWrapper.style.height = null;
				this.__divTableFooterContainerWrapper.style.height = (2 * this.__divTableFooterContainerWrapper.offsetHeight) + "px";
			}
		}
	};
	
	NSGrid.prototype.__createFooterColGroup = function(colItem)
	{
		if(colItem)
		{
			var colgroup = document.createElement("colgroup");
			colgroup.setAttribute("id",this.getID() + "FooterColGroup" + colItem.dataField);
			this.util.addStyleClass(colgroup,"nsGridColGroup");
			this.util.addStyleClass(colgroup,"nsGridColGroupFooter");
			this.__tblCenterFooter.appendChild(colgroup);
		}
	};
	
	NSGrid.prototype.__createFooterHeaderCell = function(colItem,headerRow)
	{
		if(colItem && headerRow)
		{
			var footerCell = headerRow.insertCell(-1);
			this.util.addStyleClass(footerCell,"nsGridCell");
			footerCell.style.padding = "0px"; 
			footerCell.style.width = colItem["width"]; 
			this.__addPriorityClassInCell(footerCell,colItem);
		}
	};
	
	NSGrid.prototype.__createFooterBodyCell = function(colItem,bodyRow,rowIndex,colIndex)
	{
		if(colItem && bodyRow)
		{
			var bodyCell = bodyRow.insertCell(-1);
			var colID = this.getID() + "ColFooter" + colItem["dataField"];
			bodyCell.setAttribute("id",colID);
			this.util.addStyleClass(bodyCell , "nsGridCell");
			this.util.addStyleClass(bodyCell , "nsDataGridFooter");
			this.util.addStyleClass(bodyCell , "nsDataGridFooterTheme");
			this.__addStyleForFixedCell(bodyCell,colIndex);
			this.__applyCustomClass(bodyCell,"footerCell");
			bodyCell.setAttribute("orignalColumnIndex",colIndex);
		    bodyCell.setAttribute("currentColumnIndex",colIndex);
		    
	        /*this.util.addEvent(bodyCell,"click",this.__headerClickHandler.bind(this));
	        this.util.addEvent(bodyCell,"mouseover",this.__headerMouseOverHandler.bind(this));
	        this.util.addEvent(bodyCell,"mouseout",this.__headerMouseOutHandler.bind(this));
	        this.util.addEvent(bodyCell,"mousedown",this.__headerMouseDownHandler.bind(this));*/
	        
	        var divCell = this.util.createDiv(colID + "container","nsDataGridFooterCellContainer"); 
	        bodyCell.appendChild(divCell);
			var divText = this.util.createDiv(colID + "text");
			divCell.appendChild(divText);
			var itemRenderer = colItem["footerRenderer"];
			if(itemRenderer)
			{
				var objRenderer = itemRenderer(colItem["dataField"],colItem,this.__arrFilteredGroupedSource,rowIndex,colIndex,bodyCell,bodyRow);
				var callback = function(objRenderer)
				{
					if(objRenderer)
					{
						if(this.util.isString(objRenderer))
						{
							var compSpan = document.createElement("span");
							compSpan.innerHTML = objRenderer;
							divText.appendChild(compSpan);
						}
						else
						{
							divText.appendChild(objRenderer);
						}
					}
				};
				this.util.resolveFunctionOrPromise(objRenderer,callback.bind(this));
			}
			this.__addPriorityClassInCell(bodyCell,colItem);
		}
	};
	
	NSGrid.prototype.__removeFooterColumn= function(colIndex)
	{
		if(colIndex > -1 && colIndex < this.__columns.length)
		{
			var bodyRow = this.__getBodyHeaderRow(this.__tblCenterFooter);
			if(bodyRow)
		    {
				var arrRows = this.__getBodyBodyRow(this.__tblCenterFooter);
		    	if(arrRows && arrRows.length > 0)
				{
		    		bodyRow.deleteCell(colIndex);
		    		var row = null;
		    		for (var rowCount = 0; rowCount < arrRows.length; rowCount++) 
		    		{
		    			row = arrRows[rowCount];
		    			row.deleteCell(colIndex);
		    	    }
				}
		    }
		}
	};
	
	NSGrid.prototype.__swapOrMoveFooterCell = function(functionality,sourceIndex,destinationIndex)
	{
		if(this.__isColumnIndexValid(sourceIndex) && this.__isColumnIndexValid(destinationIndex))
		{
			var bodyRow = this.__getBodyHeaderRow(this.__tblCenterFooter);
			if(bodyRow)
			{
				var arrRows = this.__getBodyBodyRow(this.__tblCenterFooter);
				if(arrRows && arrRows.length > 0)
				{
					var arrHeaderCells = bodyRow.cells;
					if(functionality === "swap")
					{
						this.__swapCell(arrHeaderCells[sourceIndex],arrHeaderCells[destinationIndex]);
					}
					else
					{
						this.__moveCell(arrHeaderCells[sourceIndex],destinationIndex);
					}
		    		var row = null;
		    		var arrBodyCells = [];
		    		for (var rowCount = 0; rowCount < arrRows.length; rowCount++) 
		    		{
		    			row = arrRows[rowCount];
		    			arrBodyCells = row.cells;
		    			if(functionality === "swap")
						{
		    				this.__swapCell(arrBodyCells[sourceIndex],arrBodyCells[destinationIndex]);
						}
		    			else
						{
							this.__moveCell(arrBodyCells[sourceIndex],destinationIndex);
						}
		    	    }
				}
				return true;
			}
		}
		return false;
	};
	
	/******************************End of Footer Creation *************************************/
	/******************************Body Creation **********************************************/
	NSGrid.prototype.__createBody = function()
	{	
		this.__divCenterTableBodyContainer = this.__createTableAndParent(this.getID() + this.__TABLE_CENTER_BODY_CONTAINER_ID,this.__CLASS_BODY_CONTAINER,this.getID() + this.__TABLE_CENTER_BODY_ID);
		if(this.__enableFooter)
		{
			this.util.addStyleClass(this.__divCenterTableBodyContainer,"nsDataGridBodyContainerWithFooter");
		}
		this.__divTableBodyContainerWrapper.appendChild(this.__divCenterTableBodyContainer);
		this.__tblCenterBody = this.__divCenterTableBodyContainer.firstChild;
		var header = this.__tblCenterBody.createTHead();
	    this.__tblCenterBodyBody =  document.createElement("tbody");
		this.__tblCenterBody.appendChild(this.__tblCenterBodyBody);
		if(!this.__enableVirtualScroll && this.__enablePagination && this.__isPaginationTypeScroll)
		{
			this.__bodyScrollRef = this.__bodyScrollHandler.bind(this);
			this.util.addEvent(this.__getVerticalScrollableContainer(),"scroll",this.__bodyScrollRef);
		}
		this.__objGrid.__createBody();
	};
	
	NSGrid.prototype.__renderBody = function(fromSort,fromFilter)
	{
		var isReset = fromSort || fromFilter;
		var self = this;
		if(this.__processArrayAsync)
	    {
			this.__processArrayAsync.stop();
	    }
		var resetTable = function(tblData)
		{
			if(tblData)
			{
				tblData.deleteTHead();
			    if(tblData.tBodies && tblData.tBodies.length > 0)
			    {
			    	tblData.removeChild(tblData.tBodies[0]);
			    }
			}
			self.__navigationIndex = -1;
		};
		var createBody = function()
		{
			return document.createElement("tbody");
		};
		var addBodyInTable = function(tblData,tblBody)
		{
			if(tblData && tblBody)
			{
				tblData.appendChild(tblBody);
			}
		};
		//for some reason the body is to be destroyed so that row we store in items is not stale
		// need to fix this
		if(!this.__enableVirtualScroll)
		{
			resetTable(this.__tblCenterBody);
			this.__tblCenterBodyBody = createBody();
			if(this.__divCenterTableBodyContainer)
			{
				this.__divCenterTableBodyContainer.scrollTop = 0;
			}
		    this.__lastScrollPos = [0,0];
		}
		if(this.__enableContextMenu)
		{
			this.__initializeContextMenu();
		}
		this.__createBodyHeader();
		this.__createHeaderExtraRows();
		this.__createFixedHeaderRows();
		this.__createFooterRows();
		if(this.__enableVirtualScroll)
		{
			this.__setNSVirtualScroll(this.__arrInternalSource);
		}
		else if(this.__enablePagination && this.__isPaginationTypeScroll)
		{
			addBodyInTable(this.__tblCenterBody,this.__tblCenterBodyBody);
			var source = this.__arrInternalSource.slice(0);
			var resetInternalSource = false;
			if(this.__isPaginationModeAuto || this.__rowsRendered)
			{
				this.__arrInternalSource = source.slice(0,this.__INFINITE_SCROLL_INITIAL_LOAD);
				resetInternalSource = true;
			}
			this.__createBodyBody(this.__arrInternalSource,0,this.__arrInternalSource.length);
			if(resetInternalSource) {
				this.__arrInternalSource = source.slice(0);
			}
			if((this.__isPaginationModeAuto || this.__rowsRendered) && this.__enableAsyncLoadPagination && this.__totalRecords > this.__getTotalRows()) 
			{
				this.__arrInternalSource = source.slice(0);//this.__objGrid.__setSourceForAsync();
				this.__processArrayAsync = new this.util.processArrayAsync(this.__arrInternalSource,this.__createRowAsync,20,this.__asyncSourceCompleteHandler,this);
				this.__processArrayAsync.start(this.__getTotalRows());
			}
		}
		else if(this.__enablePagination && !this.__isPaginationTypeScroll && this.__isPaginationModeAuto)
		{
			this.__createBodyBody(this.__arrInternalSource,0,this.__pageSize);
			addBodyInTable(this.__tblCenterBody,this.__tblCenterBodyBody);
		}
		else 
		{
			this.__createBodyBody(this.__arrInternalSource,0,this.__arrInternalSource.length);
			addBodyInTable(this.__tblCenterBody,this.__tblCenterBodyBody);
		}
		if(!fromSort)
		{
			if(this.__enablePagination && !this.__isPaginationTypeScroll)
			{
				this.__createPaginationControl(this.__divOuterContainer);
			}
			this.__setBodyMeasurement();
		}
		if(this.__enablePagination && !this.__isPaginationTypeScroll && this.__isPaginationModeAuto)
		{
			if(this.__arrInternalSource && this.__arrInternalSource.length > 0)
			{
				this.__divPagination ? this.__divPagination.style.display = "" : null;
			}
			else
			{
				this.__divPagination ? this.__divPagination.style.display = "none" : null;
			}
		}
		this.__alignTables(isReset);
		//this.__setFixedCellsPosition();
		if(this.__enableRowMove)
		{
			var setting = {table:this.__tblCenterBody,isSameTableMove:this.__isSameTableMove,dragEndHandler:this.__rowMoverDropEndHandler};
			var rowMover = new NSTableRowMover(setting);
		}
		var self = this;
		if(this.__enableCellSelection)
		{
			if(this.__nsTableCellNavigator)
			{
				this.__nsTableCellNavigator.destroy();
				if(this.__tableCellNavigatorEventRef)
				{
					this.util.removeEvent(self.__tblCenterBody,NSTableCellNavigator.CELL_SELECTED,this.__tableCellNavigatorEventRef);
					this.util.removeEvent(self.__tblCenterBody,NSTableCellNavigator.CELL_UNSELECTED,this.__tableCellNavigatorEventRef);
					this.util.removeEvent(self.__tblCenterBody,NSTableCellNavigator.CELL_SELECTABLE,this.__tableCellNavigatorEventRef);
					this.__tableCellNavigatorEventRef = null;
				}
				this.__nsTableCellNavigator = null;
			}
			var keyNavigationValid = function(event,cell)
			{
				return self.__nsGridEditor.isOtherKeyNavigationValid(event,cell);
			};
			this.__nsTableCellNavigator = new NSTableCellNavigator(self.__tblCenterBody,{keyNavigationValid:keyNavigationValid});
			this.__tableCellNavigatorEventRef = this.__tableCellNavigatorEventHandler.bind(this);
			this.util.addEvent(self.__tblCenterBody,NSTableCellNavigator.CELL_SELECTED,this.__tableCellNavigatorEventRef);
			this.util.addEvent(self.__tblCenterBody,NSTableCellNavigator.CELL_UNSELECTED,this.__tableCellNavigatorEventRef);
			this.util.addEvent(self.__tblCenterBody,NSTableCellNavigator.CELL_SELECTABLE,this.__tableCellNavigatorEventRef);
		}
		if(this.__enableMultiCellSelection)
		{
			if(this.__nsCellSelection)
			{
				this.__nsCellSelection.destroy();
				if(this.__tableCellSelectionEventRef)
				{
					this.util.removeEvent(self.__tblCenterBody,NSCellSelection.SELECTION_START,this.__tableCellSelectionEventRef);
					this.util.removeEvent(self.__tblCenterBody,NSCellSelection.SELECTION_END,this.__tableCellSelectionEventRef);
					this.util.removeEvent(self.__tblCenterBody,NSCellSelection.SET_CELL_VALUE,this.__tableCellSelectionEventRef);
					this.__tableCellSelectionEventRef = null;
				}
				this.__nsCellSelection = null;
			}
			var editors = [];
			for (var colIndex = 0; colIndex < this.__columns.length; colIndex++)
		    {
				var colItem = this.__columns[colIndex];
				if(colItem["multiSelectionEditor"])
				{
					editors.push({type:NSCellSelection.EDITORS[colItem["multiSelectionEditor"]]});
				}
				else
				{
					editors.push({type:NSCellSelection.EDITORS[NSGrid.MULTI_SELECTION_EDITORS_TEXT]});
				}
		    }
			var setting = this.__multiCellSelectionSetting; 
			setting.editors = editors;
			this.__nsCellSelection = new NSCellSelection(self.__tblCenterBody,setting);
			this.__tableCellSelectionEventRef = this.__tableCellSelectionEventHandler.bind(this);
			this.util.addEvent(self.__tblCenterBody,NSCellSelection.SELECTION_START,this.__tableCellSelectionEventRef);
			this.util.addEvent(self.__tblCenterBody,NSCellSelection.SELECTION_END,this.__tableCellSelectionEventRef);
			this.util.addEvent(self.__tblCenterBody,NSCellSelection.SET_CELL_VALUE,this.__tableCellSelectionEventRef);
		}
		this.__addMediaQueries();
		this.__addStyleForFixedColumns();
		//this.__updateFixedColumnsForAllTables();
	};
	
	NSGrid.prototype.__setNSVirtualScroll = function(source)
	{
		var length = 0;
		if(source && source.length)
		{
			for(var count = 0;count < source.length;count++)
			{
				if(source[count][this.__fieldRowVisible])
				{
					length++;
				}
			}
		}
		if(this.__nsVirtualScroll)
		{
			this.__nsVirtualScroll.dataSource(length);
		}
		else
		{
			if(length > 0)
			{
				var self = this;
				var pageChangedHandler = function(page) {
					//self.__updateStickyColumns(self.__tblCenterBody);
				}
				var setting = {scrollElement: this.__divCenterTableBodyContainer,contentElement: this.__tblCenterBodyBody,itemTag: "tr",totalLength: length,getItemComponent:this.__getRowComponentForVirtual.call(this),
								getEmptyItemComponent:this.__getEmptyRowComponentForVirtual.call(this),pageChanged: pageChangedHandler};
				var virtualScrollSetting = this.__virtualScrollSetting;
				var arrCopyFields = ["pageSize","pagesRendered","enableScrollDelay","scrollInterval","resizeInterval","enableLoader","getLoaderComponent"];
				var field = null;
				for(var count = 0;count < arrCopyFields.length;count++)
				{
					field = arrCopyFields[count];
					if(!this.util.isUndefinedOrNull(virtualScrollSetting[field]))
					{
						setting[field] = virtualScrollSetting[field];
					}
				}
				this.__nsVirtualScroll = new NSVirtualScroll(setting);
			}
			else if(this.__tblCenterBodyBody)
			{
				this.__tblCenterBodyBody.innerHTML = "";
				this.__tblCenterBodyBody.appendChild(this.__createNoDataRow());
			}
		}
	};
	
	NSGrid.prototype.__getRowComponentForVirtual = function()
	{
		var grid = this;
		var CreateRow = function(index)
		{
			this.__index = index;
			this.__grid =  grid;
			this.__item = null;
			this.__row = null;
		};
		CreateRow.prototype.getElement = function()
		{
			if(!this.__row)
			{
				if(this.__grid.__type == this.__grid.GRID_TYPE_NORMAL)
				{
					this.__item = this.__grid.__arrInternalSource[this.__index];
				}
				else
				{
					this.__item = this.__grid.__getVisibleItemByIndex(null,this.__index);
				}
				this.__row = this.__grid.__createBodyRow(this.__item,false);
			}
			return this.__row;
		};
		return CreateRow;
	};
	
	NSGrid.prototype.__getEmptyRowComponentForVirtual = function()
	{
		var grid = this;
		var CreateEmptyRow = function()
		{
			this.__grid = grid;
			this.__row = null;
		};
		CreateEmptyRow.prototype.getElement = function()
		{
			if(!this.__row)
			{
				this.__row = this.__grid.__createNoDataRow.call(this.__grid);
			}
			return this.__row;
		};
		return CreateEmptyRow;
	};
	
	NSGrid.prototype.__createCustomScroller = function()
	{
		if(this.__enableCustomScrollBar && !this.__scroller)
		{
			var setting = {verticalElement:this.__getVerticalScrollableContainer(),horizontalElement:this.__getHorizontalScrollableContainer(),enableCustomHandler: true,verticalScrollButtons:this.__customScrollBarSetting.verticalScrollButtons,horizontalScrollButtons:this.__customScrollBarSetting.horizontalScrollButtons,enableMoveOnClick: true};
			for (var key in setting) 
			{ 
				this.__scrollerSetting[key] = setting[key]; 
			}
			this.__scroller = new NSScroller(this.__scrollerSetting);
			var customScrollHandler = this.__customScrollHandler.bind(this);
			this.util.addEvent(this.__scrollerSetting.verticalElement,NSScroller.SCROLLING,customScrollHandler);
			if(this.__scrollerSetting.verticalElement != this.__scrollerSetting.horizontalElement)
			{
				this.util.addEvent(this.__scrollerSetting.horizontalElement,NSScroller.SCROLLING,customScrollHandler);
			}
		}
	};
	
	NSGrid.prototype.__customScrollHandler = function(event)
	{
		var self = this;
		var virtualVerHandler = function()
		{
			//self.__setVirtualScroll.bind(self)(scrollPos,event);
		};
		var dataRefreshVerHandler = function()
		{
			
		};
		var asyncLoadVerHandler = function()
		{
			
		};
		var paginationVerHandler = function()
		{
			
		};
		var normalVerHandler = function()
		{
			self.__getVerticalScrollableContainer().scrollTop = scrollPos;
		};
		var normalHorHandler = function()
		{
			self.__getHorizontalScrollableContainer().scrollLeft = scrollPos;
		};
		var objCondition = {virtualScroll:{eligible:this.__enableVirtualScroll,verHandler:virtualVerHandler,horHandler:normalHorHandler},
							dataRefreshOnEnd:{eligible:this.__enableDataRefreshOnScrollEnd,verHandler:dataRefreshVerHandler,horHandler:normalHorHandler},
							asyncLoad:{eligible:this.__enableAsyncLoadPagination,verHandler:asyncLoadVerHandler,horHandler:normalHorHandler},
							pagination:{eligible:(this.__enablePagination && this.__isPaginationTypeScroll),verHandler:paginationVerHandler,horHandler:normalHorHandler},
							normal:{eligible:true,verHandler:normalVerHandler,horHandler:normalHorHandler}
						   };
		var eventItem = event;
		var direction = eventItem.direction;
		var scrollPos = eventItem.scrollPos;
		var oldScrollPos = eventItem.oldScrollPos;
		for(var key in objCondition)
		{
			var item = objCondition[key];
			if(item.eligible)
			{
				if(direction == "vertical")
				{
					if(item.verHandler)
					{
						item.verHandler();
					}
				}
				else
				{
					if(item.horHandler)
					{
						item.horHandler();
					}
				}
				break;
			}
		}
	};
	
	NSGrid.prototype.__createScrollTip = function() 
	{
		if(this.__enableScrollBarTip && !this.__divScrollTipContainer)
		{
			this.__divScrollTipContainer = this.util.createDiv(this.getID() + "ScrollTipContainer","nsGridScrollTipContainer");
			this.__divScrollTipText = this.util.createDiv(this.getID() + "ScrollTipText","nsGridScrollTipText");
			this.__divScrollTipContainer.appendChild(this.__divScrollTipText);
			var divTri = this.util.createDiv(this.getID() + "ScrollTipTriangle","nsGridScrollTipTriangle");
			this.__divScrollTipContainer.appendChild(divTri);
			this.addChild(this.__divScrollTipContainer);
		}
	};
	
	NSGrid.prototype.__createRowAsync= function(item,index,array)
	{
		this.__objGrid.__createRowAsync(item,index,array);
		console.log(index + " rendererd");
	};
	
	NSGrid.prototype.__asyncSourceCompleteHandler= function()
	{
		console.log("CompleteHandler");
	};
	
	NSGrid.prototype.__createBodyHeader= function()
	{
		if(this.__tblCenterBody)
		{
			//for some reason this method is called multiple times on load so checking if colgroup is already created or not
			var isColGroupCreated = false;
			if(this.__columns && this.__columns.length > 0 && document.getElementById(this.getID() + "BodyColGroup" + this.__columns[0].dataField))
			{
				isColGroupCreated = true;
			}
			//In case of Virtual scroll thead will be present
			var header = this.__tblCenterBody.querySelector("thead");
			if(!header)
			{
				header = this.__tblCenterBody.createTHead();
			}
			var headerRow = header.insertRow(-1);
		    headerRow.style.height = "auto";
		    for (var colIndex = 0; colIndex < this.__columns.length; colIndex++)
		    {
		        var colItem = this.__columns[colIndex];
		        if(!isColGroupCreated)
		        {
		        	this.__createBodyColGroup(colItem);
		        }
		        this.__createBodyHeaderCell(colItem,headerRow);
		    }
		}
	};
	
	NSGrid.prototype.__createBodyColGroup = function(colItem)
	{
		if(colItem)
		{
			var colgroup = document.createElement("colgroup");
			colgroup.setAttribute("id",this.getID() + "BodyColGroup" + colItem.dataField);
			this.util.addStyleClass(colgroup,"nsGridColGroup");
			this.util.addStyleClass(colgroup,"nsGridColGroupBody");
			this.__tblCenterBody.appendChild(colgroup);
		}
	};
	
	NSGrid.prototype.__createBodyHeaderCell= function(colItem,headerRow)
	{
		if(colItem && headerRow)
		{
			var headerCell = headerRow.insertCell(-1);
			this.util.addStyleClass(headerCell,"nsGridCell");
			headerCell.style.width = (colItem["width"]);
		    headerCell.style.height = "0px";
		    headerCell.style.padding = "0px";
		    this.__addPriorityClassInCell(headerCell,colItem);
		}
	};
	
	NSGrid.prototype.__resetDataInBody= function(fromIndex,toIndex,fromRowIndex,useVisibleIndex)
	{
		this.__objGrid.__resetDataInBody(fromIndex,toIndex,fromRowIndex,useVisibleIndex);
	};
	
	NSGrid.prototype.__createBodyBody= function(dataSet,startIndex,endIndex,callAsync)
	{
		this.__stopScroll = true;
	    if(dataSet && dataSet.length > 0)
	    {
	    	this.__objGrid.__createBodyBody(dataSet,startIndex,endIndex);
	    }
	    else
	    {
	    	this.__tblCenterBodyBody.appendChild(this.__createNoDataRow());
	    }
	    this.__stopScroll = false;
	    if(callAsync && this.__processArrayAsync)
	    {
	    	this.__processArrayAsync.start(this.__getTotalRows());
	    }
	};
	
	NSGrid.prototype.__setBodyRowProperty = function(row,item,rowIndex)
	{
		if(row && item)
		{
			if(!this.__enableVariableRowHeight)
			{
				if(this.__rowHeight > 0)
				{
					row.style.height = this.__rowHeight + "px";
				}
				else if(this.__virtualRowHeight > 0)
				{
					row.style.height = this.__virtualRowHeight + "px";
				}
				else
				{
					row.style.height = "auto";
				}
			}
			if(!this.__enableColumnMouseHover)
			{
			    var className = ((rowIndex % 2) === 0) ? this.__CLASS_EVEN_ROW : this.__CLASS_ODD_ROW;
			    this.util.addStyleClass(row,"nsGridRow " + className);
			}
		    if(this.__enableMouseHover)
		    {
		    	this.util.addEvent(row,"mouseover",this.__rowMouseHover.bind(this));
			    this.util.addEvent(row,"mouseout",this.__rowMouseOut.bind(this));
		    }
		    this.util.addEvent(row,"click",this.__rowClickHandler.bind(this));
		    this.util.addEvent(row,"dblclick",this.__rowDblClickHandler.bind(this));
		}
	};
	
	NSGrid.prototype.__createBodyRow = function(item,isAdd)
	{
		return this.__objGrid.__createRow(item,null,isAdd);
	};
	
	NSGrid.prototype.__createBodyRowAt = function(item,index)
	{
		if(item && index > -1)
	    {
			return this.__objGrid.__createRow(item,index);
	    }
		return null;
	};
	
	NSGrid.prototype.__createBodyRowCell= function(row,colIndex,createDiv)
	{
		var cell =  row.insertCell(-1);
    	this.util.addStyleClass(cell,"nsGridCell");
    	this.util.addStyleClass(cell , "nsBodyDataGridCell");
    	this.util.addStyleClass(cell , "nsBodyDataGridCellTheme");
    	this.__addStyleForFixedCell(cell,colIndex);
    	this.__applyCustomClass(cell,"bodyCell");
    	if(colIndex === 0)
    	{
    		this.__applyCustomClass(cell,"firstBodyColumn");
    	}
    	else
    	{
    		this.__applyCustomClass(cell,"nonFirstBodyColumn");
    	}
		if(createDiv)
		{
			var cellDiv = this.util.createDiv(null);
		    cell.appendChild(cellDiv);
		}
	    return cell;
	};
	
	NSGrid.prototype.__setBodyCellProperties= function(cell)
	{
		if(cell)
		{
			var handler = this.__bodyCellEventHandler.bind(this);
			if(this.__enableColumnMouseHover)
			{
				this.util.addEvent(cell,"mouseover",handler);
				this.util.addEvent(cell,"mouseleave",handler);
			}
			this.util.addEvent(cell,"click",handler);
			this.util.addEvent(cell,"dblclick",handler);
			//this.__setClassForFixedColumn(cell);
		}
	};
	
	NSGrid.prototype.__setBodyCellProperty = function(row,cell,item,colItem,colIndex,parentIndex,level,isReset)
	{
		var hierarchicalPadding = 0;
		if(colItem && colItem.hasOwnProperty("dataField") && colItem["dataField"])
		{
			var cellDiv = cell.firstChild;
	        if((this.__enableHierarchical || this.__enableGrouping || this.__enableMasterDetail) && colIndex == 0 && item.hasOwnProperty(this.__childField) && item[this.__childField]  && item[this.__childField].length > 0)
	        {
	        	this.util.addStyleClass(cellDiv,this.__CLASS_GROUP_CELL);
	        	var isCollapsed = false;
	        	if(!isReset && item.hasOwnProperty(this.__fieldIsCollapsed))
	 	        {
	        		isCollapsed = item[this.__fieldIsCollapsed];
	 	        }
	        	//this.__createArrow(parentIndex,cellDiv,isCollapsed);
	        	var cellText = this.util.createDiv(null,this.__CLASS_CELL_CHILD);
	        	cellText.style.verticalAlign = "top";
	        	this.__addCellText(row,item,cellText,colItem,colIndex);
	        	cellDiv.appendChild(cellText);
	        }
	        else
	        {
	        	this.util.addStyleClass(cellDiv,this.__CLASS_CELL_CHILD);
	        	this.__addCellText(row,item,cellDiv,colItem,colIndex);
	        	//24 = 16(Arrow Width) + 6(Arrow Parent Padding) + 2(cellDiv horizontalGap between elements shown in debugger)
	        	hierarchicalPadding = 24;
	        }
	        if(colIndex == 0)
	        {
	        	if(this.__enableHierarchical || this.__enableMasterDetail)
	            {
	            	if(level === 0)
	            	{
	            		cell.style.paddingLeft = "1px";
	            	}
	            	else
	            	{
	            		var paddingLeft = (10 * level) + hierarchicalPadding;
	            		cell.style.paddingLeft = paddingLeft + "px";
	            	}
	            }
	        	else if(this.__enableGrouping)
	        	{
	        		if(level === 0)
	        		{
	        			cell.style.paddingLeft = "1px";
	        		}
	        	}
	        }
		}
		this.__addPriorityClassInCell(cell,colItem);
	};
	
	NSGrid.prototype.__removeBodyColumn= function(colIndex)
	{
		if(colIndex > -1 && colIndex < this.__columns.length)
		{
			var bodyRow = this.__getBodyHeaderRow(this.__tblCenterBody);
			if(bodyRow)
		    {
				var arrRows = this.__getBodyBodyRow(this.__tblCenterBody);
		    	if(arrRows && arrRows.length > 0)
				{
		    		bodyRow.deleteCell(colIndex);
		    		var row = null;
		    		for (var rowCount = 0; rowCount < arrRows.length; rowCount++) 
		    		{
		    			row = arrRows[rowCount];
		    			row.deleteCell(colIndex);
		    	    }
				}
		    }
		}
	};
	
	NSGrid.prototype.__swapOrMoveBodyCell = function(functionality,sourceIndex,destinationIndex)
	{
		if(this.__isColumnIndexValid(sourceIndex) && this.__isColumnIndexValid(destinationIndex))
		{
			var bodyRow = this.__getBodyHeaderRow(this.__tblCenterBody);
			if(bodyRow)
			{
				var arrRows = this.__getBodyBodyRow(this.__tblCenterBody);
				if(arrRows && arrRows.length > 0)
				{
					var arrHeaderCells = bodyRow.cells;
					if(functionality === "swap")
					{
						this.__swapCell(arrHeaderCells[sourceIndex],arrHeaderCells[destinationIndex]);
					}
					else
					{
						this.__moveCell(arrHeaderCells[sourceIndex],destinationIndex);
					}
		    		var row = null;
		    		var arrBodyCells = [];
		    		for (var rowCount = 0; rowCount < arrRows.length; rowCount++) 
		    		{
		    			row = arrRows[rowCount];
		    			arrBodyCells = row.cells;
		    			if(functionality === "swap")
						{
		    				this.__swapCell(arrBodyCells[sourceIndex],arrBodyCells[destinationIndex]);
						}
		    			else
						{
							this.__moveCell(arrBodyCells[sourceIndex],destinationIndex);
						}
		    	    }
				}
				return true;
			}
		}
		return false;
	};
	
	NSGrid.prototype.__createArrow = function(item,parentRowCount,parentElement,isCollapsed,colItem)
	{
		 if(parentElement && this.__showExpandCollapseIcon)
		 {
			 var cellArrowParent = this.util.createDiv(null,"nsArrowParent");
			 var arrowID = this.getID() + "compArrow" + parentRowCount;
			 var compArrow = this.util.createDiv(arrowID,"nsArrow");
			 //compArrow.style.paddingTop = "3px";
			 compArrow.setAttribute("ns-parent-row-count",parentRowCount);
			 
			 var objSVG = new NSSvg();
			 this.__objGrid.__createArrow(compArrow,objSVG,arrowID,isCollapsed,item,colItem);
			 this.util.addEvent(compArrow,"click",this.__arrowClickHandler.bind(this));
			 cellArrowParent.appendChild(compArrow);
			 parentElement.appendChild(cellArrowParent);
			 item[this.__fieldRowArrow] = compArrow;
			 return compArrow;
		 }
		 return null;
	};
	
	NSGrid.prototype.__setArrowDirection = function(compArrow,isCollapsed)
	{
		if(compArrow)
		{
			var parent = this.util.findParent(compArrow,"TD");
			var colIndex = parseInt(parent.getAttribute("currentColumnIndex"));
			var colItem = this.__getColumnObject(colIndex);
			this.__objGrid.__setArrowDirection(compArrow,isCollapsed,colItem);
		}
	};
	
	NSGrid.prototype.__isArrowCollapsed = function(compArrow)
	{
		if(compArrow && compArrow.hasAttribute("ns-parent-row-count"))
		{
			var rowIndex = parseInt(compArrow.getAttribute("ns-parent-row-count"));
			var item = this.__getItemByIndex(rowIndex);
			if(item)
			{
				return item[this.__fieldIsCollapsed];
			}
		}
		return false;
	};
	
	NSGrid.prototype.__isRowCollapsed = function(element,rowIndex)
	{
		if(element)
		{
			element = this.util.findParent(element,"TR");
			if(element)
			{
				rowIndex = parseInt(element.getAttribute("ns-index"));
			}
		}
		if(rowIndex > -1)
		{
			var item = this.__getItemByIndex(rowIndex);
			if(item)
			{
				return item[this.__fieldIsCollapsed];
			}
		}
		return false;
	};
	
	NSGrid.prototype.__createNoDataRow = function()
	{
		var row = document.createElement("tr");
		this.util.addStyleClass(row,"nsNoRecordsFound");
		row.style.height = "auto";
		var cell = row.insertCell(-1);
		cell.setAttribute("colspan",this.__columns.length);
		var textNode = document.createTextNode(this.__noDataMessage);
		cell.appendChild(textNode);
		return row;
	};
	/******************************Fixed Column ***************************************/
	NSGrid.prototype.__createFixedRows = function()
	{
		this.__createFixedHeaderRows();
		this.__createFixedBodyRows();
		this.__createFixedFooterRows();
	};
	
	NSGrid.prototype.__createFixedHeaderRows = function()
	{
		this.__arrFixedLeftCells = [];
		this.__arrFixedRightCells = [];
		var centerHeaderHeaderCells = [];
		var centerHeaderBodyCells = [];
		var centerHeaderRendererCells = [];
		var centerBodyHeaderCells = []; 
		var arrExtraHeaderCells = [];
		var centerHeaderRow = this.__getHeaderHeaderRow(this.__tblCenterHeader);
		if(centerHeaderRow)
		{
			centerHeaderHeaderCells = centerHeaderRow.cells;
		}
		var centerBodyRow = this.__getHeaderBodyRow(this.__tblCenterHeader);
		if(centerBodyRow)
		{
			centerHeaderBodyCells = centerBodyRow.cells;
			var centerRendererRow = this.__getHeaderFilterRow(this.__tblCenterHeader);
			centerHeaderRendererCells = centerRendererRow ? centerRendererRow.cells : null;
			var arrExtraRow = this.__getHeaderExtraRow(this.__tblCenterHeader);
			if(arrExtraRow && arrExtraRow.length > 0)
			{
				for (var rowIndex = 0; rowIndex < arrExtraRow.length; rowIndex++)
			    {
					var row = arrExtraRow[rowIndex];
					arrExtraHeaderCells.push(row.cells);
			    }
			}
		}
		var centerHeaderRow =  this.__getBodyHeaderRow(this.__tblCenterBody);
		if(centerHeaderRow)
		{
			centerBodyHeaderCells = centerHeaderRow.cells;
		}
		var setCellProperties = this.__setFixedCellProperties.bind(this);
		var setCells = function(arrFixed,startIndex,endIndex,isLeftDirection)
		{
			for (var colIndex = startIndex; colIndex < endIndex; colIndex++)
		    {
		    	var headerHeaderCell = centerHeaderHeaderCells[colIndex];
		    	setCellProperties(arrFixed,headerHeaderCell,isLeftDirection);
		    	var headerBodyCell = centerHeaderBodyCells[colIndex];
		    	setCellProperties(arrFixed,headerBodyCell,isLeftDirection);
		    	var headerRendererCell = centerHeaderRendererCells[colIndex];
		    	setCellProperties(arrFixed,headerRendererCell,isLeftDirection);
		    	var bodyHeaderCell = centerBodyHeaderCells[colIndex];
		    	setCellProperties(arrFixed,bodyHeaderCell,isLeftDirection);
		    	for (var rowIndex = 0; rowIndex < arrExtraHeaderCells.length; rowIndex++)
			    {
		    		var extraCell = arrExtraHeaderCells[rowIndex][colIndex];
			    	setCellProperties(arrFixed,extraCell,isLeftDirection);
			    }
		    }
		};
		this.__callFixedArrayCallback.bind(this)(setCells);
	};
	
	NSGrid.prototype.__createFixedBodyRows = function()
	{
		var headerRow = this.__getBodyHeaderRow(this.__tblCenterBody);
		if(headerRow)
		{
			this.__createFixedBodyRow(headerRow);
		}
		var arrRows = this.__getBodyBodyRow(this.__tblCenterBody);
		if(arrRows && arrRows.length > 0)
		{
			for(var count = 0; count < arrRows.length; count++) 
			{
				var row = arrRows[count];
				this.__createFixedBodyRow(row);
			}
		}
	};
	
	NSGrid.prototype.__createFixedBodyRow = function(row)
	{
		/*var centerBodyBodyCells = row.cells;
		var setCellProperties = this.__setFixedCellProperties.bind(this);
		var setCells = function(arrFixed,startIndex,endIndex,isLeftDirection)
		{
		    for (var colIndex = startIndex; colIndex < endIndex; colIndex++)
		    {
		    	var fixedCell = centerBodyBodyCells[colIndex];
		    	setCellProperties(arrFixed,fixedCell,isLeftDirection);
		    }
		};
		this.__callFixedArrayCallback.bind(this)(setCells);*/
	};
	
	NSGrid.prototype.__createFixedFooterRows = function()
	{
		var headerRow = this.__getBodyHeaderRow(this.__tblCenterFooter);
		if(headerRow)
		{
			this.__createFixedFooterRow(headerRow);
		}
		var arrRows = this.__getBodyBodyRow(this.__tblCenterFooter);
		if(arrRows && arrRows.length > 0)
		{
			for(var count = 0; count < arrRows.length; count++) 
			{
				var row = arrRows[count];
				this.__createFixedFooterRow(row);
			}
		}
	};
	
	NSGrid.prototype.__createFixedFooterRow = function(row)
	{
		/*var centerBodyBodyCells = row.cells;
		var setCellProperties = this.__setFixedCellProperties.bind(this);
		var setCells = function(arrFixed,startIndex,endIndex,isLeftDirection)
		{
		    for (var colIndex = startIndex; colIndex < endIndex; colIndex++)
		    {
		    	var fixedCell = centerBodyBodyCells[colIndex];
		    	setCellProperties(arrFixed,fixedCell,isLeftDirection);
		    }
		};
		this.__callFixedArrayCallback.bind(this)(setCells);*/
	};
	
	NSGrid.prototype.__callFixedArrayCallback = function(callBack)
	{
		/*if(this.__leftFixedColumn > 0 && this.__columns && this.__columns.length > this.__leftFixedColumn)
		{
			callBack(this.__arrFixedLeftCells,0,this.__leftFixedColumn,true);
		}
		if(this.__rightFixedColumn > 0 && this.__columns && this.__columns.length > this.__rightFixedColumn)
		{
			callBack(this.__arrFixedRightCells,this.__columns.length - this.__rightFixedColumn,this.__columns.length,false);
		}*/
	};
	
	NSGrid.prototype.__setFixedCellProperties = function(arrFixed,cell,isLeftDirection)
	{
		/*this.__setFixedBackground(cell);
		this.util.addStyleClass(cell,"nsFixedDataGridCell");
		if(isLeftDirection && cell.cellIndex === (this.__leftFixedColumn - 1))
		{
			this.util.addStyleClass(cell,"nsFixedLeftLastCell");
		}
		else if(!isLeftDirection && cell.cellIndex === (this.__columns.length - this.__rightFixedColumn))
		{
			this.util.addStyleClass(cell,"nsFixedRightFirstCell");
		}
		if(this.__enableFixedColumnAnimation)
		{
			this.util.addStyleClass(cell,"nsFixedDataGridCellAnimate");
		}*/
		arrFixed.push(cell);
	};
	
	NSGrid.prototype.__setFixedBackground = function(cell) 
	{
		var row = cell.parentNode;
		var cellBackground = this.util.getStyleValue(cell,"background-color",false);
		cellBackground = (cellBackground == "transparent" || cellBackground == "rgba(0, 0, 0, 0)") ? null : cellBackground;
	
		var rowBackground = this.util.getStyleValue(row,"background-color",false);
		rowBackground = (rowBackground == "transparent" || rowBackground == "rgba(0, 0, 0, 0)") ? null : rowBackground;
	
		var background = rowBackground ? rowBackground : "white";
		background = cellBackground ? cellBackground : background;
		
		cell.style.backgroundColor = background;
	};
	
	NSGrid.prototype.__setFixedCellsPosition = function()
	{
		/*var divBodyContainer = this.__getVerticalScrollableContainer();
		var divHorContainer = this.__getHorizontalScrollableContainer();
		var scrollWidth = divHorContainer.scrollWidth;
		var clientWidth = divHorContainer.clientWidth;
		var scrollHeight = divBodyContainer.scrollHeight;
		var clientHeight = divBodyContainer.clientHeight;
		var top = divBodyContainer.scrollTop;
		var left = divHorContainer.scrollLeft;
		var right = scrollWidth - clientWidth - left;
		for(var count = 0;count < this.__arrFixedLeftCells.length;count++)
		{
			var cell = this.__arrFixedLeftCells[count];
			cell.style.right = null; 
			cell.style.left = left + "px";
		}
		for(var count = 0;count < this.__arrFixedRightCells.length;count++)
		{
			var cell = this.__arrFixedRightCells[count];
			cell.style.left = null;
			cell.style.right = right + "px";
		}*/
	};
	
	/*NSGrid.prototype.__setClassForFixedColumn = function(cell)
	{
		this.__setFixedBackground(cell);
		this.util.addStyleClass(cell,"nsFixedDataGridCell");
		if(this.__leftFixedColumn > 0 && this.__columns && this.__columns.length > this.__leftFixedColumn)
		{
			if(cell.cellIndex === (this.__leftFixedColumn - 1))
			{
				this.util.addStyleClass(cell,"nsFixedLeftLastCell");
			}
		}
		if(this.__rightFixedColumn > 0 && this.__columns && this.__columns.length > this.__rightFixedColumn)
		{
			if(cell.cellIndex === (this.__columns.length - this.__rightFixedColumn))
			{
				this.util.addStyleClass(cell,"nsFixedRightFirstCell");
			}
		}
	}*/
	
	NSGrid.prototype.__updateFixedColumnsForAllTables = function() 
	{
		this.__updateStickyColumns(this.__tblCenterHeader);
		this.__updateStickyColumns(this.__tblCenterBody);
		this.__updateStickyColumns(this.__tblCenterFooter);
	}
	
	NSGrid.prototype.__updateStickyColumns = function(table,recalculate) 
	{
		var arrRows = this.__getBodyBodyRow(table);
		if(arrRows && arrRows.length) {
			var stickyStartStates = this.__getFixedColumnIndicatorArray("Left",recalculate);
			var stickyEndStates = this.__getFixedColumnIndicatorArray("Right",recalculate);
			var row = arrRows[0];
			var cellWidths = this.__getCellWidths(row, recalculate);
			var startPositions = this.__getStickyStartColumnPositions(cellWidths, stickyStartStates);
			var endPositions = this.__getStickyEndColumnPositions(cellWidths, stickyEndStates);

			var lastStickyStart = stickyStartStates.lastIndexOf(true);
			var firstStickyEnd = stickyEndStates.indexOf(true);
			for(var rowIndex = 0;rowIndex < arrRows.length;rowIndex++) 
			{
				row = arrRows[rowIndex];
				var arrCells = row.cells;
		        for (var cellIndex = 0;cellIndex < arrCells.length;cellIndex++) 
		        {
		        	const cell = arrCells[cellIndex]
		        	if (stickyStartStates[cellIndex]) 
		        	{
		        		this.__addStickyStyle(cell,"Left",startPositions[cellIndex],cellIndex === lastStickyStart);
		        		this.__setFixedBackground(cell);
		        	}
		        	if (stickyEndStates[cellIndex]) 
		        	{
		        		this.__addStickyStyle(cell,"Right", endPositions[cellIndex],cellIndex === firstStickyEnd);
		        		this.__setFixedBackground(cell);
		        	}
		        }
		     }
		}
	}
	
	NSGrid.prototype.__getFixedColumnIndicatorArray = function(direction,recalculate) 
	{
		var fieldName = "__cachedFixed" + direction + "Indicator";
		var arrIndicator = this[fieldName];
		var directionLower = direction.toLowerCase();
		if(!recalculate && arrIndicator && arrIndicator.length) {
			return arrIndicator;
		}
		var arrRet = [];
		for(var count = 0; count < this.__columns.length;count++)
		{
			var objColumn = this.__columns[count];
			if(objColumn.pinned && objColumn.pinned == directionLower) {
				arrRet.push(true);
			}
			else {
				arrRet.push(false);
			}
		}
		this[fieldName] = arrRet;
		return arrRet;
	}
	
	NSGrid.prototype.__getCellWidths = function(row,recalculate)
	{
		if(!recalculate && this.__cachedCellWidths && this.__cachedCellWidths.length) {
			return this.__cachedCellWidths;
		}
		var cellWidths = [];
	    var firstRowCells = row.children;
	    for (var i = 0; i < firstRowCells.length; i++) {
	      var cell = firstRowCells[i];
	      cellWidths.push(cell.getBoundingClientRect().width);
	    }
	    this.__cachedCellWidths = cellWidths;
	    return cellWidths;
	}
	
	NSGrid.prototype.__getStickyStartColumnPositions = function(widths,stickyStates)
	{
	    var positions = [];
	    var nextPosition = 0;
	
	    for (var i = 0; i < widths.length; i++) {
	      if (stickyStates[i]) {
	        positions[i] = nextPosition;
	        nextPosition += widths[i];
	      }
	    }
	
	    return positions;
	}
	
	NSGrid.prototype.__getStickyEndColumnPositions = function(widths,stickyStates)
	{
		var positions = [];
		var nextPosition = 0;

	    for (var i = widths.length; i > 0; i--) {
	      if (stickyStates[i]) {
	        positions[i] = nextPosition;
	        nextPosition += widths[i];
	      }
	    }

	    return positions;
	}
	
	NSGrid.prototype.__addStickyStyle = function(element,direction,dirValue,isBorderElement) 
    {
		var directionLower = direction.toLowerCase();
	    element.classList.add("nsFixedDataGridCell");
	    if (isBorderElement) {
	    	element.classList.add("nsFixed" + direction + "LastCell");
	    }
	    element.style[directionLower] = dirValue + "px";
	    //element.style.zIndex = this._getCalculatedZIndex(element);
	    /*if (this._needsPositionStickyOnElement) {
	      element.style.cssText += 'position: -webkit-sticky; position: sticky; ';
	    }*/
	}
	
	NSGrid.prototype.__isColumnFixed = function(index)
	{
		return ((index < this.__leftFixedColumn) || ((this.__orignalColumns.length - this.__rightFixedColumn) <= index));
	};
	
	NSGrid.prototype.__isFixedColumnApplied = function()
	{
		return ((this.__leftFixedColumn > 0) || (this.__rightFixedColumn > 0));
	};
	
	NSGrid.prototype.__addStyleForFixedCell = function(cell,colIndex)
	{
		var isColumnFixed = this.__isColumnFixed(colIndex);
		if(isColumnFixed) 
		{
			this.util.addStyleClass(cell,"nsFixedDataGridCell");
			if(colIndex === (this.__leftFixedColumn - 1))
			{
				this.util.addStyleClass(cell,"nsFixedLeftLastCell");
			}
			else if(colIndex === (this.__columns.length - this.__rightFixedColumn))
			{
				this.util.addStyleClass(cell,"nsFixedRightFirstCell");
			}
		}
	}
	
	NSGrid.prototype.__updateColumnClassForFixedColumns = function(index,direction)
	{
		var self = this;
		var refreshCellClass = function(arrRows) 
		{
			if(arrRows && arrRows.length) 
			{
				for(var count = 0;count < arrRows.length;count++) 
				{
					var cell = arrRows[count].cells[index];
					if(direction == "left" || direction == "right") 
					{
						self.util.addStyleClass(cell,"nsFixedDataGridCell");
						self.util.addStyleClass(cell,"nsFixedDataGridCell" + self.util.toCamelCase(direction));
					}
					else 
					{
						self.util.removeStyleClass(cell,"nsFixedDataGridCell");
						self.util.removeStyleClass(cell,"nsFixedDataGridCellLeft");
						self.util.removeStyleClass(cell,"nsFixedDataGridCellRight");
					}
				}
			}
		}
		if(this.__tblCenterHeaderBody) {
			var arrHeaderRows = this.__tblCenterHeaderBody.rows;
			refreshCellClass(arrHeaderRows);
		}
		if(this.__tblCenterBodyBody) {
			var arrBodyRows = this.__tblCenterBodyBody.rows;
			refreshCellClass(arrBodyRows);
		}
		if(this.__tblCenterFooterBody) {
			var arrFooterRows = this.__tblCenterFooterBody.rows;
			refreshCellClass(arrFooterRows);
		}
		this.__updateColumnClassForFixedLastColumns();
	}
	
	NSGrid.prototype.__updateColumnClassForFixedLastColumns = function()
	{
		var self = this;
		var leftIndex = this.__leftFixedColumn - 1;
		var rightIndex = this.__columns.length - this.__rightFixedColumn;
		
		var resetCellClassByCon = function(con) 
		{
			if(con) 
			{
				var arrCell = con.querySelectorAll(".nsFixedLeftLastCell");
				if(arrCell && arrCell.length) 
				{
					for(var count = 0;count < arrCell.length;count++) 
					{
						var cell = arrCell[count];
						self.util.removeStyleClass(cell,"nsFixedLeftLastCell");
					}
				}
				arrCell = con.querySelectorAll(".nsFixedRightFirstCell");
				if(arrCell && arrCell.length) 
				{
					for(var count = 0;count < arrCell.length;count++) 
					{
						var cell = arrCell[count];
						self.util.removeStyleClass(cell,"nsFixedRightFirstCell");
					}
				}
			}
		}
		
		var refreshCellInRow = function(row) {
			if(row) {
				if(row.cells.length > leftIndex) {
					var cell = row.cells[leftIndex];
					self.util.addStyleClass(cell,"nsFixedLeftLastCell");
				}
				if(row.cells.length > rightIndex) {
					var cell = row.cells[rightIndex];
					self.util.addStyleClass(cell,"nsFixedRightFirstCell");
				}
			}
		}
		
		var refreshCellClass = function(arrRows) {
			if(arrRows && arrRows.length) {
				for(var count = 0;count < arrRows.length;count++) {
					refreshCellInRow(arrRows[count]);
				}
			}
		}
		
		var refreshCellInVirtual = function(row) {
			resetCellClassByCon(row);
			refreshCellInRow(row);
			return row;
		}
		
		if(this.__isFixedColumnApplied()) {
			if(this.__tblCenterHeaderBody) {
				resetCellClassByCon(this.__tblCenterHeaderBody);
				var arrHeaderRows = this.__tblCenterHeaderBody.rows;
				refreshCellClass(arrHeaderRows);
			}
			if(this.__tblCenterBodyBody) {
				resetCellClassByCon(this.__tblCenterBodyBody);
				var arrBodyRows = this.__tblCenterBodyBody.rows;
				refreshCellClass(arrBodyRows);
			}
			if(this.__tblCenterFooterBody) {
				resetCellClassByCon(this.__tblCenterFooterBody);
				var arrFooterRows = this.__tblCenterFooterBody.rows;
				refreshCellClass(arrFooterRows);
			}
			if(this.__nsVirtualScroll) {
				this.__nsVirtualScroll.updateItems(refreshCellInVirtual);
			}
			
		}
	}
	
	NSGrid.prototype.__addStyleForFixedColumns = function()
	{
		var styleId = "nsGridFixedColumnStyle";
		var arrStyle = [];
		var table = this.__tblCenterHeader;
		var arrRows = this.__getBodyBodyRow(table);
		if(arrRows && arrRows.length && this.__columns) {
			var styleTemplate = ".nsGridHeaderRow > .nsGridCell:nth-child(###index###),.nsGridFilterRow > .nsGridCell:nth-child(###index###)," +
					".nsHeaderExtraRow > .nsGridCell:nth-child(###index###),.nsGridRow > .nsGridCell:nth-child(###index###)," +
					".nsGridFooterRow > .nsGridCell:nth-child(###index###) {\r\n" + 
					"    ###pos###;\r\n" +
					"}"
			var tableRect = table.getBoundingClientRect();
			//|| tableRect.x > 0
			if(!this.__tableRectFixedColumn) {
				this.__tableRectFixedColumn = tableRect;
			}
			else {
				tableRect = this.__tableRectFixedColumn;
			}
			var row = arrRows[1];
			var arrCells = row.cells;
			if(this.__leftFixedColumn > 0 && this.__columns.length > this.__leftFixedColumn)
    		{
		        for (var cellIndex = 0;cellIndex < arrCells.length;cellIndex++) 
		        {
		        	var cell = arrCells[cellIndex];
		        	var cellRect = cell.getBoundingClientRect();
	    			if(cell.cellIndex < this.__leftFixedColumn)
	    			{
	    			    var left = cellRect.x - tableRect.x;
	    			    var cellStyle = styleTemplate.replace(/###index###/g,cell.cellIndex + 1);
	    			    cellStyle = cellStyle.replace("###pos###","left: " + left + "px");
	    			    arrStyle.push(cellStyle);
	    			}
	    			else 
	    			{
	    				break;
	    			}
		        }
			}
			if(this.__rightFixedColumn > 0 && this.__columns.length > this.__rightFixedColumn)
			{
				var totalWidth = 0;
				var startingRightColIndex = this.__columns.length - this.__rightFixedColumn;
				for (var cellIndex = arrCells.length - 1;cellIndex > -1;cellIndex--) 
		        {
		        	var cell = arrCells[cellIndex];
		        	var cellRect = cell.getBoundingClientRect();
		        	if(cell.cellIndex >= startingRightColIndex)
	    			{
		        		var right = 0;
	    				if(cellIndex !== arrCells.length - 1) 
	    				{
	    					right = totalWidth;
	    				}
	    				totalWidth += cellRect.width;
	    				var cellStyle = styleTemplate.replace(/###index###/g,cell.cellIndex + 1);
	    			    cellStyle = cellStyle.replace("###pos###","right: " + right + "px");
	    			    arrStyle.push(cellStyle);
	    			}
		        	else 
	    			{
	    				break;
	    			}
		        }
			}
	        var styleElement = document.querySelector("#" + styleId);
	        if (styleElement) {
	          styleElement.parentNode.removeChild(styleElement);
	        }
	        this.util.addStylesToHead(styleId,arrStyle);
		}
	};
	
	
	/******************************End of Fixed Column logic **************************/
	/******************************Event Listeners *************************************/
	
	NSGrid.prototype.__arrowClickHandler = function(event)
	{
		event = this.util.getEvent(event);
		var target = this.util.getTarget(event);
		target = this.util.findParent(target,"DIV");
		if(target && target.hasAttribute("ns-parent-row-count"))
		{
			var rowIndex = target.getAttribute("ns-parent-row-count");
			var isCollapse = this.__isArrowCollapsed(target);
			rowIndex = parseInt(rowIndex);
			if(rowIndex > -1)
			{
				var item = this.__getItemByIndex(rowIndex);
				if(item[this.__childField]  && item[this.__childField].length > 0)
		        {
					this.__showHideRow(rowIndex,target,!isCollapse);
		        }
				else 
				{
					this.__objGrid.__handleOnDemandClick(item,event);
				}
				this.__objGrid.arrowClickHandler(item,!isCollapse);
			}
		}
		event.stopImmediatePropagation();
	};
	
	NSGrid.prototype.__headerClickHandler = function(event)
	{
		if(this.__onGridLine)
		{
			 return;
		}
	     var target = this.util.getTarget(event);
	     //adding the below condition so that if we add a span or a font and click on it then we should navigate till we find the header object
	     target = this.util.findParent(target,"TD");
	     var columnDetail = this.__getColumnObject(target.getAttribute("currentColumnIndex"));
	     this.__nsGridSort.handle(target,columnDetail,this.__isMultiColumnKeyPressed);
	};
	
	NSGrid.prototype.__headerMouseOverHandler = function(event)
	{
		var target = this.util.getTarget(event);
		target = this.util.findParent(target,"TD");
		this.__headerMouseMoveRef = this.__headerMouseMoveHandler.bind(this);
		this.util.addEvent(target,"mousemove",this.__headerMouseMoveRef);
	};
	
	NSGrid.prototype.__headerMouseOutHandler = function(event)
	{
		var target =  this.util.getTarget(event);
		target =  this.util.findParent(target,"TD");
		this.__onGridLine = false;
		
		this.util.removeEvent(target,"mousemove",this.__headerMouseMoveRef);
		this.__headerMouseMoveRef = null;
		/*this.util.removeEvent(target,"mousedown",this.__headerMouseDownRef);
		this.__headerMouseDownRef = null;*/
		
		this.util.removeStyleClass(target,"nsResizeHandleActive");
	};
	
	NSGrid.prototype.__headerMouseMoveHandler = function(event)
	{
		event = this.util.getEvent(event);
		var target = this.util.getTarget(event);
		target = this.util.findParent(target,"TD");
		if(target)
		{
			var objColumn = this.__getColumnObject(target.getAttribute("currentColumnIndex"));
			//var offset = this.util.getEventPosition(event);
			if(objColumn && objColumn["resizable"])
			{
				var posEvent = this.util.getEventPosition(event,this.__divCenterTableHeaderContainer);
				if(this.__isMouseOnElement(target,posEvent.left,posEvent.top))
				{
					this.util.addStyleClass(target,"nsResizeHandleActive");
					this.__onGridLine = true;
				}
				else
				{
					this.util.removeStyleClass(target,"nsResizeHandleActive");
					this.__onGridLine = false;
				}
			}
		}
	};
	
	NSGrid.prototype.__headerMouseDownHandler = function(event)
	{
		event = this.util.getEvent(event);
	    var target = this.util.getTarget(event);
	    target = this.util.findParent(target,"TD");
	    if(target)
		{
	    	var objColumn = this.__getColumnObject(target.getAttribute("currentColumnIndex"));
		    if(objColumn)
			{
		    	if(objColumn["resizable"])
		    	{
		    		//this.__nsGridColumnResize.startResize(event,target);
		    	}
		    	if(objColumn["draggable"])
		    	{
				   this.__nsGridColumnMove.handle(event,target);
		    	}
			}
		}
	};
	
	NSGrid.prototype.__headerMenuClickHandler = function(event)
	{
		 event = this.util.getEvent(event);
	     event.stopImmediatePropagation();
	};
	
	NSGrid.prototype.__bodyCellEventHandler = function(event)
	{
		event = this.util.getEvent(event);
		var target = this.util.getTarget(event);
	    target = this.util.findParent(target,"TD");
	    if(target)
	    {
	    	var index = target.cellIndex;
			switch(event.type)
			{
				case "mouseover":
					var colGroup = document.getElementById(this.getID() + "BodyColGroup" + this.__columns[index].dataField);
					this.util.addStyleClass(colGroup,"nsGridCellHover");
				break;
				case "mouseleave":
					var colGroup = document.getElementById(this.getID() + "BodyColGroup" + this.__columns[index].dataField);
					this.util.removeStyleClass(colGroup,"nsGridCellHover");
				break;
				case "click":
					/*if(this.__lastBodyCellFocus)
					{
						this.util.removeStyleClass(this.__lastBodyCellFocus,"nsCellFocus");
						if(this.__enableCellSelection)
						{
							var row = this.util.findParent(this.__lastBodyCellFocus,"TR");
							var rowIndex = this.__getIndexFromRow(this.__lastBodyCellFocus);
							var item = this.__getItemByIndex(rowIndex);
							this.__dispatchEvent(NSGrid.CELL_UNSELECTED,item,{cellIndex:this.__lastBodyCellFocus.cellIndex,rowIndex:rowIndex,item:item,cell:this.__lastBodyCellFocus,row:row});
						}
						this.__lastBodyCellFocus = null;
					}*/
					var row = this.util.findParent(target,"TR");
				    var rowIndex = this.__getIndexFromRow(row);
				    var item = this.__getItemByIndex(rowIndex);
				    this.__dispatchEvent(NSGrid.CELL_CLICKED,item,{cellIndex:index,rowIndex:rowIndex,item:item,cell:target,row:row});
				    /*if(this.__enableCellSelection)
				    {
				    	this.util.addStyleClass(target,"nsCellFocus");
						this.__dispatchEvent(NSGrid.CELL_SELECTED,item,{cellIndex:index,rowIndex:rowIndex,item:item,cell:target,row:row});
						this.__lastBodyCellFocus = target;
				    }*/
				break;
				case "dblclick":
					var row = this.util.findParent(target,"TR");
				    var rowIndex = this.__getIndexFromRow(row);
				    var item = this.__getItemByIndex(rowIndex);
				    this.__dispatchEvent(NSGrid.CELL_DOUBLE_CLICKED,item,{cellIndex:index,rowIndex:rowIndex,item:item,cell:target,row:row});
				break;
			}
	    }
	};
	
	NSGrid.prototype.__getHeaderMenuDataProvider = function(target)
	{
		var source = [];
		if(target)
		{
			target = this.util.findParent(target,"TD");
			var objColumn = this.__getColumnObject(target.getAttribute("currentColumnIndex"));
			var colIndex = objColumn[this.__fieldColIndex];
			if(objColumn)
			{
				if(objColumn["sortable"])
				{
					source.push({id:"sort",title: "Sort",children:[{id:"sortAsc",title: "Ascending"},{id:"sortDesc",title: "Descending"}]});
				}
				if(objColumn["draggable"])
				{
					source.push({id:"pin",title: "Pin",children:[{id:"pinLeft",title: "Left"},{id:"pinRight",title: "Right"},{id:"pinNo",title: "No Pin"}]});
				}
				if(objColumn["hideable"] && this.__isColumnValidForSwapOrRemove(colIndex))
				{
					source.push({id:"hideColumn",title: "Hide Column"});
				}
				if(objColumn["autoSize"])
				{
					source.push({id:"autoSize",title: "Autosize Column"});
				}
			}
		}
		return source;
	};
	
	NSGrid.prototype.__headerMenuHandler = function(target,item)
	{
		if(target && item)
		{
			target = this.util.findParent(target,"TD");
			var objColumn = this.__getColumnObject(target.getAttribute("currentColumnIndex"));
			if(objColumn)
			{
				var colIndex = objColumn[this.__fieldColIndex];
				switch(item["id"])
				{
					case "sortAsc":
						this.sortBy(colIndex,true);
					break;
					case "sortDesc":
						this.sortBy(colIndex,false);
					break;
					case "hideColumn":
						this.hideColumn(colIndex);
					break;
					case "autoSize":
						this.autoResizeColumn(colIndex);
					break;
					case "pinLeft":
						this.pinColumn(colIndex,"left");
					break;
					case "pinRight":
						this.pinColumn(colIndex,"right");
					break;
					case "pinNo":
						this.pinColumn(colIndex,"no");
					break;
				}
			}
		}
	};
	
	NSGrid.prototype.__rowMouseHover = function(event)
	{
		 event = this.util.getEvent(event);
	     var target = this.util.getTarget(event);
	     target = this.util.findParent(target,"TR");
		 var index = this.__getIndexFromRow(target);
		 if(target && index > -1 && this.__isMouseHoverAllowed(index))
	     {
			 this.util.addStyleClass(target,"nsRowHover");
			 this.__navigationIndex = index;
			 var item = this.__getItemByIndex(index);
			 this.__dispatchEvent(NSGrid.ROW_NAVIGATED,item,{rowIndex:index,item:item,row:target});
	     }
	};
	
	NSGrid.prototype.__rowMouseOut = function(event)
	{
		 var target = this.util.getTarget(event);
		 target = this.util.findParent(target,"TR");
	     if(target)
	     {
	    	 this.util.removeStyleClass(target,"nsRowHover");
	     }
	};
	
	NSGrid.prototype.__rowClickHandler= function(event)
	{
		event = this.util.getEvent(event);
	    var target = this.util.getTarget(event);
	    target = this.util.findParent(target,"TR");
	    var index = this.__getIndexFromRow(target);
	    var item = this.__getItemByIndex(index);
		this.__dispatchEvent(NSGrid.ROW_CLICKED,item,{rowIndex:index,item:item,row:target});
		if(this.__enableRowSelection)
		{
		    this.__setIndex(index,false);
		}
	    this.__lastNavigationDirection = null;
	};
	
	NSGrid.prototype.__rowDblClickHandler= function(event)
	{
		event = this.util.getEvent(event);
	    var target = this.util.getTarget(event);
	    target = this.util.findParent(target,"TR");
	    var index = this.__getIndexFromRow(target);
	    var item = this.__getItemByIndex(index);
		this.__dispatchEvent(NSGrid.ROW_DOUBLE_CLICKED,item,{rowIndex:index,item:item,row:target});
	};
	
	NSGrid.prototype.__setIndex = function(index,isMultiSelect)
	{
		if(index > -1)
		{
			isMultiSelect = Boolean.parse(isMultiSelect);
			if (this.__isShiftPressed && this.__enableMultipleSelection)
		    {
		    	this.__multiSectionHandler(index);
		    }
		    else if(isMultiSelect || (this.__isCtrlPressed && this.__enableMultipleSelection))
		    {
		    	if(this.__isRowSelected(index))
		    	{
		    		this.__markRowUnselected(index);
		    	}
		    	else
		    	{
		    		this.__markRowSelected(index);
		    	}
		    }
		    else
		    {
		    	this.__clearAllRowSelection(false);
		    	this.__markRowSelected(index);
		    } 
		}
	};
	
	NSGrid.prototype.__bodyScrollHandler = function(event)
	{
		var target = this.util.getTarget(event);
		if(this.__stopScroll)
		{
			target.scrollLeft = this.__lastScrollPos[0];
			target.scrollTop = this.__lastScrollPos[1];
			console.log(this.__stopScroll);
			return;
		}
		var scrollPos = target.scrollTop;
		var scrollValue = (target.scrollHeight * this.__bottomPercentageForAddRows) /100;
		if(scrollPos > this.__bodyScrollPos)
		{
			if((target.scrollHeight - scrollPos) < scrollValue)
		    {
				if((this.__isPaginationModeAuto || this.__rowsRendered) && this.__enableAsyncLoadPagination)
		        {
					if(this.__totalRecords > this.__getTotalRows())
					{
						if(this.__processArrayAsync)
						{
							this.__processArrayAsync.stop();
						}
						var totalRows = this.__getTotalRows();
						this.__createBodyBody(this.__arrInternalSource,totalRows,totalRows + 20,true);
					}
		        }
				else
				{
					var fromRecord =  this.__getTotalRows();
					if(fromRecord === this.__totalRecords)
					{
						this.__rowsRendered = true;
					}
					else
					{
						var toRecord = fromRecord +  this.__pageSize - 1;
						toRecord = (toRecord < this.__totalRecords) ? toRecord : ((toRecord === this.__totalRecords) ? this.__totalRecords - 1 : this.__totalRecords);
						this.__paginationFetchRecordCallBack(fromRecord,toRecord,this.__pageSize);
					}
				}
		    }
		}
		this.__lastScrollPos = [target.scrollLeft,target.scrollTop];
		this.__bodyScrollPos = target.scrollTop;
	};
	
	NSGrid.prototype.__infiniteScrollEnabler = function(event)
	{
		var target = this.util.getTarget(event);
		var scrollPos = target.scrollTop;
		var itemToBegin = 0;
		var tableTop = 0; 
	    if(scrollPos > this.__scrollOffsetPosition)
	    {
	    	tableTop = scrollPos - this.__scrollOffsetPosition;
	    	itemToBegin = Math.ceil(tableTop/this.__virtualRowHeight);
	    }
	    else
	    {
	    	tableTop = 0;
	    	itemToBegin = 0;
	    }
	    return (itemToBegin <= this.__getTotalRows());
	};
	
	/******************************End of Event Listeners*************************************/
	
	/******************************************************Start of Selection Functions*************************************************************/
	NSGrid.prototype.__isMouseHoverAllowed = function(index)
	{
		/*var item = this.__getItemByIndex(index);
		if(item)
		{
			return !item[this.__fieldDisableHover];
		}*/
		return true;
	};
	
	NSGrid.prototype.__markRowSelected= function(index)
	{
		if(index > -1)
	    {
	        if(!this.__isRowSelected(index))
	        {
	        	this.__setMultiSelectedVars(index,true);
	            this.__setValuesForSelectedRow(index);
	        	if(this.__enableVirtualScroll)
	        	{
	        		this.__virtualRowSelection();
	        	}
	        	else
	        	{
	        		var row = this.__getRowByIndex(index);
	            	this.util.addStyleClass(row,this.__CLASS_SELECTED_ROW); 
	        	}
	        }
	    }
	};
	
	NSGrid.prototype.__markRowUnselected= function(index)
	{
		if(this.__isRowSelected(index) && this.__isMouseHoverAllowed(index))
	    {
	    	var isUnselected = this.__setMultiSelectedVars(index,false);
	        if(isUnselected)
	        {
	        	this.__setValuesForUnselectedRow(index);
	        }
	        if(this.__enableVirtualScroll)
	    	{
	    		this.__virtualRowSelection();
	    	}
	    	else
	    	{
	    		var row = this.__getRowByIndex(index);
	    		this.util.removeStyleClass(row,this.__CLASS_SELECTED_ROW);
	    	}
	    }
	};
	
	NSGrid.prototype.__setValuesForSelectedRow = function(index)
	{
		if(index > -1 && this.__isMouseHoverAllowed(index))
		{
			var item = this.__getItemByIndex(index);
			if(item)
			{
				item[this.__fieldSelected] = true;
			    this.__selectedIndex = index;
			    this.__navigationIndex = index;
			    this.__dispatchEvent(NSGrid.ROW_SELECTED,item,{index:index});
			}
		}
	};
	
	NSGrid.prototype.__setValuesForUnselectedRow = function(index)
	{
		if(index > -1 && this.__isMouseHoverAllowed(index))
		{
			var item = this.__getItemByIndex(index);
			if(item)
			{
				item[this.__fieldSelected] = false;
				this.__dispatchEvent(NSGrid.ROW_UNSELECTED,item,{index:index});
			}
		}
	};
	
	NSGrid.prototype.__virtualRowSelection = function()
	{
		var arrRows = this.__getAllBodyRows();
		if(arrRows && arrRows.length > 0 && this.__arrInternalSource)
		{
			var row = null;
			var index = null;
			var item = null;
			for(var count = 0; count < arrRows.length; count++) 
			{
				row = arrRows[count];
				index = this.__getIndexFromRow(row);
				item = this.__getItemByIndex(index);
				if(item && this.__isMouseHoverAllowed(index))
				{
					if(item[this.__fieldSelected])
					{
						//DONOT REPLACE WITH __markRowSelected
						this.util.addStyleClass(row,this.__CLASS_SELECTED_ROW); 
					}
					else
					{
						//DONOT REPLACE WITH __markRowUnselected
						this.util.removeStyleClass(row,this.__CLASS_SELECTED_ROW);
					}
				}
			}
		}
	};
	
	NSGrid.prototype.__clearAllRowSelection= function(setIndexVariables)
	{
		var size = this.__selectedIndexes.length;
	    for (var count = size - 1; count >= 0 ; count--)
	    {
	    	var index = this.__selectedIndexes[count];
	        this.__markRowUnselected(index);
	    }
	    this.__setMultiSelectedVars(-1,true);
	    if(setIndexVariables)
	    {
	    	this.__selectedIndex = -1;
	        this.__navigationIndex = -1;
	    }
	};
	
	NSGrid.prototype.__tableCellNavigatorEventHandler = function(event)
	{
		switch(event.type)
		{
			case NSTableCellNavigator.CELL_SELECTED:
				var cell = event.cell;
				this.util.addStyleClass(cell,"nsCellFocus");
				var row = event.row;
			    var rowIndex = this.__getIndexFromRow(row);
			    var item = this.__getItemByIndex(rowIndex);
			    this.__dispatchEvent(NSGrid.CELL_SELECTED,item,{cellIndex:event.cellIndex,rowIndex:rowIndex,item:item,cell:cell,row:row});
			break;
			case NSTableCellNavigator.CELL_UNSELECTED:
				var cell = event.cell;
				this.util.removeStyleClass(cell,"nsCellFocus");
				var row = event.row;
				var rowIndex = this.__getIndexFromRow(row);
				var item = this.__getItemByIndex(rowIndex);
				this.__dispatchEvent(NSGrid.CELL_UNSELECTED,item,{cellIndex:event.cellIndex,rowIndex:rowIndex,item:item,cell:cell,row:row});
			break;
			case NSTableCellNavigator.CELL_SELECTABLE:
				//var cell = event.cell;
				//var row = event.row;	
			break;
		}
	};
	
	NSGrid.prototype.__tableCellSelectionEventHandler = function(event)
	{
		switch(event.type)
		{
			case NSCellSelection.SELECTION_START:
				console.debug("Selection Started");
			break;
			case NSCellSelection.SELECTION_END:
				console.debug("Selection Ended with cells " + event.selectedCells);
			break;
			case NSCellSelection.SET_CELL_VALUE:
				var cellIndex = event.cellIndex;
				var cell = event.cell;
				var row = event.row;
				var dataToBeSet = event.dataToBeSet;
				var rowIndex = this.__getIndexFromRow(row);
				var item = this.__getItemByIndex(rowIndex);
				var headerBodyRow = this.__getHeaderBodyRow(this.__tblCenterHeader);
				if(headerBodyRow)
				{
					var headerCell = headerBodyRow.cells[cellIndex];
					var columnDetail = this.__getColumnObject(headerCell.getAttribute("currentColumnIndex"));
					if(item && columnDetail)
					{
						item[columnDetail["dataField"]] = dataToBeSet;
						this.updateItemInDataSource(item);
						this.__updateCellText(row,cell,item,columnDetail,rowIndex,columnDetail[self.__fieldColIndex]);
					}
				}	
			break;
		}
	};
	
	NSGrid.prototype.__resetPluggins = function()
	{
		//this.__nsGridSort.resetVariables();
		//this.__nsGridColumnMove = new NSGridColumnMove(this);
		if(this.__nsGridFilter)
		{
			this.__nsGridFilter.resetVariables();
		}
		if(this.__nsGridEditor)
		{
			this.__nsGridEditor.resetVariables();
		}
		//this.__nsToolTipInElement = new this.util.nsToolTipInElement();
	};
	
	NSGrid.prototype.__callPlugginsInitialize = function()
	{
		if(this.__nsGridEditor)
		{
			this.__nsGridEditor.initialize();
		}
	};
	
	NSGrid.prototype.__multiSectionHandler= function(lastIndex)
	{
		 if(!lastIndex)
		 {
			 return;
		 }
		 if (this.__selectedItems.length === 0)
		 {
			 this.__isRowSelected(lastIndex);
		     return;
		 }
		 var firstIndex = this.__selectedIndexes[this.__selectedIndexes.length - 1];
		 if(lastIndex === firstIndex)
		 {
			 this.__markRowUnselected(lastIndex);
			 return;
		 }
		 var isDown = lastIndex > firstIndex;
		 var isSelection = !this.__isRowSelected(lastIndex);
		 var counter = firstIndex;
		 do
		 {
			  counter = isDown ? (counter + 1) : (counter - 1);
			  if (isSelection)
			  {
				  this.__markRowSelected(counter);
			  }
			  else
			  {
				  this.__markRowUnselected(counter);
			  }
		 }
		 while(counter != lastIndex);
	};
	
	NSGrid.prototype.__setMultiSelectedVars = function(index,add)
	{
		if(index === -1)
		{
			this.__selectedItems = [];	
			this.__selectedIndexes = [];	
		}
		else if(add)
		{
			var data = this.__getItemByIndex(index);
			this.__selectedItems.push(data);
			this.__selectedIndexes.push(index);
		}
		else
		{
			var isUnselected = false;
			for (var count= 0; count < this.__selectedIndexes.length ; count++)
	        {
	            if (this.__selectedIndexes[count] === index)
	            {
	                this.__selectedItems.splice(count,1);
	                this.__selectedIndexes.splice(count,1);
	                isUnselected = true;
	                break;
	            }
	        }
			return isUnselected;
		}
		
		return true;
	};
	
	NSGrid.prototype.__isRowSelected= function(index)
	{
		if(index > -1)
	    {
	    	var item = this.__getItemByIndex(index);
	    	if(item)
	    	{
	    		return item[this.__fieldSelected];
	    	}
	    }   
	    return false;
	};
	
	NSGrid.prototype.__setVisibilityOfColumn = function(index,isVisible)
	{
		var style;
	    if (isVisible) 
	    {
	    	style = "";
	    }
	    else
	    {
	    	style = "none";
	    }
		var rows = this.__tblCenterHeader.getElementsByTagName("tr");
		for (var count = 0; count < rows.length;count++) 
		{
		     var cells = rows[count].cells;
		     if(cells.length > index)
		     {
		    	 cells[index].style.display = style;
		     }
		     else
		     {
		    	 return;
		     }
		}
		rows = this.__tblCenterBody.getElementsByTagName("tr");
		for (var count = 0; count < rows.length;count++) 
		{
		     var cells = rows[count].cells;
		     cells[index].style.display = style;
		}
		
	};
	
	NSGrid.prototype.__keyDownHandler = function(event)
	{
		if(this.hasFocus())
		{
			event = this.util.getEvent(event);
			if(this.__enableMultiSort)
			{
				this.__isMultiColumnKeyPressed = event[this.__multiColumnKey + "Key"];
			}
			this.__isShiftPressed = event.shiftKey;
			this.__isCtrlPressed = event.ctrlKey;
			var isShiftCtrlPressed = this.__isShiftPressed || this.__isCtrlPressed;
			var keyCode = this.util.getKeyUnicode(event);
			if(this.__enableKeyboardNavigation)
			{
				this.__nsGridKeyboard.keyDownHandler(event,keyCode);
			}
			if(keyCode === this.util.KEYCODE.SHIFT)
			{
				this.util.makeBodyUnselectable();
			}
		}
	};
	
	NSGrid.prototype.__keyUpHandler = function(event)
	{
		if(this.util.getKeyUnicode(event) === this.util.KEYCODE.CTRL)
		{
			this.__isCtrlPressed = false;
		}
		if(this.util.getKeyUnicode(event) === this.util.KEYCODE.SHIFT)
		{
			this.__isShiftPressed = false;
			this.util.makeBodySelectable();
		}
		if(this.util.getKeyUnicode(event) === this.util.KEYCODE[this.__multiColumnKey.toUpperCase()] && this.__enableMultiSort)
		{
			this.__isMultiColumnKeyPressed = false;
		}
	};
	
	/******************************************************End of Selection Functions*************************************************************/
	/******************************************************Start of Filter Logic*************************************************************/
	NSGrid.prototype.__highlightDiv = function(divText,colIndex)
	{
		this.__nsGridFilter.__highlightDiv(divText,colIndex);
	};
	/******************************************************End of Filter Logic*************************************************************/
	/******************************************************Start of Context Menu*************************************************************/
	
	NSGrid.prototype.__initializeContextMenu = function()
	{
		//if(!this.__contextMenu)
		//{
			var contextMenuSetting = {parent:this.__tblCenterBody,isContextMenu:true,createRunTime:true,sourceProvider:this.__getContextMenuDataProvider.bind(this),targetType:"TD"};
			if(this.__contextMenuSetting)
			{
				for(var key in this.__contextMenuSetting)
				{
					//grid setting should not be overriden by the users
					if(!contextMenuSetting[key])
					{
						contextMenuSetting[key] = this.__contextMenuSetting[key];
					}
				}
			}
			this.__contextMenu = new NSMenu(contextMenuSetting);
		//}
	};
	
	NSGrid.prototype.__getContextMenuDataProvider = function(cell)
	{
		if(cell)
		{
			cell = this.util.findParent(cell,"TD");
			if(cell)
			{
				var row = this.util.findParent(cell,"TR");
				if(row)
				{
					var index = parseInt(row.getAttribute("ns-index"));
					var item = this.__getItemByIndex(index);
					if(item && this.__contextMenuProvider) 
					{
						return this.__contextMenuProvider(item,cell.cellIndex,index);
					}
				}
			}
		}
		return null;
	};
	
	/******************************************************End of Context Menu*************************************************************/
	/******************************Custom Function *************************************/
	
	NSGrid.prototype.__createTableAndParent = function(containerID,containerStyle,tableID)
	{
		var divTableContainer = this.util.createDiv(containerID,containerStyle); 
		var table = document.createElement("TABLE");
		table.setAttribute("id",tableID);
		this.util.addStyleClass(table , this.__CLASS_TABLE);
		this.util.addStyleClass(table , "nsDataGridTableTheme");
		divTableContainer.appendChild(table);
		return divTableContainer;
	};
	
	NSGrid.prototype.__setMeasurement = function()
	{
		this.__bodyScrollPos = 0;
	};
	
	NSGrid.prototype.__addListenerForBody = function()
	{
		if(!this.__keyDownRef)
		{
			this.__keyDownRef = this.__keyDownHandler.bind(this);
			this.util.addEvent(document,"keydown",this.__keyDownRef);
		}
		if(!this.__keyUpRef)
		{
			this.__keyUpRef = this.__keyUpHandler.bind(this);
			this.util.addEvent(document,"keyup",this.__keyUpRef);
		}
	};
	
	NSGrid.prototype.__setBodyMeasurement = function()
	{
		var divTitleBar = this.util.getElement(this.getID() + this.__TITLE_CONTAINER_ID);
		var divPagination = this.util.getElement(this.getID() + this.__PAGINATION_CONTROL_ID);
		var topHeight = this.__divCenterTableHeaderContainer.offsetHeight;
		if(divTitleBar)
		{
			topHeight += divTitleBar.offsetHeight;
		}
		if(divPagination)
		{
			topHeight += divPagination.offsetHeight;
		}
		var containerHeight = this.__divOuterContainer.offsetHeight;
		var containerWidth = this.__divOuterContainer.offsetWidth;
		var bodyContainerHeight = containerHeight - topHeight;
		this.__divCenterTableBodyContainer.style.height = bodyContainerHeight + "px";
		var scrollBarWidth = this.util.getScrollBarWidth(this.__divCenterTableBodyContainer);
		this.__divCenterTableHeaderContainer.style.width = (this.__divCenterTableBodyContainer.offsetWidth - scrollBarWidth) + "px";
		this.__initialTableWidth = containerWidth - scrollBarWidth;
		if(!this.__synchronizeTablesRef)
		{
			this.__synchronizeTablesRef = this.__synchronizeTables.bind(this);
			this.util.addEvent(this.__getHorizontalScrollableContainer(),"scroll",this.__synchronizeTablesRef);
		}
	};
	
	NSGrid.prototype.__alignTables = function(fromSort)
	{
		var getCells = function(tbl)
		{
			if(tbl && tbl.tHead && tbl.tHead.rows.length > 0)
			{
				return tbl.tHead.rows[0].cells;
			}
			return [];
		};
		var setCellWidth = function(arrCells,index,setWidth)
		{
			arrCells[index].style.width = setWidth + "px";
		};
		var headerCells = getCells(this.__tblCenterHeader);
		var bodyCells = getCells(this.__tblCenterBody);
		var footerCells = getCells(this.__tblCenterFooter);
		if(headerCells && headerCells.length > 0 && bodyCells && bodyCells.length > 0)
		{
			var totalWidth = 0;
			var count = 0;
			var widthToBeSet = 0;
			var self = this;
			var setWidths = function()
			{
				totalWidth += widthToBeSet;
				setCellWidth(headerCells,count,widthToBeSet);
				setCellWidth(bodyCells,count,widthToBeSet);
				(footerCells && footerCells.length > 0) ? setCellWidth(footerCells,count,widthToBeSet) : null;
			};
			var setTotalCellWidth = function(arrCells)
			{
				for(count = 0;count < arrCells.length;count++)
				{
					var cell = arrCells[count];
					var item = self.__columns[count];
					widthToBeSet = self.util.getDimensionAsNumber(cell,cell.style.width);
					if(widthToBeSet === 0)
					{
						widthToBeSet = cell.getBoundingClientRect().width;//cell.offsetWidth;
					}
					if(!item.hasOwnProperty(self.__fieldColVisible) || item[self.__fieldColVisible])
					{
						setWidths();
					}
				}
			};
			if(fromSort)
			{
				setTotalCellWidth(headerCells);
			}
			else
			{
				setTotalCellWidth(bodyCells);
			}
			if(this.__fillParentWidth && this.__initialTableWidth > totalWidth)
			{
				totalWidth = this.__initialTableWidth;
			}
			this.__setTableWidth(totalWidth); 
		}
	};
	
	NSGrid.prototype.__synchronizeTables = function(event) 
	{
		var target = this.util.getTarget(event);
		//if(this.__scroller)
		//{
		//	this.__divCenterTableHeaderContainer.scrollLeft = event.scrollLeft;
		//}
		//else
		//{
			
			this.__divCenterTableHeaderContainer.scrollLeft = target.scrollLeft;
			(target != this.__divCenterTableBodyContainer) ? this.__divCenterTableBodyContainer.scrollLeft = target.scrollLeft : null;
			//console.log(target.id + "," + target.scrollLeft + "," + this.__divCenterTableHeaderContainer.scrollLeft);
			//console.log(target.scrollLeft + "," + );
		//}
		if(this.__enableFixedColumnAnimation)
		{
			if(this.__fixedTimerTimeout != -1)
			{
				clearTimeout(this.__fixedTimerTimeout);
				this.__fixedTimerTimeout = -1;
			}
			var self = this;
			this.__fixedTimerTimeout = setTimeout(function()
			{ 
				//self.__setFixedCellsPosition.bind(self)();
			},250);
		}
		else
		{
			//this.__setFixedCellsPosition();
		}
	};
	
	NSGrid.prototype.__setTableWidth = function(totalWidth) 
	{
		var setWidth = function(tbl)
		{
			tbl ? tbl.style.width = totalWidth : null;
		};
		if(this.util.isUndefinedOrNull(totalWidth))
		{
			totalWidth = null;
		}
		else
		{
			totalWidth = totalWidth + "px";
		}
		setWidth(this.__tblCenterHeader);
		setWidth(this.__tblCenterBody);
		setWidth(this.__tblCenterFooter);
	};
	
	NSGrid.prototype.__expandCollapseAll = function(isCollapse)
	{
		if(!this.__enableVirtualScroll && this.__getTotalRows() < this.__totalRecords)
		{
			this.util.warning("NSGrid","Please let all the rows to render.");
			return;
		}
		var dataSource = this.__arrInternalSource;
		if(dataSource && dataSource.length > 0)
		{
			if(this.__enableVirtualScroll)
			{
				this.__setCustomScrollBarScrollTop(0);
			}
			if(this.__getVerticalScrollableContainer())
			{
				this.__getVerticalScrollableContainer().scrollTop = 0;
			}
		    this.__lastScrollPos = [0,0];
		    this.__lastScrollPosition = 0;
			if(this.__enableVirtualScroll)
			{
				this.__expandCollapseAllVirtual(dataSource,isCollapse);
			}
			else
			{
				this.__expandCollapseAllNormal(dataSource,isCollapse);
			}
		}
	};
	
	NSGrid.prototype.__expandCollapseAllNormal = function(dataSource,isCollapse)
	{
		for(var count = 0;count < dataSource.length;count++)
		{
			var item = dataSource[count];
			//setting __fieldIsCollapsed here assuming that __showHideAllArrows() will be called after this function
			item[this.__fieldIsCollapsed] = isCollapse;
			if(parseInt(item[this.__fieldRowLevel]) > 0)
			{
				var row = item[this.__fieldRow];
				if(isCollapse)
				{
					row.style.display = "none";
					item[this.__fieldRowVisible] = false;
				}
				else
				{
					row.style.display = "";
					item[this.__fieldRowVisible] = true;
				}
			}
			this.__objGrid.expandCollapseHandler(item,isCollapse);
		}
		this.__showHideAllArrows(isCollapse);
	};
	
	NSGrid.prototype.__expandCollapseAllVirtual = function(dataSource,isCollapse)
	{
		for(var count = 0;count < dataSource.length;count++)
		{
			var item = dataSource[count];
			//setting __fieldIsCollapsed here assuming that __showHideAllArrows() will be called after this function
			item[this.__fieldIsCollapsed] = isCollapse;
			if(parseInt(item[this.__fieldRowLevel]) > 0)
			{
				if(isCollapse)
				{
					item[this.__fieldRowVisible] = false;
				}
				else
				{
					item[this.__fieldRowVisible] = true;
				}
			}
			//this.__objGrid.expandCollapseHandler(item,isCollapse);
		}
		this.__showHideAllArrows(isCollapse);
		this.__updateVisibleIndex(null,0);
		this.__setNSVirtualScroll(this.__arrInternalSource);
		for(var count = 0;count < dataSource.length;count++)
		{
			var item = dataSource[count];
			this.__objGrid.expandCollapseHandler(item,isCollapse);
		}
	};
	
	NSGrid.prototype.__showHideRow = function(rowIndex,compArrow,isCollapse)
	{
		if(rowIndex > 0)
		{
			var item = this.__getItemByIndex(rowIndex);
			if(!compArrow)
			{
				compArrow = this.__getArrow(item[this.__fieldIndex]);
			}
			var rowLevel = parseInt(item[this.__fieldRowLevel]);
			var arrChildItems = [];
			if(item && item[this.__fieldHasChild])
			{
				var startIndex = 0;
				if(isCollapse)
				{
					arrChildItems = this.__arrInternalSource;
					startIndex = rowIndex;
				}
				else
				{
					arrChildItems = this.__getImmediateChildItems(arrChildItems, item);
				}
				if(this.__enableVirtualScroll)
				{
					this.__showHideRowVirtual(item,arrChildItems,startIndex,rowLevel,isCollapse);
					item[this.__fieldIsCollapsed] = isCollapse;
					//this.__updateItemInSource(item);
					this.__setNSVirtualScroll(this.__arrInternalSource);
				}
				else
				{
					this.__showHideRowNormal(item,arrChildItems,startIndex,rowLevel,isCollapse);
					this.__setArrowDirection(compArrow,isCollapse);
					item[this.__fieldIsCollapsed] = isCollapse;
				}
			}
		}
	};
	
	NSGrid.prototype.__showHideRowNormal = function(item,arrChildItems,startIndex,rowLevel,isCollapse)
	{
		if(arrChildItems && arrChildItems.length > 0)
		{
			if(isCollapse)
			{
				var retIndex = this.__getActualIndex(arrChildItems,startIndex);
				if(retIndex !== startIndex)
				{
					startIndex = (retIndex + 1);
				}
			}
			var rowItem = null;
			for(var count = startIndex;count < arrChildItems.length;count++)
			{
				rowItem = arrChildItems[count];
				var row = rowItem[this.__fieldRowHtml];
				if(!row)
				{
					this.__createBodyRowAt(rowItem,rowItem[this.__fieldIndex]);
					row = rowItem[this.__fieldRowHtml];
					this.__updateSourceIndex();
				}
				if(isCollapse)
				{
					if(rowLevel >= parseInt(rowItem[this.__fieldRowLevel]))
					{
						break;
					}
					row.style.display = "none";
					rowItem[this.__fieldRowVisible] = false;
					if(rowItem[this.__fieldHasChild])
					{
						rowItem[this.__fieldIsCollapsed] = true;
						if(rowItem[this.__fieldRowArrow])
						{
							var divArrow = rowItem[this.__fieldRowArrow];
							if(divArrow)
							{
								this.__setArrowDirection(divArrow,true);
							}
						}
					}
				}
				else
				{
					row.style.display = "";
					rowItem[this.__fieldRowVisible] = true;
				}
			}
		}
	};
	
	NSGrid.prototype.__showHideRowVirtual = function(item,arrChildItems,startIndex,rowLevel,isCollapse)
	{
		if(arrChildItems && arrChildItems.length > 0)
		{
			if(isCollapse)
			{
				var retIndex = this.__getActualIndex(arrChildItems,startIndex);
				if(retIndex !== startIndex)
				{
					startIndex = (retIndex + 1);
				}
			}
			var rowItem = null;
			for(var count = startIndex;count < arrChildItems.length;count++)
			{
				rowItem = arrChildItems[count];
				if(isCollapse)
				{
					if(rowLevel >= parseInt(rowItem[this.__fieldRowLevel]))
					{
						break;
					}
					rowItem[this.__fieldRowVisible] = false;
					if(rowItem[this.__fieldHasChild])
					{
						rowItem[this.__fieldIsCollapsed] = true;
					}
				}
				else
				{
					rowItem[this.__fieldRowVisible] = true;
				}
			}
			var index = item[this.__fieldIndex];
			//this.__updateVisibleIndex(null,index - 1);
			//done the below for MasterDetail Grid .. if there is an issue in Hierarchical or Grouping Grid while filtering then use a callback to get the index like afterFilter which we will override only for MasterDetailGrid with the below condition
			//var sendIndex = (index % 2) == 0 ? index : index - 1;
			//this.__updateVisibleIndex(null,sendIndex);
			this.__updateVisibleIndex(null,index);
		}
	};
	
	NSGrid.prototype.__showHideAllArrows = function(isCollapse)
	{
		var arrDivs = this.__getAllArrows();
		if(arrDivs && arrDivs.length > 0)
		{
			for(var count = 0;count < arrDivs.length;count++)
			{
				var div = arrDivs[count];
				if(div && div.hasAttribute("ns-parent-row-count"))
				{
					this.__setArrowDirection(div,isCollapse);
				}
			}
		}
	};
	
	NSGrid.prototype.__isNodeLastParent = function(item)
	{
		var retValue = false;
		if(item && item[this.__fieldHasChild])
		{
			var arrChildItems = item[this.__childField];
			if(arrChildItems && arrChildItems.length > 0)
			{
				var hasChild = false;
				for(var count = 0;count < arrChildItems.length;count++)
				{
					var rowItem = arrChildItems[count];
					if(rowItem && rowItem[this.__fieldHasChild])
					{
						hasChild = true;
						break;
					}
				}
				if(!hasChild)
				{
					retValue = true;
				}
			}
		}
		return retValue;
	};
	
	NSGrid.prototype.__updateSourceIndex = function(source)
	{
		if(!source)
		{
			source = this.__getAllItems();
		}
		var item = null;
		var row = null;
		var length = source.length;
		for(var count = 0;count < length;count++)
		{
			item = source[count];
			var index = (this.__enableHierarchical || this.__enableGrouping || this.__enableMasterDetail) ? (count + 1) : count;
			item[this.__fieldIndex] = index;
			row = item[this.__fieldRowHtml];
			if(row && this.util.isElementOfType(row,"tr"))
			{
				row.setAttribute("ns-index",index);
				var compArrow = row.querySelector(".nsArrow");
				if(compArrow)
				{
					compArrow.setAttribute("ns-parent-row-count",index);
					var arrowID = this.getID() + "compArrow" + index;
					compArrow.setAttribute("id",arrowID);
					var compSvg = compArrow.querySelector("svg");
					if(compSvg)
					{
						var svgID = arrowID + "svg";
						compSvg.setAttribute("id",svgID);
					}
					var compUse = compArrow.querySelector("use");
					if(compUse)
					{
						var useID = arrowID + "use";
						compUse.setAttribute("id",useID);
					}
				}
			}
		}
	};
	
	NSGrid.prototype.__applyCustomClass = function(element,type)
	{
		if(this.__customClass && element && type)
		{
			var itemProperty = {"outerContainer":{property:"outerContainer",defaultValue:null},
							    "titleBar":{property:"titleBar",defaultValue:null},
							    "headerRow":{property:"headerRow",defaultValue:null},
							    "headerCell":{property:"headerCell",defaultValue:null},
							    "filterRow":{property:"filterRow",defaultValue:null},
							    "filterCell":{property:"filterCell",defaultValue:null},
							    "bodyRow":{property:"bodyRow",defaultValue:null},
							    //for Hierarchies and Grouping grid
							    "firstBodyColumn":{property:"firstBodyColumn",defaultValue:null},
							    "nonFirstBodyColumn":{property:"nonFirstBodyColumn",defaultValue:null}
							   };
			if(itemProperty[type])
			{
				if(this.__customClass[itemProperty[type]["property"]])
				{
					this.util.addStyleClass(element,this.__customClass[itemProperty[type]["property"]]);
				}
				else if(itemProperty[type]["defaultValue"])
				{
					this.util.addStyleClass(element,itemProperty[type]["defaultValue"]);
				}
			}
		}
	};
	
	NSGrid.prototype.__addCellText = function(row,item,div,colItem,colIndex)
	{
		if(item && div && colItem)
		{
			var dataField = colItem["dataField"];
			var templateRenderer = colItem["templateRenderer"];
			var setData = colItem["setData"];
			var itemRenderer = colItem["itemRenderer"];
			var labelFunction = colItem["labelFunction"];
			var groupRenderer = colItem["groupRenderer"];
			var truncateToFit = colItem["truncateToFit"];
			var toolTipField = colItem["toolTipField"];
			var toolTipRenderer = colItem["toolTipRenderer"];
			var toolTipText = null;
			var isGroupedParent = (this.__enableGrouping && item[this.__isParentRowField]);
			//for Grouping
			if(isGroupedParent && groupRenderer)
			{
				var arrAllChildItems = this.__getAllChildItemsForGroup(null,item);
				var objRenderer = groupRenderer(item,dataField,item[this.__fieldIndex],colIndex,row,item[this.__childField],item[this.__objGrid.__childrenCountField],arrAllChildItems,parseInt(item[this.__fieldRowLevel]) + 1);
				var callback = function(objRenderer)
				{
					if(objRenderer)
					{
						if(this.util.isString(objRenderer))
						{
							var compBodySpan = document.createElement("span");
							compBodySpan.innerHTML = objRenderer;
							div.appendChild(compBodySpan);
						}
						else
						{
							div.appendChild(objRenderer);
						}
					}
				};
				this.util.resolveFunctionOrPromise(objRenderer,callback.bind(this));
			}
			else if(!isGroupedParent && itemRenderer)
			{
				var objRenderer = itemRenderer(item,dataField,item[this.__fieldIndex],colIndex,row);
				var callback = function(objRenderer)
				{
					if(objRenderer)
					{
						if(this.util.isString(objRenderer))
						{
							var compBodySpan = document.createElement("span");
							compBodySpan.innerHTML = objRenderer;
							div.appendChild(compBodySpan);
						}
						else
						{
							div.appendChild(objRenderer);
						}
					}
				};
				this.util.resolveFunctionOrPromise(objRenderer,callback.bind(this));
			}
			else if(!isGroupedParent && templateRenderer)
			{
				div.appendChild(templateRenderer.cloneNode(true));
				this.__setDataInTemplateRenderer(div,item,dataField,setData,colItem,row);
			}
			else if(!isGroupedParent && labelFunction)
			{
				var text = labelFunction(item,dataField,colItem);
				div.appendChild(document.createTextNode(text));
			}
			else if(item.hasOwnProperty(dataField) && !this.util.isUndefined(item[dataField]) && item[dataField] != null)
		    {
				var text = item[dataField];
				div.appendChild(document.createTextNode(text));
		    }
			else if(dataField)
		    {
				var text = null;
				if(dataField.includes(".")) 
				{
					text = this.util.getValueByKeys(item,dataField);
				}
				else if(item.hasOwnProperty(dataField)) 
				{
					text = item[dataField];
				}
				if(text)
				{
					div.appendChild(document.createTextNode(text));
				}
		    }
			this.__highlightDiv(div,colIndex);
			if(toolTipField)
			{
				toolTipText = item[toolTipField];
			}
			else if(toolTipRenderer)
			{
				toolTipText = toolTipRenderer(item,dataField,item[this.__fieldIndex],colIndex,row);
			}
			if(truncateToFit)
			{
				this.util.addStyleClass(div,"nsTruncateToFit");
				//This condition is above so that toolTip and title are not set togeather
				if(!toolTipText || toolTipText === "")
				{
					if(this.__enableToolTipForTruncateText)
					{
						toolTipText = div.textContent;
					}
					else
					{
						div.setAttribute("title",div.textContent);
					}
				}
			}
			var callback = function(toolTipText)
			{
				if(toolTipText && toolTipText !== "")
				{
					this.__nsToolTipInElement.addToolTip(div,toolTipText);
				}
			};
			this.util.resolveFunctionOrPromise(toolTipText,callback.bind(this));
		}
	};
	
	NSGrid.prototype.__updateCellText = function(row,cell,item,colItem,rowIndex,colIndex)
	{
		this.__objGrid.__updateCellText(row,cell,item,colItem,rowIndex,colIndex);
	};
	
	NSGrid.prototype.__setDataInTemplateRenderer = function(cellItem,data,dataField,setData,colItem,row)
	{
		if(cellItem && setData)
		{
			this.__setRendererProperties(cellItem);
			this.__setRendererInData(cellItem,data,row);
			//IE bug
			cellItem.data = data;
			if(this.util.isFunction(setData))
		    {
				var strParam = "(cellItem,data,dataField,colItem,row)"; 
		    	if(this.util.isString(setData))
		    	{
		    		this.util.callFunctionFromString(setData + strParam,function(paramValue){
						if(paramValue === "cellItem")
						{
							return cellItem;
						}
						if(paramValue === "data")
						{
							return data;
						}
						if(paramValue === "dataField")
						{
							return dataField;
						}
						if(paramValue === "colItem")
						{
							return colItem;
						}
						if(paramValue === "row")
						{
							return row;
						}
						return paramValue;
					});
		    	}
		    	else
		    	{
		    		setData(cellItem,data,dataField,colItem,row);
		    	}
		    }
		}
	};
	
	NSGrid.prototype.__setRendererInData = function(cellItem,data,row)
	{
		if(cellItem)
		{
			var compChild = null;
			for(var count = 0; count < cellItem.children.length; count++) 
			{
				compChild = cellItem.children[count];
				if(compChild)
				{
					compChild.data = data;
					compChild.row = row;
				}
				//IE 9 Bug,you got to assign it back
				//listItem.children[count] = compChild;
				this.__setRendererInData(compChild,data,row);
			}
		}
	};
	
	NSGrid.prototype.__setRendererProperties = function(cellItem)
	{
		if(cellItem)
		{
			var compChild = null;
			for(var count = 0; count < cellItem.children.length; count++) 
			{
				compChild = cellItem.children[count];
				var grid = this;
				Array.prototype.slice.call(compChild.attributes).forEach(function(attribute) 
				{
			        if(grid.util.isFunction(attribute.value))
			        {
			        	var newValue = attribute.value + "(this)";
			        	compChild.removeAttribute(attribute.name);
						compChild.setAttribute(attribute.name,newValue);
			        }
				});
				if(compChild)
				{
					if(compChild.hasAttribute("accessor-name"))
					{
						cellItem[compChild.getAttribute("accessor-name")] = compChild;
					}
				}
				this.__setRendererProperties(compChild);
			}
		}
	};
	
	NSGrid.prototype.__calculateCellExpectedHeight = function(templateRenderer)
	{
		var retHeight =  -1;
		if(templateRenderer)
		{
			var tempRenderer = templateRenderer.cloneNode(true);
			tempRenderer.removeAttribute("id");
			this.addChild(tempRenderer);
			retHeight = tempRenderer.offsetHeight;
			if(retHeight <= 0)
			{
				retHeight = this.util.getDimensionAsNumber(tempRenderer,tempRenderer.style.height);
			}
			this.deleteChild(tempRenderer);
		}
		return retHeight;
	};
	
	NSGrid.prototype.__setRowHover = function(indexToSet)
	{
		if(this.__nsGridKeyboard)
		{
			this.__nsGridKeyboard.__setRowHover(indexToSet);
		}
	};
	
	NSGrid.prototype.__getAllItems = function()
	{
		return this.__objGrid.__getFlatSource();
	};
	
	NSGrid.prototype.__isCellEditable = function(objColumn,item,cell,cellIndex,row,rowIndex)
	{
		return this.__objGrid.__isCellEditable(objColumn,item,cell,cellIndex,row,rowIndex);
	};
	
	NSGrid.prototype.__getImmediateChildItems = function(arrItems,item)
	{
		if(!arrItems)
		{
			arrItems = [];
		}
		if(item && item[this.__fieldHasChild])
		{
			var arrChild = this.__arrInternalSource;
			var rowLevel = parseInt(item[this.__fieldRowLevel]);
			var startIndex = item[this.__fieldIndex];
			var retIndex = this.__getActualIndex(arrChild,startIndex);
			if(retIndex !== startIndex)
			{
				startIndex = (retIndex + 1);
			}
			/*//for Filter condition
			//(startIndex + 1) as __fieldIndex starts from 1
			if(arrChild.length < startIndex || arrChild[startIndex][this.__fieldIndex] !== (startIndex + 1))
			{
				var rowItem = null;
				for(var count = 0;count < arrChild.length;count++)
				{
					rowItem = arrChild[count];
					if(rowItem[this.__fieldIndex] === startIndex)
					{
						startIndex = (count + 1);
						break;
					}
				}
			}*/
			//end of Filter condition
			var length = arrChild.length;
			for(var count = startIndex;count < length;count++)
			{
				var itemChild = arrChild[count];
				var childRowLevel = parseInt(itemChild[this.__fieldRowLevel]);
				if(rowLevel >= childRowLevel)
				{
					break;
				}
				if((rowLevel + 1) === childRowLevel)
				{
					arrItems.push(itemChild);
				}
			}
		}
		return arrItems;
	};
	
	//generally used for Filter condition
	NSGrid.prototype.__getActualIndex = function(arrChild,startIndex,addCompareOne)
	{
		//(startIndex + 1) as __fieldIndex starts from 1
		if(arrChild && arrChild.length < startIndex || arrChild[startIndex][this.__fieldIndex] !== (startIndex + 1))
		{
			var compareIndex = startIndex;
			if(addCompareOne)
			{
				compareIndex += 1;
			}
			var rowItem = null;
			for(var count = 0;count < arrChild.length;count++)
			{
				rowItem = arrChild[count];
				if(rowItem[this.__fieldIndex] === compareIndex)
				{
					return count;
				}
			}
		}
		return startIndex;
	};
	
	NSGrid.prototype.__getAllChildItems = function(arrItems,item)
	{
		if(!arrItems)
		{
			arrItems = [];
		}
		if(item && item[this.__fieldHasChild])
		{
			var arrChild = this.__arrInternalSource;
			var rowLevel = parseInt(item[this.__fieldRowLevel]);
			var startIndex = item[this.__fieldIndex];
			var length = arrChild.length;
			for(var count = startIndex;count < length;count++)
			{
				var itemChild = arrChild[count];
				if(rowLevel >= parseInt(itemChild[this.__fieldRowLevel]))
				{
					break;
				}
				arrItems.push(itemChild);
			}
		}
		return arrItems;
	};
	
	NSGrid.prototype.__getAllChildItemsForGroup = function(arrItems,item)
	{
		if(!arrItems)
		{
			arrItems = [];
		}
		if(item && item[this.__fieldHasChild])
		{
			var arrChild = this.__arrInternalSource;
			var rowLevel = parseInt(item[this.__fieldRowLevel]);
			var startIndex = item[this.__fieldIndex];
			var length = arrChild.length;
			for(var count = startIndex;count < length;count++)
			{
				var itemChild = arrChild[count];
				var hasChild = itemChild[this.__fieldHasChild];
				if(rowLevel >= parseInt(itemChild[this.__fieldRowLevel]))
				{
					break;
				}
				//in group collection we are giving values for rows which are not generated by grid
				if(!hasChild)
				{
					arrItems.push(itemChild);
				}
			}
		}
		return arrItems;
	};
	
	NSGrid.prototype.__getAllVisibleItems = function()
	{
		var totalRecords = 0;
		var arrItems = this.__getAllItems();
		if(arrItems && arrItems.length > 0)
		{
			for(var count = 0;count < arrItems.length;count++)
			{
				var item = arrItems[count];
				if(item && item[this.__fieldRowVisible])
				{
					totalRecords += 1;
				}
			}
		}
		return totalRecords;
	};
	
	NSGrid.prototype.__getFirstVisibleItemBeforeIndex = function(itemIndex)
	{
		var arrItems = this.__getAllItems();
		if(arrItems && arrItems.length > 0)
		{
			var retIndex = this.__getActualIndex(arrItems,itemIndex);
			if(retIndex !== itemIndex)
			{
				itemIndex = (retIndex + 1);
			}
			/*if(arrItems.length < itemIndex || arrItems[itemIndex][this.__fieldIndex] !== (itemIndex + 1))
			{
				var rowItem = null;
				for(var count = 0;count < arrItems.length;count++)
				{
					rowItem = arrItems[count];
					if(rowItem[this.__fieldIndex] === itemIndex)
					{
						itemIndex = (count + 1);
						break;
					}
				}
			}*/
			for(var count = itemIndex;count >= 0;count--)
			{
				var item = arrItems[count];
				if(item && item[this.__fieldRowVisible] && item[this.__fieldVisibleIndex] > -1)
				{
					return item;
				}
			}
		}
		return null;
	};
	
	NSGrid.prototype.__getVisibleItemByIndex = function(source,index)
	{
		var arrItems = source;
		if(!arrItems)
		{
			arrItems = this.__getAllItems();
		}
		if(arrItems && arrItems.length > 0)
		{
			var self = this; 
			var findItem = function(itemCompare)
			{
				 return (itemCompare[self.__fieldVisibleIndex] === (index + 1));
			};
			return arrItems.find(findItem);
		}
		return null;
	};
	
	NSGrid.prototype.__updateVisibleIndex = function(source,fromIndex)
	{
		var arrItems = source;
		if(!arrItems)
		{
			arrItems = this.__getAllItems();
		}
		if(this.util.isUndefinedOrNull(fromIndex))
		{
			fromIndex = 0;
		}
		if(arrItems && arrItems.length > 0)
		{
			var visibleRowIndex = 1;
			if(fromIndex > 0)
			{
				var visibleItem = this.__getFirstVisibleItemBeforeIndex(fromIndex);
				if(visibleItem)
				{
					visibleRowIndex = visibleItem[this.__fieldVisibleIndex];
					fromIndex = visibleItem[this.__fieldIndex] - 1;
					var retIndex = this.__getActualIndex(arrItems,fromIndex,true);
					if(retIndex !== fromIndex)
					{
						fromIndex = retIndex;
					}
					/*//for Filter condition
					//(startIndex + 1) as __fieldIndex starts from 1
					if(arrItems.length < fromIndex || arrItems[fromIndex][this.__fieldIndex] !== (fromIndex + 1))
					{
						var rowItem = null;
						for(var count = 0;count < arrItems.length;count++)
						{
							rowItem = arrItems[count];
							if(rowItem[this.__fieldIndex] === (fromIndex + 1))
							{
								fromIndex = count;
								break;
							}
						}
					}
					//end of Filter condition*/
				}
			}
			var length = arrItems.length;
			var item = null;
			for(var count = fromIndex; count < length; count++)
			{
				item = arrItems[count];
				if(item)
				{
					if(item[this.__fieldRowVisible])
					{
						item[this.__fieldVisibleIndex] = visibleRowIndex;
						visibleRowIndex++;
					}
					else
					{
						item[this.__fieldVisibleIndex] = -1;
					}
				}
			}
		}
	};
	
	NSGrid.prototype.__updateVisibleIndexByRow = function(source,arrAllItems)
	{
		if(source)
		{
			var arrItems = arrAllItems;
			if(!arrItems)
			{
				arrItems = this.__getAllItems();
			}
			var length = source.length;
			var item = null;
			var objVisibleIndex = {};
			for(var count = 0; count < length; count++)
			{
				item = source[count];
				if(item)
				{
					var index = item[this.__fieldIndex];
					objVisibleIndex[index] = item;
				}
			}
			if(arrItems && arrItems.length > 0)
			{
				length = arrItems.length;
				item = null;
				var visibleRowIndex = 1;
				for(var count = 0; count < length; count++)
				{
					item = arrItems[count];
					var index = item[this.__fieldIndex];
					if(this.util.isUndefinedOrNull(objVisibleIndex[index]))
					{
						item[this.__fieldVisibleIndex] = -1;
						item[this.__fieldRowVisible] = false;
					}
					else
					{
						item[this.__fieldVisibleIndex] = visibleRowIndex;
						item[this.__fieldRowVisible] = true;
						objVisibleIndex[index][this.__fieldVisibleIndex] = visibleRowIndex;
						objVisibleIndex[index][this.__fieldRowVisible] = true;
						visibleRowIndex++;
					}
				}
			}
			
		}
	};
	
	NSGrid.prototype.__getArrow = function(rowCount)
	{
		var arrDivs = this.__getAllArrows();
		if(arrDivs && arrDivs.length > 0)
		{
			for(var count = 0;count < arrDivs.length;count++)
			{
				var div = arrDivs[count];
				if(div && div.hasAttribute("ns-parent-row-count"))
				{
					var rowParentCount = div.getAttribute("ns-parent-row-count");
					if(rowParentCount && rowParentCount == rowCount)
					{
						return div;
					}
				}
			}
		}
	};
	
	NSGrid.prototype.__getAllArrows = function(divParent)
	{
		if(!divParent)
		{
			divParent = this.__tblCenterBody;
		}
		return divParent.querySelectorAll(".nsArrow");
	};
	
	NSGrid.prototype.__getAllBodyRows = function()
	{
		if(this.__tblCenterBodyBody && this.__tblCenterBodyBody.rows)
		{
			return this.__tblCenterBodyBody.rows;
		}
		return null;
	};
	
	NSGrid.prototype.__getTotalRows = function()
	{
		if(this.__tblCenterBodyBody && this.__tblCenterBodyBody.rows)
		{
			return this.__tblCenterBodyBody.rows.length;
		}
		return 0;
	};
	
	NSGrid.prototype.__getIndexFromRow = function(row)
	{
		if(row)
		{
			return parseInt(row.getAttribute("ns-index"));
		}
		return -1;
	};
	
	NSGrid.prototype.__getRowFromItem = function(item)
	{
		var row = null;
		if(item)
		{
			row = item[this.__fieldRow];
			var index = item[this.__fieldIndex];
			//below case is true if row reference has been removed due to virtual scroll 
			if(!row || row.rowIndex === -1)
			{
				var arrRows = this.__tblCenterBodyBody.querySelectorAll('[ns-index="' + index + '"]');
				if(arrRows && arrRows.length > 0)
				{
					row = arrRows[0];
				}
			}
		}
		return row;
	};
	
	NSGrid.prototype.__getRowByIndex = function(index)
	{
		var row = null;
		if(index > -1)
		{
			var item = this.__getItemByIndex(index);
			row = this.__getRowFromItem(item);
		}
		return row;
	};
	
	NSGrid.prototype.__getRowFromContainer = function(index)
	{
		var arrRows = this.__getBodyBodyRow(this.__tblCenterBody);
		if(this.__hasBodyRows() && arrRows.length > index)
		{
			return arrRows[index];
		}
		return null;
	};
	
	NSGrid.prototype.__hasBodyRows = function()
	{
		var arrRows = this.__getBodyBodyRow(this.__tblCenterBody);
		if(arrRows && arrRows.length > 0)
		{
			return true;
		}
		return false;
	};
	
	NSGrid.prototype.__getItemByIndex = function(indexToFind,source)
	{
		if(!source)
		{
			source = this.__objGrid.__getFlatSource();
		}
		if(source && source.length > 0)
		{
			for(var count = 0;count < source.length;count++)
			{
				var item = source[count];
				if(item && item[this.__fieldIndex] === indexToFind)
				{
					return item;
				}
			}
		}
		return null;
	};
	
	NSGrid.prototype.__getItemBykeyField = function(keyFieldValue,source)
	{
		if(!source)
		{
			source = this.__objGrid.__getFlatSource();
		}
		if(source && source.length > 0)
		{
			for(var count = 0;count < source.length;count++)
			{
				var item = source[count];
				if(item && item[this.__rowKeyField] === keyFieldValue)
				{
					return item;
				}
			}
		}
		return null;
	};
	
	NSGrid.prototype.__getIndexByItem = function(itemToFind,source)
	{
		if(!source)
		{
			source = this.__getAllItems();
		}
		if(itemToFind && source && source.length > 0)
		{
			for(var count = 0;count < source.length;count++)
			{
				var item = source[count];
				if(item && item[this.__fieldIndex] === itemToFind[this.__fieldIndex])
				{
					return item[this.__fieldIndex];
				}
			}
		}
		return -1;
	};
	
	NSGrid.prototype.__getColumnObject = function(index,arrColumn)
	{
		if(!arrColumn)
		{
			arrColumn = this.__columns;
		}
		index = parseInt(index);
		if(arrColumn && index > -1 && index < arrColumn.length)
		{
			var item = null;
			for(var count = 0;count < arrColumn.length;count++)
			{
				item = arrColumn[count];
				if(item[this.__fieldColIndex] === index)
				{
					return item;
				}
			}
		}
		return null;
	};
	
	NSGrid.prototype.__getColumnIndexByObject = function(objColumn,arrColumn)
	{
		if(!arrColumn)
		{
			arrColumn = this.__columns;
		}
		if(arrColumn && objColumn)
		{
			for(var count = 0;count < arrColumn.length;count++)
			{
				if(arrColumn[count][this.__fieldColIndex] === objColumn[this.__fieldColIndex])
				{
					return count;
				}
			}
		}
		return -1;
	};
	
	NSGrid.prototype.__getColumnObjectByDataField = function(dataField,arrColumn)
	{
		if(!arrColumn)
		{
			arrColumn = this.__columns;
		}
		if(arrColumn && dataField)
		{
			for(var count = 0;count < arrColumn.length;count++)
			{
				var item = arrColumn[count];
				if(item["dataField"] === dataField)
				{
					return item;
				}
			}
		}
		return null;
	};
	
	NSGrid.prototype.__getColumnIndexForSwapOrRemove = function(column,arrColumn)
	{
		if(!arrColumn)
		{
			arrColumn = this.__columns;
		}
		var index = -1;
		//checking below like this because column = 0 then column will return false;
		if(!this.util.isUndefined(column) && column != null)
		{
			if(this.util.isNumber(column) && arrColumn && column < arrColumn.length)
			{
				index = column;
			}
			else if(this.util.isString(column))
			{
				for(var count = 0;count < arrColumn.length;count++)
				{
					var item = arrColumn[count];
					if(item["dataField"] === column)
					{
						index = count;
						break;
					}
				}
			}
		}
		else
		{
			this.util.warning("NSGrid","Please pass valid column information.");
		}
		return index;
	};
	
	NSGrid.prototype.__isColumnValidForSwapOrRemove = function(columnIndex,operation)
	{
		if(this.__isColumnIndexValid(columnIndex))
		{
			if((this.__enableHierarchical && columnIndex === 0) || (this.__enableGrouping && (columnIndex === 0 || this.__columns[columnIndex]["dataField"] === this.__groupByField)) 
					|| (this.__enableMasterDetail && columnIndex === 0))
			{
				if(operation)
				{
					this.util.warning("NSGrid","This column cannot be " + operation + ".");
				}
				return false;
			}
			return true;
		}
		return false;
		
	};
	
	NSGrid.prototype.__swapCell = function(sourceCell,destinationCell)
	{
		if(sourceCell && destinationCell)
		{
			var destinationCellIndex = destinationCell.cellIndex;
			this.__moveCell(destinationCell,sourceCell.cellIndex);
			this.__moveCell(sourceCell,destinationCellIndex);
			return true;
		}
		return false;
	};
	
	NSGrid.prototype.__moveCell = function(fromCell,toIndex)
	{
		if(fromCell && toIndex > -1)
		{
			var row = fromCell.parentNode;
			row.removeChild(fromCell);
			row.insertBefore(fromCell,row.cells[toIndex]);
			return true;
		}
		return false;
	};
	
	NSGrid.prototype.__createColumnProvider = function(arrColumns)
	{
		if(arrColumns && arrColumns.length > 0)
		{
			var hasColumnProviderChanged = this.__hasColumnProviderChanged(arrColumns);
			var self = this;
			var getOrignalColumnInfo = function(dataField)
			{
				for (var count = 0;count < self.__orignalColumns.length;count++)
				{
					var colOrigItem = self.__orignalColumns[count];
					if(colOrigItem["dataField"] === dataField)
					{
						return colOrigItem;
					}
				}
				return null;
			};
			this.__columns = [];
			for (var count = 0;count < arrColumns.length;count++)
			{
				var objColumn = arrColumns[count];
				var columnInfo = getOrignalColumnInfo(objColumn["dataField"]);
				if(columnInfo)
				{
					if(objColumn.hasOwnProperty(this.__fieldColSortedAsc) && objColumn[this.__fieldColSortedAsc] != null)
					{
						columnInfo[this.__fieldColSortedAsc] = objColumn[this.__fieldColSortedAsc];
					}
					if(objColumn.hasOwnProperty(this.__fieldColIndex) && objColumn[this.__fieldColIndex] != null)
					{
						columnInfo[this.__fieldColIndex] = objColumn[this.__fieldColIndex];
					}
					if(objColumn.hasOwnProperty(this.__fieldColVisible) && objColumn[this.__fieldColVisible] != null)
					{
						columnInfo[this.__fieldColVisible] = objColumn[this.__fieldColVisible];
					}
					if(!hasColumnProviderChanged && objColumn.hasOwnProperty("width") && objColumn["width"] != null)
					{
						columnInfo["width"] = objColumn["width"];
					}
					var index = columnInfo[this.__fieldColIndex];
					if(this.__columns[index])
					{
						this.__columns.splice(index, 0, columnInfo);
					}
					else
					{
						this.__columns[index] = columnInfo;
					}
				}
			}
		}
		else
		{
			this.__columns = this.__orignalColumns.slice(0);
		}
	};
	
	NSGrid.prototype.__hasColumnProviderChanged = function(arrColumns)
	{
		if(!arrColumns || !this.__orignalColumns || this.__orignalColumns.length !== arrColumns.length)
		{
			return true;
		}
		var length = this.__orignalColumns.length;
		var count = 0;
		for(count = 0;count < length;count++)
		{
			var colItem = this.__orignalColumns[count];
			for(var innerCount = 0;innerCount < length;innerCount++)
			{
				if(colItem["dataField"] === arrColumns[innerCount]["dataField"])
				{
					break;
				}
			}
		}
		return (count !== length);
	};
	
	NSGrid.prototype.__processDefaultSort = function()
	{
		for(var count = 0; count < this.__columns.length;count++)
		{
			var objColumn = this.__columns[count];
			if(objColumn.hasOwnProperty(this.__fieldColSortedAsc) && objColumn[this.__fieldColSortedAsc] != null)
			{
				var headerBodyRow = this.__getHeaderBodyRow(this.__tblCenterHeader);
				var arrHeaderCells = headerBodyRow.cells;
				var cell = arrHeaderCells[count];
				this.__nsGridSort.handle(cell,objColumn,false,objColumn[this.__fieldColSortedAsc]);
				return true;
			}
		}
		return false;
	};
	
	NSGrid.prototype.__editColumnArray = function(mode,item)
	{
		//item should be column object
		if(mode === "add")
		{
			this.__columns[this.__columns.length] = item;
			this.__orignalColumns[this.__orignalColumns.length] = item;
		}
		else if(mode === "swap")
		{
			
		}
		//item should be column index
		else if(mode === "hide")
		{
			var colItem = this.__columns[item];
			colItem[this.__fieldColVisible] = false;
		}
		else if(mode === "show")
		{
			var colItem = this.__columns[item];
			colItem[this.__fieldColVisible] = true;
		}
	};
	
	NSGrid.prototype.__isColumnIndexValid = function(columnIndex)
	{
		if(columnIndex > -1 && columnIndex < this.__columns.length)
		{
			return true;
		}
		return false;
		
	};
	
	NSGrid.prototype.__isMouseOnElement = function(element, currentX, currentY)
	{
		var offset = this.util.getCumulativeOffset(element);
		return (currentY >= offset.y &&
				currentY <  offset.y + element.offsetHeight &&
	            currentX >= offset.x + element.offsetWidth - 5 &&
	            currentX <  offset.x + element.offsetWidth);
	};
	
	NSGrid.prototype.__updateTotalRecords = function(totalCount)
	{
		if(!totalCount)
		{
			totalCount = this.__arrInternalSource.length; 
		}
		//update total Rows if no server side call and pagination mode is manual
		if(!(this.__enableServerCall || (this.__enablePagination && !this.__isPaginationModeAuto)) || this.__rowsRendered)
		{
			this.__totalRecords = totalCount;
		}
	};
	
	NSGrid.prototype.__addPriorityClassInCell = function(cell,colItem)
	{
		if(this.__isResponsiveModeColumnToggle && cell && colItem)
		{
			this.util.addStyleClass(cell,"column-priority-" + colItem["priority"]);
		}
	};
	
	NSGrid.prototype.__setGridType = function()
	{
		if(this.__type === this.GRID_TYPE_HIERARCHICAL)
		{
			this.__enableHierarchical = true;
			this.__objGrid = new NSHierarchicalGrid(this,this.util);
		}
		else if(this.__type === this.GRID_TYPE_GROUP)
		{
			this.__enableGrouping = true;
			this.__objGrid = new NSGroupingGrid(this,this.util);
		}
		else if(this.__type === this.GRID_TYPE_MASTER_DETAIL)
		{
			this.__enableMasterDetail = true;
			this.__objGrid = new NSMasterDetailGrid(this,this.util);
		}
		else
		{
			this.__objGrid = new NSFlatGrid(this,this.util);
		}
	};
	
	NSGrid.prototype.__callFunctionInsideGridType = function(functionName,...args)
	{
		this.util.callFunctionOfObject(this.__objGrid,functionName,...args);
	};
	
	NSGrid.prototype.__setPaginationType = function()
	{
		if(!this.__paginationType || this.__paginationType === this.PAGINATION_TYPE_SCROLL)
		{
			this.__isPaginationTypeScroll = true;
		}
		else
		{
			this.__isPaginationTypeScroll = false;
		}
	};
	
	NSGrid.prototype.__setPaginationMode = function()
	{
		if(!this.__paginationMode || this.__paginationMode === this.PAGINATION_MODE_AUTO)
		{
			this.__isPaginationModeAuto = true;
		}
		else
		{
			this.__isPaginationModeAuto = false;
		}
		if(!(this.__isPaginationTypeScroll && this.__isPaginationModeAuto))
		{
			this.__enableAsyncLoadPagination = false;
		}
	};
	
	NSGrid.prototype.__setResponsiveMode = function()
	{
		if(this.__enableResponsive)
		{
			if(!this.__responsiveMode || this.__responsiveMode === this.RESPONSIVE_MODE_STACK)
			{
				this.__isResponsiveModeStack = true;
				this.__isResponsiveModeColumnToggle = false;
				this.__arrQueries = ["only screen and (max-width: 760px),(min-device-width: 768px) and (max-device-width: 1024px)"];
			}
			else
			{
				this.__arrQueries = ["only screen and (min-width: 960px)",
				                     "only screen and (max-width: 960px) and (min-width: 800px)",
				                     "only screen and (max-width: 800px) and (min-width: 640px)",
				                     "only screen and (max-width: 640px) and (min-width: 480px)",
				                     "only screen and (max-width: 480px) and (min-width: 320px)",
				                     "only screen and (max-width: 320px)"];
				this.__isResponsiveModeColumnToggle = true;
				this.__isResponsiveModeStack = false;
			}
		}
		else
		{
			this.__isResponsiveModeColumnToggle = false;
			this.__isResponsiveModeStack = false;
		}
		
	};
	
	NSGrid.prototype.__checkForVirtualMode = function()
	{
		if(this.__enableVirtualScroll)
		{
			/*if(this.__enableHierarchical || this.__enableGrouping)
			{
				this.__enableVirtualScroll = false;
			}*/
			if(this.__enablePagination)
			{
				this.__enableVirtualScroll = false;
			}
		}
	};
	
	NSGrid.prototype.__setCustomScrollBarScrollTop = function(scrollTop)
	{
		if(this.__enableCustomScrollBar)
		{
			if(this.__scroller)
			{
				this.__scroller.setScrollTop(scrollTop);
			}
		}
	};
	
	NSGrid.prototype.__getHorizontalScrollableContainer = function() 
	{
		var container = this.__enableFooter ? this.__divCenterTableFooterContainer : this.__divCenterTableBodyContainer;
		return container;
	};
	
	NSGrid.prototype.__getVerticalScrollableContainer = function() 
	{
		var container = this.__divCenterTableBodyContainer;
		return container;
	};
	
	NSGrid.prototype.__addSVGInPage = function()
	{
		if(typeof NSSvg != 'undefined')
		{
			var objSVG = new NSSvg();
			var svgShapes = new NSSvgShapes();
			//for header Menu
			var circleDownArrowID = "svgCircleDownArrow";
			var groupDown = objSVG.createGroup(circleDownArrowID + "group");
			var circle = objSVG.createCircle(circleDownArrowID + "circle",8,8,8,null);
			groupDown.appendChild(circle);
			var polygon = objSVG.createPolygon(circleDownArrowID + "polygon","2,5.5 14,5.5 8,11.5","nsMenuArrow");
			groupDown.appendChild(polygon);
			objSVG.addElementInSymbol(circleDownArrowID,"0 0 16 16",groupDown);
			if(this.__enableExport)
			{
				svgShapes.addExportInPage();
			}
			if(this.__enableColumnSetting)
			{
				svgShapes.addColumnSettingIcon();
			}
			if(this.__enableFilter)
			{
				svgShapes.addFilterIcon();
				svgShapes.addSearchIcon();
			}
			this.__objGrid.__addSVGInPage(objSVG);
			svgShapes.addMoveIcon();
			svgShapes.addLeftIcon();
			svgShapes.addRightIcon();
		}
		else
		{
			this.util.warning("NSGrid","NSSvg has not been included so the icons might not appear");
		}
		this.__imgUtil = new this.util.image();
	};
	
	NSGrid.prototype.__addStyleInDOM = function()
	{
		if(this.__enableMouseHover)
	    {
			//this.util.addCSSClassInDOM(["#" + this.getID() + " .nsGridRow:hover > td"],["background-color: " + this.__mouseHoverColor + "!important;"]);
	    }
	};
	
	NSGrid.prototype.__addRowHeightInDOM = function()
	{
		if(!this.__enableVariableRowHeight)
		{
			var rowHeight = null;
			if(this.__rowHeight > 0)
			{
				rowHeight = this.__rowHeight + "px";
			}
			else if(this.__virtualRowHeight > 0)
			{
				rowHeight = this.__virtualRowHeight + "px";
			}
			if(rowHeight)
		    {
				this.util.addCSSClassInDOM(["#" + this.getID() + " .nsBodyDataGridCell > div"],["max-height:" + rowHeight + ";"]);
		    }
		}
	};
	
	NSGrid.prototype.__initializePluggins = function()
	{
		if(!this.__nsGridSort)
		{
			this.__nsGridSort = new NSGridSort(this);
			this.__nsGridColumnMove = new NSGridColumnMove(this);
			this.__nsGridFilter = new NSGridFilter(this);
			this.__nsGridColumnResize = new NSGridColumnResize(this);
			this.__nsGridEditor = new NSGridEditor(this);
			this.__nsToolTipInElement = new this.util.nsToolTipInElement();
			if(this.__enableKeyboardNavigation)
			{
				this.__nsGridKeyboard = new NSGridKeyboard(this);
			}
		}
	};
	
	NSGrid.prototype.__getCellDetailsForEditing = function(item,dataField)
	{
		if(this.__nsGridEditor)
		{
			if(item)
			{
				var colItem = this.__getColumnObjectByDataField(dataField);
				if(colItem)
				{
					var colIndex = colItem[this.__fieldColIndex];
					var row = this.__getRowFromItem(item);
					if(row)
					{
						var cells = row.cells;
						var cell = cells[colIndex];
						return {cell: cell,item: item};
					}
				}
			}
		}
		return null;
	};
	
	NSGrid.prototype.__handleHiddenColumn = function()
	{
		var length = this.__columns.length;
		for(var count = 0;count < length;count++)
		{
			var objColumn = this.__columns[count];
			if(objColumn[this.__fieldColVisible] === false)
			{
				this.__setColumnVisibility(count,false,objColumn);
			}
		}
	};
	
	NSGrid.prototype.__setColumnVisibility = function(index,isVisible,item)
	{
		var headerColGroupID = null;
		var bodyColGroupID = null;
		var objColumn = null;
		if(item)
		{
			if(this.util.isString(item))
			{
				objColumn = this.__getColumnObjectByDataField(item);
			}
			else if(this.util.isNumber(item))
			{
				objColumn = this.__getColumnObject(item);
			}
			else
			{
				objColumn = item;
			}
			if(objColumn)
			{
				headerColGroupID = this.getID() + "HeaderColGroup" + objColumn.dataField;
				bodyColGroupID = this.getID() + "BodyColGroup" + objColumn.dataField;
			}
		}
		if(isVisible)
		{
			this.util.removeCSSClassInDOM(["#" + this.getID() + " :nth-child(" + (index + 1) +").nsGridCell"]);
			if(objColumn)
			{
				this.util.removeCSSClassInDOM(["#" + headerColGroupID + ", #" + bodyColGroupID]);
			}
			
		}
		else
		{
			this.util.addCSSClassInDOM(["#" + this.getID() + " :nth-child(" + (index + 1) +").nsGridCell"],["display:none;"]);
			if(objColumn)
			{
				this.util.addCSSClassInDOM(["#" + headerColGroupID + ", #" + bodyColGroupID],["display:none;"]);
			}
		}
	};
	
	NSGrid.prototype.__addColumnPseudoStyle = function()
	{
		var arrClass = [];
		var arrCSSText = [];
		var headerBodyRow = this.__getHeaderBodyRow(this.__tblCenterHeader);
		if(headerBodyRow)
		{
			var headerCells = headerBodyRow.cells;
			var colIndex = 0;
			var cell = null;
	        for(colIndex = 0; colIndex < headerCells.length; colIndex++)
	        {
	        	cell = headerCells[colIndex];
	        	arrClass.push("#" + this.getID() + ".nsMobileStackGrid td:nth-of-type(" + (colIndex + 1) + "):before");
	        	var text = cell.textContent.trim();
	        	if(text && text.length > 0)
	        	{
	        		text = text + ": ";
	        	}
	        	arrCSSText.push("content: '" + text + "';");
	        }
		}
		this.util.addCSSClassInDOM(arrClass,arrCSSText,false);
	};
	
	NSGrid.prototype.__updateItemInSource = function(item)
	{
		if(item)
		{
			this.__updateItemInArray(this.__dataSource,item);
			this.__updateItemInArray(this.__arrWrapper,item);
			this.__updateItemInArray(this.__arrInternalSource,item);
			this.__updateItemInArray(this.__arrFlatHierarchicalSource,item,true);
			this.__updateItemInArray(this.__arrFilteredGroupedSource,item);
		}
	};
	
	NSGrid.prototype.__updateItemInArray = function(source,item,excludeChildren)
	{
		var isFound = false;
		if(source && source.length > 0 && item)
		{
			excludeChildren = Boolean.parse(excludeChildren);
			var length = source.length;
			var tempItem = {};
			var arrChildItems = [];
			for(var count = 0;count < length;count++)
			{
				tempItem = source[count];
				if(tempItem[this.__fieldIndex] === item[this.__fieldIndex])
				{
					source[count] = item;
					isFound = true;
					break;
				}
				if((this.__enableHierarchical || this.__enableGrouping || this.__enableMasterDetail) && !excludeChildren)
				{
					arrChildItems = tempItem[this.__childField];
					if(arrChildItems && arrChildItems.length > 0)
					{
						isFound = this.__updateItemInArray(arrChildItems,item,excludeChildren);
						if(isFound)
						{
							break;
						}
					}
				}
			}
		}
		return isFound;
	};
	
	NSGrid.prototype.__setComponentHeight = function()
	{
		var offset = this.util.getNumber(this.__heightOffset);
		if(offset > 0)
		{
			var compHeight = this.util.getBodyDimension().height;
			this.__baseComponent.style.height = (compHeight - offset) + "px";
		}
	};
	
	//to get header row which has column width
	NSGrid.prototype.__getHeaderHeaderRow = function(table)
	{
		var headerRow = null;
		if(table && table.tHead && table.tHead.rows && table.tHead.rows.length > 0)
		{
			headerRow = table.tHead.rows[0];
		}
		return headerRow;
	};
	
	//to get header row which has column header Name
	NSGrid.prototype.__getHeaderBodyRow = function(table)
	{
		var headerBodyRow = null;
		if(table)
		{
			headerBodyRow = table.querySelector(".nsGridHeaderRow");
		}
		return headerBodyRow;
	};
	
	NSGrid.prototype.__getHeaderFilterRow = function(table)
	{
		var headerFilterRow = null;
		if(table)
		{
			headerFilterRow = table.querySelector(".nsGridFilterRow");
		}
		return headerFilterRow;
	};
	
	NSGrid.prototype.__getHeaderExtraRow = function(table)
	{
		var arrExtraRows = null;
		if(table)
		{
			arrExtraRows = table.querySelectorAll(".nsHeaderExtraRow");
		}
		return arrExtraRows;
	};
	
	//to get body row which has column width
	NSGrid.prototype.__getBodyHeaderRow = function(table)
	{
		var bodyRow = null;
		if(table && table.tHead && table.tHead.rows && table.tHead.rows.length > 0)
	    {
			bodyRow = table.tHead.rows[0];
		}
		return bodyRow;
	};
	
	NSGrid.prototype.__getBodyBodyRow = function(table)
	{
		var arrRows = null;
		if(table && table.tBodies && table.tBodies.length > 0 && table.tBodies[0].rows && table.tBodies[0].rows.length > 0)
		{
    		arrRows = table.tBodies[0].rows;
		}
		return arrRows;
	};
	
	NSGrid.prototype.__getCustomIcon = function(iconField)
	{
		if(this.__icons && this.__icons[iconField])
		{
			return this.__icons[iconField];
		}
		return null;
	};
	
	NSGrid.prototype.__getColumnCustomIcon = function(colItem,iconField)
	{
		if(colItem && colItem.icons && colItem.icons[iconField])
		{
			return colItem.icons[iconField];
		}
		return null;
	};
	
	NSGrid.prototype.__isSortingIconCustom = function(colItem)
	{
		if(this.__getColumnCustomIcon(colItem,"sortAscending") && this.__getColumnCustomIcon(colItem,"sortDescending"))
		{
			return true;
		}
		return false;
	};
	
	NSGrid.prototype.__isRowExpansionIconCustom = function()
	{
		if(this.__getCustomIcon("rowExpanded") && this.__getCustomIcon("rowCollapsed"))
		{
			return true;
		}
		return false;
	};
	
	NSGrid.prototype.__getViewportHeight = function()
	{
		return this.__divTableHeaderContainerWrapper.offsetHeight + this.__divTableBodyContainerWrapper.offsetHeight + this.__divTableFooterContainerWrapper.offsetHeight;
	};
	
	NSGrid.prototype.__dispatchEvent = function(eventType,data,param,bubbles,cancelable)
	{
		if(this.__eventDispatcher)
		{
			this.__eventDispatcher(eventType,data,param,bubbles,cancelable);
		}
		else
		{
			this.util.dispatchEvent(this.__baseComponent,eventType,data,param,bubbles,cancelable);
		}
	};
	
	NSGrid.prototype.__dispatchInternalEvent = function(eventType,data,param,bubbles,cancelable)
	{
		this.util.dispatchEvent(this.__baseComponent,this.__getInternalEvent(eventType),data,param,bubbles,cancelable);
	};
	
	NSGrid.prototype.__listenInternalEvent = function(eventType,callback)
	{
		this.util.addEvent(this.__baseComponent,this.__getInternalEvent(eventType),function(event){
			callback(event,event.detail);
		});
	};
	
	NSGrid.prototype.__getInternalEvent = function(eventType)
	{
		return "__" + eventType;
	};
	/******************************End of Custom Function *************************************/
	/******************************Touch Related Function *************************************/
	NSGrid.prototype.__addTouchEvent = function(element)
	{
		var objTouch = null;
		if(element && this.__enableTouchEvents)
		{
			if(this.__objTouchEvents.has(element))
			{
				objTouch = this.__objTouchEvents.get(element);
			}
			else
			{
				objTouch = new NSTouchToMouse(element);
				this.__objTouchEvents.set(element,objTouch);
			}
		}
		return objTouch;
	};
	
	NSGrid.prototype.__removeTouchEvent = function(element)
	{
		var objTouch = null;
		if(element && this.__enableTouchEvents)
		{
			if(this.__objTouchEvents.has(element))
			{
				/*objTouch = this.__objTouchEvents.get(element);
				this.__objTouchEvents.delete(objTouch);*/
			}
		}
		return objTouch;
	};
	
	/******************************End of Touch Related Function *************************************/
	/******************************Loader Related Function *************************************/
	NSGrid.prototype.showLoader = function()
	{
		if(!this.__loader)
		{
			this.__loader = new this.util.loader(this.__divOuterContainer);
		}
		this.__loader.show();
	};
	
	NSGrid.prototype.hideLoader = function()
	{
		if(this.__loader)
		{
			this.__loader.hide();
		}
	};
	/******************************End of Loader Related Function *************************************/
	/******************************Start of Export Related Function *************************************/
	NSGrid.prototype.__exportHandler = function(target,item)
	{
		if(item)
		{
			if(!this.__exportFileName || this.__exportFileName === "")
			{
				this.__exportFileName = "Download";
			}
			var nsExport = new NSExport(this,this.__exportFileName);
			switch (item.id) 
			{
			    case 0:
			    	var setting = {type:"xls",event:null,sheetName:this.__exportFileName,element:null,properties:item};
			    	nsExport.excel(setting);
			        break;
			    case 1:
			    	nsExport.csv();
			        break;
			    case 2:
			    	var setting = {type:"doc",event:null,orientation:null,element:null};
			    	nsExport.word(setting);
			        break;
			    case 3:
			    	nsExport.text();
			        break;
			    case 4:
			    	nsExport.xml();
			        break;
			    case 5:
			    	nsExport.json();
			        break;
			    case 6:
			    	nsExport.pdf();
			        break;
			    case 7:
			    	nsExport.image();
			        break;
			    case 8:
			    	var setting = {type:"xlsx",event:null,sheetName:this.__exportFileName,element:null,properties:item};
			    	nsExport.excel(setting);
			        break;
			    case 9:
			    	var setting = {type:"doc",event:null,orientation:null,element:null};
			    	nsExport.word(setting);
			        break;
			}
		}
	};
	
	//Events
	NSGrid.GRID_RENDERED = "gridRendered";
	NSGrid.ROW_SELECTED = "rowSelected";
	NSGrid.ROW_UNSELECTED = "rowUnselected";
	NSGrid.ROW_CLICKED = "rowClicked";
	NSGrid.ROW_DOUBLE_CLICKED = "rowDoubleClicked";
	NSGrid.ROW_NAVIGATED = "rowNavigated";
	NSGrid.CELL_SELECTED = "cellSelected";
	NSGrid.CELL_UNSELECTED = "cellUnselected";
	NSGrid.CELL_CLICKED = "cellClicked";
	NSGrid.CELL_DOUBLE_CLICKED = "cellDoubleClicked";
	NSGrid.SORT_CHANGING = "sortChanging";
	NSGrid.SORT_CHANGED = "sortChanged";
	NSGrid.ADVANCED_FILTER_CLOSING = "advancedFilterClosing";
	NSGrid.FILTER_CHANGING = "filterChanging";
	NSGrid.FILTER_CHANGED = "filterChanged";
	NSGrid.FILTER_RESETTED = "filterResetted";
	NSGrid.COLUMN_RESIZING = "columnResizing";
	NSGrid.COLUMN_RESIZED = "columnResized";
	NSGrid.COLUMN_MOVING = "columnMoving";
	NSGrid.COLUMN_MOVED = "columnMoved";
	NSGrid.MULTI_SELECTION_EDITORS_TEXT = "TEXT";
	NSGrid.MULTI_SELECTION_EDITORS_TEXTAREA = "TEXTAREA";
	NSGrid.EDITOR_CELL_VALUE_CHANGED = "editorCellValueChanged";
	
	
	//Editors
	NSGrid.EDITOR_EDITTYPE_CELL = "cell";
	NSGrid.EDITOR_EDITTYPE_ROW = "row";
	NSGrid.EDITOR_EDITING_SINGLECLICK = "singleClick";
	NSGrid.EDITOR_EDITING_DOUBLECLICK = "doubleClick";
	NSGrid.EDITOR_EDITING_NOCLICK = "noClick";
	NSGrid.EDITOR_TYPE_TEXT = "text";
	NSGrid.EDITOR_TYPE_TEXTAREA = "textArea";
	NSGrid.EDITOR_TYPE_CUSTOM = "custom";
	
	NSGrid.FILTER_TYPE_DATE = "date";
	NSGrid.ADVANCED_FILTER_TEXT = "text";
	NSGrid.ADVANCED_FILTER_NUMBER = "number";
	NSGrid.ADVANCED_FILTER_LIST = "list";
	NSGrid.ADVANCED_FILTER_DATE = "date";
	
	
	return NSGrid;
})();
nsModuleExport(this,"NSGrid",NSGrid);